webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(572);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(424);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _redux = __webpack_require__(64);
	
	var _reduxThunk = __webpack_require__(1083);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reactRedux = __webpack_require__(37);
	
	var _lodash = __webpack_require__(6);
	
	var _reducersRoot = __webpack_require__(563);
	
	var _reducersRoot2 = _interopRequireDefault(_reducersRoot);
	
	var _middlewareLogging = __webpack_require__(559);
	
	var _middlewareLogging2 = _interopRequireDefault(_middlewareLogging);
	
	var _utilitiesSimpleRouter = __webpack_require__(315);
	
	var _componentsLaboratoryChrome = __webpack_require__(525);
	
	var _componentsLaboratoryChrome2 = _interopRequireDefault(_componentsLaboratoryChrome);
	
	var _localStorage = __webpack_require__(558);
	
	var _stellarSdk = __webpack_require__(23);
	
	var _stellarSdk2 = _interopRequireDefault(_stellarSdk);
	
	__webpack_require__(831);
	
	var persistedState = (0, _localStorage.loadState)();
	
	if (typeof window !== "undefined") {
	  window.StellarSdk = _stellarSdk2['default'];
	}
	
	document.write('<div id="app"></div>');
	
	var createStoreWithMiddleware = (0, _redux.applyMiddleware)(_reduxThunk2['default'], _utilitiesSimpleRouter.routerMiddleware, _middlewareLogging2['default'])(_redux.createStore);
	
	var store = createStoreWithMiddleware(_reducersRoot2['default'], persistedState);
	
	store.subscribe((0, _lodash.throttle)(function () {
	  (0, _localStorage.saveState)({
	    network: store.getState().network
	  });
	}, 1000));
	
	_reactDom2['default'].render(_react2['default'].createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2['default'].createElement(_componentsLaboratoryChrome2['default'], null)
	), document.getElementById('app'));

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(46);
	var hide = __webpack_require__(34);
	var redefine = __webpack_require__(35);
	var ctx = __webpack_require__(47);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 2 */,
/* 3 */
[1175, 9],
/* 4 */,
/* 5 */
82,
/* 6 */,
/* 7 */
172,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Pair;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function Pair(props) {
	  var optionalTextBreak = undefined,
	      optionalText = undefined;
	  if (props.optional) {
	    optionalTextBreak = _react2["default"].createElement("br", null);
	    optionalText = _react2["default"].createElement(
	      "span",
	      { className: "optionsTable__pair__title__optional" },
	      " (optional)"
	    );
	  }
	
	  return _react2["default"].createElement(
	    "div",
	    { className: "optionsTable__pair" },
	    _react2["default"].createElement(
	      "div",
	      { className: "optionsTable__pair__title" },
	      props.label,
	      " ",
	      optionalTextBreak,
	      optionalText
	    ),
	    _react2["default"].createElement(
	      "div",
	      { className: "optionsTable__pair__content" },
	      props.children
	    )
	  );
	}
	
	module.exports = exports["default"];

/***/ }),
/* 9 */
100,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	var es5 = __webpack_require__(97);
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var receiver = new FakeConstructor();
	    function ic() {
	        return typeof receiver.foo;
	    }
	    ic();
	    ic();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj instanceof Error ||
	        (obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string");
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	var hasEnvVariables = typeof process !== "undefined" &&
	    "object" !== "undefined";
	
	function env(key) {
	    return hasEnvVariables ? ({"AMPLITUDE_KEY":undefined,"NODE_ENV":"production"})[key] : undefined;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	function domainBind(self, cb) {
	    return self.bind(cb);
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    hasEnvVariables: hasEnvVariables,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise,
	    domainBind: domainBind
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version;
	    if (process.versions && process.versions.node) {    
	        version = process.versions.node.split(".").map(Number);
	    } else if (process.version) {
	        version = process.version.split(".").map(Number);
	    }
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(26)))

/***/ }),
/* 14 */
[1212, 129, 95, 5],
/* 15 */
[1208, 49],
/* 16 */
[1183, 7],
/* 17 */
[1197, 3, 327, 61, 16],
/* 18 */
[1209, 59],
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = PositiveIntPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextPicker = __webpack_require__(22);
	
	var _TextPicker2 = _interopRequireDefault(_TextPicker);
	
	function PositiveIntPicker(props) {
	  return _react2['default'].createElement(_TextPicker2['default'], _extends({}, props, {
	    validator: function (value) {
	      if (value.charAt(0) === '-') {
	        return 'Expected a positive number or zero.';
	      } else if (!value.match(/^[0-9]*$/g)) {
	        return 'Expected a whole number.';
	      }
	
	      if (typeof props.validator !== 'undefined') {
	        return props.validator(value);
	      }
	    }
	  }));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = TextPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PickerError = __webpack_require__(123);
	
	var _PickerError2 = _interopRequireDefault(_PickerError);
	
	function TextPicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	  var validator = props.validator;
	
	  var errorMessage = undefined;
	
	  var validatorIsPresent = _lodash2['default'].isFunction(validator);
	  var valueIsNonEmpty = _lodash2['default'].isString(value) && value.length > 0;
	  if (validatorIsPresent && valueIsNonEmpty) {
	    errorMessage = validator(value);
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement('input', { type: 'text',
	      value: value,
	      onChange: function (event) {
	        onUpdate(event.target.value);
	      },
	      placeholder: props.placeholder,
	      className: 'picker picker--textInput ' + props.className }),
	    _react2['default'].createElement(_PickerError2['default'], { message: errorMessage })
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = PubKeyPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextPicker = __webpack_require__(22);
	
	var _TextPicker2 = _interopRequireDefault(_TextPicker);
	
	var _stellarSdk = __webpack_require__(23);
	
	function PubKeyPicker(props) {
	  return _react2['default'].createElement(_TextPicker2['default'], _extends({}, props, {
	    placeholder: props.placeholder || 'Example: GCEXAMPLE5HWNK4AYSTEQ4UWDKHTCKADVS2AHF3UI2ZMO3DPUSM6Q4UG',
	    validator: function (value) {
	      if (!_stellarSdk.StrKey.isValidEd25519PublicKey(value)) {
	        return 'Public key is invalid.';
	      }
	    }
	  }));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
863,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
[1186, 17, 91, 16],
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var hide = __webpack_require__(34);
	var has = __webpack_require__(39);
	var SRC = __webpack_require__(95)('src');
	var $toString = __webpack_require__(578);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(46).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var fails = __webpack_require__(7);
	var defined = __webpack_require__(59);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1021);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(1022);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 38 */,
/* 39 */
135,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(128);
	var createDesc = __webpack_require__(91);
	var toIObject = __webpack_require__(42);
	var toPrimitive = __webpack_require__(61);
	var has = __webpack_require__(39);
	var IE8_DOM_DEFINE = __webpack_require__(327);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(16) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 41 */
[1199, 39, 18, 227],
/* 42 */
[1207, 127, 59],
/* 43 */,
/* 44 */,
/* 45 */
237,
/* 46 */
134,
/* 47 */
[1182, 27],
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 49 */
242,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
[1177, 47, 127, 18, 15, 211],
/* 59 */
238,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1);
	var core = __webpack_require__(46);
	var fails = __webpack_require__(7);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 61 */
[1210, 9],
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(462);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1086);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1085);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1084);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(461);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(463);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(349);
	var $export = __webpack_require__(1);
	var shared = __webpack_require__(129)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(353))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(16)) {
	  var LIBRARY = __webpack_require__(77);
	  var global = __webpack_require__(5);
	  var fails = __webpack_require__(7);
	  var $export = __webpack_require__(1);
	  var $typed = __webpack_require__(164);
	  var $buffer = __webpack_require__(232);
	  var ctx = __webpack_require__(47);
	  var anInstance = __webpack_require__(86);
	  var propertyDesc = __webpack_require__(91);
	  var hide = __webpack_require__(34);
	  var redefineAll = __webpack_require__(92);
	  var toInteger = __webpack_require__(49);
	  var toLength = __webpack_require__(15);
	  var toIndex = __webpack_require__(347);
	  var toAbsoluteIndex = __webpack_require__(94);
	  var toPrimitive = __webpack_require__(61);
	  var has = __webpack_require__(39);
	  var classof = __webpack_require__(108);
	  var isObject = __webpack_require__(9);
	  var toObject = __webpack_require__(18);
	  var isArrayIter = __webpack_require__(218);
	  var create = __webpack_require__(88);
	  var getPrototypeOf = __webpack_require__(41);
	  var gOPN = __webpack_require__(89).f;
	  var getIterFn = __webpack_require__(234);
	  var uid = __webpack_require__(95);
	  var wks = __webpack_require__(14);
	  var createArrayMethod = __webpack_require__(58);
	  var createArrayIncludes = __webpack_require__(152);
	  var speciesConstructor = __webpack_require__(130);
	  var ArrayIterators = __webpack_require__(235);
	  var Iterators = __webpack_require__(109);
	  var $iterDetect = __webpack_require__(157);
	  var setSpecies = __webpack_require__(93);
	  var arrayFill = __webpack_require__(210);
	  var arrayCopyWithin = __webpack_require__(319);
	  var $DP = __webpack_require__(17);
	  var $GOPD = __webpack_require__(40);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = AssetPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RadioButtonPicker = __webpack_require__(149);
	
	var _RadioButtonPicker2 = _interopRequireDefault(_RadioButtonPicker);
	
	var _PubKeyPicker = __webpack_require__(24);
	
	var _PubKeyPicker2 = _interopRequireDefault(_PubKeyPicker);
	
	var _PickerError = __webpack_require__(123);
	
	var _PickerError2 = _interopRequireDefault(_PickerError);
	
	// Value is a string containing the currently selected id (or undefined)
	
	function AssetPicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	
	  value = _lodash2['default'].assign({
	    type: '',
	    code: '',
	    issuer: ''
	  }, value);
	
	  var isCredit = value.type === 'credit_alphanum4' || value.type === 'credit_alphanum12';
	
	  var codePicker = undefined,
	      codePickerError = undefined,
	      inputPicker = undefined;
	  if (isCredit) {
	    codePicker = _react2['default'].createElement('input', { type: 'text',
	      value: value.code,
	      onChange: function (event) {
	        return onUpdate(_lodash2['default'].assign({}, props.value, {
	          code: event.target.value
	        }));
	      },
	      placeholder: 'Asset Code',
	      className: 'picker picker--textInput' });
	    codePickerError = _react2['default'].createElement(_PickerError2['default'], { message: codeValidator(value) });
	    inputPicker = _react2['default'].createElement(_PubKeyPicker2['default'], {
	      value: value.issuer,
	      onUpdate: function (issuer) {
	        return onUpdate(_lodash2['default'].assign({}, props.value, {
	          issuer: issuer
	        }));
	      },
	      placeholder: 'Issuer Account ID'
	    });
	  }
	
	  var assetButtons = {
	    'native': 'native',
	    'credit_alphanum4': 'Alphanumeric 4',
	    'credit_alphanum12': 'Alphanumeric 12'
	  };
	
	  if (props.disableNative) {
	    delete assetButtons.native;
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(_RadioButtonPicker2['default'], {
	      value: value.type,
	      onUpdate: function (typeValue) {
	        var newTypeValue = value.type === typeValue ? "" : typeValue;
	        onUpdate(_lodash2['default'].assign({}, props.value, {
	          type: newTypeValue,
	          code: newTypeValue ? "" : value.code,
	          issuer: newTypeValue ? "" : value.issuer
	        }));
	      },
	      className: isCredit ? 'picker--spaceBottom' : '',
	      items: assetButtons
	    }),
	    codePicker,
	    codePickerError,
	    inputPicker
	  );
	}
	
	function codeValidator(value) {
	  var minLength = undefined,
	      maxLength = undefined;
	  if (value.type === 'credit_alphanum4') {
	    minLength = 1;
	    maxLength = 4;
	  } else if (value.type === 'credit_alphanum12') {
	    minLength = 5;
	    maxLength = 12;
	  } else {
	    return;
	  }
	
	  var code = value.code || '';
	
	  if (code && !code.match(/^[a-zA-Z0-9]+$/g)) {
	    return 'Asset code must consist of only letters and numbers.';
	  } else if (code.length < minLength || code.length > maxLength) {
	    return 'Asset code must be between ' + minLength + ' and ' + maxLength + ' characters long.';
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _stellarSdk = __webpack_require__(23);
	
	var NETWORK = {
	  available: {
	    master: {
	      horizonURL: 'https://api.master.ssn.digital',
	      networkPassphrase: "ssn_master_network"
	    },
	    testing: {
	      horizonURL: 'https://api.testing.ssn.digital',
	      networkPassphrase: "ssn_testing_network"
	    },
	    production: {
	      horizonURL: 'https://api.ssn.digital',
	      networkPassphrase: "ssn_production_network"
	    }
	  },
	  defaultName: 'master'
	};
	
	exports['default'] = NETWORK;
	module.exports = exports['default'];

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(14)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(34)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 78 */
[1195, 95, 9, 39, 17, 7],
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var es5 = __webpack_require__(97);
	var Objectfreeze = es5.freeze;
	var util = __webpack_require__(13);
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};


/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateLocation = updateLocation;
	exports.loadState = loadState;
	var UPDATE_LOCATION = "UPDATE_LOCATION";
	exports.UPDATE_LOCATION = UPDATE_LOCATION;
	
	function updateLocation(slug) {
	  return {
	    type: UPDATE_LOCATION,
	    slug: slug
	  };
	}
	
	var LOAD_STATE = "LOAD_STATE";
	exports.LOAD_STATE = LOAD_STATE;
	
	function loadState(slug, queryObj) {
	  return {
	    type: LOAD_STATE,
	    slug: slug,
	    queryObj: queryObj
	  };
	}

/***/ }),
/* 86 */
369,
/* 87 */
[1185, 47, 330, 218, 3, 15, 234],
/* 88 */
[1196, 3, 336, 214, 227, 213, 216],
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(338);
	var hiddenKeys = __webpack_require__(214).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 90 */
[1201, 338, 214],
/* 91 */
379,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(35);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var dP = __webpack_require__(17);
	var DESCRIPTORS = __webpack_require__(16);
	var SPECIES = __webpack_require__(14)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 94 */
[1206, 49],
/* 95 */
245,
/* 96 */
[1211, 9],
/* 97 */
/***/ (function(module, exports) {

	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}


/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports) {

	// This standardizes all the slug strings into a simple map
	// These are used in to build the url and are the "page name"
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var SLUG = {
	  HOME: '',
	  ACCOUNT_CREATOR: 'account-creator',
	  EXPLORER: 'explorer',
	  TXBUILDER: 'txbuilder',
	  TXSIGNER: 'txsigner',
	  XDRVIEWER: 'xdr-viewer'
	};
	exports['default'] = SLUG;
	module.exports = exports['default'];

/***/ }),
/* 108 */
[1180, 45, 14],
/* 109 */
136,
/* 110 */
[1202, 17, 39, 14],
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var defined = __webpack_require__(59);
	var fails = __webpack_require__(7);
	var spaces = __webpack_require__(230);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = AmountPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositiveNumberPicker = __webpack_require__(307);
	
	var _PositiveNumberPicker2 = _interopRequireDefault(_PositiveNumberPicker);
	
	// AmountPicker picks a positive amount. It extends the PositiveNumberPicker and
	// adds validation rules IN ADDITION to the ones already present in PositiveNumberPicker.
	
	function AmountPicker(props) {
	  return _react2['default'].createElement(_PositiveNumberPicker2['default'], _extends({}, props, {
	    validator: function (value) {
	      if (value.charAt(0) === '-') {
	        return 'Amount can only be a positive number.';
	      } else if (!value.match(/^[0-9]*(\.[0-9]+){0,1}$/g)) {
	        return 'Amount can only contain numbers and a period for the decimal point.';
	      } else if (value.match(/\.([0-9]){8,}$/g)) {
	        return 'Amount can only support a precision of 7 decimals.';
	      }
	    }
	  }));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = OrderPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RadioButtonPicker = __webpack_require__(149);
	
	var _RadioButtonPicker2 = _interopRequireDefault(_RadioButtonPicker);
	
	function OrderPicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	
	  return _react2['default'].createElement(_RadioButtonPicker2['default'], {
	    value: value,
	    onUpdate: function (value) {
	      return onUpdate(value);
	    },
	    items: {
	      'asc': 'asc',
	      'desc': 'desc'
	    }
	  });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	// @param {string} [props.message] - Message will display only if a string is passed in
	
	var PickerError = (function (_React$Component) {
	  _inherits(PickerError, _React$Component);
	
	  function PickerError() {
	    _classCallCheck(this, PickerError);
	
	    _get(Object.getPrototypeOf(PickerError.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(PickerError, [{
	    key: 'render',
	    value: function render() {
	      var message = this.props.message;
	      if (_lodash2['default'].isString(message)) {
	        return _react2['default'].createElement(
	          'p',
	          { className: 'picker__errorMessage' },
	          message
	        );
	      }
	      return null;
	    }
	  }]);
	
	  return PickerError;
	})(_react2['default'].Component);
	
	exports['default'] = PickerError;
	module.exports = exports['default'];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	// @param {string} props.href - Url that the help mark links to. Currently required
	function HelpMark(props) {
	  return _react2["default"].createElement(
	    "a",
	    { href: props.href, className: "HelpMark", target: "_blank" },
	    _react2["default"].createElement(
	      "svg",
	      { width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" },
	      _react2["default"].createElement(
	        "g",
	        null,
	        _react2["default"].createElement("circle", { className: "HelpMark__circle", fill: "#E3E41E", cx: "10", cy: "10", r: "10" }),
	        _react2["default"].createElement("path", { className: "HelpMark__questionMark", d: "M9 12.73V10.2c.58-.25 1.08-.5 1.5-.73.42-.23.77-.46 1.05-.7.28-.24.48-.5.6-.75.15-.26.2-.55.2-.87 0-.5-.15-.9-.48-1.2-.33-.3-.83-.44-1.5-.44-.3 0-.55.04-.78.1A2.25 2.25 0 0 0 8.1 6.77l-1.7-1.04A3.8 3.8 0 0 1 7.9 4.26a5 5 0 0 1 2.45-.53c.57 0 1.1.06 1.62.2.5.1.94.3 1.3.58a2.9 2.9 0 0 1 1.22 2.47c0 .53-.1 1-.3 1.4-.2.4-.45.77-.78 1.1-.32.3-.7.6-1.13.86-.44.26-.88.5-1.34.74v1.66H9zm2.25 2.37c0 .45-.1.75-.3.92-.2.17-.52.25-.96.25-.25 0-.45-.02-.6-.07a.82.82 0 0 1-.6-.58 1.9 1.9 0 0 1-.06-.52c0-.4.1-.7.28-.9.2-.18.5-.27.97-.27.45 0 .78.1.96.28.2.2.3.5.3.9z", fill: "#3B4151" })
	      )
	    )
	  );
	};
	HelpMark.propTypes = {
	  href: _react2["default"].PropTypes.string.isRequired
	};
	
	exports["default"] = HelpMark;
	module.exports = exports["default"];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = For;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsTextPickerJs = __webpack_require__(22);
	
	var _FormComponentsTextPickerJs2 = _interopRequireDefault(_FormComponentsTextPickerJs);
	
	var _FormComponentsPositiveIntPickerJs = __webpack_require__(21);
	
	var _FormComponentsPositiveIntPickerJs2 = _interopRequireDefault(_FormComponentsPositiveIntPickerJs);
	
	var _FormComponentsOrderPickerJs = __webpack_require__(122);
	
	var _FormComponentsOrderPickerJs2 = _interopRequireDefault(_FormComponentsOrderPickerJs);
	
	// Helper that generates any of the other For SetupPanes.
	// Adds the new option row at the top with cursor, limit, and order below.
	
	// Required props:
	// - onUpdate
	// - values
	// - label
	// - optional
	// - content
	
	function For(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: props.label, optional: props.optional },
	      props.content
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Cursor', optional: true },
	      _react2['default'].createElement(_FormComponentsTextPickerJs2['default'], {
	        value: props.values['cursor'],
	        onUpdate: function (value) {
	          props.onUpdate('cursor', value);
	        },
	        key: 'cursor'
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Limit' },
	      _react2['default'].createElement(_FormComponentsPositiveIntPickerJs2['default'], {
	        value: props.values['limit'],
	        onUpdate: function (value) {
	          props.onUpdate('limit', value);
	        },
	        key: 'limit'
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Order' },
	      _react2['default'].createElement(_FormComponentsOrderPickerJs2['default'], {
	        value: props.values['order'],
	        onUpdate: function (value) {
	          props.onUpdate('order', value);
	        },
	        key: 'order'
	      })
	    ),
	    props.children
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(3);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 127 */
[1189, 45],
/* 128 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 129 */
[1204, 46, 5, 77],
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(3);
	var aFunction = __webpack_require__(27);
	var SPECIES = __webpack_require__(14)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.resetTxbuilder = resetTxbuilder;
	exports.updateAttributes = updateAttributes;
	exports.removeOperation = removeOperation;
	exports.updateOperationType = updateOperationType;
	exports.updateOperationAttributes = updateOperationAttributes;
	exports.reorderOperation = reorderOperation;
	exports.fetchSequence = fetchSequence;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(120);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _stellarSdk = __webpack_require__(23);
	
	// Resets everything to it's default state
	var RESET_TXBUILDER = 'RESET_TXBUILDER';
	exports.RESET_TXBUILDER = RESET_TXBUILDER;
	
	function resetTxbuilder() {
	  return {
	    type: RESET_TXBUILDER
	  };
	}
	
	// Attributes
	var UPDATE_ATTRIBUTES = 'UPDATE_ATTRIBUTES';
	exports.UPDATE_ATTRIBUTES = UPDATE_ATTRIBUTES;
	
	function updateAttributes(newAttributes) {
	  return {
	    type: UPDATE_ATTRIBUTES,
	    newAttributes: newAttributes
	  };
	}
	
	// Operations
	var ADD_OPERATION = 'ADD_OPERATION';
	exports.ADD_OPERATION = ADD_OPERATION;
	var addOperation = (function () {
	  return function () {
	    return {
	      type: ADD_OPERATION,
	      opId: Date.now()
	    };
	  };
	})();
	
	exports.addOperation = addOperation;
	var REMOVE_OPERATION = 'REMOVE_OPERATION';
	exports.REMOVE_OPERATION = REMOVE_OPERATION;
	
	function removeOperation(opId) {
	  return {
	    type: REMOVE_OPERATION,
	    opId: opId
	  };
	}
	
	var UPDATE_OPERATION_TYPE = 'UPDATE_OPERATION_TYPE';
	exports.UPDATE_OPERATION_TYPE = UPDATE_OPERATION_TYPE;
	
	function updateOperationType(opId, newType) {
	  return {
	    type: UPDATE_OPERATION_TYPE,
	    opId: opId,
	    newType: newType
	  };
	}
	
	var UPDATE_OPERATION_ATTRIBUTES = 'UPDATE_OPERATION_ATTRIBUTES';
	exports.UPDATE_OPERATION_ATTRIBUTES = UPDATE_OPERATION_ATTRIBUTES;
	
	function updateOperationAttributes(opId, newAttributes) {
	  return {
	    type: UPDATE_OPERATION_ATTRIBUTES,
	    opId: opId,
	    newAttributes: newAttributes
	  };
	}
	
	var REORDER_OPERATION = 'REORDER_OPERATION';
	exports.REORDER_OPERATION = REORDER_OPERATION;
	
	function reorderOperation(opId, toNth) {
	  return {
	    type: REORDER_OPERATION,
	    opId: opId,
	    toNth: toNth
	  };
	}
	
	var FETCH_SEQUENCE = 'FETCH_SEQUENCE';
	exports.FETCH_SEQUENCE = FETCH_SEQUENCE;
	var FETCH_SEQUENCE_START = 'FETCH_SEQUENCE_START';
	exports.FETCH_SEQUENCE_START = FETCH_SEQUENCE_START;
	var FETCH_SEQUENCE_FAIL = 'FETCH_SEQUENCE_FAIL';
	exports.FETCH_SEQUENCE_FAIL = FETCH_SEQUENCE_FAIL;
	var FETCH_SEQUENCE_SUCCESS = 'FETCH_SEQUENCE_SUCCESS';
	exports.FETCH_SEQUENCE_SUCCESS = FETCH_SEQUENCE_SUCCESS;
	// This is only meant to be used for fetching *next* sequence number for txbuilder
	
	function fetchSequence(accountId, horizonBaseUrl) {
	  return function (dispatch) {
	    dispatch({
	      type: FETCH_SEQUENCE_START
	    });
	    _axios2['default'].get(horizonBaseUrl + '/accounts/' + accountId).then(function (r) {
	      return dispatch({
	        type: FETCH_SEQUENCE_SUCCESS,
	        sequence: _stellarSdk.UnsignedHyper.fromString(r.data.sequence).add(1).toString()
	      });
	    })['catch'](function (r) {
	      return dispatch({ type: FETCH_SEQUENCE_FAIL, payload: r });
	    });
	  };
	}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilitiesClickToSelect = __webpack_require__(204);
	
	var _utilitiesClickToSelect2 = _interopRequireDefault(_utilitiesClickToSelect);
	
	// Clicking an EasySelect element will select the contents
	var EasySelect = _react2['default'].createClass({
	  displayName: 'EasySelect',
	
	  render: function render() {
	    var className = 'EasySelect';
	    if (this.props.plain) {
	      className += ' EasySelect__plain';
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      { className: className, onClick: _utilitiesClickToSelect2['default'] },
	      this.props.children
	    );
	  }
	});
	exports.EasySelect = EasySelect;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = BooleanPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RadioButtonPicker = __webpack_require__(149);
	
	var _RadioButtonPicker2 = _interopRequireDefault(_RadioButtonPicker);
	
	function BooleanPicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	
	  return _react2['default'].createElement(_RadioButtonPicker2['default'], {
	    value: value,
	    onUpdate: function (value) {
	      return onUpdate(value);
	    },
	    items: {
	      'true': 'true',
	      'false': 'false'
	    }
	  });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = RadioButtonPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	// @param {object} props.items An object whose keys are the onUpdate values and
	//   object values are labels the user will see.
	// {
	//   'valueToBeStored': 'Human Readable Label',
	// }
	
	function RadioButtonPicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	  var items = props.items;
	
	  var group = Math.random(); // Allows for tabbing and prevents radio button collisions
	
	  return _react2["default"].createElement(
	    "div",
	    { className: "s-buttonGroup picker picker--radio " + props.className },
	    _.map(items, function (label, id) {
	      return _react2["default"].createElement(
	        "label",
	        { className: "s-buttonGroup__wrapper", key: id },
	        _react2["default"].createElement("input", { type: "radio", className: "s-buttonGroup__radio",
	          name: group,
	          onChange: onUpdate.bind(null, id),
	          value: id,
	          checked: value === id }),
	        _react2["default"].createElement(
	          "span",
	          { className: "s-button s-button--light" },
	          label
	        )
	      );
	    })
	  );
	}
	
	module.exports = exports["default"];

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = ForAccount;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _For = __webpack_require__(125);
	
	var _For2 = _interopRequireDefault(_For);
	
	var _FormComponentsPubKeyPickerJs = __webpack_require__(24);
	
	var _FormComponentsPubKeyPickerJs2 = _interopRequireDefault(_FormComponentsPubKeyPickerJs);
	
	function ForAccount(props) {
	  var label = 'Account ID';
	  var content = _react2['default'].createElement(_FormComponentsPubKeyPickerJs2['default'], {
	    value: props.values['account_id'],
	    onUpdate: function (value) {
	      props.onUpdate('account_id', value);
	    }
	  });
	
	  return _react2['default'].createElement(_For2['default'], _extends({ label: label, content: content }, props));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	// This standardizes all the signatures verification states
	// into a single map.
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var FETCHED_SIGNERS = {
	  NONE: 'NONE',
	  PENDING: 'PENDING',
	  SUCCESS: 'SUCCESS',
	  FAIL: 'FAIL',
	  NOT_EXIST: 'NOT_EXIST'
	};
	exports['default'] = FETCHED_SIGNERS;
	module.exports = exports['default'];

/***/ }),
/* 152 */
[1176, 42, 15, 94],
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(35);
	var redefineAll = __webpack_require__(92);
	var meta = __webpack_require__(78);
	var forOf = __webpack_require__(87);
	var anInstance = __webpack_require__(86);
	var isObject = __webpack_require__(9);
	var fails = __webpack_require__(7);
	var $iterDetect = __webpack_require__(157);
	var setToStringTag = __webpack_require__(110);
	var inheritIfRequired = __webpack_require__(217);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(350);
	var redefine = __webpack_require__(35);
	var hide = __webpack_require__(34);
	var fails = __webpack_require__(7);
	var defined = __webpack_require__(59);
	var wks = __webpack_require__(14);
	var regexpExec = __webpack_require__(225);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 155 */
[1191, 45],
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(9);
	var cof = __webpack_require__(45);
	var MATCH = __webpack_require__(14)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(14)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(77) || !__webpack_require__(7)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(5)[K];
	});


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(108);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(27);
	var ctx = __webpack_require__(47);
	var forOf = __webpack_require__(87);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(1);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 163 */
[1205, 49, 59],
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var hide = __webpack_require__(34);
	var uid = __webpack_require__(95);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setNetworks = setNetworks;
	exports.setModalVisibility = setModalVisibility;
	exports.updateModal = updateModal;
	exports.chooseNetwork = chooseNetwork;
	exports.setCustomParams = setCustomParams;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constantsNetwork = __webpack_require__(75);
	
	var _constantsNetwork2 = _interopRequireDefault(_constantsNetwork);
	
	var SET_NETWORKS = "SET_NETWORKS";
	exports.SET_NETWORKS = SET_NETWORKS;
	
	function setNetworks(networks) {
	  return {
	    type: SET_NETWORKS,
	    networks: networks
	  };
	}
	
	var SHOW_MODAL = "SHOW_MODAL";
	exports.SHOW_MODAL = SHOW_MODAL;
	var HIDE_MODAL = "HIDE_MODAL";
	exports.HIDE_MODAL = HIDE_MODAL;
	
	function setModalVisibility(visible) {
	  return {
	    type: visible ? SHOW_MODAL : HIDE_MODAL
	  };
	}
	
	var UPDATE_MODAL = "UPDATE_MODAL";
	exports.UPDATE_MODAL = UPDATE_MODAL;
	
	function updateModal(key, value) {
	  return {
	    type: UPDATE_MODAL,
	    key: key,
	    value: value
	  };
	}
	
	var SET_PARAMS = "SET_PARAMS";
	exports.SET_PARAMS = SET_PARAMS;
	
	function chooseNetwork(name) {
	  return {
	    type: SET_PARAMS,
	    params: {
	      name: name,
	      horizonURL: _constantsNetwork2["default"].available[name].horizonURL,
	      networkPassphrase: _constantsNetwork2["default"].available[name].networkPassphrase
	    }
	  };
	}
	
	function setCustomParams(params) {
	  params.name = 'custom';
	  return {
	    type: SET_PARAMS,
	    params: params
	  };
	}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SelectPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	// @param {object|array} props.items An object whose keys are the onUpdate values and
	//   object values are labels the user will see.
	// {
	//   'valueToBeStored': 'Human Readable Label',
	// }
	//
	// For array values, the UI label and onUpdate values are the same.
	// The benefit of using an array is that it can contain duplicate items.
	
	function SelectPicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	  var items = props.items;
	
	  var optionsList = undefined;
	  if (_lodash2['default'].isArray(items)) {
	    optionsList = _lodash2['default'].map(items, function (value, index) {
	      return _react2['default'].createElement(
	        'option',
	        { key: index, value: value },
	        value
	      );
	    });
	  } else {
	    optionsList = _lodash2['default'].map(items, function (value, index) {
	      return _react2['default'].createElement(
	        'option',
	        { key: index, value: index },
	        value
	      );
	    });
	  }
	
	  var selectPlaceholderClass = undefined;
	  if (value === '') {
	    selectPlaceholderClass = 'so-dropdown__select--placeholder';
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    { className: 'so-dropdown ' + props.className },
	    _react2['default'].createElement(
	      'select',
	      {
	        className: 'picker picker--select so-dropdown__select ' + selectPlaceholderClass,
	        value: value,
	        onChange: function (event) {
	          return onUpdate(event.target.value);
	        }
	      },
	      _react2['default'].createElement(
	        'option',
	        { value: '' },
	        props.placeholder
	      ),
	      optionsList
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = GenericOffer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsPositiveNumberPickerJs = __webpack_require__(307);
	
	var _FormComponentsPositiveNumberPickerJs2 = _interopRequireDefault(_FormComponentsPositiveNumberPickerJs);
	
	var _FormComponentsAmountPickerJs = __webpack_require__(121);
	
	var _FormComponentsAmountPickerJs2 = _interopRequireDefault(_FormComponentsAmountPickerJs);
	
	var _FormComponentsAssetPickerJs = __webpack_require__(74);
	
	var _FormComponentsAssetPickerJs2 = _interopRequireDefault(_FormComponentsAssetPickerJs);
	
	function GenericOffer(props, isBuy) {
	  return [_react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Selling', key: 'selling' },
	    _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	      value: props.values['selling'],
	      onUpdate: function (value) {
	        props.onUpdate('selling', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Buying', key: 'buying' },
	    _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	      value: props.values['buying'],
	      onUpdate: function (value) {
	        props.onUpdate('buying', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    {
	      label: isBuy ? "Amount you are buying" : "Amount you are selling",
	      key: isBuy ? "buyAmount" : "amount"
	    },
	    _react2['default'].createElement(_FormComponentsAmountPickerJs2['default'], {
	      value: props.values[isBuy ? "buyAmount" : 'amount'],
	      onUpdate: function (value) {
	        props.onUpdate(isBuy ? "buyAmount" : 'amount', value);
	      }
	    }),
	    _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      'An amount of zero will delete the offer.'
	    )
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Price of 1 unit of asset sold in terms of asset bought', key: 'price' },
	    _react2['default'].createElement(_FormComponentsPositiveNumberPickerJs2['default'], {
	      value: props.values['price'],
	      onUpdate: function (value) {
	        props.onUpdate('price', value);
	      }
	    })
	  )];
	}
	
	module.exports = exports['default'];

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = All;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsTextPickerJs = __webpack_require__(22);
	
	var _FormComponentsTextPickerJs2 = _interopRequireDefault(_FormComponentsTextPickerJs);
	
	var _FormComponentsPositiveIntPickerJs = __webpack_require__(21);
	
	var _FormComponentsPositiveIntPickerJs2 = _interopRequireDefault(_FormComponentsPositiveIntPickerJs);
	
	var _FormComponentsOrderPickerJs = __webpack_require__(122);
	
	var _FormComponentsOrderPickerJs2 = _interopRequireDefault(_FormComponentsOrderPickerJs);
	
	function All(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Cursor', optional: true },
	      _react2['default'].createElement(_FormComponentsTextPickerJs2['default'], {
	        value: props.values['cursor'],
	        onUpdate: function (value) {
	          props.onUpdate('cursor', value);
	        },
	        key: 'cursor'
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Limit' },
	      _react2['default'].createElement(_FormComponentsPositiveIntPickerJs2['default'], {
	        value: props.values['limit'],
	        onUpdate: function (value) {
	          props.onUpdate('limit', value);
	        },
	        key: 'limit'
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Order' },
	      _react2['default'].createElement(_FormComponentsOrderPickerJs2['default'], {
	        value: props.values['order'],
	        onUpdate: function (value) {
	          props.onUpdate('order', value);
	        },
	        key: 'order'
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = AllWithFailed;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsTextPickerJs = __webpack_require__(22);
	
	var _FormComponentsTextPickerJs2 = _interopRequireDefault(_FormComponentsTextPickerJs);
	
	var _FormComponentsPositiveIntPickerJs = __webpack_require__(21);
	
	var _FormComponentsPositiveIntPickerJs2 = _interopRequireDefault(_FormComponentsPositiveIntPickerJs);
	
	var _FormComponentsOrderPickerJs = __webpack_require__(122);
	
	var _FormComponentsOrderPickerJs2 = _interopRequireDefault(_FormComponentsOrderPickerJs);
	
	var _FormComponentsBooleanPicker = __webpack_require__(148);
	
	var _FormComponentsBooleanPicker2 = _interopRequireDefault(_FormComponentsBooleanPicker);
	
	function AllWithFailed(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Cursor', optional: true },
	      _react2['default'].createElement(_FormComponentsTextPickerJs2['default'], {
	        value: props.values['cursor'],
	        onUpdate: function (value) {
	          props.onUpdate('cursor', value);
	        },
	        key: 'cursor'
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Limit' },
	      _react2['default'].createElement(_FormComponentsPositiveIntPickerJs2['default'], {
	        value: props.values['limit'],
	        onUpdate: function (value) {
	          props.onUpdate('limit', value);
	        },
	        key: 'limit'
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Order' },
	      _react2['default'].createElement(_FormComponentsOrderPickerJs2['default'], {
	        value: props.values['order'],
	        onUpdate: function (value) {
	          props.onUpdate('order', value);
	        },
	        key: 'order'
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Include failed' },
	      _react2['default'].createElement(_FormComponentsBooleanPicker2['default'], {
	        value: props.values['include_failed'],
	        onUpdate: function (value) {
	          props.onUpdate('include_failed', value);
	        },
	        key: 'include_failed'
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = ForAccountWithFailed;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _ForAccount = __webpack_require__(150);
	
	var _ForAccount2 = _interopRequireDefault(_ForAccount);
	
	var _FormComponentsBooleanPicker = __webpack_require__(148);
	
	var _FormComponentsBooleanPicker2 = _interopRequireDefault(_FormComponentsBooleanPicker);
	
	function ForAccountWithFailed(props) {
	  return _react2['default'].createElement(
	    _ForAccount2['default'],
	    props,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Include failed' },
	      _react2['default'].createElement(_FormComponentsBooleanPicker2['default'], {
	        value: props.values['include_failed'],
	        onUpdate: function (value) {
	          props.onUpdate('include_failed', value);
	        },
	        key: 'include_failed'
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = ForLedgerWithFailed;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _ForLedger = __webpack_require__(310);
	
	var _ForLedger2 = _interopRequireDefault(_ForLedger);
	
	var _FormComponentsBooleanPicker = __webpack_require__(148);
	
	var _FormComponentsBooleanPicker2 = _interopRequireDefault(_FormComponentsBooleanPicker);
	
	function ForLedgerWithFailed(props) {
	  return _react2['default'].createElement(
	    _ForLedger2['default'],
	    props,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Include failed' },
	      _react2['default'].createElement(_FormComponentsBooleanPicker2['default'], {
	        value: props.values['include_failed'],
	        onUpdate: function (value) {
	          props.onUpdate('include_failed', value);
	        },
	        key: 'include_failed'
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = ForTransaction;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _For = __webpack_require__(125);
	
	var _For2 = _interopRequireDefault(_For);
	
	var _FormComponentsTransactionPickerJs = __webpack_require__(308);
	
	var _FormComponentsTransactionPickerJs2 = _interopRequireDefault(_FormComponentsTransactionPickerJs);
	
	function ForTransaction(props) {
	  var label = 'Transaction Hash';
	  var content = _react2['default'].createElement(_FormComponentsTransactionPickerJs2['default'], {
	    value: props.values['transaction'],
	    onUpdate: function (value) {
	      props.onUpdate('transaction', value);
	    }
	  });
	
	  return _react2['default'].createElement(_For2['default'], _extends({ label: label, content: content }, props));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.getEndpoint = getEndpoint;
	exports.getTemplate = getTemplate;
	
	function getEndpoint(resource, endpoint) {
	  var res = endpointsMap[resource];
	  if (!res) {
	    return;
	  }
	
	  return res.endpoints[endpoint];
	}
	
	function getTemplate() {
	  var ep = getEndpoint.apply(undefined, arguments);
	  if (!ep) {
	    return;
	  }
	
	  return ep.path;
	}
	
	var endpointsMap = {
	  'accounts': {
	    'label': 'Accounts',
	    'endpoints': {
	      'single': {
	        'label': 'Single Account',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/accounts-single.html',
	        'method': 'GET',
	        'path': {
	          template: '/accounts/{account_id}'
	        },
	        'setupComponent': __webpack_require__(545)
	      }
	    }
	  },
	  'assets': {
	    'label': 'Assets',
	    'endpoints': {
	      'single': {
	        'label': 'All Assets',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/endpoints/assets-all.html',
	        'method': 'GET',
	        'path': {
	          template: '/assets{?asset_code,asset_issuer,cursor,order,limit}'
	        },
	        'setupComponent': __webpack_require__(539)
	      }
	    }
	  },
	  'effects': {
	    'label': 'Effects',
	    'endpoints': {
	      'all': {
	        'label': 'All Effects',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/effects-all.html',
	        'method': 'GET',
	        'path': {
	          template: '/effects{?cursor,limit,order}'
	        },
	        'setupComponent': __webpack_require__(197)
	      },
	      'for_account': {
	        'label': 'Effects for Account',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/effects-for-account.html',
	        'method': 'GET',
	        'path': {
	          template: '/accounts/{account_id}/effects{?cursor,limit,order}'
	        },
	        'setupComponent': __webpack_require__(150)
	      },
	      'for_ledger': {
	        'label': 'Effects for Ledger',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/effects-for-ledger.html',
	        'method': 'GET',
	        'path': {
	          template: '/ledgers/{ledger}/effects{?cursor,limit,order}'
	        },
	        'setupComponent': __webpack_require__(310)
	      },
	      'for_operation': {
	        'label': 'Effects for Operation',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/effects-for-operation.html',
	        'method': 'GET',
	        'path': {
	          template: '/operations/{operation}/effects{?cursor,limit,order}'
	        },
	        'setupComponent': __webpack_require__(542)
	      },
	      'for_transaction': {
	        'label': 'Effects for Transaction',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/effects-for-transaction.html',
	        'method': 'GET',
	        'path': {
	          template: '/transactions/{transaction}/effects{?cursor,limit,order}'
	        },
	        'setupComponent': __webpack_require__(201)
	      }
	    }
	  },
	  'ledgers': {
	    'label': 'Ledger',
	    'endpoints': {
	      'all': {
	        'label': 'All Ledgers',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/ledgers-all.html',
	        'method': 'GET',
	        'path': {
	          template: '/ledgers{?cursor,limit,order}'
	        },
	        'setupComponent': __webpack_require__(197)
	      },
	      'single': {
	        'label': 'Single Ledger',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/ledgers-single.html',
	        'method': 'GET',
	        'path': {
	          template: '/ledgers/{ledger}'
	        },
	        'setupComponent': __webpack_require__(546)
	      }
	    }
	  },
	  'offers': {
	    'label': 'Offers',
	    'endpoints': {
	      'for_account': {
	        'label': 'Offers for Account',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/offers-for-account.html',
	        'method': 'GET',
	        'path': {
	          template: '/accounts/{account_id}/offers{?cursor,limit,order}'
	        },
	        'setupComponent': __webpack_require__(150)
	      }
	    }
	  },
	  'operations': {
	    'label': 'Operations',
	    'endpoints': {
	      'all': {
	        'label': 'All Operations',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/operations-all.html',
	        'method': 'GET',
	        'path': {
	          template: '/operations{?cursor,limit,order,include_failed}'
	        },
	        'setupComponent': __webpack_require__(198)
	      },
	      'single': {
	        'label': 'Single Operation',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/operations-single.html',
	        'method': 'GET',
	        'path': {
	          template: '/operations/{operation}'
	        },
	        'setupComponent': __webpack_require__(547)
	      },
	      'for_account': {
	        'label': 'Operations for Account',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/operations-for-account.html',
	        'method': 'GET',
	        'path': {
	          template: '/accounts/{account_id}/operations{?cursor,limit,order,include_failed}'
	        },
	        'setupComponent': __webpack_require__(199)
	      },
	      'for_ledger': {
	        'label': 'Operations for Ledger',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/operations-for-ledger.html',
	        'method': 'GET',
	        'path': {
	          template: '/ledgers/{ledger}/operations{?cursor,limit,order,include_failed}'
	        },
	        'setupComponent': __webpack_require__(200)
	      },
	      'for_transaction': {
	        'label': 'Operations for Transaction',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/operations-for-transaction.html',
	        'method': 'GET',
	        'path': {
	          template: '/transactions/{transaction}/operations{?cursor,limit,order}'
	        },
	        'setupComponent': __webpack_require__(201)
	      }
	    }
	  },
	  'order_book': {
	    'label': 'Order Book',
	    'endpoints': {
	      'details': {
	        'label': 'Details',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/orderbook-details.html',
	        'method': 'GET',
	        'path': {
	          template: '/order_book{?selling_asset_type,selling_asset_code,selling_asset_issuer,buying_asset_type,buying_asset_code,buying_asset_issuer}',
	          'selling_asset_type': 'selling_asset.type',
	          'selling_asset_code': 'selling_asset.code',
	          'selling_asset_issuer': 'selling_asset.issuer',
	          'buying_asset_type': 'buying_asset.type',
	          'buying_asset_code': 'buying_asset.code',
	          'buying_asset_issuer': 'buying_asset.issuer'
	        },
	        'setupComponent': __webpack_require__(543)
	      }
	    }
	  },
	  'paths': {
	    'label': 'Paths',
	    'endpoints': {
	      'all': {
	        'label': 'Find Payment Paths',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/path-finding.html',
	        'method': 'GET',
	        'path': {
	          template: '/paths{?source_account,destination_account,destination_asset_type,destination_asset_code,destination_asset_issuer,destination_amount}',
	          'destination_asset_type': 'destination_asset.type',
	          'destination_asset_code': 'destination_asset.code',
	          'destination_asset_issuer': 'destination_asset.issuer'
	        },
	        'setupComponent': __webpack_require__(540)
	      }
	    }
	  },
	  'payments': {
	    'label': 'Payments',
	    'endpoints': {
	      'all': {
	        'label': 'All Payments',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/payments-all.html',
	        'method': 'GET',
	        'path': {
	          template: '/payments{?cursor,limit,order,include_failed}'
	        },
	        'setupComponent': __webpack_require__(198)
	      },
	      'for_account': {
	        'label': 'Payments for Account',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/payments-for-account.html',
	        'method': 'GET',
	        'path': {
	          template: '/accounts/{account_id}/payments{?cursor,limit,order,include_failed}'
	        },
	        'setupComponent': __webpack_require__(199)
	      },
	      'for_ledger': {
	        'label': 'Payments for Ledger',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/payments-for-ledger.html',
	        'method': 'GET',
	        'path': {
	          template: '/ledgers/{ledger}/payments{?cursor,limit,order,include_failed}'
	        },
	        'setupComponent': __webpack_require__(200)
	      },
	      'for_transaction': {
	        'label': 'Payments for Transaction',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/payments-for-transaction.html',
	        'method': 'GET',
	        'path': {
	          template: '/transactions/{transaction}/payments{?cursor,limit,order}'
	        },
	        'setupComponent': __webpack_require__(201)
	      }
	    }
	  },
	  'trade_aggregations': {
	    'label': 'Trade Aggregations',
	    'endpoints': {
	      'all': {
	        'label': 'Trade Aggregations',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/endpoints/trade_aggregations.html',
	        'method': 'GET',
	        'path': {
	          template: '/trade_aggregations{?base_asset_type,base_asset_code,base_asset_issuer,counter_asset_type,counter_asset_code,counter_asset_issuer,start_time,end_time,resolution,limit,order}',
	          'base_asset_type': 'base_asset.type',
	          'base_asset_code': 'base_asset.code',
	          'base_asset_issuer': 'base_asset.issuer',
	          'counter_asset_type': 'counter_asset.type',
	          'counter_asset_code': 'counter_asset.code',
	          'counter_asset_issuer': 'counter_asset.issuer',
	          'start_time': 'start_time',
	          'end_time': 'end_time',
	          'resolution': 'resolution'
	        },
	        'setupComponent': __webpack_require__(549)
	      }
	    }
	  },
	  'trades': {
	    'label': 'Trades',
	    'endpoints': {
	      'all': {
	        'label': 'All Trades',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/endpoints/trades.html',
	        'method': 'GET',
	        'path': {
	          template: '/trades{?base_asset_type,base_asset_code,base_asset_issuer,counter_asset_type,counter_asset_code,counter_asset_issuer,offer_id,cursor,limit,order}',
	          'base_asset_type': 'base_asset.type',
	          'base_asset_code': 'base_asset.code',
	          'base_asset_issuer': 'base_asset.issuer',
	          'counter_asset_type': 'counter_asset.type',
	          'counter_asset_code': 'counter_asset.code',
	          'counter_asset_issuer': 'counter_asset.issuer',
	          'offer_id': 'offer_id'
	        },
	        'setupComponent': __webpack_require__(550)
	      },
	      'for_account': {
	        'label': 'Trades for Account',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/trades-for-account.html',
	        'method': 'GET',
	        'path': {
	          template: '/accounts/{account_id}/trades{?cursor,limit,order}'
	        },
	        'setupComponent': __webpack_require__(150)
	      },
	      'for_offer': {
	        'label': 'Trades for Offer',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/trades-for-offer.html',
	        'method': 'GET',
	        'path': {
	          template: '/offers/{offer_id}/trades{?cursor,limit,order}'
	        },
	        'setupComponent': __webpack_require__(541)
	      }
	    }
	  },
	  'transactions': {
	    'label': 'Transactions',
	    'endpoints': {
	      'all': {
	        'label': 'All Transactions',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/transactions-all.html',
	        'method': 'GET',
	        'path': {
	          template: '/transactions{?cursor,limit,order,include_failed}'
	        },
	        'setupComponent': __webpack_require__(198)
	      },
	      'single': {
	        'label': 'Single Transaction',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/transactions-single.html',
	        'method': 'GET',
	        'path': {
	          template: '/transactions/{transaction}'
	        },
	        'setupComponent': __webpack_require__(548)
	      },
	      'create': {
	        'label': 'Post Transaction',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/transactions-create.html',
	        'method': 'POST',
	        'disableStreaming': true,
	        'path': {
	          template: '/transactions'
	        },
	        'setupComponent': __webpack_require__(544)
	      },
	      'for_account': {
	        'label': 'Transactions for Account',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/transactions-for-account.html',
	        'method': 'GET',
	        'path': {
	          template: '/accounts/{account_id}/transactions{?cursor,limit,order,include_failed}'
	        },
	        'setupComponent': __webpack_require__(199)
	      },
	      'for_ledger': {
	        'label': 'Transactions for Ledger',
	        'helpUrl': 'https://www.stellar.org/developers/horizon/reference/transactions-for-ledger.html',
	        'method': 'GET',
	        'path': {
	          template: '/ledgers/{ledger}/transactions{?cursor,limit,order,include_failed}'
	        },
	        'setupComponent': __webpack_require__(200)
	      }
	    }
	  }
	};
	exports.endpointsMap = endpointsMap;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.getOperation = getOperation;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function getOperation(opName) {
	  return _lodash2['default'].find(operationsMap, { name: opName });
	}
	
	// Operations map documentation:
	// [ // In an array because we really want this to be ordered correctly (whereas for params, it is not as important)
	//   {
	//     name: 'createAccount', // Corresponds to the operation key in js-stellar-sdk.Operation
	//     label: 'Create Account', // Human friendly name for the operation
	//     operationPane: require('../components/OperationPanes/CreateAccount'), // React component that contains the multiple pickers for this operation
	//   },
	// ]
	
	var operationsMap = [{
	  name: 'createAccount',
	  label: 'Create Account',
	  operationPane: __webpack_require__(531),
	  helpNote: 'Creates and funds a new account with the specified starting balance.',
	  docsUrl: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html#create-account'
	}, {
	  name: 'payment',
	  label: 'Payment',
	  operationPane: __webpack_require__(536),
	  helpNote: 'Sends an amount in a specific asset to a destination account.',
	  docsUrl: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html#payment'
	}, {
	  name: 'pathPayment',
	  label: 'Path Payment',
	  operationPane: __webpack_require__(535),
	  helpNote: 'Sends an amount in a specific asset to a destination account through a path of offers. This allows the asset sent (e.g., 450 XLM) to be different from the asset received (e.g, 6 BTC).',
	  docsUrl: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html#path-payment'
	}, {
	  name: 'manageSellOffer',
	  label: 'Manage Sell Offer',
	  operationPane: __webpack_require__(534),
	  helpNote: 'Creates, updates, or deletes an offer.',
	  docsUrl: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html#manage-offer'
	}, {
	  name: 'manageBuyOffer',
	  label: 'Manage Buy Offer',
	  operationPane: __webpack_require__(532),
	  helpNote: 'Creates, updates, or deletes an offer.',
	  docsUrl: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html#manage-offer'
	}, {
	  name: 'createPassiveSellOffer',
	  label: 'Create Passive Sell Offer',
	  operationPane: __webpack_require__(196),
	  helpNote: 'Creates an offer that does not take another offer of equal price when created.',
	  docsUrl: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html#create-passive-offer'
	}, {
	  name: 'setOptions',
	  label: 'Set Options',
	  operationPane: __webpack_require__(537),
	  helpNote: 'Sets various configuration options for an account.',
	  docsUrl: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html#set-options'
	}, {
	  name: 'changeTrust',
	  label: 'Change Trust',
	  operationPane: __webpack_require__(530),
	  helpNote: 'Creates, updates, or deletes a trustline.',
	  docsUrl: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html#change-trust'
	}, {
	  name: 'allowTrust',
	  label: 'Allow Trust',
	  operationPane: __webpack_require__(528),
	  helpNote: 'Updates the authorized flag of an existing trustline.',
	  docsUrl: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html#allow-trust'
	}, {
	  name: 'accountMerge',
	  label: 'Account Merge',
	  operationPane: __webpack_require__(527),
	  helpNote: 'Transfers the native balance (the amount of XLM an account holds) to another account and removes the source account from the ledger.',
	  docsUrl: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html#account-merge'
	}, {
	  name: 'inflation',
	  label: 'Inflation',
	  operationPane: function operationPane() {
	    return [];
	  }, // empty operation pane
	  helpNote: 'Runs the weekly inflation',
	  docsUrl: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html#inflation'
	}, {
	  name: 'manageData',
	  label: 'Manage Data',
	  operationPane: __webpack_require__(533),
	  helpNote: 'Sets, modifies, or deletes a Data Entry (name/value pair).',
	  docsUrl: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html#manage-data'
	}, {
	  name: 'bumpSequence',
	  label: 'Bump Sequence',
	  operationPane: __webpack_require__(529),
	  helpNote: 'Bumps sequence number.',
	  docsUrl: 'https://www.stellar.org/developers/guides/concepts/list-of-operations.html#bump-sequence'
	}];
	exports.operationsMap = operationsMap;

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	// DOM helper. When an element has clickToSelect and a users clicks on the element,
	// then the whole element will be selected/highlighted.
	
	// usage: <Element onClick={clickToSelect} />
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = clickToSelect;
	
	function clickToSelect(event) {
	  var range = document.createRange();
	  range.selectNodeContents(event.target);
	  window.getSelection().removeAllRanges();
	  window.getSelection().addRange(range);
	}
	
	;
	module.exports = exports["default"];

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var errorMessage = 'Unable to parse values passed in url query parameters';
	
	var rehydrate = function rehydrate(obj) {
	  try {
	    return JSON.parse(new Buffer(obj, 'base64').toString());
	  } catch (e) {
	    if (typeof alert !== 'undefined') {
	      alert(errorMessage);
	    } else {
	      console.error(errorMessage);
	    }
	    return {};
	  }
	};
	
	exports.rehydrate = rehydrate;
	var dehydrate = function dehydrate(obj) {
	  return new Buffer(JSON.stringify(obj)).toString('base64');
	};
	exports.dehydrate = dehydrate;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10).Buffer))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.txSignerLink = txSignerLink;
	exports.txPostLink = txPostLink;
	exports.xdrViewer = xdrViewer;
	exports.singleAccount = singleAccount;
	exports.horizonUrlToExplorerLink = horizonUrlToExplorerLink;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stateSerializer = __webpack_require__(316);
	
	var _url = __webpack_require__(119);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _constantsSlug = __webpack_require__(107);
	
	var _constantsSlug2 = _interopRequireDefault(_constantsSlug);
	
	var _horizonUrlParser = __webpack_require__(568);
	
	var _horizonUrlParser2 = _interopRequireDefault(_horizonUrlParser);
	
	// The linkBuilder attempts to abstract the specific details of the store so that
	// consumers of linkBuilder need to know very little to be able to generate a link.
	
	// These functions will return `undefined` if a link could not be producted with
	// the given info
	
	function txSignerLink(xdr) {
	  var query = (0, _stateSerializer.stateToQueryObj)(_constantsSlug2['default'].TXSIGNER, {
	    transactionSigner: {
	      xdr: xdr
	    }
	  });
	  return hashBuilder(_constantsSlug2['default'].TXSIGNER, query);
	}
	
	function txPostLink(xdr) {
	  var query = (0, _stateSerializer.stateToQueryObj)(_constantsSlug2['default'].EXPLORER, {
	    endpointExplorer: {
	      currentEndpoint: 'create',
	      currentResource: 'transactions',
	      pendingRequest: {
	        values: {
	          tx: xdr
	        }
	      }
	    }
	  });
	  return hashBuilder(_constantsSlug2['default'].EXPLORER, query);
	}
	
	function xdrViewer(xdr, type) {
	  var query = (0, _stateSerializer.stateToQueryObj)(_constantsSlug2['default'].XDRVIEWER, {
	    xdrViewer: {
	      input: xdr,
	      type: type
	    }
	  });
	  return hashBuilder(_constantsSlug2['default'].XDRVIEWER, query);
	}
	
	// explorerEndpoint is a helper function that generates a link from values
	// mirroring the structure of the endpointExplorer reducer. We should try to
	// abstract this with other functions with simpler arguments to reduce
	// complexity and dependence on understanding the reducers.
	function explorerEndpoint(resource, endpoint, values) {
	  var query = (0, _stateSerializer.stateToQueryObj)(_constantsSlug2['default'].EXPLORER, {
	    endpointExplorer: {
	      currentResource: resource,
	      currentEndpoint: endpoint,
	      pendingRequest: {
	        values: values
	      }
	    }
	  });
	  return hashBuilder(_constantsSlug2['default'].EXPLORER, query);
	}
	
	function singleAccount(accountId) {
	  return explorerEndpoint('accounts', 'single', {
	    'account_id': accountId
	  });
	}
	
	function horizonUrlToExplorerLink(horizonUrl) {
	  var urlInfo = (0, _horizonUrlParser2['default'])(horizonUrl);
	  if (typeof urlInfo === 'undefined') {
	    return;
	  }
	
	  return explorerEndpoint(urlInfo.resource, urlInfo.endpoint, urlInfo.params);
	}
	
	// Simply takes in a slug and a object and converts it into a hash url.
	// Example input:
	// slug: foo
	// query: {happy: 'yes'}
	//
	// Example returns: #foo?happy=yes
	function hashBuilder(slug, query) {
	  var urlObj = {
	    pathname: slug,
	    query: query
	  };
	  return '#' + _url2['default'].format(urlObj);
	}

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	// scrollOnAnchorOpen is a function that can be used in the onClick of an element.
	// When an event bubbles up to this handler with the target being an anchor link,
	// this will scroll the user to the top of the page.
	
	// This will also handle the edgecase to not scroll when the link is targeting
	// a different tab.
	// It will only scroll the user if the url is now the same as that of the link.
	
	// Edgecase: This won't detect context menu link opens.
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = scrollOnAnchorOpen;
	
	function scrollOnAnchorOpen(event) {
	  if (isScrollEligible(event)) {
	    window.scrollTo(0, 0);
	    event.target.blur();
	  }
	}
	
	function isScrollEligible(event, initialWindowLocation) {
	  if (event.target.tagName !== 'A') {
	    return false;
	  } // not A tag
	  if (event.target.target !== '') {
	    return false;
	  } // non-empty target attr (such as _blank)
	  if (typeof event.target.href !== 'string') {
	    return false;
	  } // target anchor has no href
	
	  // If user used any keyboard modifiers, then they might be opening in a new
	  // tab or window.. Won't be completely accurate but it should improve the
	  // experience for the most common cases. It is better to scroll too much than
	  // too little.
	
	  // NOTE: Another method to achieve this is to check that the window.location.href
	  // changes before and after. This works great except that links that go to the
	  // current page also get detected as "not changed". This gets really confusing
	  // since the click doesn't scroll the window.
	  if (event.metaKey || event.shiftKey || event.ctrlKey) {
	    return false;
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = validateTxXdr;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _stellarSdk = __webpack_require__(23);
	
	var _validateBase64 = __webpack_require__(317);
	
	var _validateBase642 = _interopRequireDefault(_validateBase64);
	
	function validateTxXdr(input) {
	  input = _lodash2['default'].trim(input);
	
	  var base64Validation = (0, _validateBase642['default'])(input);
	  if (base64Validation.result !== 'success') {
	    return base64Validation;
	  }
	
	  try {
	    new _stellarSdk.Transaction(input);
	    return {
	      result: 'success',
	      message: 'Valid Transaction Envelope XDR'
	    };
	  } catch (e) {
	    return {
	      result: 'error',
	      message: 'Unable to parse input XDR into Transaction Envelope'
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(163)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(18);
	var toAbsoluteIndex = __webpack_require__(94);
	var toLength = __webpack_require__(15);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 211 */
[1179, 574],
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(17);
	var createDesc = __webpack_require__(91);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 213 */
[1184, 9, 5],
/* 214 */
371,
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(14)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 216 */
[1187, 5],
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(9);
	var setPrototypeOf = __webpack_require__(226).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 218 */
[1190, 109, 14],
/* 219 */
[1193, 88, 91, 110, 34, 14],
/* 220 */
[1194, 77, 1, 35, 34, 109, 219, 110, 41, 14],
/* 221 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 222 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var macrotask = __webpack_require__(231).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(45)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(27);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(126);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(9);
	var anObject = __webpack_require__(3);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(47)(Function.call, __webpack_require__(40).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 227 */
[1203, 129, 95],
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(156);
	var defined = __webpack_require__(59);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(49);
	var defined = __webpack_require__(59);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(47);
	var invoke = __webpack_require__(328);
	var html = __webpack_require__(216);
	var cel = __webpack_require__(213);
	var global = __webpack_require__(5);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(45)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var DESCRIPTORS = __webpack_require__(16);
	var LIBRARY = __webpack_require__(77);
	var $typed = __webpack_require__(164);
	var hide = __webpack_require__(34);
	var redefineAll = __webpack_require__(92);
	var fails = __webpack_require__(7);
	var anInstance = __webpack_require__(86);
	var toInteger = __webpack_require__(49);
	var toLength = __webpack_require__(15);
	var toIndex = __webpack_require__(347);
	var gOPN = __webpack_require__(89).f;
	var dP = __webpack_require__(17).f;
	var arrayFill = __webpack_require__(210);
	var setToStringTag = __webpack_require__(110);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(46);
	var LIBRARY = __webpack_require__(77);
	var wksExt = __webpack_require__(348);
	var defineProperty = __webpack_require__(17).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 234 */
[1213, 108, 14, 109, 46],
/* 235 */
[1214, 76, 331, 109, 42, 220],
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(70),
	    getPrototype = __webpack_require__(255),
	    isObjectLike = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StatusCodes = exports.DBNotReset = exports.DBWrongPassword = exports.NoDBPathGiven = exports.FirmwareOrAppUpdateRequired = exports.LedgerAPI5xx = exports.LedgerAPI4xx = exports.GenuineCheckFailed = exports.PairingFailed = exports.SyncError = exports.FeeRequired = exports.FeeNotLoaded = exports.CantScanQRCode = exports.ETHAddressNonEIP = exports.WrongDeviceForAccount = exports.WebsocketConnectionFailed = exports.WebsocketConnectionError = exports.DeviceShouldStayInApp = exports.TransportInterfaceNotAvailable = exports.TransportOpenUserCancelled = exports.UserRefusedOnDevice = exports.UserRefusedAllowManager = exports.UserRefusedFirmwareUpdate = exports.UserRefusedAddress = exports.UserRefusedDeviceNameChange = exports.UpdateYourApp = exports.UnexpectedBootloader = exports.TimeoutTagged = exports.PasswordIncorrectError = exports.PasswordsDontMatchError = exports.NotEnoughBalanceBecauseDestinationNotCreated = exports.NotEnoughBalance = exports.NoAddressesFound = exports.NetworkDown = exports.ManagerUninstallBTCDep = exports.ManagerNotEnoughSpaceError = exports.ManagerDeviceLockedError = exports.ManagerAppRelyOnBTCError = exports.ManagerAppAlreadyInstalledError = exports.LedgerAPINotAvailable = exports.LedgerAPIErrorWithMessage = exports.LedgerAPIError = exports.UnknownMCU = exports.LatestMCUInstalledError = exports.InvalidAddressBecauseDestinationIsAlsoSource = exports.InvalidAddress = exports.HardResetFail = exports.FeeEstimationFailed = exports.EthAppPleaseEnableContractData = exports.EnpointConfigError = exports.DisconnectedDeviceDuringOperation = exports.DisconnectedDevice = exports.DeviceSocketNoBulkStatus = exports.DeviceSocketFail = exports.DeviceNameInvalid = exports.DeviceHalted = exports.DeviceInOSUExpected = exports.DeviceOnDashboardExpected = exports.DeviceNotGenuineError = exports.DeviceGenuineSocketEarlyClose = exports.DeviceAppVerifyNotSupported = exports.CantOpenDevice = exports.BtcUnmatchedApp = exports.BluetoothRequired = exports.AccountNameRequiredError = exports.addCustomErrorDeserializer = exports.createCustomErrorClass = exports.deserializeError = exports.serializeError = undefined;
	exports.TransportError = TransportError;
	exports.getAltStatusMessage = getAltStatusMessage;
	exports.TransportStatusError = TransportStatusError;
	
	var _helpers = __webpack_require__(488);
	
	exports.serializeError = _helpers.serializeError;
	exports.deserializeError = _helpers.deserializeError;
	exports.createCustomErrorClass = _helpers.createCustomErrorClass;
	exports.addCustomErrorDeserializer = _helpers.addCustomErrorDeserializer;
	var AccountNameRequiredError = exports.AccountNameRequiredError = (0, _helpers.createCustomErrorClass)("AccountNameRequired");
	var BluetoothRequired = exports.BluetoothRequired = (0, _helpers.createCustomErrorClass)("BluetoothRequired");
	var BtcUnmatchedApp = exports.BtcUnmatchedApp = (0, _helpers.createCustomErrorClass)("BtcUnmatchedApp");
	var CantOpenDevice = exports.CantOpenDevice = (0, _helpers.createCustomErrorClass)("CantOpenDevice");
	var DeviceAppVerifyNotSupported = exports.DeviceAppVerifyNotSupported = (0, _helpers.createCustomErrorClass)("DeviceAppVerifyNotSupported");
	var DeviceGenuineSocketEarlyClose = exports.DeviceGenuineSocketEarlyClose = (0, _helpers.createCustomErrorClass)("DeviceGenuineSocketEarlyClose");
	var DeviceNotGenuineError = exports.DeviceNotGenuineError = (0, _helpers.createCustomErrorClass)("DeviceNotGenuine");
	var DeviceOnDashboardExpected = exports.DeviceOnDashboardExpected = (0, _helpers.createCustomErrorClass)("DeviceOnDashboardExpected");
	var DeviceInOSUExpected = exports.DeviceInOSUExpected = (0, _helpers.createCustomErrorClass)("DeviceInOSUExpected");
	var DeviceHalted = exports.DeviceHalted = (0, _helpers.createCustomErrorClass)("DeviceHalted");
	var DeviceNameInvalid = exports.DeviceNameInvalid = (0, _helpers.createCustomErrorClass)("DeviceNameInvalid");
	var DeviceSocketFail = exports.DeviceSocketFail = (0, _helpers.createCustomErrorClass)("DeviceSocketFail");
	var DeviceSocketNoBulkStatus = exports.DeviceSocketNoBulkStatus = (0, _helpers.createCustomErrorClass)("DeviceSocketNoBulkStatus");
	var DisconnectedDevice = exports.DisconnectedDevice = (0, _helpers.createCustomErrorClass)("DisconnectedDevice");
	var DisconnectedDeviceDuringOperation = exports.DisconnectedDeviceDuringOperation = (0, _helpers.createCustomErrorClass)("DisconnectedDeviceDuringOperation");
	var EnpointConfigError = exports.EnpointConfigError = (0, _helpers.createCustomErrorClass)("EnpointConfig");
	var EthAppPleaseEnableContractData = exports.EthAppPleaseEnableContractData = (0, _helpers.createCustomErrorClass)("EthAppPleaseEnableContractData");
	var FeeEstimationFailed = exports.FeeEstimationFailed = (0, _helpers.createCustomErrorClass)("FeeEstimationFailed");
	var HardResetFail = exports.HardResetFail = (0, _helpers.createCustomErrorClass)("HardResetFail");
	var InvalidAddress = exports.InvalidAddress = (0, _helpers.createCustomErrorClass)("InvalidAddress");
	var InvalidAddressBecauseDestinationIsAlsoSource = exports.InvalidAddressBecauseDestinationIsAlsoSource = (0, _helpers.createCustomErrorClass)("InvalidAddressBecauseDestinationIsAlsoSource");
	var LatestMCUInstalledError = exports.LatestMCUInstalledError = (0, _helpers.createCustomErrorClass)("LatestMCUInstalledError");
	var UnknownMCU = exports.UnknownMCU = (0, _helpers.createCustomErrorClass)("UnknownMCU");
	var LedgerAPIError = exports.LedgerAPIError = (0, _helpers.createCustomErrorClass)("LedgerAPIError");
	var LedgerAPIErrorWithMessage = exports.LedgerAPIErrorWithMessage = (0, _helpers.createCustomErrorClass)("LedgerAPIErrorWithMessage");
	var LedgerAPINotAvailable = exports.LedgerAPINotAvailable = (0, _helpers.createCustomErrorClass)("LedgerAPINotAvailable");
	var ManagerAppAlreadyInstalledError = exports.ManagerAppAlreadyInstalledError = (0, _helpers.createCustomErrorClass)("ManagerAppAlreadyInstalled");
	var ManagerAppRelyOnBTCError = exports.ManagerAppRelyOnBTCError = (0, _helpers.createCustomErrorClass)("ManagerAppRelyOnBTC");
	var ManagerDeviceLockedError = exports.ManagerDeviceLockedError = (0, _helpers.createCustomErrorClass)("ManagerDeviceLocked");
	var ManagerNotEnoughSpaceError = exports.ManagerNotEnoughSpaceError = (0, _helpers.createCustomErrorClass)("ManagerNotEnoughSpace");
	var ManagerUninstallBTCDep = exports.ManagerUninstallBTCDep = (0, _helpers.createCustomErrorClass)("ManagerUninstallBTCDep");
	var NetworkDown = exports.NetworkDown = (0, _helpers.createCustomErrorClass)("NetworkDown");
	var NoAddressesFound = exports.NoAddressesFound = (0, _helpers.createCustomErrorClass)("NoAddressesFound");
	var NotEnoughBalance = exports.NotEnoughBalance = (0, _helpers.createCustomErrorClass)("NotEnoughBalance");
	var NotEnoughBalanceBecauseDestinationNotCreated = exports.NotEnoughBalanceBecauseDestinationNotCreated = (0, _helpers.createCustomErrorClass)("NotEnoughBalanceBecauseDestinationNotCreated");
	var PasswordsDontMatchError = exports.PasswordsDontMatchError = (0, _helpers.createCustomErrorClass)("PasswordsDontMatch");
	var PasswordIncorrectError = exports.PasswordIncorrectError = (0, _helpers.createCustomErrorClass)("PasswordIncorrect");
	var TimeoutTagged = exports.TimeoutTagged = (0, _helpers.createCustomErrorClass)("TimeoutTagged");
	var UnexpectedBootloader = exports.UnexpectedBootloader = (0, _helpers.createCustomErrorClass)("UnexpectedBootloader");
	var UpdateYourApp = exports.UpdateYourApp = (0, _helpers.createCustomErrorClass)("UpdateYourApp");
	var UserRefusedDeviceNameChange = exports.UserRefusedDeviceNameChange = (0, _helpers.createCustomErrorClass)("UserRefusedDeviceNameChange");
	var UserRefusedAddress = exports.UserRefusedAddress = (0, _helpers.createCustomErrorClass)("UserRefusedAddress");
	var UserRefusedFirmwareUpdate = exports.UserRefusedFirmwareUpdate = (0, _helpers.createCustomErrorClass)("UserRefusedFirmwareUpdate");
	var UserRefusedAllowManager = exports.UserRefusedAllowManager = (0, _helpers.createCustomErrorClass)("UserRefusedAllowManager");
	var UserRefusedOnDevice = exports.UserRefusedOnDevice = (0, _helpers.createCustomErrorClass)("UserRefusedOnDevice"); // TODO rename because it's just for transaction refusal
	var TransportOpenUserCancelled = exports.TransportOpenUserCancelled = (0, _helpers.createCustomErrorClass)("TransportOpenUserCancelled");
	var TransportInterfaceNotAvailable = exports.TransportInterfaceNotAvailable = (0, _helpers.createCustomErrorClass)("TransportInterfaceNotAvailable");
	var DeviceShouldStayInApp = exports.DeviceShouldStayInApp = (0, _helpers.createCustomErrorClass)("DeviceShouldStayInApp");
	var WebsocketConnectionError = exports.WebsocketConnectionError = (0, _helpers.createCustomErrorClass)("WebsocketConnectionError");
	var WebsocketConnectionFailed = exports.WebsocketConnectionFailed = (0, _helpers.createCustomErrorClass)("WebsocketConnectionFailed");
	var WrongDeviceForAccount = exports.WrongDeviceForAccount = (0, _helpers.createCustomErrorClass)("WrongDeviceForAccount");
	var ETHAddressNonEIP = exports.ETHAddressNonEIP = (0, _helpers.createCustomErrorClass)("ETHAddressNonEIP");
	var CantScanQRCode = exports.CantScanQRCode = (0, _helpers.createCustomErrorClass)("CantScanQRCode");
	var FeeNotLoaded = exports.FeeNotLoaded = (0, _helpers.createCustomErrorClass)("FeeNotLoaded");
	var FeeRequired = exports.FeeRequired = (0, _helpers.createCustomErrorClass)("FeeRequired");
	var SyncError = exports.SyncError = (0, _helpers.createCustomErrorClass)("SyncError");
	var PairingFailed = exports.PairingFailed = (0, _helpers.createCustomErrorClass)("PairingFailed");
	var GenuineCheckFailed = exports.GenuineCheckFailed = (0, _helpers.createCustomErrorClass)("GenuineCheckFailed");
	var LedgerAPI4xx = exports.LedgerAPI4xx = (0, _helpers.createCustomErrorClass)("LedgerAPI4xx");
	var LedgerAPI5xx = exports.LedgerAPI5xx = (0, _helpers.createCustomErrorClass)("LedgerAPI5xx");
	var FirmwareOrAppUpdateRequired = exports.FirmwareOrAppUpdateRequired = (0, _helpers.createCustomErrorClass)("FirmwareOrAppUpdateRequired");
	
	// db stuff, no need to translate
	var NoDBPathGiven = exports.NoDBPathGiven = (0, _helpers.createCustomErrorClass)("NoDBPathGiven");
	var DBWrongPassword = exports.DBWrongPassword = (0, _helpers.createCustomErrorClass)("DBWrongPassword");
	var DBNotReset = exports.DBNotReset = (0, _helpers.createCustomErrorClass)("DBNotReset");
	
	/**
	 * TransportError is used for any generic transport errors.
	 * e.g. Error thrown when data received by exchanges are incorrect or if exchanged failed to communicate with the device for various reason.
	 */
	function TransportError(message, id) {
	  this.name = "TransportError";
	  this.message = message;
	  this.stack = new Error().stack;
	  this.id = id;
	}
	//$FlowFixMe
	TransportError.prototype = new Error();
	
	(0, _helpers.addCustomErrorDeserializer)("TransportError", function (e) {
	  return new TransportError(e.message, e.id);
	});
	
	var StatusCodes = exports.StatusCodes = {
	  PIN_REMAINING_ATTEMPTS: 0x63c0,
	  INCORRECT_LENGTH: 0x6700,
	  COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 0x6981,
	  SECURITY_STATUS_NOT_SATISFIED: 0x6982,
	  CONDITIONS_OF_USE_NOT_SATISFIED: 0x6985,
	  INCORRECT_DATA: 0x6a80,
	  NOT_ENOUGH_MEMORY_SPACE: 0x6a84,
	  REFERENCED_DATA_NOT_FOUND: 0x6a88,
	  FILE_ALREADY_EXISTS: 0x6a89,
	  INCORRECT_P1_P2: 0x6b00,
	  INS_NOT_SUPPORTED: 0x6d00,
	  CLA_NOT_SUPPORTED: 0x6e00,
	  TECHNICAL_PROBLEM: 0x6f00,
	  OK: 0x9000,
	  MEMORY_PROBLEM: 0x9240,
	  NO_EF_SELECTED: 0x9400,
	  INVALID_OFFSET: 0x9402,
	  FILE_NOT_FOUND: 0x9404,
	  INCONSISTENT_FILE: 0x9408,
	  ALGORITHM_NOT_SUPPORTED: 0x9484,
	  INVALID_KCV: 0x9485,
	  CODE_NOT_INITIALIZED: 0x9802,
	  ACCESS_CONDITION_NOT_FULFILLED: 0x9804,
	  CONTRADICTION_SECRET_CODE_STATUS: 0x9808,
	  CONTRADICTION_INVALIDATION: 0x9810,
	  CODE_BLOCKED: 0x9840,
	  MAX_VALUE_REACHED: 0x9850,
	  GP_AUTH_FAILED: 0x6300,
	  LICENSING: 0x6f42,
	  HALTED: 0x6faa
	};
	
	function getAltStatusMessage(code) {
	  switch (code) {
	    // improve text of most common errors
	    case 0x6700:
	      return "Incorrect length";
	    case 0x6982:
	      return "Security not satisfied (dongle locked or have invalid access rights)";
	    case 0x6985:
	      return "Condition of use not satisfied (denied by the user?)";
	    case 0x6a80:
	      return "Invalid data received";
	    case 0x6b00:
	      return "Invalid parameter received";
	  }
	  if (0x6f00 <= code && code <= 0x6fff) {
	    return "Internal error, please report";
	  }
	}
	
	/**
	 * Error thrown when a device returned a non success status.
	 * the error.statusCode is one of the `StatusCodes` exported by this library.
	 */
	function TransportStatusError(statusCode) {
	  this.name = "TransportStatusError";
	  var statusText = Object.keys(StatusCodes).find(function (k) {
	    return StatusCodes[k] === statusCode;
	  }) || "UNKNOWN_ERROR";
	  var smsg = getAltStatusMessage(statusCode) || statusText;
	  var statusCodeStr = statusCode.toString(16);
	  this.message = "Ledger device: " + smsg + " (0x" + statusCodeStr + ")";
	  this.stack = new Error().stack;
	  this.statusCode = statusCode;
	  this.statusText = statusText;
	}
	//$FlowFixMe
	TransportStatusError.prototype = new Error();
	
	(0, _helpers.addCustomErrorDeserializer)("TransportStatusError", function (e) {
	  return new TransportStatusError(e.statusCode);
	});
	//# sourceMappingURL=index.js.map

/***/ }),
/* 296 */,
/* 297 */,
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.generateNewKeypair = generateNewKeypair;
	exports.updateFriendbotTarget = updateFriendbotTarget;
	exports.startFriendbotRequest = startFriendbotRequest;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(120);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _utilitiesDispatchInNewStack = __webpack_require__(313);
	
	var _utilitiesDispatchInNewStack2 = _interopRequireDefault(_utilitiesDispatchInNewStack);
	
	var _stellarSdk = __webpack_require__(23);
	
	var GENERATE_NEW_KEYPAIR = 'GENERATE_NEW_KEYPAIR';
	exports.GENERATE_NEW_KEYPAIR = GENERATE_NEW_KEYPAIR;
	
	function generateNewKeypair() {
	  var keypair = _stellarSdk.Keypair.random();
	  return {
	    type: GENERATE_NEW_KEYPAIR,
	    pubKey: keypair.publicKey(),
	    secretKey: keypair.secret()
	  };
	}
	
	var UPDATE_FRIENDBOT_TARGET = 'UPDATE_FRIENDBOT_TARGET';
	exports.UPDATE_FRIENDBOT_TARGET = UPDATE_FRIENDBOT_TARGET;
	
	function updateFriendbotTarget(target) {
	  return {
	    type: UPDATE_FRIENDBOT_TARGET,
	    target: target
	  };
	}
	
	var START_FRIENDBOT_REQUEST = 'START_FRIENDBOT_REQUEST';
	exports.START_FRIENDBOT_REQUEST = START_FRIENDBOT_REQUEST;
	var FINISH_FRIENDBOT_REQUEST = 'FINISH_FRIENDBOT_REQUEST';
	exports.FINISH_FRIENDBOT_REQUEST = FINISH_FRIENDBOT_REQUEST;
	
	function startFriendbotRequest(target) {
	  return function (dispatch) {
	    dispatch({
	      type: START_FRIENDBOT_REQUEST,
	      message: 'Loading...',
	      status: 'loading'
	    });
	
	    _axios2['default'].get('https://friendbot.stellar.org/?addr=' + target).then(function (r) {
	      (0, _utilitiesDispatchInNewStack2['default'])(dispatch, {
	        type: FINISH_FRIENDBOT_REQUEST,
	        target: target,
	        message: 'Successfully funded ' + target + ' on the test network',
	        status: 'success',
	        code: ''
	      });
	    })['catch'](function (e) {
	      var code = undefined,
	          message = undefined;
	      if (e.status === 0) {
	        code = '';
	        message = 'Unable to reach Friendbot server at https://friendbot.stellar.org';
	      } else {
	        code = JSON.stringify(e.data, null, 2);
	        message = 'Failed to fund ' + target + ' on the test network';
	      }
	
	      (0, _utilitiesDispatchInNewStack2['default'])(dispatch, {
	        type: FINISH_FRIENDBOT_REQUEST,
	        target: target,
	        message: message,
	        status: 'failure',
	        code: code
	      });
	    });
	  };
	}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.chooseEndpoint = chooseEndpoint;
	exports.changePendingRequestProps = changePendingRequestProps;
	exports.updateValue = updateValue;
	exports.submitRequest = submitRequest;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _axios = __webpack_require__(120);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utilitiesDispatchInNewStack = __webpack_require__(313);
	
	var _utilitiesDispatchInNewStack2 = _interopRequireDefault(_utilitiesDispatchInNewStack);
	
	var _stellarSdkLibCall_builder = __webpack_require__(30);
	
	var _urijs = __webpack_require__(106);
	
	var _urijs2 = _interopRequireDefault(_urijs);
	
	var CHOOSE_ENDPOINT = "CHOOSE_ENDPOINT";
	exports.CHOOSE_ENDPOINT = CHOOSE_ENDPOINT;
	
	function chooseEndpoint(resource, endpoint) {
	  return {
	    type: CHOOSE_ENDPOINT,
	    resource: resource,
	    endpoint: endpoint
	  };
	}
	
	var CHANGE_PENDING_REQUEST_PROPS = "CHANGE_PENDING_REQUEST_PROPS";
	exports.CHANGE_PENDING_REQUEST_PROPS = CHANGE_PENDING_REQUEST_PROPS;
	
	function changePendingRequestProps(props) {
	  return {
	    type: CHANGE_PENDING_REQUEST_PROPS,
	    props: props
	  };
	}
	
	var UPDATE_VALUE = "UPDATE_VALUE";
	exports.UPDATE_VALUE = UPDATE_VALUE;
	
	function updateValue(param, value) {
	  return {
	    type: UPDATE_VALUE,
	    param: param,
	    value: value
	  };
	}
	
	var START_REQUEST = "START_REQUEST";
	exports.START_REQUEST = START_REQUEST;
	var ERROR_REQUEST = "ERROR_REQUEST";
	exports.ERROR_REQUEST = ERROR_REQUEST;
	var UPDATE_REQUEST = "UPDATE_REQUEST";
	exports.UPDATE_REQUEST = UPDATE_REQUEST;
	var resultIdNonce = 0;
	var closeStreamFn = undefined;
	
	function submitRequest(request) {
	  return function (dispatch) {
	    // Close old stream if it exists
	    if (typeof closeStreamFn === 'function') {
	      closeStreamFn();
	      closeStreamFn = null;
	    }
	
	    var id = resultIdNonce++;
	    dispatch({
	      type: START_REQUEST,
	      id: id,
	      isStreaming: Boolean(request.streaming)
	    });
	
	    if (request.streaming) {
	      closeStreamFn = streamingRequest(request.url, function (message) {
	        // dispatchInNewStack is not needed for streaming since there is no catch here
	        dispatch({
	          type: UPDATE_REQUEST,
	          id: id,
	          body: message,
	          isStreaming: true
	        });
	      });
	    } else {
	      // dispatchInNewStack will only be called at most one time.
	      httpRequest(request).then(function (r) {
	        (0, _utilitiesDispatchInNewStack2['default'])(dispatch, {
	          type: UPDATE_REQUEST,
	          id: id,
	          body: r.data
	        });
	      })['catch'](function (e) {
	        (0, _utilitiesDispatchInNewStack2['default'])(dispatch, {
	          type: ERROR_REQUEST,
	          id: id,
	          errorStatus: e.status,
	          body: e.data
	        });
	      });
	    }
	  };
	}
	
	function httpRequest(request) {
	  if (request.method === 'POST') {
	    if (typeof request.formData !== 'string') {
	      throw new Error('Network POST requests require the form data to be in string format.');
	    }
	    return _axios2['default'].post(request.url, request.formData);
	  }
	  return _axios2['default'].get(request.url);
	}
	
	function streamingRequest(url, onmessage) {
	  var callBuilder = new _stellarSdkLibCall_builder.CallBuilder((0, _urijs2['default'])(url));
	  return callBuilder.stream({ onmessage: onmessage });
	}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.importFromXdr = importFromXdr;
	exports.clearTransaction = clearTransaction;
	exports.setSecrets = setSecrets;
	exports.setBIPPath = setBIPPath;
	exports.signWithLedger = signWithLedger;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _ledgerhqHwTransportU2f = __webpack_require__(491);
	
	var _ledgerhqHwTransportU2f2 = _interopRequireDefault(_ledgerhqHwTransportU2f);
	
	var _ledgerhqHwAppStr = __webpack_require__(489);
	
	var _ledgerhqHwAppStr2 = _interopRequireDefault(_ledgerhqHwAppStr);
	
	var _stellarSdk = __webpack_require__(23);
	
	var BP = __webpack_require__(776);
	
	var IMPORT_FROM_XDR = 'IMPORT_FROM_XDR';
	exports.IMPORT_FROM_XDR = IMPORT_FROM_XDR;
	
	function importFromXdr(xdr) {
	  return {
	    type: IMPORT_FROM_XDR,
	    xdr: xdr
	  };
	}
	
	var CLEAR_TRANSACTION = 'CLEAR_TRANSACTION';
	exports.CLEAR_TRANSACTION = CLEAR_TRANSACTION;
	
	function clearTransaction() {
	  return {
	    type: CLEAR_TRANSACTION
	  };
	}
	
	var SET_SECRETS = 'SET_SECRETS';
	exports.SET_SECRETS = SET_SECRETS;
	
	function setSecrets(secrets) {
	  return {
	    type: SET_SECRETS,
	    secrets: secrets
	  };
	}
	
	var SET_BIP_PATH = 'SET_BIP_PATH';
	exports.SET_BIP_PATH = SET_BIP_PATH;
	
	function setBIPPath(bipPath) {
	  return {
	    type: SET_BIP_PATH,
	    bipPath: bipPath
	  };
	}
	
	var LEDGER_WALLET_SIGN_START = 'LEDGER_WALLET_SIGN_START';
	exports.LEDGER_WALLET_SIGN_START = LEDGER_WALLET_SIGN_START;
	var LEDGER_WALLET_SIGN_SUCCESS = 'LEDGER_WALLET_SIGN_SUCCESS';
	exports.LEDGER_WALLET_SIGN_SUCCESS = LEDGER_WALLET_SIGN_SUCCESS;
	var LEDGER_WALLET_SIGN_ERROR = 'LEDGER_WALLET_SIGN_ERROR';
	
	exports.LEDGER_WALLET_SIGN_ERROR = LEDGER_WALLET_SIGN_ERROR;
	
	function signWithLedger(txXDR, bipPath) {
	  return function (dispatch) {
	    dispatch({ type: LEDGER_WALLET_SIGN_START });
	
	    var transaction = new _stellarSdk.Transaction(txXDR);
	
	    var onError = function onError(err) {
	      if (err.message) {
	        err = err.message;
	      } else if (err.errorCode == 2) {
	        err = 'Couldn\'t connect to Ledger device. Connection can only be established using a secure connection.';
	      } else if (err.errorCode == 5) {
	        err = 'Connection timeout.';
	      }
	
	      dispatch({
	        type: LEDGER_WALLET_SIGN_ERROR,
	        error: err
	      });
	    };
	
	    var onConnect = function onConnect(ledgerApi) {
	      var publicKey = undefined;
	      ledgerApi.getPublicKey(bipPath).then(function (result) {
	        return publicKey = result.publicKey;
	      }).then(function () {
	        return ledgerApi.signTransaction(bipPath, transaction.signatureBase());
	      }).then(function (result) {
	        var signature = result.signature;
	
	        var keyPair = _stellarSdk.Keypair.fromPublicKey(publicKey);
	        var hint = keyPair.signatureHint();
	        var decorated = new _stellarSdk.xdr.DecoratedSignature({ hint: hint, signature: signature });
	
	        dispatch({
	          type: LEDGER_WALLET_SIGN_SUCCESS,
	          signature: decorated
	        });
	      })['catch'](onError);
	    };
	
	    var openTimeout = 60 * 1000;
	    _ledgerhqHwTransportU2f2['default'].create(openTimeout).then(function (transport) {
	      transport.setDebugMode(true);
	      onConnect(new _ledgerhqHwAppStr2['default'](transport));
	    })['catch'](onError);
	  };
	}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.updateXdrInput = updateXdrInput;
	exports.updateXdrType = updateXdrType;
	exports.fetchLatestTx = fetchLatestTx;
	exports.fetchSigners = fetchSigners;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stellarSdk = __webpack_require__(23);
	
	var _axios = __webpack_require__(120);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constantsSignature = __webpack_require__(311);
	
	var _constantsSignature2 = _interopRequireDefault(_constantsSignature);
	
	var _constantsFetched_signers = __webpack_require__(151);
	
	var _constantsFetched_signers2 = _interopRequireDefault(_constantsFetched_signers);
	
	var UPDATE_XDR_INPUT = 'UPDATE_XDR_INPUT';
	exports.UPDATE_XDR_INPUT = UPDATE_XDR_INPUT;
	
	function updateXdrInput(input) {
	  return {
	    type: UPDATE_XDR_INPUT,
	    input: input
	  };
	}
	
	var UPDATE_XDR_TYPE = 'UPDATE_XDR_TYPE';
	exports.UPDATE_XDR_TYPE = UPDATE_XDR_TYPE;
	
	function updateXdrType(xdrType) {
	  return {
	    type: UPDATE_XDR_TYPE,
	    xdrType: xdrType
	  };
	}
	
	var FETCH_LATEST_TX = 'FETCH_LATEST_TX';
	exports.FETCH_LATEST_TX = FETCH_LATEST_TX;
	
	function fetchLatestTx(horizonBaseUrl, networkPassphrase) {
	  return function (dispatch) {
	    dispatch({ type: FETCH_LATEST_TX });
	    _axios2['default'].get(horizonBaseUrl + '/transactions?limit=1&order=desc').then(function (r) {
	      var xdr = r.data._embedded.records[0].envelope_xdr;
	      dispatch(updateXdrInput(xdr));
	      dispatch(updateXdrType('TransactionEnvelope'));
	      dispatch(fetchSigners(xdr, horizonBaseUrl, networkPassphrase));
	    })['catch'](function (r) {
	      return dispatch({ type: FETCH_SEQUENCE_FAIL, payload: r });
	    });
	  };
	}
	
	function fetchSigners(input, horizonBaseUrl, networkPassphrase) {
	  return function (dispatch) {
	    dispatch({ type: _constantsFetched_signers2['default'].PENDING });
	    try {
	      (function () {
	        // Capture network for determining signature base
	        StellarSdk.Network.use(new _stellarSdk.Network(networkPassphrase));
	
	        var tx = new StellarSdk.Transaction(input);
	        var hashedSignatureBase = (0, _stellarSdk.hash)(tx.signatureBase());
	
	        // Extract all signatures on transaction
	        var signatures = tx.signatures.map(function (x) {
	          return { sig: x.signature() };
	        });
	
	        // Extract all source accounts from transaction (base transaction and all operations)
	        var sourceAccounts = {};
	
	        var baseAccountId = tx.source;
	        sourceAccounts[baseAccountId] = true;
	
	        tx.operations.forEach(function (op) {
	          if (op.source) {
	            sourceAccounts[op.source] = true;
	          }
	        });
	
	        // Get all signers per source account - array of promises
	        sourceAccounts = Object.keys(sourceAccounts).map(function (accountID) {
	          return _axios2['default'].get(horizonBaseUrl + '/accounts/' + accountID);
	        });
	
	        Promise.all(sourceAccounts).then(function (response) {
	          var allSigners = {};
	          response.forEach(function (r) {
	            return r.data.signers.forEach(function (signer) {
	              return allSigners[signer.key] = signer;
	            });
	          });
	
	          allSigners = Object.values(allSigners);
	
	          // We are only interested in checking if each of the signatures can be verified for some valid
	          // signer for any of the source accounts in the transaction -- we are not taking into account
	          // weights, or even if this signer makes sense.
	          for (var i = 0; i < signatures.length; i++) {
	            var sigObj = signatures[i];
	            var isValid = false;
	
	            for (var j = 0; j < allSigners.length; j++) {
	              var signer = allSigners[j];
	
	              // By nature of pre-authorized transaction, we won't ever receive a pre-auth
	              // tx hash in signatures array, so we can ignore pre-authorized transactions here.
	              switch (signer.type) {
	                case 'sha256_hash':
	                  var hashXSigner = _stellarSdk.StrKey.decodeSha256Hash(signer.key);
	                  var hashXSignature = (0, _stellarSdk.hash)(sigObj.sig);
	                  isValid = hashXSigner.equals(hashXSignature);
	                  break;
	                case 'ed25519_public_key':
	                  var keypair = _stellarSdk.Keypair.fromPublicKey(signer.key);
	                  isValid = keypair.verify(hashedSignatureBase, sigObj.sig);
	                  break;
	              }
	
	              if (isValid) {
	                break;
	              }
	            }
	
	            sigObj.isValid = isValid ? _constantsSignature2['default'].VALID : _constantsSignature2['default'].INVALID;
	          }
	          dispatch({
	            type: _constantsFetched_signers2['default'].SUCCESS,
	            result: signatures
	          });
	        })['catch'](function (e) {
	          console.error(e);
	          if (e.status == 404) {
	            dispatch({ type: _constantsFetched_signers2['default'].NOT_EXIST });
	          } else {
	            dispatch({ type: _constantsFetched_signers2['default'].FAIL });
	          }
	        });
	      })();
	    } catch (e) {
	      console.error(e);
	      dispatch({ type: _constantsFetched_signers2['default'].FAIL });
	    }
	  };
	}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.EndpointPicker = EndpointPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(166);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dataEndpoints = __webpack_require__(202);
	
	var _lodash = __webpack_require__(6);
	
	function EndpointPicker(props) {
	  var onChange = props.onChange;
	  var currentResource = props.currentResource;
	  var currentEndpoint = props.currentEndpoint;
	
	  var resources = makeItems(_dataEndpoints.endpointsMap);
	
	  var resourcePicker = _react2['default'].createElement(
	    'div',
	    { className: 'EndpointPicker__section' },
	    _react2['default'].createElement(
	      'p',
	      { className: 'EndpointPicker__section__title' },
	      '1. Select a resource'
	    ),
	    _react2['default'].createElement(ButtonGroup, {
	      items: resources,
	      onChange: function (newResource) {
	        return onChange(newResource, "");
	      },
	      selectedIndex: (0, _lodash.findIndex)(resources, { id: currentResource })
	    })
	  );
	
	  var endpointPicker = null;
	  if (currentResource !== "") {
	    var endpoints = makeItems(_dataEndpoints.endpointsMap[currentResource].endpoints);
	    endpointPicker = _react2['default'].createElement(
	      'div',
	      { className: 'EndpointPicker__section' },
	      _react2['default'].createElement(
	        'p',
	        { className: 'EndpointPicker__section__title' },
	        '2. Select an endpoint'
	      ),
	      _react2['default'].createElement(ButtonGroup, {
	        items: endpoints,
	        onChange: function (newEndpoint) {
	          return onChange(currentResource, newEndpoint);
	        },
	        selectedIndex: (0, _lodash.findIndex)(endpoints, { id: currentEndpoint })
	      })
	    );
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    { className: 'EndpointPicker' },
	    resourcePicker,
	    endpointPicker
	  );
	}
	
	function ButtonGroup(props) {
	  var onChange = props.onChange;
	  var items = props.items;
	  var selectedIndex = props.selectedIndex;
	
	  var buttons = items.map(function (item, idx) {
	    var selected = selectedIndex === idx;
	    return _react2['default'].createElement(ButtonGroupButton, _extends({}, item, {
	      selected: selected,
	      key: idx,
	      onChange: onChange
	    }));
	  });
	
	  return _react2['default'].createElement(
	    'nav',
	    { className: 's-buttonGroup s-buttonGroup--vertical' },
	    buttons
	  );
	}
	
	function ButtonGroupButton(props) {
	  var selected = props.selected;
	  var label = props.label;
	  var onChange = props.onChange;
	  var id = props.id;
	
	  var classes = (0, _classnames2['default'])('s-button', 's-button--light', { "is-active": selected });
	
	  return _react2['default'].createElement(
	    'li',
	    { className: classes, onClick: function () {
	        return onChange(id);
	      } },
	    label
	  );
	}
	
	var makeItems = function makeItems(itemMap) {
	  return (0, _lodash.map)(itemMap, function (value, id) {
	    return { id: id, label: value.label };
	  });
	};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _CodeBlock = __webpack_require__(508);
	
	var EndpointResult = (function (_React$Component) {
	  _inherits(EndpointResult, _React$Component);
	
	  function EndpointResult() {
	    _classCallCheck(this, EndpointResult);
	
	    _get(Object.getPrototypeOf(EndpointResult.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(EndpointResult, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var id = _props.id;
	      var available = _props.available;
	      var isError = _props.isError;
	      var body = _props.body;
	
	      if (!available) {
	        return null;
	      }
	
	      if (body.length === 0) {
	        return _react2['default'].createElement(LoadingPane, null);
	      }
	
	      if (isError) {
	        return ErrorPane(body);
	      }
	
	      return ResultPane(body);
	    }
	  }]);
	
	  return EndpointResult;
	})(_react2['default'].Component);
	
	exports.EndpointResult = EndpointResult;
	
	function LoadingPane(props) {
	  return _react2['default'].createElement(
	    'div',
	    { className: 'EndpointResult' },
	    _react2['default'].createElement(
	      'div',
	      { className: 'EndpointResult__loading' },
	      'Loading...'
	    )
	  );
	}
	
	function ErrorPane(body) {
	  return _react2['default'].createElement(
	    'div',
	    { className: 'EndpointResult' },
	    _react2['default'].createElement(
	      'div',
	      { className: 'EndpointResult__error' },
	      BodyContent(body)
	    )
	  );
	}
	
	function ResultPane(body) {
	  return _react2['default'].createElement(
	    'div',
	    { className: 'EndpointResult' },
	    _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'EndpointResult__tabs' },
	        _react2['default'].createElement(
	          'button',
	          { className: 'EndpointResult__tabs__tab is-current' },
	          'JSON Response'
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'EndpointResult__content' },
	        BodyContent(body)
	      )
	    )
	  );
	}
	
	function BodyContent(body) {
	  return _.map(body, function (bodyEntry, index) {
	    return _react2['default'].createElement(_CodeBlock.CodeBlock, { key: index, code: body[index], language: 'json' });
	  });
	}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.EndpointSetup = EndpointSetup;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HelpMark = __webpack_require__(124);
	
	var _HelpMark2 = _interopRequireDefault(_HelpMark);
	
	var _EasySelect = __webpack_require__(147);
	
	function EndpointSetup(props) {
	  var onSubmit = props.onSubmit;
	  var onUpdate = props.onUpdate;
	  var request = props.request;
	  var params = props.params;
	  var endpoint = props.endpoint;
	  var values = props.values;
	
	  var streamingRow = undefined;
	  if (!endpoint.disableStreaming) {
	    streamingRow = [_react2['default'].createElement('hr', { key: 0, className: 'optionsTable__separator' }), _react2['default'].createElement(StreamingRow, { key: 1, onUpdate: onUpdate, checked: values.streaming })];
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    { className: 'so-chunk' },
	    _react2['default'].createElement(
	      'p',
	      { className: 'EndpointSetup__title' },
	      endpoint.label,
	      ' ',
	      _react2['default'].createElement(_HelpMark2['default'], { href: endpoint.helpUrl })
	    ),
	    _react2['default'].createElement(
	      'div',
	      { className: 'optionsTable' },
	      _react2['default'].createElement(endpoint.setupComponent, {
	        onUpdate: onUpdate,
	        values: values
	      }),
	      streamingRow,
	      _react2['default'].createElement('hr', { className: 'optionsTable__separator' }),
	      _react2['default'].createElement(UrlRow, { url: request.url, method: request.method }),
	      _react2['default'].createElement(PostDataRow, { formData: request.formData }),
	      _react2['default'].createElement(SubmitRow, { onSubmit: onSubmit })
	    )
	  );
	}
	
	function StreamingRow(props) {
	  return _react2['default'].createElement(
	    'div',
	    { className: 'optionsTable__blank EndpointSetup__streaming' },
	    _react2['default'].createElement(
	      'label',
	      null,
	      _react2['default'].createElement('input', { type: 'checkbox', className: 'EndpointSetup__streaming__checkbox',
	        onChange: function (event) {
	          props.onUpdate('streaming', event.target.checked);
	        },
	        checked: props.checked
	      }),
	      _react2['default'].createElement(
	        'span',
	        { className: 'EndpointSetup__streaming__title' },
	        'Server-Sent Events (streaming) mode'
	      ),
	      ' ',
	      _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/horizon/reference/streaming.html' })
	    )
	  );
	}
	
	function UrlRow(props) {
	  return _react2['default'].createElement(
	    'div',
	    { className: 'optionsTable__blank EndpointSetup__url' },
	    _react2['default'].createElement(
	      'span',
	      { className: 'EndpointSetup__url__method' },
	      props.method
	    ),
	    _react2['default'].createElement(
	      'span',
	      null,
	      ' '
	    ),
	    _react2['default'].createElement(
	      _EasySelect.EasySelect,
	      null,
	      props.url
	    )
	  );
	}
	
	function PostDataRow(_ref) {
	  var formData = _ref.formData;
	
	  if (formData === '') {
	    return _react2['default'].createElement('div', null);
	  }
	  return _react2['default'].createElement(
	    'div',
	    { className: 'optionsTable__blank EndpointSetup__url' },
	    _react2['default'].createElement(
	      'span',
	      null,
	      formData
	    )
	  );
	}
	
	function SubmitRow(props) {
	  return _react2['default'].createElement(
	    'div',
	    { className: 'optionsTable__blank' },
	    _react2['default'].createElement(
	      'button',
	      { className: 's-button', onClick: props.onSubmit },
	      'Submit'
	    )
	  );
	}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = LedgerPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositiveIntPicker = __webpack_require__(21);
	
	var _PositiveIntPicker2 = _interopRequireDefault(_PositiveIntPicker);
	
	function LedgerPicker(props) {
	  return _react2['default'].createElement(_PositiveIntPicker2['default'], _extends({}, props, {
	    placeholder: props.placeholder || 'Example: 1714814'
	  }));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = OperationPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositiveIntPicker = __webpack_require__(21);
	
	var _PositiveIntPicker2 = _interopRequireDefault(_PositiveIntPicker);
	
	function OperationPicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	
	  return _react2['default'].createElement(_PositiveIntPicker2['default'], {
	    value: value,
	    placeholder: 'Example: 55834578945',
	    onUpdate: function (value) {
	      return onUpdate(value);
	    }
	  });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = PositiveNumberPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextPicker = __webpack_require__(22);
	
	var _TextPicker2 = _interopRequireDefault(_TextPicker);
	
	function PositiveNumberPicker(props) {
	  return _react2['default'].createElement(_TextPicker2['default'], _extends({}, props, {
	    validator: function (value) {
	      if (value.charAt(0) === '-') {
	        return 'Expected a positive number or zero.';
	      } else if (!value.match(/^[0-9]*(\.[0-9]+){0,1}$/g)) {
	        return 'Expected a positive number with a period for the decimal point.';
	      }
	
	      if (typeof props.validator !== 'undefined') {
	        return props.validator(value);
	      }
	    }
	  }));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = TransactionPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PickerError = __webpack_require__(123);
	
	var _PickerError2 = _interopRequireDefault(_PickerError);
	
	function TransactionPicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement('input', { type: 'text',
	      value: value,
	      onChange: function (event) {
	        onUpdate(event.target.value);
	      },
	      placeholder: 'Example: 3389e9f0f1a65f19736cacf544c2e825313e8447f569233bb8db39aa607c8889',
	      className: 'picker picker--textInput' }),
	    _react2['default'].createElement(_PickerError2['default'], { message: validator(value) })
	  );
	}
	
	function validator(value) {
	  if (!_.isString(value) || value.length === 0) {
	    return;
	  }
	  if (value.match(/^[0-9a-f]{64}$/g) === null) {
	    return 'Transaction hash is invalid.';
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = Unsigned8bitIntPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositiveIntPicker = __webpack_require__(21);
	
	var _PositiveIntPicker2 = _interopRequireDefault(_PositiveIntPicker);
	
	function Unsigned8bitIntPicker(props) {
	  return _react2['default'].createElement(_PositiveIntPicker2['default'], _extends({}, props, {
	    placeholder: '0 - 255',
	    validator: function (value) {
	      if (value >= 255) {
	        return 'Expected an integer between 0 and 255 (inclusive).';
	      }
	    }
	  }));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = ForLedger;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _For = __webpack_require__(125);
	
	var _For2 = _interopRequireDefault(_For);
	
	var _FormComponentsLedgerPickerJs = __webpack_require__(305);
	
	var _FormComponentsLedgerPickerJs2 = _interopRequireDefault(_FormComponentsLedgerPickerJs);
	
	function ForLedger(props) {
	  var label = 'Ledger Sequence';
	  var content = _react2['default'].createElement(_FormComponentsLedgerPickerJs2['default'], {
	    value: props.values['ledger'],
	    onUpdate: function (value) {
	      props.onUpdate('ledger', value);
	    }
	  });
	
	  return _react2['default'].createElement(_For2['default'], _extends({ label: label, content: content }, props));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	// This standardizes all the signature verification states
	// into a single map.
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var SIGNATURE = {
	    NOT_VERIFIED_YET: 'NOT_VERIFIED_YET',
	    INVALID: 'INVALID',
	    VALID: 'VALID'
	};
	exports['default'] = SIGNATURE;
	module.exports = exports['default'];

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Libify is a utility that converts a wide variety of inputs into their stricter
	// representations in Stellar libraries such as js-stellar-sdk and js-stellar-sdk.
	//
	// The Libify api aims to look similar to that of js-stellar-sdk and Sdk. It
	// will output better error messages in cases where helpful (instead of just
	// undefined error messages).
	//
	// Libify could also be used to generate source code from input but might not be
	// the best choice since source code differs based on content.
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stellarSdk = __webpack_require__(23);
	
	var _stellarSdk2 = _interopRequireDefault(_stellarSdk);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	// Helpers
	var isEmpty = function isEmpty(value) {
	  return _lodash2['default'].isUndefined(value) || value === '' || value === null;
	};
	var isInt = function isInt(value) {
	  return String(value).match(/^[0-9]*$/g);
	};
	var assertNotEmpty = function assertNotEmpty(value, message) {
	  if (isEmpty(value)) {
	    throw new Error(message);
	  }
	};
	var assertIntOrEmpty = function assertIntOrEmpty(value, message) {
	  if (!isEmpty(value) && !isInt(value)) {
	    throw new Error(message);
	  }
	};
	
	// Converts a value into a boolean. String values are converted to their respective
	// boolean values since html forms can only output string values.
	var isLooseTruthy = function isLooseTruthy(value) {
	  if (value == 'true') {
	    return true;
	  }
	  if (value == 'false') {
	    return false;
	  }
	  return value == true;
	};
	
	// This function processes the value in three situations:
	// 1. Is a number: return as is
	// 2. String contains just digits: will convert into JavaScript Number integer
	// 3. String is empty: converts to undefined (useful for optional arguments)
	var castIntOrUndefined = function castIntOrUndefined(value) {
	  if (typeof value === 'number') {
	    return value;
	  }
	  if (_lodash2['default'].isString(value) && value.match(/^[0-9]+$/g)) {
	    return Number(value);
	  }
	  return undefined;
	};
	
	// This function processes the value in three situations:
	// 1. Is a string: return as is
	// 2. String is empty: converts to undefined (useful for optional arguments)
	var castStringOrUndefined = function castStringOrUndefined(value) {
	  if (!_lodash2['default'].isString(value) || value === '') {
	    return undefined;
	  }
	  return String(value);
	};
	
	var castStringOrNull = function castStringOrNull(value) {
	  if (!_lodash2['default'].isString(value) || value === '') {
	    return null;
	  }
	  return String(value);
	};
	
	var Libify = {};
	
	Libify.Asset = function (opts) {
	  if (isEmpty(opts) || opts.type === 'native') {
	    return _stellarSdk2['default'].Asset.native();
	  }
	
	  assertNotEmpty(opts.code, 'Asset requires asset code');
	  return new _stellarSdk2['default'].Asset(opts.code, opts.issuer);
	};
	
	Libify.Memo = function (opts) {
	  switch (opts.type) {
	    case '':
	    case 'MEMO_TEXT':
	      return _stellarSdk2['default'].Memo.text(opts.content);
	    case 'MEMO_ID':
	      return _stellarSdk2['default'].Memo.id(opts.content);
	    case 'MEMO_HASH':
	      return _stellarSdk2['default'].Memo.hash(opts.content);
	    case 'MEMO_RETURN':
	      return _stellarSdk2['default'].Memo['return'](opts.content);
	  }
	};
	
	// Takes in a type and a pile of options and attempts to turn it into a valid
	// js-stellar-sdk operation. If not, it will throw an error.
	Libify.Operation = function (type, opts) {
	  assertNotEmpty(type, 'Operation type is required');
	  var opFunction = Libify.Operation[type];
	  if (typeof opFunction === 'undefined' || _lodash2['default'].has(Libify.Operation, 'opFunction')) {
	    throw new Error('Unknown operation type: ' + type);
	  }
	  return opFunction(opts);
	};
	
	Libify.Operation.createAccount = function (opts) {
	  assertNotEmpty(opts.destination, 'Create Account operation requires destination');
	  assertNotEmpty(opts.startingBalance, 'Create Account operation requires starting balance');
	  return _stellarSdk2['default'].Operation.createAccount({
	    destination: opts.destination,
	    startingBalance: opts.startingBalance,
	    source: opts.sourceAccount
	  });
	};
	
	Libify.Operation.payment = function (opts) {
	  assertNotEmpty(opts.destination, 'Payment operation requires destination');
	  assertNotEmpty(opts.asset, 'Payment operation requires asset');
	  assertNotEmpty(opts.amount, 'Payment operation requires amount');
	  return _stellarSdk2['default'].Operation.payment({
	    destination: opts.destination,
	    asset: Libify.Asset(opts.asset),
	    amount: opts.amount,
	    source: opts.sourceAccount
	  });
	};
	
	Libify.Operation.pathPayment = function (opts) {
	  assertNotEmpty(opts.sendAsset, 'Path Payment operation requires sending asset');
	  assertNotEmpty(opts.sendMax, 'Path Payment operation requires max send');
	  assertNotEmpty(opts.destination, 'Payment operation requires destination');
	  assertNotEmpty(opts.destAsset, 'Path Payment operation requires destination asset');
	  assertNotEmpty(opts.destAmount, 'Path Payment operation requires the destination amount');
	
	  var libifiedPath = _lodash2['default'].map(opts.path, function (hopAsset) {
	    if (_lodash2['default'].isUndefined(hopAsset.type)) {
	      throw new Error('All assets in path must be filled out');
	    }
	    return Libify.Asset(hopAsset);
	  });
	
	  return _stellarSdk2['default'].Operation.pathPayment({
	    sendAsset: Libify.Asset(opts.sendAsset),
	    sendMax: opts.sendMax,
	    destination: opts.destination,
	    destAsset: Libify.Asset(opts.destAsset),
	    destAmount: opts.destAmount,
	    path: libifiedPath,
	    source: opts.sourceAccount
	  });
	};
	
	Libify.Operation.changeTrust = function (opts) {
	  assertNotEmpty(opts.asset, 'Change Trust operation requires asset');
	  return _stellarSdk2['default'].Operation.changeTrust({
	    asset: Libify.Asset(opts.asset),
	    limit: opts.limit === '' ? undefined : opts.limit,
	    source: opts.sourceAccount
	  });
	};
	
	Libify.Operation.allowTrust = function (opts) {
	  assertNotEmpty(opts.trustor, 'Allow Trust operation requires trustor');
	  assertNotEmpty(opts.assetCode, 'Allow Trust operation requires asset code');
	  assertNotEmpty(opts.authorize, 'Allow Trust operation requires authorization setting');
	  return _stellarSdk2['default'].Operation.allowTrust({
	    trustor: opts.trustor,
	    assetCode: opts.assetCode,
	    authorize: isLooseTruthy(opts.authorize),
	    source: opts.sourceAccount
	  });
	};
	
	Libify.Operation.accountMerge = function (opts) {
	  assertNotEmpty(opts.destination, 'Account Merge operation requires destination');
	  return _stellarSdk2['default'].Operation.accountMerge({
	    destination: opts.destination,
	    source: opts.sourceAccount
	  });
	};
	
	Libify.Operation.manageSellOffer = function (opts) {
	  assertNotEmpty(opts.selling, 'Manage Sell Offer operation requires selling asset');
	  assertNotEmpty(opts.buying, 'Manage Sell Offer operation requires buying asset');
	  assertNotEmpty(opts.amount, 'Manage Sell Offer operation requires amount');
	  assertNotEmpty(opts.price, 'Manage Sell Offer operation requires price');
	  assertNotEmpty(opts.offerId, 'Manage Sell Offer operation requires Offer ID');
	  return _stellarSdk2['default'].Operation.manageSellOffer({
	    selling: Libify.Asset(opts.selling),
	    buying: Libify.Asset(opts.buying),
	    amount: opts.amount,
	    price: opts.price,
	    offerId: opts.offerId,
	    source: opts.sourceAccount
	  });
	};
	
	Libify.Operation.manageBuyOffer = function (opts) {
	  assertNotEmpty(opts.selling, 'Manage Buy Offer operation requires selling asset');
	  assertNotEmpty(opts.buying, 'Manage Buy Offer operation requires buying asset');
	  assertNotEmpty(opts.buyAmount, 'Manage Buy Offer operation requires buyAmount');
	  assertNotEmpty(opts.price, 'Manage Buy Offer operation requires price');
	  assertNotEmpty(opts.offerId, 'Manage Buy Offer operation requires Offer ID');
	  return _stellarSdk2['default'].Operation.manageBuyOffer({
	    selling: Libify.Asset(opts.selling),
	    buying: Libify.Asset(opts.buying),
	    buyAmount: opts.buyAmount,
	    price: opts.price,
	    offerId: opts.offerId,
	    source: opts.sourceAccount
	  });
	};
	
	Libify.Operation.createPassiveSellOffer = function (opts) {
	  assertNotEmpty(opts.selling, 'Create Passive Sell Offer operation requires selling asset');
	  assertNotEmpty(opts.buying, 'Create Passive Sell Offer operation requires buying asset');
	  assertNotEmpty(opts.amount, 'Create Passive Sell Offer operation requires amount');
	  assertNotEmpty(opts.price, 'Create Passive Sell Offer operation requires price');
	  return _stellarSdk2['default'].Operation.createPassiveSellOffer({
	    selling: Libify.Asset(opts.selling),
	    buying: Libify.Asset(opts.buying),
	    amount: opts.amount,
	    price: opts.price,
	    source: opts.sourceAccount
	  });
	};
	
	Libify.Operation.inflation = function (opts) {
	  return _stellarSdk2['default'].Operation.inflation({
	    source: opts.sourceAccount
	  });
	};
	
	Libify.Operation.setOptions = function (opts) {
	  var signer = undefined;
	  if (opts.signer && opts.signer.type) {
	    var signerPubKeyEmpty = isEmpty(opts.signer.content);
	    var signerWeightEmpty = isEmpty(opts.signer.weight);
	    if (signerPubKeyEmpty && !signerWeightEmpty) {
	      throw new Error('Signer weight is required if signer key is present');
	    }
	    if (!signerPubKeyEmpty && signerWeightEmpty) {
	      throw new Error('Signer key is required if signer weight is present');
	    }
	
	    if (!signerPubKeyEmpty && !signerWeightEmpty) {
	      signer = {
	        weight: castIntOrUndefined(opts.signer.weight)
	      };
	      switch (opts.signer.type) {
	        case "ed25519PublicKey":
	          signer.ed25519PublicKey = opts.signer.content;
	          break;
	        case "sha256Hash":
	        case "preAuthTx":
	          signer[opts.signer.type] = Buffer.from(opts.signer.content, "hex");
	          break;
	        default:
	          throw new Error('Invalid signer type');
	      }
	    } else {
	      throw new Error('Enter signer key and weight');
	    }
	  }
	
	  assertIntOrEmpty(opts.clearFlags, 'Clear flags must be an integer');
	  assertIntOrEmpty(opts.setFlags, 'Set flags must be an integer');
	  assertIntOrEmpty(opts.masterWeight, 'Master Weight must be an integer');
	  assertIntOrEmpty(opts.lowThreshold, 'Low Threshold must be an integer');
	  assertIntOrEmpty(opts.medThreshold, 'Medium Threshold must be an integer');
	  assertIntOrEmpty(opts.highThreshold, 'High Threshold must be an integer');
	
	  return _stellarSdk2['default'].Operation.setOptions({
	    inflationDest: opts.inflationDest,
	    clearFlags: castIntOrUndefined(opts.clearFlags),
	    setFlags: castIntOrUndefined(opts.setFlags),
	    masterWeight: castIntOrUndefined(opts.masterWeight),
	    lowThreshold: castIntOrUndefined(opts.lowThreshold),
	    medThreshold: castIntOrUndefined(opts.medThreshold),
	    highThreshold: castIntOrUndefined(opts.highThreshold),
	    signer: signer,
	    homeDomain: castStringOrUndefined(opts.homeDomain),
	    source: opts.sourceAccount
	  });
	};
	
	Libify.Operation.manageData = function (opts) {
	  assertNotEmpty(opts.name, 'Manage Data operation requires entry name');
	
	  return _stellarSdk2['default'].Operation.manageData({
	    name: opts.name,
	    value: castStringOrNull(opts.value),
	    source: opts.sourceAccount
	  });
	};
	
	Libify.Operation.bumpSequence = function (opts) {
	  assertNotEmpty(opts.bumpTo, 'Sequence number should be set');
	  return _stellarSdk2['default'].Operation.bumpSequence({
	    bumpTo: opts.bumpTo,
	    source: opts.sourceAccount
	  });
	};
	
	// buildTransaction is not something found js-stellar libs but acts as an
	// abstraction to building a transaction with input data in the same format
	// as the reducers
	Libify.buildTransaction = function (attributes, operations, networkObj) {
	  _stellarSdk2['default'].Network.use(networkObj);
	  var result = {
	    errors: [],
	    xdr: ''
	  };
	
	  try {
	    var account = new _stellarSdk2['default'].Account(attributes.sourceAccount, _stellarSdk2['default'].UnsignedHyper.fromString(attributes.sequence).subtract(1).toString());
	
	    var opts = {};
	    if (attributes.fee !== '') {
	      var MAX_UINT32 = Math.pow(2, 32) - 1;
	      if (parseInt(attributes.fee) > MAX_UINT32) {
	        throw Error('Base Fee: too large (invalid 32-bit unisigned integer)');
	      }
	
	      opts.fee = attributes.fee;
	    }
	
	    var timebounds = {};
	
	    if (attributes.minTime !== '') {
	      timebounds.minTime = attributes.minTime;
	    }
	
	    if (attributes.maxTime !== '') {
	      timebounds.maxTime = attributes.maxTime;
	    }
	
	    if (!_lodash2['default'].isEmpty(timebounds)) {
	      opts.timebounds = _lodash2['default'].defaults(timebounds, {
	        minTime: '0',
	        maxTime: '0'
	      });
	    }
	
	    var transaction = new _stellarSdk2['default'].TransactionBuilder(account, opts);
	
	    if (_lodash2['default'].isEmpty(timebounds) || opts.timebounds && opts.timebounds.maxTime == 0) {
	      transaction.setTimeout(transaction.setTimeout(_stellarSdk2['default'].TimeoutInfinite));
	    }
	
	    if (attributes.memoType !== 'MEMO_NONE' && attributes.memoType !== '') {
	      try {
	        transaction = transaction.addMemo(Libify.Memo({
	          type: attributes.memoType,
	          content: attributes.memoContent
	        }));
	      } catch (e) {
	        result.errors.push('Memo: ' + e.message);
	      }
	    }
	
	    _lodash2['default'].each(operations, function (op, index) {
	      try {
	        transaction = transaction.addOperation(Libify.Operation(op.name, op.attributes));
	      } catch (e) {
	        result.errors.push('Operation #' + (index + 1) + ': ' + e.message);
	      }
	    });
	
	    transaction = transaction.build();
	    result.xdr = transaction.toEnvelope().toXDR('base64');
	    result.hash = transaction.hash().toString('hex');
	  } catch (e) {
	    result.errors.push(e.message);
	  }
	
	  return result;
	};
	
	Libify.signTransaction = function (txXdr, signers, networkObj, ledgerWalletSigs) {
	  _stellarSdk2['default'].Network.use(networkObj);
	
	  var validSecretKeys = [];
	  var validPreimages = [];
	  for (var i = 0; i < signers.length; i++) {
	    var signer = signers[i];
	    if (signer !== null && !_lodash2['default'].isUndefined(signer) && signer !== '') {
	      // Signer
	      if (signer.charAt(0) == 'S') {
	        if (!_stellarSdk2['default'].StrKey.isValidEd25519SecretSeed(signer)) {
	          return {
	            message: 'One of secret keys is invalid'
	          };
	        }
	        validSecretKeys.push(signer);
	      } else {
	        // Hash preimage
	        if (!signer.match(/^[0-9a-f]{2,128}$/gi) || signer.length % 2 == 1) {
	          return {
	            message: 'Hash preimage is invalid'
	          };
	        }
	        validPreimages.push(signer);
	      }
	    }
	  }
	
	  var newTx = new _stellarSdk2['default'].Transaction(txXdr);
	  var existingSigs = newTx.signatures.length;
	  var addedSigs = 0;
	
	  _lodash2['default'].each(validSecretKeys, function (signer) {
	    addedSigs++;
	    newTx.sign(_stellarSdk2['default'].Keypair.fromSecret(signer));
	  });
	  _lodash2['default'].each(validPreimages, function (signer) {
	    addedSigs++;
	    newTx.signHashX(Buffer.from(signer, 'hex'));
	  });
	  _lodash2['default'].each(ledgerWalletSigs, function (ledgerSig) {
	    addedSigs++;
	    newTx.signatures.push(ledgerSig);
	  });
	
	  if (addedSigs < 1) {
	    return {
	      message: 'Enter a secret key to sign message'
	    };
	  }
	
	  return {
	    xdr: newTx.toEnvelope().toXDR('base64'),
	    message: addedSigs + ' signature(s) added; ' + (existingSigs + addedSigs) + ' signature(s) total'
	  };
	};
	
	exports['default'] = Libify;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10).Buffer))

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	// Calling `dispatch` inside the `.catch` of `httpRequest` causes problems
	// because it silently hides errors down the stack including all the React
	// re-rendering happening due to the dispatch.
	// By dispatching in a new stack, the dispatch function won't be caught
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = dispatchInNewStack;
	
	function dispatchInNewStack(dispatch, dispatchObj) {
	  setTimeout(function () {
	    dispatch(dispatchObj);
	  }, 0);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// This code originally taken from the XDR Viewer https://github.com/stellar/xdr-viewer
	// by Stellar Development Foundation under Apache-2.0.
	
	// This turns a base64 encoded xdr object with it's type, and turns it into an
	// object with more detailed information suitable for use in the tree view.
	
	// Values can be one of three types:
	// - undefined
	// - string: string values that appear as just plain text
	// - object: typed values always with a type and value `{type: 'code', value: 'Foo();'}`
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = extrapolateFromXdr;
	
	var _stellarSdk = __webpack_require__(23);
	
	function extrapolateFromXdr(input, type) {
	  // TODO: Check to see if type exists
	  // TODO: input validation
	
	  var xdrObject = undefined;
	  try {
	    xdrObject = _stellarSdk.xdr[type].fromXDR(input, 'base64');
	  } catch (error) {
	    throw new Error('Input XDR could not be parsed');
	  }
	
	  var tree = [{}];
	  buildTreeFromObject(xdrObject, tree[0], type);
	  return tree;
	}
	
	function buildTreeFromObject(object, anchor, name) {
	  anchor.type = name;
	
	  if (_.isArray(object)) {
	    parseArray(anchor, object);
	  } else if (!hasChildren(object)) {
	    anchor.value = getValue(object, name);
	  } else if (object['switch']) {
	    parseArm(anchor, object);
	  } else {
	    parseNormal(anchor, object);
	  }
	}
	
	function parseArray(anchor, object) {
	  anchor.value = 'Array[' + object.length + ']';
	  anchor.nodes = [];
	  for (var i = 0; i < object.length; i++) {
	    anchor.nodes.push({});
	    buildTreeFromObject(object[i], anchor.nodes[anchor.nodes.length - 1], '[' + i + ']');
	  }
	}
	
	function parseArm(anchor, object) {
	  anchor.value = '[' + object['switch']().name + ']';
	  if (_.isString(object.arm())) {
	    anchor.nodes = [{}];
	    buildTreeFromObject(object[object.arm()](), anchor.nodes[anchor.nodes.length - 1], object.arm());
	  }
	}
	
	function parseNormal(anchor, object) {
	  anchor.nodes = [];
	  _(object).functionsIn().without('toXDR').value().forEach(function (name) {
	    anchor.nodes.push({});
	    buildTreeFromObject(object[name](), anchor.nodes[anchor.nodes.length - 1], name);
	  });
	}
	
	function hasChildren(object) {
	  // string
	  if (_.isString(object)) {
	    return false;
	  }
	  // node buffer
	  if (object && object._isBuffer) {
	    return false;
	  }
	  var functions = _.functionsIn(object);
	  if (functions.length == 0) {
	    return false;
	  }
	  // int64
	  if (_.includes(functions, 'getLowBits') && _.includes(functions, 'getHighBits')) {
	    return false;
	  }
	  return true;
	}
	
	var amountFields = ['amount', 'startingBalance', 'sendMax', 'destAmount', 'limit'];
	
	function getValue(object, name) {
	  if (_.includes(amountFields, name)) {
	    return {
	      type: 'amount',
	      value: {
	        parsed: _stellarSdk.Operation._fromXDRAmount(object),
	        raw: object.toString()
	      }
	    };
	  }
	
	  if (name === 'hint') {
	    // strkey encoding is using base32 encoding. Encoded public key consists of:
	    //
	    //  * 1 byte version byte (0x30 encoded as `G`)
	    //  * 32 bytes public key
	    //  * 2 bytes checksum
	    //
	    // Because base32 symbols are 5-bit, more than one symbol is needed to represent a single byte.
	    // Signature Hint is the last 4 bytes of the public key. So we need to try to show as many 5-bit
	    // chunks as possible included between bytes 30 and 33 (included).
	    //
	    // byte 1: ##### ###
	    // byte 2:          ## ##### #
	    // byte 3:                    #### ####
	    // byte 4:                             # ##### ##
	    // byte 5:                                       ### #####  <---------- 40 bits / full alignment
	    // byte 6:                                                ##### ###
	    // byte 7:                                                         ## ##### #
	    //
	    // .....
	    //
	    // byte 26: ##### ###
	    // byte 27:          ## ##### #
	    // byte 28:                    #### ####                    full b32 symbols
	    // byte 29:                             # ##### ##    |--------------------------|
	    // byte 30:                                       ### 48###                      |
	    // byte 31:                  Signature Hint start |        49### 50#             |    Signature Hint end
	    // byte 32:                                                         ## 51### 5   |    |
	    // byte 33:                                                                   2### 53##
	    // byte 34:                                                                            # 54### 55
	    // byte 35:                                                                                      ### 56###
	    //
	    var hintBytes = new Buffer(object, 'base64');
	    var partialPublicKey = Buffer.concat([new Buffer(28).fill(0), hintBytes]);
	    var keypair = new _stellarSdk.Keypair({ type: 'ed25519', publicKey: partialPublicKey });
	    var partialPublicKeyString = 'G' + new Buffer(46).fill('_').toString() + keypair.publicKey().substr(47, 5) + new Buffer(4).fill('_').toString();
	    return { type: 'code', value: partialPublicKeyString };
	  }
	
	  if (name === 'ed25519') {
	    var address = _stellarSdk.StrKey.encodeEd25519PublicKey(object);
	    return { type: 'code', value: address };
	  }
	
	  if (name === 'assetCode' || name === 'assetCode4' || name === 'assetCode12') {
	    return object.toString();
	  }
	
	  if (object && object._isBuffer) {
	    return { type: 'code', raw: object, value: new Buffer(object).toString('base64') };
	  }
	
	  if (typeof object === 'undefined') {
	    return;
	  }
	
	  // getValue is a leaf in the recursive xdr extrapolating function meaning that
	  // whatever this function returns will be in the final result as-is.
	  // Therefore, we want them in string format so that it displayable in React.
	  // One example of why we need this is that UnsignedHyper values won't get
	  // displayed unless we convert it to a string.
	  if (typeof object.toString === 'function') {
	    return object.toString();
	  }
	
	  throw new Error('Internal laboratory bug: Encountered value type in XDR viewer that does not have a toString method');
	}
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10).Buffer))

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _reactRedux = __webpack_require__(37);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _url = __webpack_require__(119);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _querystring = __webpack_require__(268);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _actionsRouting = __webpack_require__(85);
	
	var _stateSerializer = __webpack_require__(316);
	
	// One way data flow for routerMiddleware: redux -> url
	var routerMiddleware = function routerMiddleware(store) {
	  return function (next) {
	    return function (action) {
	      var result = next(action);
	      var state = store.getState();
	
	      // We will still process on UPDATE_LOCATION because it doesn't affect state
	      if (action.type === _actionsRouting.LOAD_STATE) {
	        return result;
	      }
	
	      var newUrlObj = parseUrlHash(window.location.hash);
	      newUrlObj.query = (0, _stateSerializer.stateToQueryObj)(state.routing.location, state);
	      delete newUrlObj.search;
	
	      // NOTE: We only replace state here since these are only for general state
	      // changes. By using history.replaceState, the routerListener won't pick up
	      // on these changes.
	      var newUrlHash = '#' + _url2['default'].format(newUrlObj);
	      if (newUrlHash === '#') {
	        newUrlHash = window.location.pathname;
	      }
	      history.replaceState(null, null, newUrlHash);
	
	      return result;
	    };
	  };
	};
	
	exports.routerMiddleware = routerMiddleware;
	// One way data flow for RouterListener: url change -> redux
	
	var RouterHashListener = (function (_React$Component) {
	  _inherits(RouterHashListener, _React$Component);
	
	  function RouterHashListener() {
	    _classCallCheck(this, RouterHashListener);
	
	    _get(Object.getPrototypeOf(RouterHashListener.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(RouterHashListener, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      window.addEventListener('hashchange', this.hashChangeHandler.bind(this), false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Just doing our duty of cleanup though it's really not necessary
	      window.removeEventListener('hashchange', this.hashChangeHandler.bind(this), false);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.changeProcessor(parseUrlHash(window.location.hash), {}, true);
	    }
	  }, {
	    key: 'hashChangeHandler',
	    value: function hashChangeHandler(e) {
	      this.changeProcessor(parseUrlHash(e.newURL), parseUrlHash(e.oldURL));
	    }
	
	    // @param {UrlObj|object} newUrl - URL object (of the hash) from node `url`
	    // @param {UrlObj|object} oldUrl - URL object (of the hash) from node `url`. Can be empty object
	  }, {
	    key: 'changeProcessor',
	    value: function changeProcessor(newUrl, oldUrl, firstLoad) {
	      var queryChanged = oldUrl.query !== newUrl.query;
	      var shouldLoadState = firstLoad || queryChanged && newUrl.query !== null;
	
	      if (shouldLoadState) {
	        var newQueryObj = _querystring2['default'].parse(newUrl.query);
	        this.props.dispatch((0, _actionsRouting.loadState)(newUrl.pathname, newQueryObj));
	        return;
	      } else {
	        this.props.dispatch((0, _actionsRouting.updateLocation)(newUrl.pathname));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return RouterHashListener;
	})(_react2['default'].Component);
	
	function parseUrlHash(input) {
	  var hash = _url2['default'].parse(input).hash || '';
	  return _url2['default'].parse(hash.substr(1));
	}
	
	var RouterListener = (0, _reactRedux.connect)(chooseState, function (dispatch) {
	  return { dispatch: dispatch };
	})(RouterHashListener);
	exports.RouterListener = RouterListener;
	function chooseState(state) {
	  return {
	    routing: state.routing
	  };
	}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.stateToQueryObj = stateToQueryObj;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _hydration = __webpack_require__(205);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constantsSlug = __webpack_require__(107);
	
	var _constantsSlug2 = _interopRequireDefault(_constantsSlug);
	
	var _constantsNetwork = __webpack_require__(75);
	
	var _constantsNetwork2 = _interopRequireDefault(_constantsNetwork);
	
	// The state serializer converts the state relevant to a specific page into an object.
	// This object is then used to build the routing url.
	
	// It is optional in that if a feature was implemented in just the reducer, it
	// can work without needing a state serializer implemented. Without the state
	// serializer implemented, the url hash state params will be empty.
	
	// This does two parts of the 3 part cycle of routing:
	// (state) --->[stateToQueryObj()]---> (queryObj)
	// (queryObj) --->[queryObjToLoadStatePayload()]---> (loadStateObj)
	// (loadStateObj) --->[LOAD_STATE action]--->[redux reducers]---> (state)
	
	// The state that gets passed here may be an incomplete one.
	// Incomplete ones are useful because it lets us build URLs without needing the
	// whole state tree (such as in ../utilities/linkBuilder.js).
	
	function stateToQueryObj(slug, state) {
	  return _lodash2['default'].assign({}, serializePageSpecificState(slug, state), serializeNetworkState(state));
	}
	
	function serializeNetworkState(state) {
	  // Only return something if we were passed the current network
	  if (_lodash2['default'].has(state, 'network')) {
	    if (state.network.current.name == "custom") {
	      return {
	        network: state.network.current.name,
	        horizonURL: state.network.current.horizonURL,
	        networkPassphrase: state.network.current.networkPassphrase
	      };
	    }
	
	    return { network: state.network.current.name };
	  }
	  return {};
	}
	
	function serializePageSpecificState(slug, state) {
	  switch (slug) {
	    case _constantsSlug2['default'].EXPLORER:
	      var endpointsResult = {};
	      if (state.endpointExplorer.currentResource) {
	        endpointsResult.resource = state.endpointExplorer.currentResource;
	      }
	      if (state.endpointExplorer.currentEndpoint) {
	        endpointsResult.endpoint = state.endpointExplorer.currentEndpoint;
	      }
	      if (_lodash2['default'].size(state.endpointExplorer.pendingRequest.values) > 0) {
	        endpointsResult.values = (0, _hydration.dehydrate)(state.endpointExplorer.pendingRequest.values);
	      }
	      return endpointsResult;
	    case _constantsSlug2['default'].TXBUILDER:
	      var txbuilderResult = {};
	      var txbuilderAttributes = assignNonEmpty({}, state.transactionBuilder.attributes);
	      if (_lodash2['default'].size(txbuilderAttributes) > 0) {
	        txbuilderResult.attributes = txbuilderAttributes;
	      }
	
	      var firstOpEmpty = state.transactionBuilder.operations[0].name === '';
	      if (state.transactionBuilder.operations.length > 1 || !firstOpEmpty) {
	        txbuilderResult.operations = state.transactionBuilder.operations;
	      }
	
	      if (_lodash2['default'].has(txbuilderResult, 'attributes.memoType') && txbuilderResult.attributes.memoType === 'MEMO_NONE') {
	        delete txbuilderResult.attributes.memoType;
	      }
	
	      if (_lodash2['default'].size(txbuilderResult.attributes) === 0) {
	        delete txbuilderResult.attributes;
	      }
	
	      if (_lodash2['default'].size(txbuilderResult) === 0) {
	        return {};
	      }
	      return {
	        params: (0, _hydration.dehydrate)(txbuilderResult)
	      };
	    case _constantsSlug2['default'].TXSIGNER:
	      // We only want to serialize the imported xdr and not the saved secret key
	      // to prevent sensitive data being stored in browser history.
	      var txsignerResult = {};
	      if (state.transactionSigner.xdr.length > 0) {
	        txsignerResult.xdr = state.transactionSigner.xdr;
	      }
	      return txsignerResult;
	    case 'xdr-viewer':
	      var xdrViewer = {};
	      if (state.xdrViewer.input !== '') {
	        xdrViewer.input = state.xdrViewer.input;
	      }
	      if (state.xdrViewer.type !== '') {
	        xdrViewer.type = state.xdrViewer.type;
	      }
	      return xdrViewer;
	    default:
	      return {};
	  }
	}
	
	// Similar to Object.assign except it doesn't copy over non-empty ones such
	// as '' or undefined
	function assignNonEmpty(targetObj, inputObj) {
	  _lodash2['default'].each(inputObj, function (value, key) {
	    if (value === '' || value === undefined) {
	      return;
	    }
	    targetObj[key] = value;
	  });
	
	  return targetObj;
	}

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = validateBase64;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function validateBase64(input) {
	  input = _lodash2['default'].trim(input);
	
	  if (input === '') {
	    return {
	      result: 'empty'
	    };
	  }
	  if (input.match(/^[-A-Za-z0-9+\/=]*$/) === null) {
	    return {
	      result: 'error',
	      message: 'The input is not valid base64 (a-zA-Z0-9+/=).'
	    };
	  }
	
	  return { result: 'success' };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(45);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(18);
	var toAbsoluteIndex = __webpack_require__(94);
	var toLength = __webpack_require__(15);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(87);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(27);
	var toObject = __webpack_require__(18);
	var IObject = __webpack_require__(127);
	var toLength = __webpack_require__(15);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(27);
	var isObject = __webpack_require__(9);
	var invoke = __webpack_require__(328);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 323 */
[1181, 17, 88, 92, 47, 86, 87, 220, 331, 93, 16, 78, 96],
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(108);
	var from = __webpack_require__(320);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(92);
	var getWeak = __webpack_require__(78).getWeak;
	var anObject = __webpack_require__(3);
	var isObject = __webpack_require__(9);
	var anInstance = __webpack_require__(86);
	var forOf = __webpack_require__(87);
	var createArrayMethod = __webpack_require__(58);
	var $has = __webpack_require__(39);
	var validate = __webpack_require__(96);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(155);
	var isObject = __webpack_require__(9);
	var toLength = __webpack_require__(15);
	var ctx = __webpack_require__(47);
	var IS_CONCAT_SPREADABLE = __webpack_require__(14)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 327 */
[1188, 16, 7, 213],
/* 328 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(9);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 330 */
[1192, 3],
/* 331 */
375,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(222);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 333 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 334 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(16);
	var getKeys = __webpack_require__(90);
	var gOPS = __webpack_require__(159);
	var pIE = __webpack_require__(128);
	var toObject = __webpack_require__(18);
	var IObject = __webpack_require__(127);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(7)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 336 */
[1198, 17, 3, 90, 16],
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(42);
	var gOPN = __webpack_require__(89).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 338 */
[1200, 39, 42, 152, 227],
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(16);
	var getKeys = __webpack_require__(90);
	var toIObject = __webpack_require__(42);
	var isEnum = __webpack_require__(128).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(89);
	var gOPS = __webpack_require__(159);
	var anObject = __webpack_require__(3);
	var Reflect = __webpack_require__(5).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(5).parseFloat;
	var $trim = __webpack_require__(111).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(230) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(5).parseInt;
	var $trim = __webpack_require__(111).trim;
	var ws = __webpack_require__(230);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(3);
	var isObject = __webpack_require__(9);
	var newPromiseCapability = __webpack_require__(224);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(15);
	var repeat = __webpack_require__(229);
	var defined = __webpack_require__(59);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(49);
	var toLength = __webpack_require__(15);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(14);


/***/ }),
/* 349 */
[1215, 323, 96, 153],
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(225);
	__webpack_require__(1)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(16) && /./g.flags != 'g') __webpack_require__(17).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(126)
	});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(323);
	var validate = __webpack_require__(96);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(153)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var each = __webpack_require__(58)(0);
	var redefine = __webpack_require__(35);
	var meta = __webpack_require__(78);
	var assign = __webpack_require__(335);
	var weak = __webpack_require__(325);
	var isObject = __webpack_require__(9);
	var validate = __webpack_require__(96);
	var NATIVE_WEAK_MAP = __webpack_require__(96);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(153)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 354 */,
/* 355 */,
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = __webpack_require__(13);
	var getKeys = __webpack_require__(97).keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var util = __webpack_require__(13);
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = __webpack_require__(80);
	var OperationalError = errors.OperationalError;
	var es5 = __webpack_require__(97);
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;


/***/ }),
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1014)();
	}


/***/ }),
/* 424 */,
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(423);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(266);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1087);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* eslint-disable no-continue */
	/* eslint-disable no-param-reassign */
	/* eslint-disable no-prototype-builtins */
	
	var errorClasses = {};
	var deserializers = {};
	
	var addCustomErrorDeserializer = exports.addCustomErrorDeserializer = function addCustomErrorDeserializer(name, deserializer) {
	  deserializers[name] = deserializer;
	};
	
	var createCustomErrorClass = exports.createCustomErrorClass = function createCustomErrorClass(name) {
	  var C = function CustomError(message, fields) {
	    Object.assign(this, fields);
	    this.name = name;
	    this.message = message || name;
	    this.stack = new Error().stack;
	  };
	  // $FlowFixMe
	  C.prototype = new Error();
	
	  errorClasses[name] = C;
	  // $FlowFixMe we can't easily type a subset of Error for now...
	  return C;
	};
	
	// inspired from https://github.com/programble/errio/blob/master/index.js
	var deserializeError = exports.deserializeError = function deserializeError(object) {
	  if ((typeof object === "undefined" ? "undefined" : _typeof(object)) === "object" && object) {
	    try {
	      // $FlowFixMe FIXME HACK
	      var msg = JSON.parse(object.message);
	      if (msg.message && msg.name) {
	        object = msg;
	      }
	    } catch (e) {
	      // nothing
	    }
	
	    var error = void 0;
	    if (typeof object.name === "string") {
	      var _object = object,
	          name = _object.name;
	
	      var des = deserializers[name];
	      if (des) {
	        error = des(object);
	      } else {
	        var _constructor = name === "Error" ? Error : errorClasses[name];
	
	        if (!_constructor) {
	          console.warn("deserializing an unknown class '" + name + "'");
	          _constructor = createCustomErrorClass(name);
	        }
	
	        error = Object.create(_constructor.prototype);
	        try {
	          for (var prop in object) {
	            if (object.hasOwnProperty(prop)) {
	              error[prop] = object[prop];
	            }
	          }
	        } catch (e) {
	          // sometimes setting a property can fail (e.g. .name)
	        }
	      }
	    } else {
	      error = new Error(object.message);
	    }
	
	    if (!error.stack && Error.captureStackTrace) {
	      Error.captureStackTrace(error, deserializeError);
	    }
	    return error;
	  }
	  return new Error(String(object));
	};
	
	// inspired from https://github.com/sindresorhus/serialize-error/blob/master/index.js
	var serializeError = exports.serializeError = function serializeError(value) {
	  if (!value) return value;
	  if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
	    return destroyCircular(value, []);
	  }
	  if (typeof value === "function") {
	    return "[Function: " + (value.name || "anonymous") + "]";
	  }
	  return value;
	};
	
	// https://www.npmjs.com/package/destroy-circular
	function destroyCircular(from, seen) {
	  var to = {};
	  seen.push(from);
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Object.keys(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var key = _step.value;
	
	      var value = from[key];
	      if (typeof value === "function") {
	        continue;
	      }
	      if (!value || (typeof value === "undefined" ? "undefined" : _typeof(value)) !== "object") {
	        to[key] = value;
	        continue;
	      }
	      if (seen.indexOf(from[key]) === -1) {
	        to[key] = destroyCircular(from[key], seen.slice(0));
	        continue;
	      }
	      to[key] = "[Circular]";
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  if (typeof from.name === "string") {
	    to.name = from.name;
	  }
	  if (typeof from.message === "string") {
	    to.message = from.message;
	  }
	  if (typeof from.stack === "string") {
	    to.stack = from.stack;
	  }
	  return to;
	}
	//# sourceMappingURL=helpers.js.map

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(490);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/********************************************************************************
	 *   Ledger Node JS API
	 *   (c) 2017-2018 Ledger
	 *
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 ********************************************************************************/
	var CLA = 0xe0;
	var INS_GET_PK = 0x02;
	var INS_SIGN_TX = 0x04;
	var INS_GET_CONF = 0x06;
	var INS_SIGN_TX_HASH = 0x08;
	var INS_KEEP_ALIVE = 0x10;
	
	var APDU_MAX_SIZE = 150;
	var P1_FIRST_APDU = 0x00;
	var P1_MORE_APDU = 0x80;
	var P2_LAST_APDU = 0x00;
	var P2_MORE_APDU = 0x80;
	
	var SW_OK = 0x9000;
	var SW_CANCEL = 0x6985;
	var SW_UNKNOWN_OP = 0x6c24;
	var SW_MULTI_OP = 0x6c25;
	var SW_NOT_ALLOWED = 0x6c66;
	var SW_UNSUPPORTED = 0x6d00;
	var SW_KEEP_ALIVE = 0x6e02;
	
	var TX_MAX_SIZE = 1540;
	
	/**
	 * Stellar API
	 *
	 * @example
	 * import Str from "@ledgerhq/hw-app-str";
	 * const str = new Str(transport)
	 */
	
	var Str = function () {
	  function Str(transport) {
	    var scrambleKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "l0v";
	
	    _classCallCheck(this, Str);
	
	    this.transport = transport;
	    transport.decorateAppAPIMethods(this, ["getAppConfiguration", "getPublicKey", "signTransaction", "signHash"], scrambleKey);
	  }
	
	  _createClass(Str, [{
	    key: "getAppConfiguration",
	    value: function getAppConfiguration() {
	      return this.transport.send(CLA, INS_GET_CONF, 0x00, 0x00).then(function (response) {
	        var multiOpsEnabled = response[0] === 0x01 || response[1] < 0x02;
	        var version = "" + response[1] + "." + response[2] + "." + response[3];
	        return {
	          version: version,
	          multiOpsEnabled: multiOpsEnabled
	        };
	      });
	    }
	
	    /**
	     * get Stellar public key for a given BIP 32 path.
	     * @param path a path in BIP 32 format
	     * @option boolValidate optionally enable key pair validation
	     * @option boolDisplay optionally enable or not the display
	     * @return an object with the publicKey (using XLM public key format) and
	     * the raw ed25519 public key.
	     * @example
	     * str.getPublicKey("44'/148'/0'").then(o => o.publicKey)
	     */
	
	  }, {
	    key: "getPublicKey",
	    value: function getPublicKey(path, boolValidate, boolDisplay) {
	      var _this = this;
	
	      (0, _utils.checkStellarBip32Path)(path);
	
	      var apdus = [];
	      var response = void 0;
	
	      var pathElts = (0, _utils.splitPath)(path);
	      var buffer = new Buffer(1 + pathElts.length * 4);
	      buffer[0] = pathElts.length;
	      pathElts.forEach(function (element, index) {
	        buffer.writeUInt32BE(element, 1 + 4 * index);
	      });
	      var verifyMsg = Buffer.from("via lumina", "ascii");
	      apdus.push(Buffer.concat([buffer, verifyMsg]));
	      var keepAlive = false;
	      return (0, _utils.foreach)(apdus, function (data) {
	        return _this.transport.send(CLA, keepAlive ? INS_KEEP_ALIVE : INS_GET_PK, boolValidate ? 0x01 : 0x00, boolDisplay ? 0x01 : 0x00, data, [SW_OK, SW_KEEP_ALIVE]).then(function (apduResponse) {
	          var status = Buffer.from(apduResponse.slice(apduResponse.length - 2)).readUInt16BE(0);
	          if (status === SW_KEEP_ALIVE) {
	            keepAlive = true;
	            apdus.push(Buffer.alloc(0));
	          }
	          response = apduResponse;
	        });
	      }).then(function () {
	        // response = Buffer.from(response, 'hex');
	        var offset = 0;
	        var rawPublicKey = response.slice(offset, offset + 32);
	        offset += 32;
	        var publicKey = (0, _utils.encodeEd25519PublicKey)(rawPublicKey);
	        if (boolValidate) {
	          var _signature = response.slice(offset, offset + 64);
	          if (!(0, _utils.verifyEd25519Signature)(verifyMsg, _signature, rawPublicKey)) {
	            throw new Error("Bad signature. Keypair is invalid. Please report this.");
	          }
	        }
	        return {
	          publicKey: publicKey,
	          raw: rawPublicKey
	        };
	      });
	    }
	
	    /**
	     * sign a Stellar transaction.
	     * @param path a path in BIP 32 format
	     * @param transaction signature base of the transaction to sign
	     * @return an object with the signature and the status
	     * @example
	     * str.signTransaction("44'/148'/0'", signatureBase).then(o => o.signature)
	     */
	
	  }, {
	    key: "signTransaction",
	    value: function signTransaction(path, transaction) {
	      var _this2 = this;
	
	      (0, _utils.checkStellarBip32Path)(path);
	
	      if (transaction.length > TX_MAX_SIZE) {
	        throw new Error("Transaction too large: max = " + TX_MAX_SIZE + "; actual = " + transaction.length);
	      }
	
	      var apdus = [];
	      var response = void 0;
	
	      var pathElts = (0, _utils.splitPath)(path);
	      var bufferSize = 1 + pathElts.length * 4;
	      var buffer = Buffer.alloc(bufferSize);
	      buffer[0] = pathElts.length;
	      pathElts.forEach(function (element, index) {
	        buffer.writeUInt32BE(element, 1 + 4 * index);
	      });
	      var chunkSize = APDU_MAX_SIZE - bufferSize;
	      if (transaction.length <= chunkSize) {
	        // it fits in a single apdu
	        apdus.push(Buffer.concat([buffer, transaction]));
	      } else {
	        // we need to send multiple apdus to transmit the entire transaction
	        var chunk = Buffer.alloc(chunkSize);
	        var offset = 0;
	        transaction.copy(chunk, 0, offset, chunkSize);
	        apdus.push(Buffer.concat([buffer, chunk]));
	        offset += chunkSize;
	        while (offset < transaction.length) {
	          var remaining = transaction.length - offset;
	          chunkSize = remaining < APDU_MAX_SIZE ? remaining : APDU_MAX_SIZE;
	          chunk = Buffer.alloc(chunkSize);
	          transaction.copy(chunk, 0, offset, offset + chunkSize);
	          offset += chunkSize;
	          apdus.push(chunk);
	        }
	      }
	      var keepAlive = false;
	      return (0, _utils.foreach)(apdus, function (data, i) {
	        return _this2.transport.send(CLA, keepAlive ? INS_KEEP_ALIVE : INS_SIGN_TX, i === 0 ? P1_FIRST_APDU : P1_MORE_APDU, i === apdus.length - 1 ? P2_LAST_APDU : P2_MORE_APDU, data, [SW_OK, SW_CANCEL, SW_UNKNOWN_OP, SW_MULTI_OP, SW_KEEP_ALIVE]).then(function (apduResponse) {
	          var status = Buffer.from(apduResponse.slice(apduResponse.length - 2)).readUInt16BE(0);
	          if (status === SW_KEEP_ALIVE) {
	            keepAlive = true;
	            apdus.push(Buffer.alloc(0));
	          }
	          response = apduResponse;
	        });
	      }).then(function () {
	        var status = Buffer.from(response.slice(response.length - 2)).readUInt16BE(0);
	        if (status === SW_OK) {
	          var _signature2 = Buffer.from(response.slice(0, response.length - 2));
	          return {
	            signature: _signature2
	          };
	        } else if (status === SW_UNKNOWN_OP) {
	          // pre-v2 app version: fall back on hash signing
	          return _this2.signHash_private(path, (0, _utils.hash)(transaction));
	        } else if (status === SW_MULTI_OP) {
	          // multi-operation transaction: attempt hash signing
	          return _this2.signHash_private(path, (0, _utils.hash)(transaction));
	        } else {
	          throw new Error("Transaction approval request was rejected");
	        }
	      });
	    }
	
	    /**
	     * sign a Stellar transaction hash.
	     * @param path a path in BIP 32 format
	     * @param hash hash of the transaction to sign
	     * @return an object with the signature
	     * @example
	     * str.signHash("44'/148'/0'", hash).then(o => o.signature)
	     */
	
	  }, {
	    key: "signHash",
	    value: function signHash(path, hash) {
	      (0, _utils.checkStellarBip32Path)(path);
	      return this.signHash_private(path, hash);
	    }
	  }, {
	    key: "signHash_private",
	    value: function signHash_private(path, hash) {
	      var _this3 = this;
	
	      var apdus = [];
	      var response = void 0;
	
	      var pathElts = (0, _utils.splitPath)(path);
	      var buffer = Buffer.alloc(1 + pathElts.length * 4);
	      buffer[0] = pathElts.length;
	      pathElts.forEach(function (element, index) {
	        buffer.writeUInt32BE(element, 1 + 4 * index);
	      });
	      apdus.push(Buffer.concat([buffer, hash]));
	      var keepAlive = false;
	      return (0, _utils.foreach)(apdus, function (data) {
	        return _this3.transport.send(CLA, keepAlive ? INS_KEEP_ALIVE : INS_SIGN_TX_HASH, 0x00, 0x00, data, [SW_OK, SW_CANCEL, SW_NOT_ALLOWED, SW_UNSUPPORTED, SW_KEEP_ALIVE]).then(function (apduResponse) {
	          var status = Buffer.from(apduResponse.slice(apduResponse.length - 2)).readUInt16BE(0);
	          if (status === SW_KEEP_ALIVE) {
	            keepAlive = true;
	            apdus.push(Buffer.alloc(0));
	          }
	          response = apduResponse;
	        });
	      }).then(function () {
	        var status = Buffer.from(response.slice(response.length - 2)).readUInt16BE(0);
	        if (status === SW_OK) {
	          var _signature3 = Buffer.from(response.slice(0, response.length - 2));
	          return {
	            signature: _signature3
	          };
	        } else if (status === SW_CANCEL) {
	          throw new Error("Transaction approval request was rejected");
	        } else if (status === SW_UNSUPPORTED) {
	          throw new Error("Hash signing is not supported");
	        } else {
	          throw new Error("Hash signing not allowed. Have you enabled it in the app settings?");
	        }
	      });
	    }
	  }]);
	
	  return Str;
	}();
	
	exports.default = Str;
	//# sourceMappingURL=Str.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10).Buffer))

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.splitPath = splitPath;
	exports.foreach = foreach;
	exports.crc16xmodem = crc16xmodem;
	exports.encodeEd25519PublicKey = encodeEd25519PublicKey;
	exports.verifyEd25519Signature = verifyEd25519Signature;
	exports.hash = hash;
	exports.checkStellarBip32Path = checkStellarBip32Path;
	
	var _base = __webpack_require__(354);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _tweetnacl = __webpack_require__(294);
	
	var _tweetnacl2 = _interopRequireDefault(_tweetnacl);
	
	var _sha = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO use bip32-path library
	function splitPath(path) {
	  var result = [];
	  var components = path.split("/");
	  components.forEach(function (element) {
	    var number = parseInt(element, 10);
	    if (isNaN(number)) {
	      return; // FIXME shouldn't it throws instead?
	    }
	    if (element.length > 1 && element[element.length - 1] === "'") {
	      number += 0x80000000;
	    }
	    result.push(number);
	  });
	  return result;
	} /********************************************************************************
	   *   Ledger Node JS API
	   *   (c) 2017-2018 Ledger
	   *
	   *  Licensed under the Apache License, Version 2.0 (the "License");
	   *  you may not use this file except in compliance with the License.
	   *  You may obtain a copy of the License at
	   *
	   *      http://www.apache.org/licenses/LICENSE-2.0
	   *
	   *  Unless required by applicable law or agreed to in writing, software
	   *  distributed under the License is distributed on an "AS IS" BASIS,
	   *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   *  See the License for the specific language governing permissions and
	   *  limitations under the License.
	   ********************************************************************************/
	
	
	function foreach(arr, callback) {
	  function iterate(index, array, result) {
	    if (index >= array.length) {
	      return result;
	    } else {
	      return callback(array[index], index).then(function (res) {
	        result.push(res);
	        return iterate(index + 1, array, result);
	      });
	    }
	  }
	  return Promise.resolve().then(function () {
	    return iterate(0, arr, []);
	  });
	}
	
	function crc16xmodem(buf, previous) {
	  var crc = typeof previous !== "undefined" ? ~~previous : 0x0;
	
	  for (var index = 0; index < buf.length; index++) {
	    var byte = buf[index];
	    var code = crc >>> 8 & 0xff;
	
	    code ^= byte & 0xff;
	    code ^= code >>> 4;
	    crc = crc << 8 & 0xffff;
	    crc ^= code;
	    code = code << 5 & 0xffff;
	    crc ^= code;
	    code = code << 7 & 0xffff;
	    crc ^= code;
	  }
	
	  return crc;
	}
	
	function encodeEd25519PublicKey(rawPublicKey) {
	  var versionByte = 6 << 3; // 'G'
	  var data = Buffer.from(rawPublicKey);
	  var versionBuffer = Buffer.from([versionByte]);
	  var payload = Buffer.concat([versionBuffer, data]);
	  var checksum = Buffer.alloc(2);
	  checksum.writeUInt16LE(crc16xmodem(payload), 0);
	  var unencoded = Buffer.concat([payload, checksum]);
	  return _base2.default.encode(unencoded);
	}
	
	function verifyEd25519Signature(data, signature, publicKey) {
	  return _tweetnacl2.default.sign.detached.verify(new Uint8Array(data.toJSON().data), new Uint8Array(signature.toJSON().data), new Uint8Array(publicKey.toJSON().data));
	}
	
	function hash(data) {
	  var hasher = new _sha.sha256();
	  hasher.update(data, "utf8");
	  return hasher.digest();
	}
	
	function checkStellarBip32Path(path) {
	  path.split("/").forEach(function (element) {
	    if (!element.toString().endsWith("'")) {
	      throw new Error("Detected a non-hardened path element in requested BIP32 path." + " Non-hardended paths are not supported at this time. Please use an all-hardened path." + " Example: 44'/148'/0'");
	    }
	  });
	}
	//# sourceMappingURL=utils.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10).Buffer))

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _u2fApi = __webpack_require__(1155);
	
	var _hwTransport = __webpack_require__(492);
	
	var _hwTransport2 = _interopRequireDefault(_hwTransport);
	
	var _logs = __webpack_require__(493);
	
	var _errors = __webpack_require__(295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function wrapU2FTransportError(originalError, message, id) {
	  var err = new _errors.TransportError(message, id);
	  // $FlowFixMe
	  err.originalError = originalError;
	  return err;
	}
	
	function wrapApdu(apdu, key) {
	  var result = Buffer.alloc(apdu.length);
	  for (var i = 0; i < apdu.length; i++) {
	    result[i] = apdu[i] ^ key[i % key.length];
	  }
	  return result;
	}
	
	// Convert from normal to web-safe, strip trailing "="s
	var webSafe64 = function webSafe64(base64) {
	  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
	};
	
	// Convert from web-safe to normal, add trailing "="s
	var normal64 = function normal64(base64) {
	  return base64.replace(/-/g, "+").replace(/_/g, "/") + "==".substring(0, 3 * base64.length % 4);
	};
	
	function attemptExchange(apdu, timeoutMillis, scrambleKey, unwrap) {
	  var keyHandle = wrapApdu(apdu, scrambleKey);
	  var challenge = Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex");
	  var signRequest = {
	    version: "U2F_V2",
	    keyHandle: webSafe64(keyHandle.toString("base64")),
	    challenge: webSafe64(challenge.toString("base64")),
	    appId: location.origin
	  };
	  (0, _logs.log)("apdu", "=> " + apdu.toString("hex"));
	  return (0, _u2fApi.sign)(signRequest, timeoutMillis / 1000).then(function (response) {
	    var signatureData = response.signatureData;
	
	    if (typeof signatureData === "string") {
	      var data = Buffer.from(normal64(signatureData), "base64");
	      var result = void 0;
	      if (!unwrap) {
	        result = data;
	      } else {
	        result = data.slice(5);
	      }
	      (0, _logs.log)("apdu", "<= " + result.toString("hex"));
	      return result;
	    } else {
	      throw response;
	    }
	  });
	}
	
	var transportInstances = [];
	
	function emitDisconnect() {
	  transportInstances.forEach(function (t) {
	    return t.emit("disconnect");
	  });
	  transportInstances = [];
	}
	
	function isTimeoutU2FError(u2fError) {
	  return u2fError.metaData.code === 5;
	}
	
	/**
	 * U2F web Transport implementation
	 * @example
	 * import TransportU2F from "@ledgerhq/hw-transport-u2f";
	 * ...
	 * TransportU2F.create().then(transport => ...)
	 */
	
	var TransportU2F = function (_Transport) {
	  _inherits(TransportU2F, _Transport);
	
	  _createClass(TransportU2F, null, [{
	    key: "open",
	
	
	    /**
	     * static function to create a new Transport from a connected Ledger device discoverable via U2F (browser support)
	     */
	
	
	    /*
	     */
	    value: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_) {
	        var _openTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt("return", new TransportU2F());
	
	              case 1:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function open(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return open;
	    }()
	
	    /*
	     */
	
	  }]);
	
	  function TransportU2F() {
	    _classCallCheck(this, TransportU2F);
	
	    var _this = _possibleConstructorReturn(this, (TransportU2F.__proto__ || Object.getPrototypeOf(TransportU2F)).call(this));
	
	    _this.unwrap = true;
	
	    transportInstances.push(_this);
	    return _this;
	  }
	
	  /**
	   * Exchange with the device using APDU protocol.
	   * @param apdu
	   * @returns a promise of apdu response
	   */
	
	
	  _createClass(TransportU2F, [{
	    key: "exchange",
	    value: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(apdu) {
	        var isU2FError;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	                _context2.next = 3;
	                return attemptExchange(apdu, this.exchangeTimeout, this.scrambleKey, this.unwrap);
	
	              case 3:
	                return _context2.abrupt("return", _context2.sent);
	
	              case 6:
	                _context2.prev = 6;
	                _context2.t0 = _context2["catch"](0);
	                isU2FError = _typeof(_context2.t0.metaData) === "object";
	
	                if (!isU2FError) {
	                  _context2.next = 14;
	                  break;
	                }
	
	                if (isTimeoutU2FError(_context2.t0)) {
	                  emitDisconnect();
	                }
	                // the wrapping make error more usable and "printable" to the end user.
	                throw wrapU2FTransportError(_context2.t0, "Failed to sign with Ledger device: U2F " + _context2.t0.metaData.type, "U2F_" + _context2.t0.metaData.code);
	
	              case 14:
	                throw _context2.t0;
	
	              case 15:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[0, 6]]);
	      }));
	
	      function exchange(_x3) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return exchange;
	    }()
	
	    /**
	     */
	
	  }, {
	    key: "setScrambleKey",
	    value: function setScrambleKey(scrambleKey) {
	      this.scrambleKey = Buffer.from(scrambleKey, "ascii");
	    }
	
	    /**
	     */
	
	  }, {
	    key: "setUnwrap",
	    value: function setUnwrap(unwrap) {
	      this.unwrap = unwrap;
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      // u2f have no way to clean things up
	      return Promise.resolve();
	    }
	  }]);
	
	  return TransportU2F;
	}(_hwTransport2.default);
	
	TransportU2F.isSupported = _u2fApi.isSupported;
	
	TransportU2F.list = function () {
	  return (
	    // this transport is not discoverable but we are going to guess if it is here with isSupported()
	    (0, _u2fApi.isSupported)().then(function (supported) {
	      return supported ? [null] : [];
	    })
	  );
	};
	
	TransportU2F.listen = function (observer) {
	  var unsubscribed = false;
	  (0, _u2fApi.isSupported)().then(function (supported) {
	    if (unsubscribed) return;
	    if (supported) {
	      observer.next({ type: "add", descriptor: null });
	      observer.complete();
	    } else {
	      observer.error(new _errors.TransportError("U2F browser support is needed for Ledger. " + "Please use Chrome, Opera or Firefox with a U2F extension. " + "Also make sure you're on an HTTPS connection", "U2FNotSupported"));
	    }
	  });
	  return {
	    unsubscribe: function unsubscribe() {
	      unsubscribed = true;
	    }
	  };
	};
	
	exports.default = TransportU2F;
	//# sourceMappingURL=TransportU2F.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10).Buffer))

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAltStatusMessage = exports.StatusCodes = exports.TransportStatusError = exports.TransportError = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events2 = __webpack_require__(167);
	
	var _events3 = _interopRequireDefault(_events2);
	
	var _errors = __webpack_require__(295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.TransportError = _errors.TransportError;
	exports.TransportStatusError = _errors.TransportStatusError;
	exports.StatusCodes = _errors.StatusCodes;
	exports.getAltStatusMessage = _errors.getAltStatusMessage;
	
	/**
	 */
	
	
	/**
	 */
	
	
	/**
	 * type: add or remove event
	 * descriptor: a parameter that can be passed to open(descriptor)
	 * deviceModel: device info on the model (is it a nano s, nano x, ...)
	 * device: transport specific device info
	 */
	
	/**
	 */
	
	/**
	 * Transport defines the generic interface to share between node/u2f impl
	 * A **Descriptor** is a parametric type that is up to be determined for the implementation.
	 * it can be for instance an ID, an file path, a URL,...
	 */
	var Transport = function () {
	  function Transport() {
	    var _this = this;
	
	    _classCallCheck(this, Transport);
	
	    this.exchangeTimeout = 30000;
	    this._events = new _events3.default();
	
	    this.send = function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(cla, ins, p1, p2) {
	        var data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Buffer.alloc(0);
	        var statusList = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [_errors.StatusCodes.OK];
	        var response, sw;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(data.length >= 256)) {
	                  _context.next = 2;
	                  break;
	                }
	
	                throw new _errors.TransportError("data.length exceed 256 bytes limit. Got: " + data.length, "DataLengthTooBig");
	
	              case 2:
	                _context.next = 4;
	                return _this.exchange(Buffer.concat([Buffer.from([cla, ins, p1, p2]), Buffer.from([data.length]), data]));
	
	              case 4:
	                response = _context.sent;
	                sw = response.readUInt16BE(response.length - 2);
	
	                if (statusList.some(function (s) {
	                  return s === sw;
	                })) {
	                  _context.next = 8;
	                  break;
	                }
	
	                throw new _errors.TransportStatusError(sw);
	
	              case 8:
	                return _context.abrupt("return", response);
	
	              case 9:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x, _x2, _x3, _x4) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    this.exchangeAtomicImpl = function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(f) {
	        var resolveBusy, busyPromise, res;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!_this.exchangeBusyPromise) {
	                  _context2.next = 2;
	                  break;
	                }
	
	                throw new _errors.TransportError("Transport race condition", "RaceCondition");
	
	              case 2:
	                resolveBusy = void 0;
	                busyPromise = new Promise(function (r) {
	                  resolveBusy = r;
	                });
	
	                _this.exchangeBusyPromise = busyPromise;
	                _context2.prev = 5;
	                _context2.next = 8;
	                return f();
	
	              case 8:
	                res = _context2.sent;
	                return _context2.abrupt("return", res);
	
	              case 10:
	                _context2.prev = 10;
	
	                if (resolveBusy) resolveBusy();
	                _this.exchangeBusyPromise = null;
	                return _context2.finish(10);
	
	              case 14:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this, [[5,, 10, 14]]);
	      }));
	
	      return function (_x7) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    this._appAPIlock = null;
	  }
	
	  /**
	   * Statically check if a transport is supported on the user's platform/browser.
	   */
	
	
	  /**
	   * List once all available descriptors. For a better granularity, checkout `listen()`.
	   * @return a promise of descriptors
	   * @example
	   * TransportFoo.list().then(descriptors => ...)
	   */
	
	
	  /**
	   * Listen all device events for a given Transport. The method takes an Obverver of DescriptorEvent and returns a Subscription (according to Observable paradigm https://github.com/tc39/proposal-observable )
	   * a DescriptorEvent is a `{ descriptor, type }` object. type can be `"add"` or `"remove"` and descriptor is a value you can pass to `open(descriptor)`.
	   * each listen() call will first emit all potential device already connected and then will emit events can come over times,
	   * for instance if you plug a USB device after listen() or a bluetooth device become discoverable.
	   * @param observer is an object with a next, error and complete function (compatible with observer pattern)
	   * @return a Subscription object on which you can `.unsubscribe()` to stop listening descriptors.
	   * @example
	  const sub = TransportFoo.listen({
	  next: e => {
	    if (e.type==="add") {
	      sub.unsubscribe();
	      const transport = await TransportFoo.open(e.descriptor);
	      ...
	    }
	  },
	  error: error => {},
	  complete: () => {}
	  })
	   */
	
	
	  /**
	   * attempt to create a Transport instance with potentially a descriptor.
	   * @param descriptor: the descriptor to open the transport with.
	   * @param timeout: an optional timeout
	   * @return a Promise of Transport instance
	   * @example
	  TransportFoo.open(descriptor).then(transport => ...)
	   */
	
	
	  /**
	   * low level api to communicate with the device
	   * This method is for implementations to implement but should not be directly called.
	   * Instead, the recommanded way is to use send() method
	   * @param apdu the data to send
	   * @return a Promise of response data
	   */
	
	
	  /**
	   * set the "scramble key" for the next exchanges with the device.
	   * Each App can have a different scramble key and they internally will set it at instanciation.
	   * @param key the scramble key
	   */
	
	
	  /**
	   * close the exchange with the device.
	   * @return a Promise that ends when the transport is closed.
	   */
	
	
	  _createClass(Transport, [{
	    key: "on",
	
	
	    /**
	     * Listen to an event on an instance of transport.
	     * Transport implementation can have specific events. Here is the common events:
	     * * `"disconnect"` : triggered if Transport is disconnected
	     */
	    value: function on(eventName, cb) {
	      this._events.on(eventName, cb);
	    }
	
	    /**
	     * Stop listening to an event on an instance of transport.
	     */
	
	  }, {
	    key: "off",
	    value: function off(eventName, cb) {
	      this._events.removeListener(eventName, cb);
	    }
	  }, {
	    key: "emit",
	    value: function emit(event) {
	      var _events;
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      (_events = this._events).emit.apply(_events, [event].concat(_toConsumableArray(args)));
	    }
	
	    /**
	     * Enable or not logs of the binary exchange
	     */
	
	  }, {
	    key: "setDebugMode",
	    value: function setDebugMode() {
	      console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
	    }
	
	    /**
	     * Set a timeout (in milliseconds) for the exchange call. Only some transport might implement it. (e.g. U2F)
	     */
	
	  }, {
	    key: "setExchangeTimeout",
	    value: function setExchangeTimeout(exchangeTimeout) {
	      this.exchangeTimeout = exchangeTimeout;
	    }
	
	    /**
	     * wrapper on top of exchange to simplify work of the implementation.
	     * @param cla
	     * @param ins
	     * @param p1
	     * @param p2
	     * @param data
	     * @param statusList is a list of accepted status code (shorts). [0x9000] by default
	     * @return a Promise of response buffer
	     */
	
	  }, {
	    key: "decorateAppAPIMethods",
	    value: function decorateAppAPIMethods(self, methods, scrambleKey) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = methods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var methodName = _step.value;
	
	          self[methodName] = this.decorateAppAPIMethod(methodName, self[methodName], self, scrambleKey);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: "decorateAppAPIMethod",
	    value: function decorateAppAPIMethod(methodName, f, ctx, scrambleKey) {
	      var _this2 = this;
	
	      return function () {
	        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }
	
	          var _appAPIlock;
	
	          return regeneratorRuntime.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  _appAPIlock = _this2._appAPIlock;
	
	                  if (!_appAPIlock) {
	                    _context3.next = 3;
	                    break;
	                  }
	
	                  return _context3.abrupt("return", Promise.reject(new _errors.TransportError("Ledger Device is busy (lock " + _appAPIlock + ")", "TransportLocked")));
	
	                case 3:
	                  _context3.prev = 3;
	
	                  _this2._appAPIlock = methodName;
	                  _this2.setScrambleKey(scrambleKey);
	                  _context3.next = 8;
	                  return f.apply(ctx, args);
	
	                case 8:
	                  return _context3.abrupt("return", _context3.sent);
	
	                case 9:
	                  _context3.prev = 9;
	
	                  _this2._appAPIlock = null;
	                  return _context3.finish(9);
	
	                case 12:
	                case "end":
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2, [[3,, 9, 12]]);
	        }));
	
	        return function () {
	          return _ref3.apply(this, arguments);
	        };
	      }();
	    }
	  }], [{
	    key: "create",
	
	
	    /**
	     * create() allows to open the first descriptor available or
	     * throw if there is none or if timeout is reached.
	     * This is a light helper, alternative to using listen() and open() (that you may need for any more advanced usecase)
	     * @example
	    TransportFoo.create().then(transport => ...)
	     */
	    value: function create() {
	      var _this3 = this;
	
	      var openTimeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3000;
	      var listenTimeout = arguments[1];
	
	      return new Promise(function (resolve, reject) {
	        var found = false;
	        var sub = _this3.listen({
	          next: function next(e) {
	            found = true;
	            if (sub) sub.unsubscribe();
	            if (listenTimeoutId) clearTimeout(listenTimeoutId);
	            _this3.open(e.descriptor, openTimeout).then(resolve, reject);
	          },
	          error: function error(e) {
	            if (listenTimeoutId) clearTimeout(listenTimeoutId);
	            reject(e);
	          },
	          complete: function complete() {
	            if (listenTimeoutId) clearTimeout(listenTimeoutId);
	            if (!found) {
	              reject(new _errors.TransportError(_this3.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
	            }
	          }
	        });
	        var listenTimeoutId = listenTimeout ? setTimeout(function () {
	          sub.unsubscribe();
	          reject(new _errors.TransportError(_this3.ErrorMessage_ListenTimeout, "ListenTimeout"));
	        }, listenTimeout) : null;
	      });
	    }
	
	    // $FlowFixMe
	
	  }]);
	
	  return Transport;
	}();
	
	Transport.ErrorMessage_ListenTimeout = "No Ledger device found (timeout)";
	Transport.ErrorMessage_NoDeviceFound = "No Ledger device found";
	exports.default = Transport;
	//# sourceMappingURL=Transport.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10).Buffer))

/***/ }),
/* 493 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * A Log object
	 */
	var id = 0;
	var subscribers = [];
	
	/**
	 * log something
	 * @param type a namespaced identifier of the log (it is not a level like "debug", "error" but more like "apdu-in", "apdu-out", etc...)
	 * @param message a clear message of the log associated to the type
	 */
	var log = exports.log = function log(type, message, data) {
	  var obj = { type: type, id: String(++id), date: new Date() };
	  if (message) obj.message = message;
	  if (data) obj.data = data;
	  dispatch(obj);
	};
	
	/**
	 * listen to logs.
	 * @param cb that is called for each future log() with the Log object
	 * @return a function that can be called to unsubscribe the listener
	 */
	var listen = exports.listen = function listen(cb) {
	  subscribers.push(cb);
	  return function () {
	    var i = subscribers.indexOf(cb);
	    if (i !== -1) {
	      // equivalent of subscribers.splice(i, 1) // https://twitter.com/Rich_Harris/status/1125850391155965952
	      subscribers[i] = subscribers[subscribers.length - 1];
	      subscribers.pop();
	    }
	  };
	};
	
	function dispatch(log) {
	  for (var i = 0; i < subscribers.length; i++) {
	    try {
	      subscribers[i](log);
	    } catch (e) {
	      console.error(e);
	    }
	  }
	}
	
	// for debug purpose
	global.__ledgerLogsListen = listen;
	//# sourceMappingURL=index.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(37);
	
	var _actionsAccountCreator = __webpack_require__(298);
	
	var AccountCreator = (function (_React$Component) {
	  _inherits(AccountCreator, _React$Component);
	
	  function AccountCreator() {
	    _classCallCheck(this, AccountCreator);
	
	    _get(Object.getPrototypeOf(AccountCreator.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(AccountCreator, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var state = _props.state;
	      var dispatch = _props.dispatch;
	
	      var keypairTable = undefined,
	          keypairGeneratorLink = undefined;
	      if (state.keypairGeneratorResult !== null) {
	        keypairTable = _react2['default'].createElement(
	          'div',
	          { className: 'simpleTable AccountCreator__generator__table' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'simpleTable__row' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'simpleTable__row__label' },
	              'Public Key'
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'simpleTable__row__content' },
	              state.keypairGeneratorResult.pubKey
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'simpleTable__row' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'simpleTable__row__label' },
	              'Secret Key'
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'simpleTable__row__content' },
	              state.keypairGeneratorResult.secretKey
	            )
	          )
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'AccountCreator' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'so-back AccountCreator__section' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'so-chunk' },
	            _react2['default'].createElement(
	              'h3',
	              null,
	              '1. Keypair generator'
	            ),
	            _react2['default'].createElement(
	              'p',
	              null,
	              'These keypairs can be used on the Sabay Settlement Network'
	            ),
	            _react2['default'].createElement(
	              'button',
	              { className: 's-button', onClick: function () {
	                  dispatch((0, _actionsAccountCreator.generateNewKeypair)());
	                } },
	              'Generate keypair'
	            ),
	            keypairTable,
	            keypairGeneratorLink
	          )
	        )
	      );
	    }
	  }]);
	
	  return AccountCreator;
	})(_react2['default'].Component);
	
	exports['default'] = (0, _reactRedux.connect)(chooseState)(AccountCreator);
	
	function chooseState(state) {
	  return {
	    state: state.accountCreator
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilitiesPrismJs = __webpack_require__(571);
	
	var _utilitiesPrismJs2 = _interopRequireDefault(_utilitiesPrismJs);
	
	var _utilitiesPrismJsonLinkHighlighter = __webpack_require__(570);
	
	var _utilitiesPrismJsonLinkHighlighter2 = _interopRequireDefault(_utilitiesPrismJsonLinkHighlighter);
	
	var _utilitiesScrollOnAnchorOpen = __webpack_require__(207);
	
	var _utilitiesScrollOnAnchorOpen2 = _interopRequireDefault(_utilitiesScrollOnAnchorOpen);
	
	// @param {string} language - key for the code language. available languages can
	//   be discovered by doing a console log on `Prism.languages`. More can be added
	//   in the prism.js
	
	var CodeBlock = _react2['default'].createClass({
	  displayName: 'CodeBlock',
	
	  propTypes: {
	    code: _react2['default'].PropTypes.string.isRequired,
	    language: _react2['default'].PropTypes.string
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return nextProps.code !== this.props.code || nextProps.language !== this.props.language;
	  },
	  getHighlightedCode: function getHighlightedCode() {
	    var highlightedCode = _utilitiesPrismJs2['default'].highlight(this.props.code, _utilitiesPrismJs2['default'].languages[this.props.language]);
	    if (this.props.language === 'json') {
	      return (0, _utilitiesPrismJsonLinkHighlighter2['default'])(highlightedCode);
	    }
	    return highlightedCode;
	  },
	  render: function render() {
	    var className = 'CodeBlock__code language-' + this.props.language;
	    var innerHtml = { __html: this.getHighlightedCode() };
	    return _react2['default'].createElement(
	      'pre',
	      { className: 'CodeBlock ' + this.props.className, onClick: _utilitiesScrollOnAnchorOpen2['default'] },
	      _react2['default'].createElement('code', { className: className, dangerouslySetInnerHTML: innerHtml })
	    );
	  }
	});
	exports.CodeBlock = CodeBlock;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _actionsEndpointExplorer = __webpack_require__(299);
	
	var _reactRedux = __webpack_require__(37);
	
	var _EndpointPicker = __webpack_require__(302);
	
	var _EndpointSetup = __webpack_require__(304);
	
	var _EndpointResult = __webpack_require__(303);
	
	var _dataEndpoints = __webpack_require__(202);
	
	var _constantsNetwork = __webpack_require__(75);
	
	var _constantsNetwork2 = _interopRequireDefault(_constantsNetwork);
	
	var _uriTemplates = __webpack_require__(1158);
	
	var _uriTemplates2 = _interopRequireDefault(_uriTemplates);
	
	var _querystring = __webpack_require__(268);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var EndpointExplorer = (function (_React$Component) {
	  _inherits(EndpointExplorer, _React$Component);
	
	  function EndpointExplorer() {
	    _classCallCheck(this, EndpointExplorer);
	
	    _get(Object.getPrototypeOf(EndpointExplorer.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(EndpointExplorer, [{
	    key: 'render',
	    value: function render() {
	      var dispatch = this.props.dispatch;
	      var _props$state = this.props.state;
	      var currentResource = _props$state.currentResource;
	      var currentEndpoint = _props$state.currentEndpoint;
	      var results = _props$state.results;
	      var pendingRequest = _props$state.pendingRequest;
	
	      var endpoint = (0, _dataEndpoints.getEndpoint)(currentResource, currentEndpoint);
	      var request = buildRequest(this.props.baseURL, endpoint, pendingRequest);
	
	      var endpointSetup = undefined;
	      if (currentEndpoint !== '') {
	        endpointSetup = _react2['default'].createElement(_EndpointSetup.EndpointSetup, {
	          request: request,
	          values: pendingRequest.values,
	          endpoint: endpoint,
	          onSubmit: function () {
	            return dispatch((0, _actionsEndpointExplorer.submitRequest)(request));
	          },
	          onUpdate: function (param, value) {
	            return dispatch((0, _actionsEndpointExplorer.updateValue)(param, value));
	          }
	        });
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'so-back' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'so-chunk' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'pageIntro' },
	            _react2['default'].createElement(
	              'p',
	              null,
	              'Endpoint explorer'
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'EndpointExplorer' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'EndpointExplorer__picker' },
	              _react2['default'].createElement(_EndpointPicker.EndpointPicker, {
	                currentResource: currentResource,
	                currentEndpoint: currentEndpoint,
	                onChange: function (r, e) {
	                  return dispatch((0, _actionsEndpointExplorer.chooseEndpoint)(r, e));
	                }
	              })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'EndpointExplorer__setup' },
	              endpointSetup
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'EndpointExplorer__result' },
	              _react2['default'].createElement(_EndpointResult.EndpointResult, results)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EndpointExplorer;
	})(_react2['default'].Component);
	
	exports['default'] = (0, _reactRedux.connect)(chooseState)(EndpointExplorer);
	
	function chooseState(state) {
	  return {
	    state: state.endpointExplorer,
	    baseURL: state.network.current.horizonURL
	  };
	}
	
	function buildRequest(baseUrl, endpoint, pendingRequest) {
	  var request = {
	    url: buildRequestUrl(baseUrl, endpoint, pendingRequest.values),
	    formData: ''
	  };
	
	  if (typeof endpoint !== 'undefined') {
	    request.method = endpoint.method;
	  }
	
	  // Currently, this only supports simple string values
	  if (request.method === 'POST') {
	    (function () {
	      var postData = {};
	      _lodash2['default'].each(pendingRequest.values, function (value, id) {
	        postData[id] = _lodash2['default'].trim(value);
	      });
	
	      request.formData = _querystring2['default'].stringify(postData);
	    })();
	  }
	
	  if (pendingRequest.values.streaming) {
	    request.streaming = true;
	  }
	
	  return request;
	}
	
	function buildRequestUrl(baseUrl, endpoint, values) {
	  if (typeof endpoint === 'undefined') {
	    return '';
	  }
	  var uriTemplate = baseUrl + endpoint.path.template;
	  var template = new _uriTemplates2['default'](uriTemplate);
	
	  // uriParams contains what we want to fill the url with
	  var uriParams = {};
	  _lodash2['default'].each(template.varNames, function (varName) {
	
	    // With the appropriate getter, extract/transform the relevant value from values
	    // 1. Simple value:
	    //      - no getter string in `endpoint.path`
	    // 2. String resolver: value is inside object in `values`
	    //      - getter string in `endpoint.path`
	    // 3. Function resolver:
	    //      - getter function in `endpoint.path`
	    //
	    // getter can only either be: `undefined`, `String`, or `Function`
	
	    var getterPresent = (varName in endpoint.path);
	    var getter = endpoint.path[varName];
	    var getterIsFunc = _lodash2['default'].isFunction(getter);
	    var value = undefined;
	
	    if (getterPresent && getterIsFunc) {
	      // case 3
	      value = getter(values);
	    } else if (getterPresent && !getterIsFunc) {
	      // case 2
	      value = _lodash2['default'].get(values, getter);
	    } else {
	      // case 1
	      value = values[varName];
	    }
	
	    if (!_lodash2['default'].isUndefined(value) && value !== '') {
	      if (!_lodash2['default'].isString(value)) {
	        throw new Error('Endpoint explorer value must be a string');
	      }
	      uriParams[varName] = _lodash2['default'].trim(value);
	    }
	  });
	
	  // Fill in unfilled parameters with placeholders (like {source_account})
	  // Also create a map to unescape these placeholders
	  var unescapeMap = [];
	  _lodash2['default'].each(template.fromUri(uriTemplate), function (placeholder, param) {
	    if (!(param in uriParams)) {
	      uriParams[param] = placeholder;
	      unescapeMap.push({
	        oldStr: encodeURIComponent(placeholder),
	        newStr: placeholder
	      });
	    }
	  });
	
	  var builtUrl = _lodash2['default'].reduce(unescapeMap, function (url, replacement) {
	    return url.replace(replacement.oldStr, replacement.newStr);
	  }, template.fill(uriParams));
	
	  return builtUrl;
	};
	module.exports = exports['default'];

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = BipPathPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextPicker = __webpack_require__(22);
	
	var _TextPicker2 = _interopRequireDefault(_TextPicker);
	
	function BipPathPicker(props) {
	  return _react2['default'].createElement(_TextPicker2['default'], _extends({}, props, {
	    placeholder: props.placeholder || "BIP path in format: 44'/148'/0'",
	    validator: function (value) {
	      var regexp = /44'\/148'\/(\d+)'/;
	      var match = regexp.exec(value);
	      if (!(match && match[1].length > 0)) {
	        return "Invalid BIP path. Please provide it in format 44'/148'/x'. We call 44'/148'/0' the primary account";
	      }
	    },
	    className: props.className
	  }));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = CheckboxButtonPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	// @param {object} props.items An object whose keys are the onUpdate values and
	//   object values are labels the user will see.
	// {
	//   'valueToBeStored': 'Human Readable Label',
	// }
	// @param {array} props.value Value is expected to be in an array format containing
	//   all the keys of the checked items
	
	function CheckboxButtonPicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	  var items = props.items;
	
	  var group = Math.random(); // Allows for tabbing and prevents radio button collisions
	
	  return _react2["default"].createElement(
	    "div",
	    { className: "s-buttonGroup picker picker--radio " + props.className },
	    _.map(items, function (label, id) {
	      return _react2["default"].createElement(
	        "label",
	        { className: "s-buttonGroup__wrapper", key: id },
	        _react2["default"].createElement("input", { type: "checkbox", className: "s-buttonGroup__radio",
	          name: group,
	          onChange: function (e) {
	            onUpdate(calculateNewValue(props.value, e.target.value, e.target.checked));
	          },
	          value: id,
	          checked: value.indexOf(id) >= 0 }),
	        _react2["default"].createElement(
	          "span",
	          { className: "s-button s-button--light" },
	          label
	        )
	      );
	    })
	  );
	}
	
	// Calculate the new value of the array when changing around the array
	function calculateNewValue(previousValue, value, checked) {
	  var valueArray = [].concat(previousValue);
	  var valueIndex = valueArray.indexOf(value);
	  var valueExists = valueIndex >= 0;
	
	  if (checked && !valueExists) {
	    valueArray.push(value);
	  }
	  if (!checked && valueExists) {
	    valueArray.splice(valueIndex, 1);
	  }
	
	  valueArray.sort();
	  return valueArray;
	}
	module.exports = exports["default"];

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = FlagfieldPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CheckboxButtonPicker = __webpack_require__(511);
	
	var _CheckboxButtonPicker2 = _interopRequireDefault(_CheckboxButtonPicker);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	// When all the items are empty, then this picker should be equal to ''
	
	// @param {object} props.items An object whose keys are the bitfield number
	//   and values are the label displayed to the user. The keys must be consecutive
	//   or else it won't work (example: 1, 2, 4, 8, 16...).
	// {
	//   1: 'Human Readable Label',
	// }
	
	function FlagfieldPicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	  var items = props.items;
	
	  var group = Math.random(); // Allows for tabbing and prevents checkbox collisions
	
	  var parsedValue = parseInt(value);
	  var pickerValue = [];
	  if (isInteger(parsedValue)) {
	    pickerValue = intToExistenceArray(parsedValue);
	  }
	
	  var statusLine = undefined;
	  if (pickerValue.length > 0) {
	    (function () {
	      var sumItems = [],
	          total = 0;
	      _lodash2['default'].each(pickerValue, function (bitValue) {
	        sumItems.push(items[bitValue] + ' (' + bitValue + ')');
	        total += parseInt(bitValue);
	      });
	      statusLine = sumItems.join(' + ') + (' = ' + total);
	    })();
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      'div',
	      { className: 's-buttonGroup picker picker--radio ' + props.className },
	      _react2['default'].createElement(_CheckboxButtonPicker2['default'], {
	        className: statusLine === undefined ? '' : 'picker--spaceBottom',
	        value: pickerValue,
	        onUpdate: function (valueArray) {
	          return onUpdate(existenceArrayToInt(valueArray));
	        },
	        items: items
	      })
	    ),
	    statusLine
	  );
	}
	
	// Converts an integer to an array of strings with decimal representations of the number
	// Example:
	//   int input: 5
	//   existence array output: [1, 4]
	function intToExistenceArray(inputInt) {
	  var existenceArray = [];
	  // iterate through binary representation of number
	  var binaryArray = inputInt.toString(2).split('');
	  _lodash2['default'].each(binaryArray, function (binaryValue, index) {
	    if (binaryValue === '1') {
	      existenceArray.push(String(Math.pow(2, binaryArray.length - 1 - index))); // calculate decimal representation of bit in specific index
	    }
	  });
	  return existenceArray;
	}
	
	// The reverse of intToExistenceArray
	function existenceArrayToInt(existenceArray) {
	  return _lodash2['default'].reduce(existenceArray, function (result, intValue) {
	    return result | parseInt(intValue);
	  }, undefined);
	}
	
	function isInteger(input) {
	  return String(input).match(/^[0-9]*$/g);
	}
	module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = ManualMultiPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(166);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	// ManualMultiPicker is a compound picker interface that displays multiple
	// instances of a Picker. It is manual in that the user uses to add or reduce
	// the amount of pickers displayed. This picker is useful for instances where
	// the number of items are more precise (like payment paths) or the picker has a
	// compound value (AssetPicker values are objects).
	
	// @param {array} props.value - Array of values. If empty or non array, then it will default to a zero element array
	// @param {Picker|function} props.component - A React Picker component function to be repeated
	// @param {object|string} [props.default] - This is the default value for new elements that are added
	// @param {function} props.onUpdate - Picker callback function called when the values change.
	// @param {stromg} (props.addNewLabel) - Custom label for the `add new` button.
	
	function ManualMultiPicker(props) {
	  var onUpdate = props.onUpdate;
	  var component = props.component;
	
	  var values = _lodash2['default'].isArray(props.value) ? props.value : [props['default']];
	  var addNewLabel = props.addNewLabel || 'Add new';
	
	  return _react2['default'].createElement(
	    'div',
	    { className: 'ManualMultiPicker' },
	    _lodash2['default'].map(values, function (singleValue, index) {
	      return _react2['default'].createElement(
	        'div',
	        { key: index, className: (0, _classnames2['default'])('ManualMultiPicker__item', { 'ManualMultiPicker__item--last': index === values.length - 1 }) },
	        _react2['default'].createElement(
	          'div',
	          { className: 'ManualMultiPicker__item__infobar' },
	          _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement(
	              'strong',
	              null,
	              '#',
	              index + 1
	            )
	          ),
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 's-button ManualMultiPicker__item__remove',
	              onClick: function () {
	                return onUpdate(removeValueAt(values, index));
	              } },
	            'remove'
	          )
	        ),
	        _react2['default'].createElement(props.component, {
	          onUpdate: function (newValue) {
	            return onUpdate(updateValueAt(values, index, newValue));
	          },
	          value: singleValue
	        })
	      );
	    }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'ManualMultiPicker__addNew' },
	      _react2['default'].createElement(
	        'button',
	        { className: 's-button', onClick: function () {
	            return onUpdate(values.concat(props['default']));
	          } },
	        addNewLabel
	      )
	    )
	  );
	}
	
	// Removes a item in specific area of index
	function removeValueAt(values, index) {
	  values = [].concat(values);
	  values.splice(index, 1);
	  return values;
	}
	
	// Replaces a value of the array at a specific index
	function updateValueAt(values, index, newValue) {
	  values = values.slice();
	  values[index] = newValue;
	  return values;
	}
	module.exports = exports['default'];

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = MemoPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RadioButtonPicker = __webpack_require__(149);
	
	var _RadioButtonPicker2 = _interopRequireDefault(_RadioButtonPicker);
	
	var _TextPicker = __webpack_require__(22);
	
	var _TextPicker2 = _interopRequireDefault(_TextPicker);
	
	var _PickerError = __webpack_require__(123);
	
	var _PickerError2 = _interopRequireDefault(_PickerError);
	
	var _stellarSdk = __webpack_require__(23);
	
	function MemoPicker(props) {
	  var onUpdate = props.onUpdate;
	
	  var contentPicker = undefined;
	  var normalizedValue = _lodash2['default'].assign({}, props.value);
	  normalizedValue.type = props.value.type === '' ? 'MEMO_NONE' : props.value.type;
	
	  if (normalizedValue.type !== 'MEMO_NONE') {
	    contentPicker = _react2['default'].createElement(_TextPicker2['default'], {
	      value: normalizedValue.content,
	      onUpdate: function (contentValue) {
	        return onUpdate(_lodash2['default'].assign({}, normalizedValue, {
	          content: contentValue
	        }));
	      },
	      placeholder: memoPlaceholder(normalizedValue.type),
	      validator: contentValidator.bind(null, normalizedValue) // Use entire Memo value and not just the content value
	    });
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(_RadioButtonPicker2['default'], {
	      value: normalizedValue.type,
	      onUpdate: function (typeValue) {
	        return onUpdate(_lodash2['default'].assign({}, normalizedValue, {
	          type: typeValue
	        }));
	      },
	      className: 'picker--spaceBottom',
	      items: {
	        'MEMO_NONE': 'None',
	        'MEMO_TEXT': 'Text',
	        'MEMO_ID': 'ID',
	        'MEMO_HASH': 'Hash',
	        'MEMO_RETURN': 'Return'
	      }
	    }),
	    contentPicker
	  );
	}
	
	function contentValidator(value) {
	  switch (value.type) {
	    case 'MEMO_TEXT':
	      var memoTextBytes = Buffer.byteLength(value.content, 'utf8');
	      if (memoTextBytes > 28) {
	        return 'MEMO_TEXT accepts a string of up to 28 bytes. ' + memoTextBytes + ' bytes entered.';
	      }
	      break;
	    case 'MEMO_ID':
	      if (!value.content.match(/^[0-9]*$/g) || value < 0) {
	        return 'MEMO_ID accepts a positive integer.';
	      }
	      if (value.content !== _stellarSdk.UnsignedHyper.fromString(value.content).toString()) {
	        return 'MEMO_ID is an unsigned 64-bit integer and the max valid\n              value is ' + _stellarSdk.UnsignedHyper.MAX_UNSIGNED_VALUE.toString();
	      }
	      break;
	    case 'MEMO_HASH':
	    case 'MEMO_RETURN':
	      if (!value.content.match(/^[0-9a-f]{64}$/gi)) {
	        return value.type + ' accepts a 32-byte hash in hexadecimal format (64 characters).';
	      }
	      break;
	  }
	}
	
	function memoPlaceholder(type) {
	  switch (type) {
	    case 'MEMO_TEXT':
	      return 'UTF-8 string of up to 28 bytes';
	    case 'MEMO_ID':
	      return 'Unsigned 64-bit integer';
	    case 'MEMO_HASH':
	    case 'MEMO_RETURN':
	      return '32-byte hash in hexadecimal format (64 [0-9a-f] characters)';
	  }
	}
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10).Buffer))

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = MultiPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	// MultiPicker is a compound picker interface that ensures there is always
	// enough rows for the user to add more data. MultiPicker accomplishes this
	// by making sure there is only one consecutive empty picker at the end.
	//
	// An empty element is defined as null, undefined, or ''. This means that only
	// string value pickers (like PositiveIntPicker but not AssetPicker) can be
	// used inside the MultiPicker. For non string values with no way to empty the
	// value (such as radio buttons that can't be cleared), use ManualMultiPicker.
	
	// @param {array} props.value - Array of values. If empty or non array, then it
	//   will default to a one element array. The length of the array will be
	//   normalized to have one empty element at the end.
	// @param {function} props.onUpdate - Picker callback function called when the values change.
	
	function MultiPicker(props) {
	  var onUpdate = props.onUpdate;
	  var component = props.component;
	
	  var value = props.value;
	  if (!_lodash2['default'].isArray(value)) {
	    value = [];
	  }
	
	  var normalizedValues = adjustTrailingEmptyElements(value);
	
	  var SingleComponent = props.component;
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _lodash2['default'].map(normalizedValues, function (singleValue, index) {
	      return _react2['default'].createElement(SingleComponent, {
	        onUpdate: function (newValue) {
	          return onUpdate(updateValueAt(normalizedValues, index, newValue));
	        },
	        value: singleValue,
	        className: 'picker--spaceBottom',
	        key: index
	      });
	    })
	  );
	}
	
	MultiPicker.propTypes = {
	  value: _react2['default'].PropTypes.array.isRequired
	};
	
	function isEmpty(value) {
	  return value === null || _lodash2['default'].isUndefined(value) || value === '';
	}
	function arelastTwoEmpty(values) {
	  return isEmpty(values[values.length - 1]) && isEmpty(values[values.length - 2]);
	}
	
	// Makes sure there is only one consecutive trailing element in the value array.
	// Does not mutate value.
	function adjustTrailingEmptyElements(values) {
	  values = values.slice();
	
	  // Add a trailing empty element. May be removed in the next step
	  // This is to ensure that we have at least one trailing empty element. In many
	  // cases, this will cause two trailing empty elements, but it will be removed
	  // in the next step.
	  values.push(null);
	
	  // Remove trailing empty elements until there is only one trailing empty element.
	  // This makes sure we will only have one consecutive trailing element (especially)
	  // remove the defensive one we just added before.
	  while (values.length > 1 && arelastTwoEmpty(values)) {
	    values.pop();
	  }
	
	  return values;
	}
	
	// Updates a value of the array at a specific index
	function updateValueAt(values, index, newValue) {
	  values = values.slice();
	  values[index] = newValue;
	  return values;
	}
	module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = OperationTypePicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dataOperationsJs = __webpack_require__(203);
	
	var _SelectPicker = __webpack_require__(195);
	
	var _SelectPicker2 = _interopRequireDefault(_SelectPicker);
	
	var operationItemMap = {};
	_lodash2['default'].each(_dataOperationsJs.operationsMap, function (op) {
	  operationItemMap[op.name] = op.label;
	});
	
	function OperationTypePicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	
	  return _react2['default'].createElement(_SelectPicker2['default'], {
	    value: value,
	    onUpdate: onUpdate,
	    placeholder: 'Select operation type',
	    items: operationItemMap
	  });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = SecretKeyPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextPicker = __webpack_require__(22);
	
	var _TextPicker2 = _interopRequireDefault(_TextPicker);
	
	var _stellarSdk = __webpack_require__(23);
	
	function SecretKeyPicker(props) {
	  return _react2['default'].createElement(_TextPicker2['default'], _extends({}, props, {
	    placeholder: props.placeholder || 'Secret key (starting with S) or hash preimage (in hex)',
	    validator: function (value) {
	      if (value.charAt(0) == 'S') {
	        if (!_stellarSdk.StrKey.isValidEd25519SecretSeed(value)) {
	          return 'Invalid secret key.';
	        }
	      } else {
	        if (!value.match(/^[0-9a-f]{2,128}$/gi) || value.length % 2 == 1) {
	          return 'Invalid hex value. Please provide up to 64 bytes in hexadecimal format.';
	        }
	      }
	    },
	    className: props.className
	  }));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SequencePicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositiveIntPicker = __webpack_require__(21);
	
	var _PositiveIntPicker2 = _interopRequireDefault(_PositiveIntPicker);
	
	function SequencePicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	
	  return _react2['default'].createElement(_PositiveIntPicker2['default'], {
	    value: value,
	    placeholder: 'Example: 55834579143',
	    onUpdate: function (value) {
	      return onUpdate(value);
	    }
	  });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SignerPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PubKeyPicker = __webpack_require__(24);
	
	var _PubKeyPicker2 = _interopRequireDefault(_PubKeyPicker);
	
	var _SelectPicker = __webpack_require__(195);
	
	var _SelectPicker2 = _interopRequireDefault(_SelectPicker);
	
	var _TextPicker = __webpack_require__(22);
	
	var _TextPicker2 = _interopRequireDefault(_TextPicker);
	
	var _Unsigned8bitIntPicker = __webpack_require__(309);
	
	var _Unsigned8bitIntPicker2 = _interopRequireDefault(_Unsigned8bitIntPicker);
	
	function SignerPicker(props) {
	  var value = _lodash2['default'].extend({ type: null, content: '', weight: null }, props.value);
	
	  var items = {
	    ed25519PublicKey: "Ed25519 Public Key",
	    sha256Hash: "sha256 Hash",
	    preAuthTx: "Pre-authorized Transaction Hash"
	  };
	
	  var onUpdate = function onUpdate(val) {
	    if (val.type) {
	      // When changing type clean content.
	      val.content = '';
	    }
	    value = _lodash2['default'].extend(value, val);
	    props.onUpdate(value);
	  };
	
	  var input = null;
	  var weight = null;
	
	  switch (value.type) {
	    case "ed25519PublicKey":
	      input = _react2['default'].createElement(_PubKeyPicker2['default'], {
	        value: value.content,
	        onUpdate: function (content) {
	          onUpdate({ content: content });
	        }
	      });
	      break;
	    case "sha256Hash":
	    case "preAuthTx":
	      input = _react2['default'].createElement(_TextPicker2['default'], {
	        value: value.content,
	        onUpdate: function (content) {
	          return onUpdate({ content: content });
	        },
	        placeholder: 'Accepts a 32-byte hash in hexadecimal format (64 characters).',
	        validator: hashValidator.bind(null, value.content)
	      });
	      break;
	  }
	
	  if (value.type) {
	    weight = _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(_Unsigned8bitIntPicker2['default'], {
	        value: value.weight,
	        onUpdate: function (weight) {
	          onUpdate({ weight: weight });
	        }
	      }),
	      _react2['default'].createElement(
	        'p',
	        { className: 'optionsTable__pair__content__note' },
	        'Signer will be removed from account if this weight is 0.'
	      )
	    );
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(_SelectPicker2['default'], {
	      value: value.type,
	      onUpdate: function (type) {
	        onUpdate({ type: type });
	      },
	      placeholder: 'Select signer type',
	      items: items,
	      className: 'picker--spaceBottom'
	    }),
	    input,
	    weight
	  );
	}
	
	function hashValidator(value) {
	  if (!value.match(/^[0-9a-f]{64}$/gi)) {
	    return 'Accepts a 32-byte hash in hexadecimal format (64 characters).';
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SequencePicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositiveIntPicker = __webpack_require__(21);
	
	var _PositiveIntPicker2 = _interopRequireDefault(_PositiveIntPicker);
	
	function SequencePicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	
	  return _react2['default'].createElement(_PositiveIntPicker2['default'], {
	    value: value,
	    placeholder: 'Amount in stroops (1 lumen = 10,000,000 stroops)',
	    onUpdate: function (value) {
	      return onUpdate(value);
	    }
	  });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = TimeBoundsPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _TimestampPicker = __webpack_require__(522);
	
	var _TimestampPicker2 = _interopRequireDefault(_TimestampPicker);
	
	function TimeBoundsPicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(_TimestampPicker2['default'], {
	      value: value.minTime,
	      placeholder: 'Lower time bound unix timestamp. Example: 1479151713',
	      onUpdate: function (minTimeValue) {
	        return onUpdate(_lodash2['default'].assign({}, value, {
	          minTime: minTimeValue
	        }));
	      }
	    }),
	    _react2['default'].createElement(_TimestampPicker2['default'], {
	      value: value.maxTime,
	      placeholder: 'Upper time bound unix timestamp.  Example: 1479151713',
	      onUpdate: function (maxTimeValue) {
	        return onUpdate(_lodash2['default'].assign({}, value, {
	          maxTime: maxTimeValue
	        }));
	      }
	    })
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = TimestampPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositiveIntPicker = __webpack_require__(21);
	
	var _PositiveIntPicker2 = _interopRequireDefault(_PositiveIntPicker);
	
	function TimestampPicker(props) {
	  var value = props.value;
	  var placeholder = props.placeholder;
	  var onUpdate = props.onUpdate;
	
	  return _react2['default'].createElement(_PositiveIntPicker2['default'], {
	    value: value,
	    placeholder: placeholder,
	    onUpdate: function (value) {
	      return onUpdate(value);
	    }
	  });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = XdrPicker;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PickerError = __webpack_require__(123);
	
	var _PickerError2 = _interopRequireDefault(_PickerError);
	
	function XdrPicker(props) {
	  var value = props.value;
	  var onUpdate = props.onUpdate;
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement('textarea', { type: 'text',
	      value: value,
	      onChange: function (event) {
	        onUpdate(event.target.value);
	      },
	      placeholder: 'Example: AAAAABbxCy3mLg3hiTqX4VUEEp60pFOrJNxYM1JtxXTwXhY2AAAAZAAAAAMAAAAGAAAAAAAAAAEAAAAAAAAAAQAAAAAAAAAJAAAAAAAAAAHwXhY2AAAAQCPAo8QwsZe9FA0sz/deMdhlu6/zrk7SgkBG22ApvtpETBhnGkX4trSFDz8sVlKqvweqGUVgvjUyM0AcHxyXZQw=',
	      className: 'picker picker--textarea picker--breakContent' }),
	    _react2['default'].createElement(_PickerError2['default'], { message: validator(value) })
	  );
	}
	
	function validator(value) {
	  if (_lodash2['default'].isString(value) && value.match(/^[-A-Za-z0-9+\/=]*$/) === null) {
	    return 'Input is not valid base64';
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Introduction;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(37);
	
	function Introduction() {
	  return _react2['default'].createElement(
	    'div',
	    { className: 'Introduction' },
	    _react2['default'].createElement(
	      'div',
	      { className: 'so-back' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'so-chunk' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'Introduction__container' },
	          _react2['default'].createElement(
	            'h2',
	            null,
	            'Sabay Settlement Network'
	          ),
	          _react2['default'].createElement(
	            'p',
	            { className: 'Introduction__lead' },
	            'This is the administration portal for the Sabay Settlement Network. Access to the test network is open however to access the production host a VPN key must be used'
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'Please note the Friendbot is disabled on both networks'
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'This project is based on the Stellar Laboratory'
	          )
	        )
	      )
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(37);
	
	var _classnames = __webpack_require__(166);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _NetworkPicker = __webpack_require__(526);
	
	var _NetworkPicker2 = _interopRequireDefault(_NetworkPicker);
	
	var _Introduction = __webpack_require__(524);
	
	var _Introduction2 = _interopRequireDefault(_Introduction);
	
	var _AccountCreator = __webpack_require__(507);
	
	var _AccountCreator2 = _interopRequireDefault(_AccountCreator);
	
	var _EndpointExplorer = __webpack_require__(509);
	
	var _EndpointExplorer2 = _interopRequireDefault(_EndpointExplorer);
	
	var _TransactionBuilder = __webpack_require__(551);
	
	var _TransactionBuilder2 = _interopRequireDefault(_TransactionBuilder);
	
	var _TransactionSigner = __webpack_require__(553);
	
	var _TransactionSigner2 = _interopRequireDefault(_TransactionSigner);
	
	var _XdrViewer = __webpack_require__(557);
	
	var _XdrViewer2 = _interopRequireDefault(_XdrViewer);
	
	var _utilitiesSimpleRouter = __webpack_require__(315);
	
	var _constantsSlug = __webpack_require__(107);
	
	var _constantsSlug2 = _interopRequireDefault(_constantsSlug);
	
	function LaboratoryChrome(props) {
	  var tabItem = function tabItem(name, slug) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        href: '#' + slug,
	        className: (0, _classnames2['default'])('buttonList__item s-button s-button--min', { 'is-active': props.routing.location === slug }),
	        key: slug },
	      name
	    );
	  };
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      'div',
	      { className: 'so-back' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'so-chunk' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'so-siteHeader LaboratoryChrome__header' },
	          _react2['default'].createElement(
	            'span',
	            { className: 'so-logo' },
	            _react2['default'].createElement(
	              'a',
	              { href: '#', className: 'so-logo__main' },
	              'Sabay Settlement Network'
	            )
	          ),
	          _react2['default'].createElement(_NetworkPicker2['default'], null)
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      'div',
	      { className: 'so-back LaboratoryChrome__siteNavBack' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'so-chunk' },
	        _react2['default'].createElement(
	          'nav',
	          { className: 's-buttonList' },
	          tabItem('Introduction', _constantsSlug2['default'].HOME),
	          tabItem('Account Creator', _constantsSlug2['default'].ACCOUNT_CREATOR),
	          tabItem('Endpoint Explorer', _constantsSlug2['default'].EXPLORER),
	          tabItem('Transaction Builder', _constantsSlug2['default'].TXBUILDER),
	          tabItem('Transaction Signer', _constantsSlug2['default'].TXSIGNER),
	          tabItem('XDR Viewer', _constantsSlug2['default'].XDRVIEWER)
	        )
	      )
	    ),
	    getContent(props.routing.location),
	    _react2['default'].createElement(_utilitiesSimpleRouter.RouterListener, null)
	  );
	}
	
	function getContent(slug) {
	  switch (slug) {
	    case _constantsSlug2['default'].HOME:
	      return _react2['default'].createElement(_Introduction2['default'], null);
	    case _constantsSlug2['default'].ACCOUNT_CREATOR:
	      return _react2['default'].createElement(_AccountCreator2['default'], null);
	    case _constantsSlug2['default'].EXPLORER:
	      return _react2['default'].createElement(_EndpointExplorer2['default'], null);
	    case _constantsSlug2['default'].TXBUILDER:
	      return _react2['default'].createElement(_TransactionBuilder2['default'], null);
	    case _constantsSlug2['default'].TXSIGNER:
	      return _react2['default'].createElement(_TransactionSigner2['default'], null);
	    case 'xdr-viewer':
	      return _react2['default'].createElement(_XdrViewer2['default'], null);
	    default:
	      return _react2['default'].createElement(
	        SimplePage,
	        null,
	        _react2['default'].createElement(
	          'p',
	          null,
	          'Page "',
	          slug,
	          '" not found'
	        )
	      );
	  }
	}
	
	function SimplePage(props) {
	  return _react2['default'].createElement(
	    'div',
	    { className: 'so-back SimplePage__back' },
	    _react2['default'].createElement(
	      'div',
	      { className: 'so-chunk' },
	      props.children
	    )
	  );
	}
	
	exports['default'] = (0, _reactRedux.connect)(chooseState)(LaboratoryChrome);
	
	function chooseState(state) {
	  return {
	    routing: state.routing,
	    currentNetwork: state.network.current
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(37);
	
	var _actionsNetwork = __webpack_require__(194);
	
	var _constantsNetwork = __webpack_require__(75);
	
	var _constantsNetwork2 = _interopRequireDefault(_constantsNetwork);
	
	var _FormComponentsTextPickerJs = __webpack_require__(22);
	
	var _FormComponentsTextPickerJs2 = _interopRequireDefault(_FormComponentsTextPickerJs);
	
	var NetworkPicker = (function (_React$Component) {
	  _inherits(NetworkPicker, _React$Component);
	
	  function NetworkPicker() {
	    _classCallCheck(this, NetworkPicker);
	
	    _get(Object.getPrototypeOf(NetworkPicker.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(NetworkPicker, [{
	    key: 'render',
	    value: function render() {
	      var dispatch = this.props.dispatch;
	      var _props = this.props;
	      var current = _props.current;
	      var modal = _props.modal;
	
	      var items = Object.keys(_constantsNetwork2['default'].available).map(function (n) {
	        return _react2['default'].createElement(NetworkToggle, {
	          name: n,
	          key: n,
	          selected: current.name === n,
	          onToggle: function () {
	            return dispatch((0, _actionsNetwork.chooseNetwork)(n));
	          }
	        });
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'NetworkPicker' },
	        _react2['default'].createElement(
	          'form',
	          { className: 's-buttonGroup NetworkPicker__buttonGroup' },
	          items
	        ),
	        _react2['default'].createElement(
	          'span',
	          { className: 'NetworkPicker__url' },
	          current.horizonURL
	        )
	      );
	    }
	  }]);
	
	  return NetworkPicker;
	})(_react2['default'].Component);
	
	var isValidHorizonURL = function isValidHorizonURL(u) {
	  try {
	    new URL(u);
	    return true;
	  } catch (e) {
	    return "Value is not a valid URL";
	  }
	};
	
	var NetworkToggle = function NetworkToggle(props) {
	  var name = props.name;
	  var onToggle = props.onToggle;
	  var selected = props.selected;
	
	  return _react2['default'].createElement(
	    'label',
	    { className: 's-buttonGroup__wrapper' },
	    _react2['default'].createElement('input', {
	      type: 'radio',
	      className: 's-buttonGroup__radio',
	      name: 'network-toggle',
	      onChange: onToggle,
	      checked: selected,
	      value: name }),
	    _react2['default'].createElement(
	      'span',
	      { className: 's-button s-button--light NetworkPicker__button' },
	      name
	    )
	  );
	};
	
	exports['default'] = (0, _reactRedux.connect)(chooseState)(NetworkPicker);
	
	function chooseState(state) {
	  return {
	    current: state.network.current,
	    modal: state.network.modal
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = AccountMerge;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsPubKeyPickerJs = __webpack_require__(24);
	
	var _FormComponentsPubKeyPickerJs2 = _interopRequireDefault(_FormComponentsPubKeyPickerJs);
	
	function AccountMerge(props) {
	  return [_react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Destination', key: 'destination' },
	    _react2['default'].createElement(_FormComponentsPubKeyPickerJs2['default'], {
	      value: props.values['destination'],
	      onUpdate: function (value) {
	        props.onUpdate('destination', value);
	      }
	    })
	  )];
	}
	
	module.exports = exports['default'];

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = AllowTrust;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsPubKeyPickerJs = __webpack_require__(24);
	
	var _FormComponentsPubKeyPickerJs2 = _interopRequireDefault(_FormComponentsPubKeyPickerJs);
	
	var _FormComponentsTextPickerJs = __webpack_require__(22);
	
	var _FormComponentsTextPickerJs2 = _interopRequireDefault(_FormComponentsTextPickerJs);
	
	var _FormComponentsBooleanPickerJs = __webpack_require__(148);
	
	var _FormComponentsBooleanPickerJs2 = _interopRequireDefault(_FormComponentsBooleanPickerJs);
	
	function AllowTrust(props) {
	  return [_react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Trustor', key: 'trustor' },
	    _react2['default'].createElement(_FormComponentsPubKeyPickerJs2['default'], {
	      value: props.values['trustor'],
	      onUpdate: function (value) {
	        props.onUpdate('trustor', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Asset Code', key: 'assetCode' },
	    _react2['default'].createElement(_FormComponentsTextPickerJs2['default'], {
	      value: props.values['assetCode'],
	      onUpdate: function (value) {
	        props.onUpdate('assetCode', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Authorize', key: 'authorize' },
	    _react2['default'].createElement(_FormComponentsBooleanPickerJs2['default'], {
	      value: props.values['authorize'],
	      onUpdate: function (value) {
	        props.onUpdate('authorize', value);
	      }
	    })
	  )];
	}
	
	module.exports = exports['default'];

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = BumpSequence;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsPositiveIntPickerJs = __webpack_require__(21);
	
	var _FormComponentsPositiveIntPickerJs2 = _interopRequireDefault(_FormComponentsPositiveIntPickerJs);
	
	function BumpSequence(props) {
	  return [_react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'BumpTo', key: 'bumpTo' },
	    _react2['default'].createElement(_FormComponentsPositiveIntPickerJs2['default'], {
	      value: props.values['bumpTo'],
	      onUpdate: function (value) {
	        props.onUpdate('bumpTo', value);
	      }
	    })
	  )];
	}
	
	module.exports = exports['default'];

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = ChangeTrust;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsAssetPickerJs = __webpack_require__(74);
	
	var _FormComponentsAssetPickerJs2 = _interopRequireDefault(_FormComponentsAssetPickerJs);
	
	var _FormComponentsPositiveIntPickerJs = __webpack_require__(21);
	
	var _FormComponentsPositiveIntPickerJs2 = _interopRequireDefault(_FormComponentsPositiveIntPickerJs);
	
	function ChangeTrust(props) {
	  return [_react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Asset', key: 'asset' },
	    _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	      value: props.values['asset'],
	      disableNative: true,
	      onUpdate: function (value) {
	        props.onUpdate('asset', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Trust Limit', optional: 'true', key: 'limit' },
	    _react2['default'].createElement(_FormComponentsPositiveIntPickerJs2['default'], {
	      value: props.values['limit'],
	      onUpdate: function (value) {
	        props.onUpdate('limit', value);
	      }
	    }),
	    _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      'Leave empty to default to the max int64.',
	      _react2['default'].createElement('br', null),
	      'Set to 0 to remove the trust line.'
	    )
	  )];
	}
	
	module.exports = exports['default'];

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = CreateAccount;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsPubKeyPickerJs = __webpack_require__(24);
	
	var _FormComponentsPubKeyPickerJs2 = _interopRequireDefault(_FormComponentsPubKeyPickerJs);
	
	var _FormComponentsAmountPickerJs = __webpack_require__(121);
	
	var _FormComponentsAmountPickerJs2 = _interopRequireDefault(_FormComponentsAmountPickerJs);
	
	function CreateAccount(props) {
	  return [_react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Destination', key: 'destination' },
	    _react2['default'].createElement(_FormComponentsPubKeyPickerJs2['default'], {
	      value: props.values['destination'],
	      onUpdate: function (value) {
	        props.onUpdate('destination', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Starting Balance', key: 'startingBalance' },
	    _react2['default'].createElement(_FormComponentsAmountPickerJs2['default'], {
	      value: props.values['startingBalance'],
	      onUpdate: function (value) {
	        props.onUpdate('startingBalance', value);
	      }
	    })
	  )];
	}
	
	module.exports = exports['default'];

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = ManageBuyOffer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _GenericOffer = __webpack_require__(196);
	
	var _GenericOffer2 = _interopRequireDefault(_GenericOffer);
	
	var _FormComponentsPositiveIntPickerJs = __webpack_require__(21);
	
	var _FormComponentsPositiveIntPickerJs2 = _interopRequireDefault(_FormComponentsPositiveIntPickerJs);
	
	function ManageBuyOffer(props) {
	  var GenericOfferPickers = (0, _GenericOffer2['default'])(props, true);
	  return GenericOfferPickers.concat(_react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Offer ID', key: 'offerId' },
	    _react2['default'].createElement(_FormComponentsPositiveIntPickerJs2['default'], {
	      value: props.values['offerId'],
	      onUpdate: function (value) {
	        props.onUpdate('offerId', value);
	      }
	    }),
	    _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      'If 0, will create a new offer. Existing offer id numbers can be found using the Offers for Account endpoint.'
	    )
	  ));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = ManageData;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsTextPickerJs = __webpack_require__(22);
	
	var _FormComponentsTextPickerJs2 = _interopRequireDefault(_FormComponentsTextPickerJs);
	
	function ManageData(props) {
	  var nameValidator = function nameValidator(value) {
	    if (value.length > 64) {
	      return 'Entry name can only contain a maximum of 64 characters. ' + value.length + ' entered.';
	    }
	  };
	
	  var valueValidator = function valueValidator(value) {
	    var valueSize = new Buffer(value).length;
	    if (valueSize > 64) {
	      return 'Entry value can only contain a maximum of 64 bytes. ' + valueSize + ' bytes entered.';
	    }
	  };
	
	  return [_react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Entry name', key: 'name' },
	    _react2['default'].createElement(_FormComponentsTextPickerJs2['default'], {
	      value: props.values['name'],
	      onUpdate: function (value) {
	        props.onUpdate('name', value);
	      },
	      validator: nameValidator
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Entry value', optional: 'true', key: 'value' },
	    _react2['default'].createElement(_FormComponentsTextPickerJs2['default'], {
	      value: props.values['value'],
	      onUpdate: function (value) {
	        props.onUpdate('value', value);
	      },
	      validator: valueValidator
	    }),
	    _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      'If empty, will delete the data entry named in this operation.',
	      _react2['default'].createElement('br', null),
	      'Note: The laboratory only supports strings.'
	    )
	  )];
	}
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10).Buffer))

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = ManageSellOffer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _GenericOffer = __webpack_require__(196);
	
	var _GenericOffer2 = _interopRequireDefault(_GenericOffer);
	
	var _FormComponentsPositiveIntPickerJs = __webpack_require__(21);
	
	var _FormComponentsPositiveIntPickerJs2 = _interopRequireDefault(_FormComponentsPositiveIntPickerJs);
	
	function ManageSellOffer(props) {
	  var GenericOfferPickers = (0, _GenericOffer2['default'])(props);
	  return GenericOfferPickers.concat(_react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Offer ID', key: 'offerId' },
	    _react2['default'].createElement(_FormComponentsPositiveIntPickerJs2['default'], {
	      value: props.values['offerId'],
	      onUpdate: function (value) {
	        props.onUpdate('offerId', value);
	      }
	    }),
	    _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      'If 0, will create a new offer. Existing offer id numbers can be found using the Offers for Account endpoint.'
	    )
	  ));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = PathPayment;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsAssetPickerJs = __webpack_require__(74);
	
	var _FormComponentsAssetPickerJs2 = _interopRequireDefault(_FormComponentsAssetPickerJs);
	
	var _FormComponentsAmountPickerJs = __webpack_require__(121);
	
	var _FormComponentsAmountPickerJs2 = _interopRequireDefault(_FormComponentsAmountPickerJs);
	
	var _FormComponentsPubKeyPickerJs = __webpack_require__(24);
	
	var _FormComponentsPubKeyPickerJs2 = _interopRequireDefault(_FormComponentsPubKeyPickerJs);
	
	var _FormComponentsManualMultiPickerJs = __webpack_require__(513);
	
	var _FormComponentsManualMultiPickerJs2 = _interopRequireDefault(_FormComponentsManualMultiPickerJs);
	
	function PathPayment(props) {
	  return [_react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Destination', key: 'destination' },
	    _react2['default'].createElement(_FormComponentsPubKeyPickerJs2['default'], {
	      value: props.values['destination'],
	      onUpdate: function (value) {
	        props.onUpdate('destination', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Sending Asset', key: 'sendAsset' },
	    _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	      value: props.values['sendAsset'],
	      onUpdate: function (value) {
	        props.onUpdate('sendAsset', value);
	      }
	    }),
	    _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      'The asset to be deduced from the sender\'s account'
	    )
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Maximum send amount', key: 'sendMax' },
	    _react2['default'].createElement(_FormComponentsAmountPickerJs2['default'], {
	      value: props.values['sendMax'],
	      onUpdate: function (value) {
	        props.onUpdate('sendMax', value);
	      }
	    }),
	    _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      'The most the sender is willing to spend to take the paths to. Resulting amount may vary due to the offers in the orderbook.'
	    )
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Intermediate Path', key: 'path', optional: 'true' },
	    _react2['default'].createElement(_FormComponentsManualMultiPickerJs2['default'], {
	      component: _FormComponentsAssetPickerJs2['default'],
	      value: props.values['path'],
	      'default': {},
	      addNewLabel: 'Add new intermediate asset',
	      onUpdate: function (value) {
	        props.onUpdate('path', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Destination Asset', key: 'destAsset' },
	    _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	      value: props.values['destAsset'],
	      onUpdate: function (value) {
	        props.onUpdate('destAsset', value);
	      }
	    }),
	    _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      'The asset to be received by the destination account'
	    )
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Destination Amount', key: 'destAmount' },
	    _react2['default'].createElement(_FormComponentsAmountPickerJs2['default'], {
	      value: props.values['destAmount'],
	      onUpdate: function (value) {
	        props.onUpdate('destAmount', value);
	      }
	    })
	  )];
	}
	
	module.exports = exports['default'];

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Payment;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsPubKeyPickerJs = __webpack_require__(24);
	
	var _FormComponentsPubKeyPickerJs2 = _interopRequireDefault(_FormComponentsPubKeyPickerJs);
	
	var _FormComponentsAmountPickerJs = __webpack_require__(121);
	
	var _FormComponentsAmountPickerJs2 = _interopRequireDefault(_FormComponentsAmountPickerJs);
	
	var _FormComponentsAssetPickerJs = __webpack_require__(74);
	
	var _FormComponentsAssetPickerJs2 = _interopRequireDefault(_FormComponentsAssetPickerJs);
	
	function Payment(props) {
	  return [_react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Destination', key: 'destination' },
	    _react2['default'].createElement(_FormComponentsPubKeyPickerJs2['default'], {
	      value: props.values['destination'],
	      onUpdate: function (value) {
	        props.onUpdate('destination', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Asset', key: 'asset' },
	    _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	      value: props.values['asset'],
	      onUpdate: function (value) {
	        props.onUpdate('asset', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    { label: 'Amount', key: 'amount' },
	    _react2['default'].createElement(_FormComponentsAmountPickerJs2['default'], {
	      value: props.values['amount'],
	      onUpdate: function (value) {
	        props.onUpdate('amount', value);
	      }
	    })
	  )];
	}
	
	module.exports = exports['default'];

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SetOptions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsPubKeyPicker = __webpack_require__(24);
	
	var _FormComponentsPubKeyPicker2 = _interopRequireDefault(_FormComponentsPubKeyPicker);
	
	var _FormComponentsPositiveIntPicker = __webpack_require__(21);
	
	var _FormComponentsPositiveIntPicker2 = _interopRequireDefault(_FormComponentsPositiveIntPicker);
	
	var _FormComponentsSignerPicker = __webpack_require__(519);
	
	var _FormComponentsSignerPicker2 = _interopRequireDefault(_FormComponentsSignerPicker);
	
	var _FormComponentsTextPicker = __webpack_require__(22);
	
	var _FormComponentsTextPicker2 = _interopRequireDefault(_FormComponentsTextPicker);
	
	var _FormComponentsFlagfieldPicker = __webpack_require__(512);
	
	var _FormComponentsFlagfieldPicker2 = _interopRequireDefault(_FormComponentsFlagfieldPicker);
	
	var _FormComponentsUnsigned8bitIntPicker = __webpack_require__(309);
	
	var _FormComponentsUnsigned8bitIntPicker2 = _interopRequireDefault(_FormComponentsUnsigned8bitIntPicker);
	
	var _HelpMark = __webpack_require__(124);
	
	var _HelpMark2 = _interopRequireDefault(_HelpMark);
	
	var accountFlagFieldsSet = {
	  1: 'Authorization required',
	  2: 'Authorization revocable',
	  4: 'Authorization immutable'
	};
	
	var accountFlagFieldsClear = {
	  1: 'Authorization required',
	  2: 'Authorization revocable'
	};
	
	function SetOptions(props) {
	  return [_react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    {
	      label: _react2['default'].createElement(
	        'span',
	        null,
	        'Inflation Destination ',
	        _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/accounts.html#inflation-destination' })
	      ),
	      optional: true, key: 'inflationDest' },
	    _react2['default'].createElement(_FormComponentsPubKeyPicker2['default'], {
	      value: props.values['inflationDest'],
	      onUpdate: function (value) {
	        props.onUpdate('inflationDest', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    {
	      label: _react2['default'].createElement(
	        'span',
	        null,
	        'Set Flags ',
	        _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/accounts.html#flags' })
	      ),
	      optional: true, key: 'setFlags' },
	    _react2['default'].createElement(_FormComponentsFlagfieldPicker2['default'], {
	      value: props.values['setFlags'],
	      items: accountFlagFieldsSet,
	      onUpdate: function (value) {
	        props.onUpdate('setFlags', value);
	      }
	    }),
	    _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      'Selected ',
	      _react2['default'].createElement(
	        'a',
	        { href: 'https://en.wikipedia.org/wiki/Flag_field', target: '_blank' },
	        'flags'
	      ),
	      ' mean to add selected flags in addition to flags already present on the account.'
	    )
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    {
	      label: _react2['default'].createElement(
	        'span',
	        null,
	        'Clear Flags ',
	        _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/accounts.html#flags' })
	      ),
	      optional: true, key: 'clearFlags' },
	    _react2['default'].createElement(_FormComponentsFlagfieldPicker2['default'], {
	      value: props.values['clearFlags'],
	      items: accountFlagFieldsClear,
	      onUpdate: function (value) {
	        props.onUpdate('clearFlags', value);
	      }
	    }),
	    _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      'Selected ',
	      _react2['default'].createElement(
	        'a',
	        { href: 'https://en.wikipedia.org/wiki/Flag_field', target: '_blank' },
	        'flags'
	      ),
	      ' mean to remove selected flags already present on the account.'
	    )
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    {
	      label: _react2['default'].createElement(
	        'span',
	        null,
	        'Master Weight ',
	        _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/accounts.html#thresholds' })
	      ),
	      optional: true, key: 'masterWeight' },
	    _react2['default'].createElement(_FormComponentsUnsigned8bitIntPicker2['default'], {
	      value: props.values['masterWeight'],
	      onUpdate: function (value) {
	        props.onUpdate('masterWeight', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    {
	      label: _react2['default'].createElement(
	        'span',
	        null,
	        'Low Threshold ',
	        _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/accounts.html#thresholds' })
	      ),
	      optional: true, key: 'lowThreshold' },
	    _react2['default'].createElement(_FormComponentsUnsigned8bitIntPicker2['default'], {
	      value: props.values['lowThreshold'],
	      onUpdate: function (value) {
	        props.onUpdate('lowThreshold', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    {
	      label: _react2['default'].createElement(
	        'span',
	        null,
	        'Medium Threshold ',
	        _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/accounts.html#thresholds' })
	      ),
	      optional: true, key: 'medThreshold' },
	    _react2['default'].createElement(_FormComponentsUnsigned8bitIntPicker2['default'], {
	      value: props.values['medThreshold'],
	      onUpdate: function (value) {
	        props.onUpdate('medThreshold', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    {
	      label: _react2['default'].createElement(
	        'span',
	        null,
	        'High Threshold ',
	        _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/accounts.html#thresholds' })
	      ),
	      optional: true, key: 'highThreshold' },
	    _react2['default'].createElement(_FormComponentsUnsigned8bitIntPicker2['default'], {
	      value: props.values['highThreshold'],
	      onUpdate: function (value) {
	        props.onUpdate('highThreshold', value);
	      }
	    })
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    {
	      label: _react2['default'].createElement(
	        'span',
	        null,
	        'Signer Type ',
	        _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/multi-sig.html#additional-signing-keys' })
	      ),
	      optional: true, key: 'signer' },
	    _react2['default'].createElement(_FormComponentsSignerPicker2['default'], {
	      value: props.values['signer'],
	      onUpdate: function (value) {
	        props.onUpdate('signer', value);
	      }
	    }),
	    _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      'Used to add/remove or adjust weight of an additional signer on the account.'
	    )
	  ), _react2['default'].createElement(
	    _OptionsTablePair2['default'],
	    {
	      label: _react2['default'].createElement(
	        'span',
	        null,
	        'Home Domain ',
	        _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/multi-sig.html#additional-signing-keys' })
	      ),
	      optional: true, key: 'homeDomain' },
	    _react2['default'].createElement(_FormComponentsTextPicker2['default'], {
	      value: props.values['homeDomain'],
	      placeholder: 'Example: example.com',
	      onUpdate: function (value) {
	        props.onUpdate('homeDomain', value);
	      }
	    })
	  )];
	}
	
	module.exports = exports['default'];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(37);
	
	var _FormComponentsPubKeyPickerJs = __webpack_require__(24);
	
	var _FormComponentsPubKeyPickerJs2 = _interopRequireDefault(_FormComponentsPubKeyPickerJs);
	
	var _dataOperations = __webpack_require__(203);
	
	var _actionsTransactionBuilder = __webpack_require__(146);
	
	var _FormComponentsOperationTypePicker = __webpack_require__(516);
	
	var _FormComponentsOperationTypePicker2 = _interopRequireDefault(_FormComponentsOperationTypePicker);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _HelpMark = __webpack_require__(124);
	
	var _HelpMark2 = _interopRequireDefault(_HelpMark);
	
	var OperationsBuilder = (function (_React$Component) {
	  _inherits(OperationsBuilder, _React$Component);
	
	  function OperationsBuilder() {
	    _classCallCheck(this, OperationsBuilder);
	
	    _get(Object.getPrototypeOf(OperationsBuilder.prototype), 'constructor', this).call(this);
	  }
	
	  // takes in op state from the reducer
	
	  _createClass(OperationsBuilder, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'TransactionOperations' },
	        _.map(this.props.ops, function (op, index) {
	          return operation(_this.props.ops, index, _this.props.dispatch);
	        })
	      );
	    }
	  }]);
	
	  return OperationsBuilder;
	})(_react2['default'].Component);
	
	var operation = function operation(ops, index, dispatch) {
	  var op = ops[index];
	  var opConfig = (0, _dataOperations.getOperation)(op.name);
	  var operationPane = undefined,
	      sourceAccountRow = undefined,
	      separator = undefined;
	  var dispatchUpdateOpAtts = function dispatchUpdateOpAtts(key, value) {
	    dispatch((0, _actionsTransactionBuilder.updateOperationAttributes)(op.id, _defineProperty({}, key, value)));
	  };
	  var helpNote = undefined,
	      docsLink = undefined;
	  if (opConfig !== undefined) {
	    operationPane = opConfig.operationPane({
	      onUpdate: dispatchUpdateOpAtts,
	      values: op.attributes
	    });
	
	    helpNote = _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      opConfig.helpNote
	    );
	    docsLink = _react2['default'].createElement(
	      'p',
	      { className: 'optionsTable__pair__content__note' },
	      _react2['default'].createElement(
	        'a',
	        { href: opConfig.docsUrl, target: '_blank' },
	        'See documentation for ',
	        opConfig.label
	      )
	    );
	
	    sourceAccountRow = _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Source Account', optional: true, key: 'sourceAccount' },
	      _react2['default'].createElement(_FormComponentsPubKeyPickerJs2['default'], {
	        value: op.attributes['sourceAccount'],
	        onUpdate: function (value) {
	          return dispatchUpdateOpAtts('sourceAccount', value);
	        }
	      })
	    );
	
	    separator = _react2['default'].createElement('hr', { className: 'optionsTable__separator' });
	  }
	
	  var removeLink = undefined;
	  if (ops.length > 1) {
	    removeLink = _react2['default'].createElement(
	      'p',
	      { className: 'TransactionOpMeta__remove' },
	      _react2['default'].createElement(
	        'a',
	        { onClick: function () {
	            return dispatch((0, _actionsTransactionBuilder.removeOperation)(op.id));
	          } },
	        'remove'
	      )
	    );
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    { className: 'TransactionOp', key: op.id },
	    _react2['default'].createElement(
	      'div',
	      { className: 'TransactionOp__meta TransactionOpMeta' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'TransactionOpMeta__order' },
	        _react2['default'].createElement(BlurNumberInput, {
	          value: Number(index) + 1,
	          onUpdate: function (value) {
	            return dispatch((0, _actionsTransactionBuilder.reorderOperation)(op.id, value));
	          },
	          maxLength: '2',
	          className: 'TransactionOpMeta__order__input' })
	      ),
	      removeLink
	    ),
	    _react2['default'].createElement(
	      'div',
	      { className: 'TransactionOp__config TransactionOpConfig optionsTable' },
	      _react2['default'].createElement(
	        _OptionsTablePair2['default'],
	        { label: _react2['default'].createElement(
	            'span',
	            null,
	            'Operation Type ',
	            _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/list-of-operations.html' })
	          ) },
	        _react2['default'].createElement(_FormComponentsOperationTypePicker2['default'], { value: op.name, onUpdate: function (value) {
	            dispatch((0, _actionsTransactionBuilder.updateOperationType)(op.id, value));
	          } }),
	        helpNote,
	        docsLink
	      ),
	      separator,
	      operationPane,
	      sourceAccountRow
	    )
	  );
	};
	
	exports['default'] = (0, _reactRedux.connect)(chooseState)(OperationsBuilder);
	
	function chooseState(state) {
	  return {
	    ops: state.transactionBuilder.operations
	  };
	}
	
	// BlurNumberInput is a controller input component that calls onUpdate only when
	// the user unfocuses the input
	
	var BlurNumberInput = (function (_React$Component2) {
	  _inherits(BlurNumberInput, _React$Component2);
	
	  function BlurNumberInput(props) {
	    _classCallCheck(this, BlurNumberInput);
	
	    _get(Object.getPrototypeOf(BlurNumberInput.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      currentValue: props.value
	    };
	  }
	
	  _createClass(BlurNumberInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        currentValue: nextProps.value
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      this.setState({
	        currentValue: event.target.value
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(event) {
	      this.props.onUpdate(this.state.currentValue);
	      this.setState({
	        currentValue: this.props.value
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement('input', {
	        className: this.props.className,
	        type: 'text',
	        onChange: this.onChange.bind(this),
	        onBlur: this.onBlur.bind(this),
	        value: this.state.currentValue,
	        maxLength: this.props.maxLength });
	    }
	  }]);
	
	  return BlurNumberInput;
	})(_react2['default'].Component);
	
	BlurNumberInput.propTypes = {
	  onUpdate: _react2['default'].PropTypes.func.isRequired,
	  value: _react2['default'].PropTypes.number.isRequired
	};
	module.exports = exports['default'];

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = AllAssets;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _All = __webpack_require__(197);
	
	var _All2 = _interopRequireDefault(_All);
	
	var _FormComponentsTextPickerJs = __webpack_require__(22);
	
	var _FormComponentsTextPickerJs2 = _interopRequireDefault(_FormComponentsTextPickerJs);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsPubKeyPickerJs = __webpack_require__(24);
	
	var _FormComponentsPubKeyPickerJs2 = _interopRequireDefault(_FormComponentsPubKeyPickerJs);
	
	function AllAssets(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Asset Code', optional: true },
	      _react2['default'].createElement(_FormComponentsTextPickerJs2['default'], {
	        value: props.values['asset_code'],
	        onUpdate: function (value) {
	          props.onUpdate('asset_code', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Asset Issuer', optional: true },
	      _react2['default'].createElement(_FormComponentsPubKeyPickerJs2['default'], {
	        value: props.values['asset_issuer'],
	        onUpdate: function (value) {
	          props.onUpdate('asset_issuer', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(_All2['default'], props)
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = FindPaymentPaths;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsPubKeyPickerJs = __webpack_require__(24);
	
	var _FormComponentsPubKeyPickerJs2 = _interopRequireDefault(_FormComponentsPubKeyPickerJs);
	
	var _FormComponentsAssetPickerJs = __webpack_require__(74);
	
	var _FormComponentsAssetPickerJs2 = _interopRequireDefault(_FormComponentsAssetPickerJs);
	
	var _FormComponentsAmountPickerJs = __webpack_require__(121);
	
	var _FormComponentsAmountPickerJs2 = _interopRequireDefault(_FormComponentsAmountPickerJs);
	
	function FindPaymentPaths(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Source Account' },
	      _react2['default'].createElement(_FormComponentsPubKeyPickerJs2['default'], {
	        value: props.values['source_account'],
	        onUpdate: function (value) {
	          props.onUpdate('source_account', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Destination Account' },
	      _react2['default'].createElement(_FormComponentsPubKeyPickerJs2['default'], {
	        value: props.values['destination_account'],
	        onUpdate: function (value) {
	          props.onUpdate('destination_account', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Destination Asset' },
	      _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	        value: props.values['destination_asset'],
	        onUpdate: function (value) {
	          props.onUpdate('destination_asset', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Destination Amount' },
	      _react2['default'].createElement(_FormComponentsAmountPickerJs2['default'], {
	        value: props.values['destination_amount'],
	        onUpdate: function (value) {
	          props.onUpdate('destination_amount', value);
	        }
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = ForOffer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _For = __webpack_require__(125);
	
	var _For2 = _interopRequireDefault(_For);
	
	var _FormComponentsPositiveIntPickerJs = __webpack_require__(21);
	
	var _FormComponentsPositiveIntPickerJs2 = _interopRequireDefault(_FormComponentsPositiveIntPickerJs);
	
	function ForOffer(props) {
	  var label = 'Offer ID';
	  var content = _react2['default'].createElement(_FormComponentsPositiveIntPickerJs2['default'], {
	    value: props.values['offer_id'],
	    onUpdate: function (value) {
	      props.onUpdate('offer_id', value);
	    },
	    placeholder: 'Example: 323223'
	  });
	
	  return _react2['default'].createElement(_For2['default'], _extends({ label: label, content: content }, props));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = ForOperation;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _For = __webpack_require__(125);
	
	var _For2 = _interopRequireDefault(_For);
	
	var _FormComponentsOperationPickerJs = __webpack_require__(306);
	
	var _FormComponentsOperationPickerJs2 = _interopRequireDefault(_FormComponentsOperationPickerJs);
	
	function ForOperation(props) {
	  var label = 'Operation ID';
	  var content = _react2['default'].createElement(_FormComponentsOperationPickerJs2['default'], {
	    value: props.values['operation'],
	    onUpdate: function (value) {
	      props.onUpdate('operation', value);
	    }
	  });
	
	  return _react2['default'].createElement(_For2['default'], _extends({ label: label, content: content }, props));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Trades;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsAssetPickerJs = __webpack_require__(74);
	
	var _FormComponentsAssetPickerJs2 = _interopRequireDefault(_FormComponentsAssetPickerJs);
	
	function Trades(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Selling Asset' },
	      _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	        value: props.values['selling_asset'],
	        onUpdate: function (value) {
	          props.onUpdate('selling_asset', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Buying Asset' },
	      _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	        value: props.values['buying_asset'],
	        onUpdate: function (value) {
	          props.onUpdate('buying_asset', value);
	        }
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = PostTransaction;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsXdrPickerJs = __webpack_require__(523);
	
	var _FormComponentsXdrPickerJs2 = _interopRequireDefault(_FormComponentsXdrPickerJs);
	
	function PostTransaction(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Transaction Envelope XDR' },
	      _react2['default'].createElement(_FormComponentsXdrPickerJs2['default'], {
	        value: props.values['tx'],
	        onUpdate: function (value) {
	          props.onUpdate('tx', value);
	        }
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SingleAccount;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsPubKeyPickerJs = __webpack_require__(24);
	
	var _FormComponentsPubKeyPickerJs2 = _interopRequireDefault(_FormComponentsPubKeyPickerJs);
	
	function SingleAccount(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Account ID' },
	      _react2['default'].createElement(_FormComponentsPubKeyPickerJs2['default'], {
	        value: props.values['account_id'],
	        onUpdate: function (value) {
	          props.onUpdate('account_id', value);
	        }
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SingleLedger;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsLedgerPickerJs = __webpack_require__(305);
	
	var _FormComponentsLedgerPickerJs2 = _interopRequireDefault(_FormComponentsLedgerPickerJs);
	
	function SingleLedger(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Ledger Sequence' },
	      _react2['default'].createElement(_FormComponentsLedgerPickerJs2['default'], {
	        value: props.values['ledger'],
	        onUpdate: function (value) {
	          props.onUpdate('ledger', value);
	        }
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SingleOperation;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsOperationPickerJs = __webpack_require__(306);
	
	var _FormComponentsOperationPickerJs2 = _interopRequireDefault(_FormComponentsOperationPickerJs);
	
	function SingleOperation(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Operation ID' },
	      _react2['default'].createElement(_FormComponentsOperationPickerJs2['default'], {
	        value: props.values['operation'],
	        onUpdate: function (value) {
	          props.onUpdate('operation', value);
	        }
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SingleTransaction;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsTransactionPickerJs = __webpack_require__(308);
	
	var _FormComponentsTransactionPickerJs2 = _interopRequireDefault(_FormComponentsTransactionPickerJs);
	
	function SingleTransaction(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Transaction Hash' },
	      _react2['default'].createElement(_FormComponentsTransactionPickerJs2['default'], {
	        value: props.values['transaction'],
	        onUpdate: function (value) {
	          props.onUpdate('transaction', value);
	        }
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = TradeAggregations;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsAssetPickerJs = __webpack_require__(74);
	
	var _FormComponentsAssetPickerJs2 = _interopRequireDefault(_FormComponentsAssetPickerJs);
	
	var _FormComponentsTextPickerJs = __webpack_require__(22);
	
	var _FormComponentsTextPickerJs2 = _interopRequireDefault(_FormComponentsTextPickerJs);
	
	var _FormComponentsPositiveIntPickerJs = __webpack_require__(21);
	
	var _FormComponentsPositiveIntPickerJs2 = _interopRequireDefault(_FormComponentsPositiveIntPickerJs);
	
	var _FormComponentsOrderPickerJs = __webpack_require__(122);
	
	var _FormComponentsOrderPickerJs2 = _interopRequireDefault(_FormComponentsOrderPickerJs);
	
	function TradeAggregations(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Base Asset', optional: false },
	      _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	        value: props.values['base_asset'],
	        onUpdate: function (value) {
	          props.onUpdate('base_asset', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Counter Asset', optional: false },
	      _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	        value: props.values['counter_asset'],
	        onUpdate: function (value) {
	          props.onUpdate('counter_asset', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Start Time', optional: false },
	      _react2['default'].createElement(_FormComponentsTextPickerJs2['default'], {
	        value: props.values['start_time'],
	        onUpdate: function (value) {
	          props.onUpdate('start_time', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'End Time', optional: false },
	      _react2['default'].createElement(_FormComponentsTextPickerJs2['default'], {
	        value: props.values['end_time'],
	        onUpdate: function (value) {
	          props.onUpdate('end_time', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Resolution', optional: false },
	      _react2['default'].createElement(_FormComponentsTextPickerJs2['default'], {
	        value: props.values['resolution'],
	        onUpdate: function (value) {
	          props.onUpdate('resolution', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Limit', optional: true },
	      _react2['default'].createElement(_FormComponentsPositiveIntPickerJs2['default'], {
	        value: props.values['limit'],
	        onUpdate: function (value) {
	          props.onUpdate('limit', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Order', optional: true },
	      _react2['default'].createElement(_FormComponentsOrderPickerJs2['default'], {
	        value: props.values['order'],
	        onUpdate: function (value) {
	          props.onUpdate('order', value);
	        }
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Trades;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsAssetPickerJs = __webpack_require__(74);
	
	var _FormComponentsAssetPickerJs2 = _interopRequireDefault(_FormComponentsAssetPickerJs);
	
	var _FormComponentsTextPickerJs = __webpack_require__(22);
	
	var _FormComponentsTextPickerJs2 = _interopRequireDefault(_FormComponentsTextPickerJs);
	
	var _FormComponentsPositiveIntPickerJs = __webpack_require__(21);
	
	var _FormComponentsPositiveIntPickerJs2 = _interopRequireDefault(_FormComponentsPositiveIntPickerJs);
	
	var _FormComponentsOrderPickerJs = __webpack_require__(122);
	
	var _FormComponentsOrderPickerJs2 = _interopRequireDefault(_FormComponentsOrderPickerJs);
	
	function Trades(props) {
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Base Asset', optional: true },
	      _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	        value: props.values['base_asset'],
	        onUpdate: function (value) {
	          props.onUpdate('base_asset', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Counter Asset', optional: true },
	      _react2['default'].createElement(_FormComponentsAssetPickerJs2['default'], {
	        value: props.values['counter_asset'],
	        onUpdate: function (value) {
	          props.onUpdate('counter_asset', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Offer id', optional: true },
	      _react2['default'].createElement(_FormComponentsTextPickerJs2['default'], {
	        value: props.values['offer_id'],
	        onUpdate: function (value) {
	          props.onUpdate('offer_id', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Cursor', optional: true },
	      _react2['default'].createElement(_FormComponentsTextPickerJs2['default'], {
	        value: props.values['cursor'],
	        onUpdate: function (value) {
	          props.onUpdate('cursor', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Limit', optional: true },
	      _react2['default'].createElement(_FormComponentsPositiveIntPickerJs2['default'], {
	        value: props.values['limit'],
	        onUpdate: function (value) {
	          props.onUpdate('limit', value);
	        }
	      })
	    ),
	    _react2['default'].createElement(
	      _OptionsTablePair2['default'],
	      { label: 'Order', optional: true },
	      _react2['default'].createElement(_FormComponentsOrderPickerJs2['default'], {
	        value: props.values['order'],
	        onUpdate: function (value) {
	          props.onUpdate('order', value);
	        }
	      })
	    )
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(37);
	
	var _EndpointPicker = __webpack_require__(302);
	
	var _EndpointSetup = __webpack_require__(304);
	
	var _EndpointResult = __webpack_require__(303);
	
	var _FormComponentsPubKeyPicker = __webpack_require__(24);
	
	var _TxBuilderAttributes = __webpack_require__(555);
	
	var _TxBuilderAttributes2 = _interopRequireDefault(_TxBuilderAttributes);
	
	var _actionsTransactionBuilder = __webpack_require__(146);
	
	var _OperationsBuilder = __webpack_require__(538);
	
	var _OperationsBuilder2 = _interopRequireDefault(_OperationsBuilder);
	
	var _dataOperations = __webpack_require__(203);
	
	var _TxBuilderResult = __webpack_require__(556);
	
	var _TxBuilderResult2 = _interopRequireDefault(_TxBuilderResult);
	
	var TransactionBuilder = (function (_React$Component) {
	  _inherits(TransactionBuilder, _React$Component);
	
	  function TransactionBuilder() {
	    _classCallCheck(this, TransactionBuilder);
	
	    _get(Object.getPrototypeOf(TransactionBuilder.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(TransactionBuilder, [{
	    key: 'render',
	    value: function render() {
	      var dispatch = this.props.dispatch;
	      var _props$state = this.props.state;
	      var attributes = _props$state.attributes;
	      var operations = _props$state.operations;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'TransactionBuilder' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'so-back' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'so-chunk' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'pageIntro' },
	              _react2['default'].createElement(
	                'p',
	                null,
	                'Build a new transaction'
	              )
	            ),
	            _react2['default'].createElement(
	              'p',
	              { className: 'TransactionBuilder__clearBar' },
	              _react2['default'].createElement(
	                'a',
	                { className: 'TransactionBuilder__clearBar__link',
	                  onClick: function () {
	                    return dispatch((0, _actionsTransactionBuilder.resetTxbuilder)());
	                  } },
	                'Clear form contents and start over'
	              )
	            ),
	            _react2['default'].createElement(_TxBuilderAttributes2['default'], {
	              attributes: attributes,
	              onUpdate: onAttributeUpdate.bind(this, dispatch) }),
	            _react2['default'].createElement(_OperationsBuilder2['default'], null),
	            _react2['default'].createElement(
	              'div',
	              { className: 'TransactionOperations__add' },
	              _react2['default'].createElement(
	                'button',
	                { className: 'TransactionOperations__add__button s-button', onClick: function () {
	                    return dispatch((0, _actionsTransactionBuilder.addOperation)());
	                  } },
	                '+ Add Operation'
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'so-back TransactionBuilder__result' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'so-chunk' },
	            _react2['default'].createElement(_TxBuilderResult2['default'], null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return TransactionBuilder;
	})(_react2['default'].Component);
	
	;
	
	exports['default'] = (0, _reactRedux.connect)(chooseState)(TransactionBuilder);
	
	function chooseState(state) {
	  return {
	    state: state.transactionBuilder
	  };
	}
	
	function onAttributeUpdate(dispatch, param, value) {
	  var newAttributes = {};
	  switch (param) {
	    case 'sourceAccount':
	      newAttributes.sourceAccount = value;
	      break;
	    case 'sequence':
	      newAttributes.sequence = value;
	      break;
	    case 'fee':
	      newAttributes.fee = value;
	      break;
	    case 'memo':
	      newAttributes.memoType = value.type;
	      newAttributes.memoContent = value.content;
	    case 'timebounds':
	      newAttributes.minTime = value.minTime;
	      newAttributes.maxTime = value.maxTime;
	      break;
	  }
	  dispatch((0, _actionsTransactionBuilder.updateAttributes)(newAttributes));
	}
	module.exports = exports['default'];

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(166);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utilitiesValidateTxXdr = __webpack_require__(208);
	
	var _utilitiesValidateTxXdr2 = _interopRequireDefault(_utilitiesValidateTxXdr);
	
	// TransactionImporter will call the onImport passed to it's props when the user
	// presses the import button and the input is valid
	
	var TransactionImporter = (function (_React$Component) {
	  _inherits(TransactionImporter, _React$Component);
	
	  function TransactionImporter() {
	    _classCallCheck(this, TransactionImporter);
	
	    _get(Object.getPrototypeOf(TransactionImporter.prototype), 'constructor', this).call(this);
	    this.state = {
	      input: ''
	    };
	  }
	
	  _createClass(TransactionImporter, [{
	    key: 'updateTextarea',
	    value: function updateTextarea(event) {
	      this.setState({
	        'input': event.target.value
	      });
	    }
	  }, {
	    key: 'triggerImport',
	    value: function triggerImport() {
	      if ((0, _utilitiesValidateTxXdr2['default'])(this.state.input).result === 'success') {
	        this.props.onImport(this.state.input);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var validation = undefined,
	          message = undefined,
	          submitEnabled = undefined,
	          messageClass = undefined;
	      validation = (0, _utilitiesValidateTxXdr2['default'])(this.state.input);
	      messageClass = validation.result === 'error' ? 'xdrInput__message__alert' : 'xdrInput__message__success';
	      message = _react2['default'].createElement(
	        'p',
	        { className: messageClass },
	        validation.message
	      );
	
	      submitEnabled = validation.result === 'success';
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'xdrInput' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'xdrInput__input' },
	          _react2['default'].createElement('textarea', {
	            className: 'xdrInput__input__textarea',
	            onChange: this.updateTextarea.bind(this),
	            placeholder: 'Example: AAAAAGXNhB2hIkbP//jgzn4os/AAAAZAB+BaLPAAA5Q/xL...' })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'xdrInput__message' },
	          message
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 's-buttonList' },
	          _react2['default'].createElement(
	            'button',
	            { className: 's-button',
	              disabled: !submitEnabled, onClick: this.triggerImport.bind(this) },
	            'Import Transaction'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TransactionImporter;
	})(_react2['default'].Component);
	
	exports['default'] = TransactionImporter;
	
	TransactionImporter.propTypes = {
	  'onImport': _react2['default'].PropTypes.func.isRequired
	};
	module.exports = exports['default'];

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(37);
	
	var _stellarSdk = __webpack_require__(23);
	
	var _TransactionImporter = __webpack_require__(552);
	
	var _TransactionImporter2 = _interopRequireDefault(_TransactionImporter);
	
	var _actionsTransactionSigner = __webpack_require__(300);
	
	var _EasySelect = __webpack_require__(147);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _FormComponentsSecretKeyPicker = __webpack_require__(517);
	
	var _FormComponentsSecretKeyPicker2 = _interopRequireDefault(_FormComponentsSecretKeyPicker);
	
	var _FormComponentsMultiPicker = __webpack_require__(515);
	
	var _FormComponentsMultiPicker2 = _interopRequireDefault(_FormComponentsMultiPicker);
	
	var _FormComponentsBipPathPicker = __webpack_require__(510);
	
	var _FormComponentsBipPathPicker2 = _interopRequireDefault(_FormComponentsBipPathPicker);
	
	var _utilitiesLinkBuilder = __webpack_require__(206);
	
	var _HelpMark = __webpack_require__(124);
	
	var _HelpMark2 = _interopRequireDefault(_HelpMark);
	
	var _utilitiesClickToSelect = __webpack_require__(204);
	
	var _utilitiesClickToSelect2 = _interopRequireDefault(_utilitiesClickToSelect);
	
	var _utilitiesScrollOnAnchorOpen = __webpack_require__(207);
	
	var _utilitiesScrollOnAnchorOpen2 = _interopRequireDefault(_utilitiesScrollOnAnchorOpen);
	
	var _utilitiesExtrapolateFromXdr = __webpack_require__(314);
	
	var _utilitiesExtrapolateFromXdr2 = _interopRequireDefault(_utilitiesExtrapolateFromXdr);
	
	var _utilitiesValidateTxXdr = __webpack_require__(208);
	
	var _utilitiesValidateTxXdr2 = _interopRequireDefault(_utilitiesValidateTxXdr);
	
	var _constantsNetwork = __webpack_require__(75);
	
	var _constantsNetwork2 = _interopRequireDefault(_constantsNetwork);
	
	var _utilitiesLibify = __webpack_require__(312);
	
	var TransactionSigner = (function (_React$Component) {
	  _inherits(TransactionSigner, _React$Component);
	
	  function TransactionSigner() {
	    _classCallCheck(this, TransactionSigner);
	
	    _get(Object.getPrototypeOf(TransactionSigner.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(TransactionSigner, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var dispatch = _props.dispatch;
	      var networkPassphrase = _props.networkPassphrase;
	      var _props$state = this.props.state;
	      var xdr = _props$state.xdr;
	      var signers = _props$state.signers;
	      var bipPath = _props$state.bipPath;
	      var ledgerwalletStatus = _props$state.ledgerwalletStatus;
	
	      var content = undefined;
	
	      var networkObj = new _stellarSdk.Network(networkPassphrase);
	
	      if ((0, _utilitiesValidateTxXdr2['default'])(xdr).result !== 'success') {
	        content = _react2['default'].createElement(
	          'div',
	          { className: 'so-back' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'so-chunk' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'TxSignerImport TransactionSigner__import' },
	              _react2['default'].createElement(
	                'p',
	                { className: 'TxSignerImport__title' },
	                'Import a transaction envelope in XDR format:'
	              ),
	              _react2['default'].createElement(_TransactionImporter2['default'], { onImport: function (xdr) {
	                  return dispatch((0, _actionsTransactionSigner.importFromXdr)(xdr));
	                } })
	            )
	          )
	        );
	      } else {
	        var ledgerSigs = ledgerwalletStatus.signatures;
	        var result = (0, _utilitiesLibify.signTransaction)(xdr, signers, networkObj, ledgerSigs);
	        var transaction = new _stellarSdk.Transaction(xdr);
	
	        var infoTable = {
	          'Signing for': _react2['default'].createElement(
	            'pre',
	            { className: 'so-code so-code__wrap' },
	            _react2['default'].createElement(
	              'code',
	              null,
	              networkPassphrase
	            )
	          ),
	          'Transaction Envelope XDR': _react2['default'].createElement(
	            _EasySelect.EasySelect,
	            { plain: true },
	            _react2['default'].createElement(
	              'pre',
	              { className: 'so-code so-code__wrap' },
	              _react2['default'].createElement(
	                'code',
	                null,
	                xdr
	              )
	            )
	          ),
	          'Transaction Hash': _react2['default'].createElement(
	            _EasySelect.EasySelect,
	            { plain: true },
	            _react2['default'].createElement(
	              'pre',
	              { className: 'so-code so-code__wrap' },
	              _react2['default'].createElement(
	                'code',
	                null,
	                transaction.hash().toString('hex')
	              )
	            )
	          ),
	          'Source account': transaction.source,
	          'Sequence number': transaction.sequence,
	          'Transaction Fee (stroops)': transaction.fee,
	          'Number of operations': transaction.operations.length,
	          'Number of existing signatures': transaction.signatures.length
	        };
	
	        var codeResult = undefined,
	            submitLink = undefined,
	            xdrLink = undefined,
	            resultTitle = undefined,
	            submitInstructions = undefined;
	
	        if (!_.isUndefined(result.xdr)) {
	          codeResult = _react2['default'].createElement(
	            'pre',
	            { className: 'TxSignerResult__xdr so-code so-code__wrap', onClick: _utilitiesClickToSelect2['default'] },
	            _react2['default'].createElement(
	              'code',
	              null,
	              result.xdr
	            )
	          );
	          submitLink = _react2['default'].createElement(
	            'a',
	            {
	              className: 's-button TxSignerResult__submit',
	              href: (0, _utilitiesLinkBuilder.txPostLink)(result.xdr),
	              onClick: _utilitiesScrollOnAnchorOpen2['default']
	            },
	            'Submit to Post Transaction endpoint'
	          );
	          xdrLink = _react2['default'].createElement(
	            'a',
	            {
	              className: 's-button TxSignerResult__submit',
	              href: (0, _utilitiesLinkBuilder.xdrViewer)(result.xdr, 'TransactionEnvelope'),
	              onClick: _utilitiesScrollOnAnchorOpen2['default']
	            },
	            'View in XDR Viewer'
	          );
	          resultTitle = _react2['default'].createElement(
	            'h3',
	            { className: 'TxSignerResult__title' },
	            'Transaction signed!'
	          );
	          submitInstructions = _react2['default'].createElement(
	            'p',
	            { className: 'TxSignerResult__instructions' },
	            'Now that this transaction is signed, you can submit it to the network. Horizon provides an endpoint called Post Transaction that will relay your transaction to the network and inform you of the result.'
	          );
	        }
	
	        var ledgerwalletMessage = undefined;
	        if (ledgerwalletStatus.message) {
	
	          var messageAlertType = undefined;
	          if (ledgerwalletStatus.status === 'loading') {
	            messageAlertType = 's-alert--info';
	          } else if (ledgerwalletStatus.status === 'success') {
	            messageAlertType = 's-alert--success';
	          } else if (ledgerwalletStatus.status === 'failure') {
	            messageAlertType = 's-alert--alert';
	          }
	
	          ledgerwalletMessage = _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement('br', null),
	            _react2['default'].createElement(
	              'div',
	              { className: 's-alert TxSignerKeys__ledgerwallet_message ' + messageAlertType },
	              ' ',
	              ledgerwalletStatus.message,
	              ' '
	            )
	          );
	        }
	
	        content = _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'div',
	            { className: 'so-back' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'so-chunk' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'TxSignerOverview TransactionSigner__overview' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'TxSignerOverview__titleBar' },
	                  _react2['default'].createElement(
	                    'p',
	                    { className: 'TxSignerOverview__titleBar__title' },
	                    'Transaction overview'
	                  ),
	                  _react2['default'].createElement(
	                    'a',
	                    { className: 'TxSignerOverview__titleBar__reset',
	                      onClick: function () {
	                        return dispatch((0, _actionsTransactionSigner.clearTransaction)());
	                      } },
	                    'Clear and import new transaction'
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'simpleTable' },
	                  _.map(infoTable, function (content, label) {
	                    return _react2['default'].createElement(
	                      'div',
	                      { className: 'simpleTable__row', key: label },
	                      _react2['default'].createElement(
	                        'div',
	                        { className: 'simpleTable__row__label' },
	                        label
	                      ),
	                      _react2['default'].createElement(
	                        'div',
	                        { className: 'simpleTable__row__content' },
	                        content
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'so-chunk' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'TxSignerKeys TransactionSigner__keys' },
	                _react2['default'].createElement(
	                  'p',
	                  { className: 'TxSignerKeys__title' },
	                  'Signatures ',
	                  _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/multi-sig.html' })
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'optionsTable' },
	                  _react2['default'].createElement(
	                    _OptionsTablePair2['default'],
	                    { label: 'Add Signer' },
	                    _react2['default'].createElement(_FormComponentsMultiPicker2['default'], {
	                      component: _FormComponentsSecretKeyPicker2['default'],
	                      value: signers,
	                      onUpdate: function (value) {
	                        return dispatch((0, _actionsTransactionSigner.setSecrets)(value));
	                      }
	                    })
	                  ),
	                  _react2['default'].createElement(
	                    _OptionsTablePair2['default'],
	                    { label: 'Ledger Wallet' },
	                    _react2['default'].createElement(_FormComponentsBipPathPicker2['default'], {
	                      value: bipPath,
	                      onUpdate: function (value) {
	                        return dispatch((0, _actionsTransactionSigner.setBIPPath)(value));
	                      }
	                    }),
	                    _react2['default'].createElement(
	                      'button',
	                      {
	                        className: 's-button TxSignerKeys__signBipPath',
	                        onClick: function () {
	                          dispatch((0, _actionsTransactionSigner.signWithLedger)(xdr, bipPath));
	                        }
	                      },
	                      'Sign with BIP Path'
	                    ),
	                    ledgerwalletMessage
	                  )
	                )
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'so-back TxSignerResult TransactionSigner__result' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'so-chunk' },
	              resultTitle,
	              _react2['default'].createElement(
	                'p',
	                { className: 'TxSignerResult__summary' },
	                result.message
	              ),
	              codeResult,
	              submitInstructions,
	              submitLink,
	              ' ',
	              xdrLink
	            )
	          )
	        );
	      }
	      return _react2['default'].createElement(
	        'div',
	        { className: 'TransactionSigner' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'so-back' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'so-chunk' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'pageIntro' },
	              _react2['default'].createElement(
	                'p',
	                null,
	                'Sign a transaction'
	              )
	            )
	          )
	        ),
	        content
	      );
	    }
	  }]);
	
	  return TransactionSigner;
	})(_react2['default'].Component);
	
	exports['default'] = (0, _reactRedux.connect)(chooseState)(TransactionSigner);
	
	function chooseState(state) {
	  return {
	    state: state.transactionSigner,
	    networkPassphrase: state.network.current.networkPassphrase
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	// TreeView is a recursive tree view
	// It takes data from extrapolateFromXdr and formats it in a more user friendly way
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _EasySelect = __webpack_require__(147);
	
	var _constantsSignature = __webpack_require__(311);
	
	var _constantsSignature2 = _interopRequireDefault(_constantsSignature);
	
	var _constantsFetched_signers = __webpack_require__(151);
	
	var _constantsFetched_signers2 = _interopRequireDefault(_constantsFetched_signers);
	
	// @param {array} props.nodes - Array of TreeView compatible nodes
	
	var TreeView = (function (_React$Component) {
	  _inherits(TreeView, _React$Component);
	
	  function TreeView() {
	    _classCallCheck(this, TreeView);
	
	    _get(Object.getPrototypeOf(TreeView.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(TreeView, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var nodes = _props.nodes;
	      var className = _props.className;
	      var fetchedSigners = _props.fetchedSigners;
	      var parent = _props.parent;
	
	      var rootClass =  true ? className : '';
	
	      var result = _react2['default'].createElement(
	        'div',
	        { className: rootClass },
	        _lodash2['default'].map(Array.prototype.slice.call(nodes), function (node, index) {
	          var childNodes = undefined;
	
	          var position = getPosition(node, parent);
	
	          if (typeof node.nodes !== 'undefined') {
	            childNodes = _react2['default'].createElement(
	              'div',
	              { className: 'TreeView__child' },
	              _react2['default'].createElement(TreeView, { nodes: node.nodes, fetchedSigners: fetchedSigners, parent: position })
	            );
	          }
	
	          return _react2['default'].createElement(
	            'div',
	            { className: 'TreeView__set', key: index },
	            _react2['default'].createElement(
	              'div',
	              { className: 'TreeView__row', key: index + node.type },
	              _react2['default'].createElement(RowValue, { node: node, position: position, fetchedSigners: fetchedSigners })
	            ),
	            childNodes
	          );
	        })
	      );
	
	      return result;
	    }
	  }]);
	
	  return TreeView;
	})(_react2['default'].Component);
	
	exports['default'] = TreeView;
	
	function RowValue(props) {
	  var value = undefined,
	      separatorNeeded = undefined,
	      separator = undefined;
	  var node = props.node;
	  var position = props.position;
	  var fetchedSigners = props.fetchedSigners;
	
	  if (typeof node.value === 'string') {
	    value = String(node.value);
	    separatorNeeded = true;
	  } else if (typeof node.value !== 'undefined' && _lodash2['default'].has(node.value, 'type')) {
	    value = convertTypedValue(node.value);
	    separatorNeeded = true;
	  } else {
	    if (typeof node.nodes !== 'undefined') {
	      value = '';
	    } else {
	      value = _react2['default'].createElement(
	        'em',
	        null,
	        'none'
	      );
	      separatorNeeded = true;
	    }
	  }
	  if (separatorNeeded) {
	    separator = ': ';
	  }
	
	  if (position === 'TransactionEnvelope.signatures') {
	    checkSignatures(node, fetchedSigners);
	    return formatSignatureCheckState(node, separator);
	  }
	
	  if (position.match(/^TransactionEnvelope\.signatures\[[0-9]+\]\.signature$/)) {
	    return formatSignature(node, separator);
	  }
	
	  // Buffers with possible text representation
	  if (node.value && (position === 'TransactionEnvelope.tx.memo.text' || position.match(/^TransactionEnvelope\.tx.operations\[[0-9]+\]\.body.manageDataOp.data.*$/) || position.match(/^TransactionEnvelope\.tx.operations\[[0-9]+\]\.body.setOptionsOp.homeDomain$/))) {
	    return _react2['default'].createElement(
	      'span',
	      null,
	      _react2['default'].createElement(
	        'strong',
	        null,
	        node.type
	      ),
	      separator,
	      _react2['default'].createElement(
	        'code',
	        null,
	        node.value.raw.toString()
	      ),
	      ' [hex: ',
	      value,
	      ']'
	    );
	  }
	
	  return _react2['default'].createElement(
	    'span',
	    null,
	    _react2['default'].createElement(
	      'strong',
	      null,
	      node.type
	    ),
	    separator,
	    value
	  );
	}
	
	function checkSignatures(signatures, fetchedSigners) {
	  // catch fetch signature errors
	  signatures.state = fetchedSigners.state;
	
	  if (fetchedSigners.state !== _constantsFetched_signers2['default'].SUCCESS) {
	    return;
	  }
	
	  var _loop = function () {
	    var sig = signatures.nodes[i].nodes.find(function (n) {
	      return n.type == 'signature';
	    });
	    var fetchedSignature = fetchedSigners.data.find(function (x) {
	      return x.sig.equals(sig.value.raw);
	    });
	
	    var isValid = _constantsSignature2['default'].NOT_VERIFIED_YET;
	    if (fetchedSignature) {
	      isValid = fetchedSignature.isValid;
	    }
	
	    sig.value.isValid = isValid;
	  };
	
	  for (var i = 0; i < signatures.nodes.length; i++) {
	    _loop();
	  }
	}
	
	// Types values are values that will be displayed with special formatting to
	// provide for a more rich experience other than just plain text.
	// "untyped" values are simply strings. They will be displayed as strings in the
	// tree node.
	function convertTypedValue(_ref) {
	  var type = _ref.type;
	  var value = _ref.value;
	
	  switch (type) {
	    case 'code':
	      return _react2['default'].createElement(
	        _EasySelect.EasySelect,
	        null,
	        _react2['default'].createElement(
	          'code',
	          null,
	          value
	        )
	      );
	    case 'amount':
	      return _react2['default'].createElement(
	        'span',
	        null,
	        value.parsed,
	        ' (raw: ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          value.raw
	        ),
	        ')'
	      );
	  }
	}
	
	// Calculating position within xdr tree allows for awareness of location.
	// This is useful for many things, for example, adding visual indicators for
	// signature verification.
	function getPosition(node, parent) {
	  var sep = '.';
	
	  if (!parent || node.type.charAt(0) == '[') {
	    sep = '';
	  }
	
	  return (parent ? parent + sep : '') + node.type;
	}
	
	// Signatures have a special verification feature, so they require a
	// richer formating with ternary based coloring based on whether the
	// signature is valid for one of the signers related to the transaction
	// envelope.
	function formatSignature(node, separator) {
	  var style = { color: "black" };
	  var symbol = '';
	  if (node.value.isValid === _constantsSignature2['default'].INVALID) {
	    style = { color: "red" };
	    symbol = ' ❌ ';
	  } else if (node.value.isValid === _constantsSignature2['default'].VALID) {
	    style = { color: "green" };
	    symbol = ' ✅ ';
	  }
	  return _react2['default'].createElement(
	    'span',
	    { style: style },
	    _react2['default'].createElement(
	      'strong',
	      null,
	      node.type
	    ),
	    separator,
	    node.value.value,
	    ' ',
	    symbol
	  );
	}
	
	// Signature fetch may exist in different states so it requires
	// richer formating with ternary based coloring based on whether the
	// state is NONE, SUCCCESS, PENDING, FAIL or NOT_EXIST.
	function formatSignatureCheckState(node, separator) {
	  var message = "";
	  switch (node.state) {
	    case _constantsFetched_signers2['default'].SUCCESS:
	      message = _react2['default'].createElement(
	        'span',
	        { style: { fontStyle: "italic" } },
	        ' Signatures checked!'
	      );
	      break;
	    case _constantsFetched_signers2['default'].PENDING:
	      message = _react2['default'].createElement(
	        'span',
	        { style: { fontStyle: "italic" } },
	        ' Checking signatures...'
	      );
	      break;
	    case _constantsFetched_signers2['default'].FAIL:
	      message = _react2['default'].createElement(
	        'span',
	        { style: { color: "red" } },
	        ' Error checking signatures...'
	      );
	      break;
	    case _constantsFetched_signers2['default'].NOT_EXIST:
	      message = _react2['default'].createElement(
	        'span',
	        { style: { color: "red" } },
	        ' Some source accounts does not exist...'
	      );
	      break;
	  }
	  return _react2['default'].createElement(
	    'span',
	    null,
	    _react2['default'].createElement(
	      'strong',
	      null,
	      node.type
	    ),
	    separator,
	    node.value,
	    message
	  );
	}
	module.exports = exports['default'];

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	exports['default'] = TxBuilderAttributes;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptionsTablePair = __webpack_require__(8);
	
	var _OptionsTablePair2 = _interopRequireDefault(_OptionsTablePair);
	
	var _HelpMark = __webpack_require__(124);
	
	var _HelpMark2 = _interopRequireDefault(_HelpMark);
	
	var _FormComponentsPubKeyPicker = __webpack_require__(24);
	
	var _FormComponentsPubKeyPicker2 = _interopRequireDefault(_FormComponentsPubKeyPicker);
	
	var _FormComponentsSequencePicker = __webpack_require__(518);
	
	var _FormComponentsSequencePicker2 = _interopRequireDefault(_FormComponentsSequencePicker);
	
	var _FormComponentsStroopsPicker = __webpack_require__(520);
	
	var _FormComponentsStroopsPicker2 = _interopRequireDefault(_FormComponentsStroopsPicker);
	
	var _FormComponentsMemoPicker = __webpack_require__(514);
	
	var _FormComponentsMemoPicker2 = _interopRequireDefault(_FormComponentsMemoPicker);
	
	var _FormComponentsTimeBoundsPicker = __webpack_require__(521);
	
	var _FormComponentsTimeBoundsPicker2 = _interopRequireDefault(_FormComponentsTimeBoundsPicker);
	
	var _reactRedux = __webpack_require__(37);
	
	var _stellarSdk = __webpack_require__(23);
	
	var _constantsNetwork = __webpack_require__(75);
	
	var _constantsNetwork2 = _interopRequireDefault(_constantsNetwork);
	
	var _actionsTransactionBuilder = __webpack_require__(146);
	
	function TxBuilderAttributes(props) {
	  var onUpdate = props.onUpdate;
	  var attributes = props.attributes;
	
	  return _react2['default'].createElement(
	    'div',
	    { className: 'TransactionAttributes' },
	    _react2['default'].createElement(
	      'div',
	      { className: 'TransactionOp__config TransactionOpConfig optionsTable' },
	      _react2['default'].createElement(
	        _OptionsTablePair2['default'],
	        { label: _react2['default'].createElement(
	            'span',
	            null,
	            'Source Account ',
	            _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/accounts.html' })
	          ) },
	        _react2['default'].createElement(_FormComponentsPubKeyPicker2['default'], {
	          value: attributes['sourceAccount'],
	          onUpdate: function (value) {
	            onUpdate('sourceAccount', value);
	          }
	        }),
	        _react2['default'].createElement(
	          'p',
	          { className: 'optionsTable__pair__content__note' },
	          'If you don\'t have an account yet, you can create and fund a test net account with the ',
	          _react2['default'].createElement(
	            'a',
	            { href: '#account-creator' },
	            'account creator'
	          ),
	          '.'
	        )
	      ),
	      _react2['default'].createElement(
	        _OptionsTablePair2['default'],
	        { label: _react2['default'].createElement(
	            'span',
	            null,
	            'Transaction Sequence Number ',
	            _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/transactions.html#sequence-number' })
	          ) },
	        _react2['default'].createElement(_FormComponentsSequencePicker2['default'], {
	          value: attributes['sequence'],
	          onUpdate: function (value) {
	            onUpdate('sequence', value);
	          }
	        }),
	        _react2['default'].createElement(
	          'p',
	          { className: 'optionsTable__pair__content__note' },
	          'The transaction sequence number is usually one higher than current account sequence number.'
	        ),
	        _react2['default'].createElement(SequenceFetcher, null)
	      ),
	      _react2['default'].createElement(
	        _OptionsTablePair2['default'],
	        { optional: true, label: _react2['default'].createElement(
	            'span',
	            null,
	            'Base Fee ',
	            _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/transactions.html#fee' })
	          ) },
	        _react2['default'].createElement(_FormComponentsStroopsPicker2['default'], {
	          value: attributes['fee'],
	          onUpdate: function (value) {
	            onUpdate('fee', value);
	          }
	        }),
	        _react2['default'].createElement(
	          'p',
	          { className: 'optionsTable__pair__content__note' },
	          'The ',
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://www.stellar.org/developers/learn/concepts/fees.html' },
	            'network base fee'
	          ),
	          ' is currently set to 10000000 stroops (1 lumen). Transaction fee is equal to base fee times number of operations in this transaction.'
	        )
	      ),
	      _react2['default'].createElement(
	        _OptionsTablePair2['default'],
	        { optional: true, label: _react2['default'].createElement(
	            'span',
	            null,
	            'Memo ',
	            _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/learn/concepts/transactions.html#memo' })
	          ) },
	        _react2['default'].createElement(_FormComponentsMemoPicker2['default'], {
	          value: {
	            type: attributes.memoType,
	            content: attributes.memoContent
	          },
	          onUpdate: function (value) {
	            onUpdate('memo', value);
	          }
	        })
	      ),
	      _react2['default'].createElement(
	        _OptionsTablePair2['default'],
	        { optional: true, label: _react2['default'].createElement(
	            'span',
	            null,
	            'Time Bounds ',
	            _react2['default'].createElement(_HelpMark2['default'], { href: 'https://www.stellar.org/developers/guides/concepts/transactions.html#time-bounds' })
	          ) },
	        _react2['default'].createElement(_FormComponentsTimeBoundsPicker2['default'], {
	          value: {
	            minTime: attributes.minTime,
	            maxTime: attributes.maxTime
	          },
	          onUpdate: function (value) {
	            onUpdate('timebounds', value);
	          }
	        }),
	        _react2['default'].createElement(
	          'p',
	          { className: 'optionsTable__pair__content__note' },
	          'Enter ',
	          _react2['default'].createElement(
	            'a',
	            { href: 'http://www.epochconverter.com/', target: '_blank' },
	            'unix timestamp'
	          ),
	          ' values of time bounds when this transaction will be valid.'
	        ),
	        _react2['default'].createElement(
	          'p',
	          { className: 'optionsTable__pair__content__note' },
	          'For regular transactions, it is highly recommended to set ',
	          _react2['default'].createElement(
	            'code',
	            null,
	            'max_time'
	          ),
	          ' to get ',
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/stellar/stellar-core/issues/1811', target: '_blank' },
	            'a final result'
	          ),
	          ' of a transaction in a defined time.'
	        ),
	        _react2['default'].createElement(
	          'p',
	          { className: 'optionsTable__pair__content__note' },
	          _react2['default'].createElement(
	            'a',
	            {
	              className: 's-button',
	              onClick: function () {
	                return onUpdate('timebounds', { maxTime: Math.ceil(new Date().getTime() / 1000) + 5 * 60 });
	              }
	            },
	            'Set to 5 minutes from now'
	          ),
	          _react2['default'].createElement('br', null)
	        )
	      )
	    )
	  );
	}
	
	var sequenceFetcherClass = (function (_React$Component) {
	  _inherits(sequenceFetcherClass, _React$Component);
	
	  function sequenceFetcherClass() {
	    _classCallCheck(this, sequenceFetcherClass);
	
	    _get(Object.getPrototypeOf(sequenceFetcherClass.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(sequenceFetcherClass, [{
	    key: 'render',
	    value: function render() {
	      var _props$state = this.props.state;
	      var attributes = _props$state.attributes;
	      var sequenceFetcherError = _props$state.sequenceFetcherError;
	
	      var dispatch = this.props.dispatch;
	      var horizonURL = this.props.horizonURL;
	      if (!_stellarSdk.StrKey.isValidEd25519PublicKey(attributes.sourceAccount)) {
	        return null;
	      }
	
	      var sequenceErrorMessage = undefined;
	      if (sequenceFetcherError.length > 0) {
	        sequenceErrorMessage = _react2['default'].createElement(
	          'span',
	          { className: 'optionsTable__pair__content__note optionsTable__pair__content__note--alert' },
	          sequenceFetcherError
	        );
	      }
	
	      var truncatedAccountId = attributes.sourceAccount.substr(0, 10);
	
	      return _react2['default'].createElement(
	        'p',
	        { className: 'optionsTable__pair__content__note' },
	        _react2['default'].createElement(
	          'a',
	          {
	            className: 's-button',
	            onClick: function () {
	              return dispatch((0, _actionsTransactionBuilder.fetchSequence)(attributes.sourceAccount, horizonURL));
	            }
	          },
	          'Fetch next sequence number for account starting with "',
	          truncatedAccountId,
	          '"'
	        ),
	        _react2['default'].createElement('br', null),
	        _react2['default'].createElement(
	          'small',
	          null,
	          'Fetching from: ',
	          _react2['default'].createElement(
	            'code',
	            null,
	            horizonURL
	          )
	        ),
	        _react2['default'].createElement('br', null),
	        sequenceErrorMessage
	      );
	    }
	  }]);
	
	  return sequenceFetcherClass;
	})(_react2['default'].Component);
	
	var SequenceFetcher = (0, _reactRedux.connect)(chooseState)(sequenceFetcherClass);
	function chooseState(state) {
	  return {
	    state: state.transactionBuilder,
	    horizonURL: state.network.current.horizonURL
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(37);
	
	var _stellarSdk = __webpack_require__(23);
	
	var _FormComponentsPubKeyPicker = __webpack_require__(24);
	
	var _EasySelect = __webpack_require__(147);
	
	var _utilitiesLibify = __webpack_require__(312);
	
	var _utilitiesLibify2 = _interopRequireDefault(_utilitiesLibify);
	
	var _utilitiesLinkBuilder = __webpack_require__(206);
	
	var _utilitiesScrollOnAnchorOpen = __webpack_require__(207);
	
	var _utilitiesScrollOnAnchorOpen2 = _interopRequireDefault(_utilitiesScrollOnAnchorOpen);
	
	var _utilitiesClickToSelect = __webpack_require__(204);
	
	var _utilitiesClickToSelect2 = _interopRequireDefault(_utilitiesClickToSelect);
	
	var _constantsNetwork = __webpack_require__(75);
	
	var _constantsNetwork2 = _interopRequireDefault(_constantsNetwork);
	
	var TxBuilderResult = (function (_React$Component) {
	  _inherits(TxBuilderResult, _React$Component);
	
	  function TxBuilderResult() {
	    _classCallCheck(this, TxBuilderResult);
	
	    _get(Object.getPrototypeOf(TxBuilderResult.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(TxBuilderResult, [{
	    key: 'render',
	    value: function render() {
	      var _props$state = this.props.state;
	      var attributes = _props$state.attributes;
	      var operations = _props$state.operations;
	
	      var xdrResult = undefined,
	          buildError = undefined;
	      var validationErrors = [];
	
	      if (attributes.sourceAccount === '') {
	        validationErrors.push('Source account ID is a required field');
	      }
	      if (attributes.sequence === '') {
	        validationErrors.push('Sequence number is a required field');
	      }
	      var memoIsNone = attributes.memoType === 'MEMO_NONE' || attributes.memoType === '';
	      if (!memoIsNone && attributes.memoContent === '') {
	        validationErrors.push('Memo content is required if memo type is selected');
	      }
	
	      var finalResult = undefined,
	          errorTitleText = undefined,
	          successTitleText = undefined,
	          signingInstructions = undefined,
	          signingLink = undefined,
	          xdrLink = undefined;
	      if (validationErrors.length > 0) {
	        errorTitleText = 'Form validation errors:';
	        finalResult = formatErrorList(validationErrors);
	      } else {
	        var transactionBuild = _utilitiesLibify2['default'].buildTransaction(attributes, operations, new _stellarSdk.Network(this.props.networkPassphrase));
	
	        if (transactionBuild.errors.length > 0) {
	          errorTitleText = 'Transaction building errors:';
	          finalResult = formatErrorList(transactionBuild.errors);
	        } else {
	          successTitleText = 'Success! Transaction Envelope XDR:';
	          finalResult = _react2['default'].createElement(
	            'div',
	            null,
	            'Network Passphrase:',
	            _react2['default'].createElement('br', null),
	            this.props.networkPassphrase,
	            _react2['default'].createElement('br', null),
	            'Hash:',
	            _react2['default'].createElement('br', null),
	            transactionBuild.hash,
	            _react2['default'].createElement('br', null),
	            'XDR:',
	            _react2['default'].createElement('br', null),
	            transactionBuild.xdr
	          );
	          signingInstructions = _react2['default'].createElement(
	            'p',
	            { className: 'TransactionBuilderResult__instructions' },
	            'In order for the transaction to make it into the ledger, a transaction must be successfully signed and submitted to the network. The laboratory provides the ',
	            _react2['default'].createElement(
	              'a',
	              { href: '#txsigner' },
	              'Transaction Signer'
	            ),
	            ' to for signing a transaction, and the ',
	            _react2['default'].createElement(
	              'a',
	              { href: '#explorer?resource=transactions&endpoint=create' },
	              'Post Transaction endpoint'
	            ),
	            ' for submitting one to the network.'
	          );
	          signingLink = _react2['default'].createElement(
	            'a',
	            { className: 's-button',
	              href: (0, _utilitiesLinkBuilder.txSignerLink)(transactionBuild.xdr),
	              onClick: _utilitiesScrollOnAnchorOpen2['default'] },
	            'Sign in Transaction Signer'
	          );
	          xdrLink = _react2['default'].createElement(
	            'a',
	            { className: 's-button',
	              href: (0, _utilitiesLinkBuilder.xdrViewer)(transactionBuild.xdr, 'TransactionEnvelope'),
	              onClick: _utilitiesScrollOnAnchorOpen2['default'] },
	            'View in XDR Viewer'
	          );
	        }
	      }
	
	      var errorTitle = errorTitleText ? _react2['default'].createElement(
	        'h3',
	        { className: 'TransactionBuilderResult__error' },
	        errorTitleText
	      ) : null;
	      var successTitle = successTitleText ? _react2['default'].createElement(
	        'h3',
	        { className: 'TransactionBuilderResult__success' },
	        successTitleText
	      ) : null;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'TransactionBuilderResult' },
	        successTitle,
	        errorTitle,
	        _react2['default'].createElement(
	          'pre',
	          { className: 'TransactionXDR so-code so-code__wrap TransactionBuilderResult__code', onClick: _utilitiesClickToSelect2['default'] },
	          _react2['default'].createElement(
	            'code',
	            null,
	            finalResult
	          )
	        ),
	        signingInstructions,
	        signingLink,
	        ' ',
	        xdrLink
	      );
	    }
	  }]);
	
	  return TxBuilderResult;
	})(_react2['default'].Component);
	
	exports['default'] = TxBuilderResult;
	exports['default'] = (0, _reactRedux.connect)(chooseState)(TxBuilderResult);
	
	function chooseState(state) {
	  return {
	    state: state.transactionBuilder,
	    networkPassphrase: state.network.current.networkPassphrase
	  };
	}
	
	function formatErrorList(errors) {
	  return _.reduce(errors, function (result, error) {
	    return result + '- ' + error + ' \n';
	  }, '');
	}
	module.exports = exports['default'];

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(37);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constantsFetched_signers = __webpack_require__(151);
	
	var _constantsFetched_signers2 = _interopRequireDefault(_constantsFetched_signers);
	
	var _FormComponentsSelectPicker = __webpack_require__(195);
	
	var _FormComponentsSelectPicker2 = _interopRequireDefault(_FormComponentsSelectPicker);
	
	var _utilitiesExtrapolateFromXdr = __webpack_require__(314);
	
	var _utilitiesExtrapolateFromXdr2 = _interopRequireDefault(_utilitiesExtrapolateFromXdr);
	
	var _TreeView = __webpack_require__(554);
	
	var _TreeView2 = _interopRequireDefault(_TreeView);
	
	var _utilitiesValidateBase64 = __webpack_require__(317);
	
	var _utilitiesValidateBase642 = _interopRequireDefault(_utilitiesValidateBase64);
	
	var _actionsXdrViewer = __webpack_require__(301);
	
	var _stellarSdk = __webpack_require__(23);
	
	function XdrViewer(props) {
	  var dispatch = props.dispatch;
	  var state = props.state;
	  var baseURL = props.baseURL;
	  var networkPassphrase = props.networkPassphrase;
	
	  var validation = (0, _utilitiesValidateBase642['default'])(state.input);
	  var messageClass = validation.result === 'error' ? 'xdrInput__message__alert' : 'xdrInput__message__success';
	  var message = _react2['default'].createElement(
	    'p',
	    { className: messageClass },
	    validation.message
	  );
	
	  var xdrTypeIsValid = _lodash2['default'].indexOf(xdrTypes, state.type) >= 0;
	  var treeView = undefined,
	      errorMessage = undefined;
	  if (state.input === '') {
	    errorMessage = _react2['default'].createElement(
	      'p',
	      null,
	      'Enter a base-64 encoded XDR blob to decode.'
	    );
	  } else if (!xdrTypeIsValid) {
	    errorMessage = _react2['default'].createElement(
	      'p',
	      null,
	      'Please select a XDR type'
	    );
	  } else {
	    try {
	      treeView = _react2['default'].createElement(_TreeView2['default'], { nodes: (0, _utilitiesExtrapolateFromXdr2['default'])(state.input, state.type), fetchedSigners: state.fetchedSigners });
	    } catch (e) {
	      console.error(e);
	      errorMessage = _react2['default'].createElement(
	        'p',
	        null,
	        'Unable to decode input as ',
	        state.type
	      );
	    }
	  }
	
	  // Fetch signers on initial load
	  if (state.type === "TransactionEnvelope" && state.fetchedSigners.state === _constantsFetched_signers2['default'].NONE) {
	    dispatch((0, _actionsXdrViewer.fetchSigners)(state.input, baseURL, networkPassphrase));
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      'div',
	      { className: 'XdrViewer__setup so-back' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'so-chunk' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'pageIntro' },
	          _react2['default'].createElement(
	            'p',
	            null,
	            'View the contents of a XDR envelope'
	          )
	        ),
	        _react2['default'].createElement(
	          'p',
	          { className: 'XdrViewer__label' },
	          'Input a base-64 encoded XDR blob, or ',
	          _react2['default'].createElement(
	            'a',
	            { onClick: function () {
	                return dispatch((0, _actionsXdrViewer.fetchLatestTx)(baseURL, networkPassphrase));
	              } },
	            'fetch the latest transaction to try it out'
	          ),
	          ':'
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'xdrInput__input' },
	          _react2['default'].createElement('textarea', {
	            value: state.input,
	            className: 'xdrInput__input__textarea',
	            onChange: function (event) {
	              dispatch((0, _actionsXdrViewer.updateXdrInput)(event.target.value));
	              if (state.type === "TransactionEnvelope") {
	                dispatch((0, _actionsXdrViewer.fetchSigners)(event.target.value, baseURL, networkPassphrase));
	              }
	            },
	            placeholder: 'Example: AAAAAGXNhB2hIkbP//jgzn4os/AAAAZAB+BaLPAAA5Q/xL...' })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'xdrInput__message' },
	          message
	        ),
	        _react2['default'].createElement(
	          'p',
	          { className: 'XdrViewer__label' },
	          'XDR type:'
	        ),
	        _react2['default'].createElement(_FormComponentsSelectPicker2['default'], {
	          value: state.type,
	          placeholder: 'Select XDR type',
	          onUpdate: function (input) {
	            return dispatch((0, _actionsXdrViewer.updateXdrType)(input));
	          },
	          items: xdrTypes
	        })
	      )
	    ),
	    _react2['default'].createElement(
	      'div',
	      { className: 'XdrViewer__results so-back' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'so-chunk' },
	        errorMessage,
	        treeView
	      )
	    )
	  );
	}
	
	exports['default'] = (0, _reactRedux.connect)(chooseState)(XdrViewer);
	
	function chooseState(state) {
	  return {
	    state: state.xdrViewer,
	    baseURL: state.network.current.horizonURL,
	    networkPassphrase: state.network.current.networkPassphrase
	  };
	}
	
	// Array of all the xdr types. Then, the most common ones appear at the top
	// again for convenience
	var xdrTypes = (0, _lodash2['default'])(_stellarSdk.xdr).functions().sort().value();
	xdrTypes = ['TransactionEnvelope', 'TransactionResult', 'TransactionMeta', '---'].concat(xdrTypes);
	module.exports = exports['default'];

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var loadState = function loadState() {
	  try {
	    var serializerdState = localStorage.getItem('state');
	    if (serializerdState === null) {
	      return undefined;
	    }
	    return JSON.parse(serializerdState);
	  } catch (err) {
	    return undefined;
	  }
	};
	
	exports.loadState = loadState;
	var saveState = function saveState(state) {
	  try {
	    var serializerdState = JSON.stringify(state);
	    localStorage.setItem('state', serializerdState);
	  } catch (err) {
	    // Ignore error.
	  }
	};
	exports.saveState = saveState;

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var logging = function logging(store) {
	  return function (next) {
	    return function (action) {
	      console.log('dispatching', action);
	      var result = next(action);
	      console.log('next state', store.getState());
	      return result;
	    };
	  };
	};
	
	exports['default'] = logging;
	module.exports = exports['default'];

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(64);
	
	var _actionsAccountCreator = __webpack_require__(298);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function keypairGeneratorResult(state, action) {
	  if (state === undefined) state = null;
	
	  if (action.type === _actionsAccountCreator.GENERATE_NEW_KEYPAIR) {
	    return {
	      pubKey: action.pubKey,
	      secretKey: action.secretKey
	    };
	  }
	  return state;
	}
	function keypairGeneratorPubKey(state, action) {
	  if (state === undefined) state = '';
	
	  if (action.type === _actionsAccountCreator.GENERATE_NEW_KEYPAIR) {
	    return action.pubKey;
	  }
	  return state;
	}
	function friendbotTarget(state, action) {
	  if (state === undefined) state = '';
	
	  if (action.type === _actionsAccountCreator.UPDATE_FRIENDBOT_TARGET) {
	    return action.target;
	  }
	  return state;
	}
	
	var defaultRequestState = {
	  message: '',
	  code: '',
	  status: 'inital'
	};
	function friendbotStatus(state, action) {
	  if (state === undefined) state = defaultRequestState;
	
	  if (action.type === _actionsAccountCreator.START_FRIENDBOT_REQUEST) {
	    return _lodash2['default'].assign({}, defaultRequestState, {
	      message: action.message,
	      status: action.status
	    });
	  }
	  if (action.type === _actionsAccountCreator.FINISH_FRIENDBOT_REQUEST) {
	    return {
	      message: action.message,
	      code: action.code,
	      status: action.status
	    };
	  }
	  return state;
	}
	
	var accountCreator = (0, _redux.combineReducers)({
	  keypairGeneratorResult: keypairGeneratorResult,
	  keypairGeneratorPubKey: keypairGeneratorPubKey,
	  friendbotTarget: friendbotTarget,
	  friendbotStatus: friendbotStatus
	});
	exports['default'] = accountCreator;
	module.exports = exports['default'];

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _redux = __webpack_require__(64);
	
	var _actionsEndpointExplorer = __webpack_require__(299);
	
	var _actionsRouting = __webpack_require__(85);
	
	var _dataEndpoints = __webpack_require__(202);
	
	var _utilitiesHydration = __webpack_require__(205);
	
	var _constantsSlug = __webpack_require__(107);
	
	var _constantsSlug2 = _interopRequireDefault(_constantsSlug);
	
	function currentResource(state, action) {
	  if (state === undefined) state = "";
	
	  switch (action.type) {
	    case _actionsRouting.LOAD_STATE:
	      if (action.slug === _constantsSlug2["default"].EXPLORER && action.queryObj.resource) {
	        return action.queryObj.resource;
	      }
	      break;
	    case _actionsEndpointExplorer.CHOOSE_ENDPOINT:
	      return action.resource;
	  }
	  return state;
	}
	
	function currentEndpoint(state, action) {
	  if (state === undefined) state = "";
	
	  switch (action.type) {
	    case _actionsRouting.LOAD_STATE:
	      if (action.slug === _constantsSlug2["default"].EXPLORER && action.queryObj.endpoint) {
	        return action.queryObj.endpoint;
	      }
	      break;
	    case _actionsEndpointExplorer.CHOOSE_ENDPOINT:
	      return action.endpoint;
	  }
	  return state;
	}
	
	function pendingRequestTemplate(state, action) {
	  if (state === undefined) state = "";
	
	  switch (action.type) {
	    case _actionsEndpointExplorer.CHOOSE_ENDPOINT:
	      return (0, _dataEndpoints.getTemplate)(action.resource, action.endpoint) || "";
	    default:
	      return state;
	  }
	}
	
	function pendingRequestValues(state, action) {
	  if (state === undefined) state = {};
	
	  switch (action.type) {
	    case _actionsRouting.LOAD_STATE:
	      if (action.slug === _constantsSlug2["default"].EXPLORER && action.queryObj.values) {
	        return (0, _utilitiesHydration.rehydrate)(action.queryObj.values);
	      }
	      break;
	    case _actionsEndpointExplorer.UPDATE_VALUE:
	      return Object.assign({}, state, _defineProperty({}, action.param, action.value));
	    case _actionsEndpointExplorer.CHOOSE_ENDPOINT:
	      return {};
	  }
	  return state;
	}
	
	var blankResults = {
	  id: null,
	  available: false,
	  body: []
	};
	function results(state, action) {
	  if (typeof state === 'undefined') {
	    return blankResults;
	  }
	
	  // Clear the results when a change to the explorer happens
	  switch (action.type) {
	    case _actionsRouting.LOAD_STATE:
	      if (action.slug === _constantsSlug2["default"].EXPLORER) {
	        return blankResults;
	      }
	      return state;
	    case _actionsEndpointExplorer.CHOOSE_ENDPOINT:
	    case _actionsEndpointExplorer.UPDATE_VALUE:
	      return blankResults;
	  }
	
	  if (action.type === _actionsEndpointExplorer.START_REQUEST) {
	    return Object.assign({}, state, {
	      available: true,
	      id: action.id,
	      isError: false,
	      body: []
	    });
	  }
	
	  if (action.id !== state.id) {
	    // This action has expired as we've moved on to a new request
	    // Or, this is likely an irrelevant action
	    return state;
	  }
	
	  if (action.type === _actionsEndpointExplorer.ERROR_REQUEST) {
	    var errorContent = undefined;
	    if (action.errorStatus === 0) {
	      errorContent = 'Unable to reach Horizon server.';
	    } else {
	      errorContent = JSON.stringify(action.body, null, 2);
	    }
	
	    return Object.assign({}, state, {
	      isError: true,
	      body: [errorContent]
	    });
	  }
	
	  if (action.type === _actionsEndpointExplorer.UPDATE_REQUEST) {
	    return Object.assign({}, state, {
	      body: [].concat(state.body, JSON.stringify(action.body, null, 2))
	    });
	  }
	
	  return state;
	}
	
	var endpointExplorer = (0, _redux.combineReducers)({
	  currentResource: currentResource,
	  currentEndpoint: currentEndpoint,
	  pendingRequest: (0, _redux.combineReducers)({
	    template: pendingRequestTemplate,
	    values: pendingRequestValues
	  }),
	  results: results
	});
	
	exports["default"] = endpointExplorer;
	module.exports = exports["default"];

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _redux = __webpack_require__(64);
	
	var _actionsNetwork = __webpack_require__(194);
	
	var _constantsNetwork = __webpack_require__(75);
	
	var _constantsNetwork2 = _interopRequireDefault(_constantsNetwork);
	
	var _actionsRouting = __webpack_require__(85);
	
	var defaultNetwork = {
	  name: _constantsNetwork2["default"].defaultName,
	  horizonURL: _constantsNetwork2["default"].available[_constantsNetwork2["default"].defaultName].horizonURL,
	  networkPassphrase: _constantsNetwork2["default"].available[_constantsNetwork2["default"].defaultName].networkPassphrase
	};
	
	var current = function current(state, action) {
	  if (state === undefined) state = defaultNetwork;
	
	  switch (action.type) {
	    case _actionsRouting.LOAD_STATE:
	      if (action.queryObj.network == "custom") {
	        return {
	          name: action.queryObj.network,
	          horizonURL: action.queryObj.horizonURL,
	          networkPassphrase: action.queryObj.networkPassphrase
	        };
	      }
	
	      if (action.queryObj.network && _constantsNetwork2["default"].available[action.queryObj.network]) {
	        return Object.assign({ name: action.queryObj.network }, _constantsNetwork2["default"].available[action.queryObj.network]);
	      }
	      return state;
	    case _actionsNetwork.SET_PARAMS:
	      return action.params;
	    default:
	      return state;
	  }
	};
	
	function modal(state, action) {
	  if (state === undefined) state = { visible: false, values: {} };
	
	  switch (action.type) {
	    case _actionsNetwork.SHOW_MODAL:
	      return Object.assign({}, state, { visible: true });
	    case _actionsNetwork.HIDE_MODAL:
	      return Object.assign({}, state, { visible: false });
	    case _actionsNetwork.SET_PARAMS:
	      return { visible: false, values: Object.assign({}, action.params) };
	    case _actionsNetwork.UPDATE_MODAL:
	      var values = state.values;
	      values[action.key] = action.value;
	      return { visible: true, values: values };
	    default:
	      return state;
	  }
	}
	
	var network = (0, _redux.combineReducers)({
	  current: current,
	  modal: modal
	});
	
	exports["default"] = network;
	module.exports = exports["default"];

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(64);
	
	var _accountCreator = __webpack_require__(560);
	
	var _accountCreator2 = _interopRequireDefault(_accountCreator);
	
	var _endpointExplorer = __webpack_require__(561);
	
	var _endpointExplorer2 = _interopRequireDefault(_endpointExplorer);
	
	var _transactionBuilder = __webpack_require__(565);
	
	var _transactionBuilder2 = _interopRequireDefault(_transactionBuilder);
	
	var _transactionSigner = __webpack_require__(566);
	
	var _transactionSigner2 = _interopRequireDefault(_transactionSigner);
	
	var _xdrViewer = __webpack_require__(567);
	
	var _xdrViewer2 = _interopRequireDefault(_xdrViewer);
	
	var _network = __webpack_require__(562);
	
	var _network2 = _interopRequireDefault(_network);
	
	var _routing = __webpack_require__(564);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var rootReducer = (0, _redux.combineReducers)({
	  accountCreator: _accountCreator2['default'],
	  endpointExplorer: _endpointExplorer2['default'],
	  transactionBuilder: _transactionBuilder2['default'],
	  transactionSigner: _transactionSigner2['default'],
	  xdrViewer: _xdrViewer2['default'],
	  network: _network2['default'],
	  routing: _routing2['default']
	});
	
	exports['default'] = rootReducer;
	module.exports = exports['default'];

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(64);
	
	var _actionsRouting = __webpack_require__(85);
	
	var _url = __webpack_require__(119);
	
	var _url2 = _interopRequireDefault(_url);
	
	var routing = (0, _redux.combineReducers)({
	  location: location
	});
	
	exports['default'] = routing;
	
	function location(state, action) {
	  if (state === undefined) state = '';
	
	  switch (action.type) {
	    case _actionsRouting.UPDATE_LOCATION:
	    case _actionsRouting.LOAD_STATE:
	      if (action.slug === null) {
	        return '';
	      }
	      return action.slug;
	  }
	  return state;
	}
	module.exports = exports['default'];

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(64);
	
	var _actionsTransactionBuilder = __webpack_require__(146);
	
	var _actionsRouting = __webpack_require__(85);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utilitiesHydration = __webpack_require__(205);
	
	var _constantsSlug = __webpack_require__(107);
	
	var _constantsSlug2 = _interopRequireDefault(_constantsSlug);
	
	var defaultOperations = [{
	  id: 0,
	  attributes: {},
	  name: ''
	}];
	function operations(state, action) {
	  if (state === undefined) state = defaultOperations;
	
	  var targetOpIndex = undefined,
	      newOps = undefined;
	  switch (action.type) {
	    case _actionsRouting.LOAD_STATE:
	      if (action.slug === _constantsSlug2['default'].TXBUILDER) {
	        if (action.queryObj.params) {
	          // TODO: validate that this is actually a valid operations object
	          return (0, _utilitiesHydration.rehydrate)(action.queryObj.params).operations;
	        }
	        return defaultOperations;
	      }
	      break;
	    case 'ADD_OPERATION':
	      return Array.prototype.concat(state, {
	        id: action.opId,
	        name: '',
	        attributes: {}
	      });
	    case 'REMOVE_OPERATION':
	      return _lodash2['default'].filter(state.slice(), function (op) {
	        return op.id != action.opId;
	      });
	    case 'REORDER_OPERATION':
	      return reorderOps(state, action.opId, action.toNth);
	    case 'UPDATE_OPERATION_TYPE':
	      return updateOperation(state, action.opId, {
	        name: action.newType,
	        attributes: {}
	      });
	    case 'UPDATE_OPERATION_ATTRIBUTES':
	      return updateOperation(state, action.opId, {
	        attributes: _lodash2['default'].assign({}, getAttributes(state, action.opId), action.newAttributes)
	      });
	    case _actionsTransactionBuilder.RESET_TXBUILDER:
	      return defaultOperations;
	  }
	  return state;
	}
	function getAttributes(state, opId) {
	  return _lodash2['default'].find(state, { id: opId }).attributes;
	}
	function updateOperation(state, opId, newSource) {
	  var targetOpIndex = _lodash2['default'].findIndex(state, { id: opId });
	  var newOps = state.slice();
	  newOps[targetOpIndex] = _lodash2['default'].assign({}, newOps[targetOpIndex], newSource);
	  return newOps;
	}
	function updateSigner(state, opId, newSource) {
	  var targetOpIndex = _lodash2['default'].findIndex(state, { id: opId });
	  var newOps = state.slice();
	  newOps[targetOpIndex] = _lodash2['default'].assign({}, newOps[targetOpIndex], newSource);
	  return newOps;
	}
	function reorderOps(state, opId, toNth) {
	  if (toNth < 1) {
	    toNth = 1;
	  }
	  if (toNth > state.length) {
	    toNth = state.length;
	  }
	  var ops = state.slice();
	  var targetOpIndex = _lodash2['default'].findIndex(ops, { id: opId });
	  var targetOp = ops[targetOpIndex];
	  ops.splice(targetOpIndex, 1);
	  ops.splice(toNth - 1, 0, targetOp);
	  return ops;
	}
	
	var defaultAttributes = {
	  sourceAccount: '',
	  sequence: '',
	  fee: '',
	  memoType: '',
	  memoContent: '',
	  minTime: '',
	  maxTime: ''
	};
	function attributes(state, action) {
	  if (state === undefined) state = defaultAttributes;
	
	  switch (action.type) {
	    case _actionsRouting.LOAD_STATE:
	      if (action.queryObj.params) {
	        return _lodash2['default'].assign({}, defaultAttributes, (0, _utilitiesHydration.rehydrate)(action.queryObj.params).attributes);
	      }
	      break;
	    case _actionsTransactionBuilder.UPDATE_ATTRIBUTES:
	      return Object.assign({}, state, action.newAttributes);
	    case _actionsTransactionBuilder.FETCH_SEQUENCE_SUCCESS:
	      return Object.assign({}, state, { sequence: action.sequence });
	    case _actionsTransactionBuilder.RESET_TXBUILDER:
	      return defaultAttributes;
	  }
	  return state;
	}
	
	function sequenceFetcherError(state, action) {
	  if (state === undefined) state = '';
	
	  var payload = action.payload;
	  if (action.type === _actionsTransactionBuilder.FETCH_SEQUENCE_FAIL) {
	    if (payload.data.title === 'Resource Missing') {
	      return 'Account not found. Make sure the correct network is selected and the account is funded/created.';
	    }
	    if (payload.status === 0) {
	      return 'Unable to reach server at ' + payload.config.url;
	    }
	    return JSON.stringify(action.payload, null, 2);
	  }
	  if (action.type === _actionsTransactionBuilder.FETCH_SEQUENCE_START) {
	    return '';
	  }
	  return state;
	}
	
	var transactionBuilder = (0, _redux.combineReducers)({
	  attributes: attributes,
	  operations: operations,
	  sequenceFetcherError: sequenceFetcherError
	});
	
	exports['default'] = transactionBuilder;
	module.exports = exports['default'];

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(64);
	
	var _actionsTransactionSigner = __webpack_require__(300);
	
	var _actionsRouting = __webpack_require__(85);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utilitiesValidateTxXdr = __webpack_require__(208);
	
	var _utilitiesValidateTxXdr2 = _interopRequireDefault(_utilitiesValidateTxXdr);
	
	var _constantsSlug = __webpack_require__(107);
	
	var _constantsSlug2 = _interopRequireDefault(_constantsSlug);
	
	var transactionSigner = (0, _redux.combineReducers)({
	  xdr: xdr,
	  signers: signers,
	  bipPath: bipPath,
	  ledgerwalletStatus: ledgerwalletStatus
	});
	
	exports['default'] = transactionSigner;
	
	function xdr(state, action) {
	  if (state === undefined) state = '';
	
	  switch (action.type) {
	    case _actionsRouting.LOAD_STATE:
	      if (action.slug === _constantsSlug2['default'].TXSIGNER && action.queryObj.xdr) {
	        if ((0, _utilitiesValidateTxXdr2['default'])(action.queryObj.xdr).result === 'success') {
	          return action.queryObj.xdr;
	        }
	        // If invalid xdr in the url, then we go back to step zero
	        return '';
	      }
	      return state;
	    case _actionsTransactionSigner.IMPORT_FROM_XDR:
	      return action.xdr;
	    case _actionsTransactionSigner.CLEAR_TRANSACTION:
	      return '';
	  }
	  return state;
	}
	
	function signers(state, action) {
	  if (state === undefined) state = [];
	
	  switch (action.type) {
	    case _actionsTransactionSigner.IMPORT_FROM_XDR:
	    case _actionsTransactionSigner.CLEAR_TRANSACTION:
	      return [];
	    case _actionsTransactionSigner.SET_SECRETS:
	      return action.secrets;
	  }
	  return state;
	}
	
	function bipPath(state, action) {
	  if (state === undefined) state = [];
	
	  switch (action.type) {
	    case _actionsRouting.LOAD_STATE:
	    case _actionsTransactionSigner.IMPORT_FROM_XDR:
	    case _actionsTransactionSigner.CLEAR_TRANSACTION:
	      return "44'/148'/0'";
	    case _actionsTransactionSigner.SET_BIP_PATH:
	      return action.bipPath;
	  }
	  return state;
	}
	
	function ledgerwalletStatus(state, action) {
	  if (state === undefined) state = {};
	
	  switch (action.type) {
	    case _actionsTransactionSigner.IMPORT_FROM_XDR:
	    case _actionsTransactionSigner.CLEAR_TRANSACTION:
	      return {};
	    case _actionsTransactionSigner.LEDGER_WALLET_SIGN_START:
	      return Object.assign({}, state, {
	        status: 'loading',
	        message: 'Waiting for wallet'
	      });
	    case _actionsTransactionSigner.LEDGER_WALLET_SIGN_ERROR:
	      return Object.assign({}, state, {
	        status: 'failure',
	        message: 'Error:' + JSON.stringify(action.error)
	      });
	    case _actionsTransactionSigner.LEDGER_WALLET_SIGN_SUCCESS:
	      return Object.assign({}, state, {
	        status: 'success',
	        message: 'Success!',
	        signatures: [action.signature]
	      });
	  }
	  return state;
	}
	module.exports = exports['default'];

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(64);
	
	var _actionsXdrViewer = __webpack_require__(301);
	
	var _constantsFetched_signers = __webpack_require__(151);
	
	var _constantsFetched_signers2 = _interopRequireDefault(_constantsFetched_signers);
	
	var _actionsRouting = __webpack_require__(85);
	
	var _actionsNetwork = __webpack_require__(194);
	
	var routing = (0, _redux.combineReducers)({
	  input: input,
	  type: type,
	  fetchedSigners: fetchedSigners
	});
	
	exports['default'] = routing;
	
	function input(state, action) {
	  if (state === undefined) state = '';
	
	  switch (action.type) {
	    case _actionsRouting.LOAD_STATE:
	      if (action.slug === 'xdr-viewer' && action.queryObj.input) {
	        return action.queryObj.input;
	      }
	      break;
	    case _actionsXdrViewer.UPDATE_XDR_INPUT:
	      return action.input;
	  }
	
	  return state;
	}
	
	function type(state, action) {
	  if (state === undefined) state = 'TransactionEnvelope';
	
	  switch (action.type) {
	    case _actionsRouting.LOAD_STATE:
	      if (action.slug === 'xdr-viewer' && action.queryObj.type) {
	        return action.queryObj.type;
	      }
	      break;
	    case _actionsXdrViewer.UPDATE_XDR_TYPE:
	      return action.xdrType;
	  }
	
	  return state;
	}
	
	function fetchedSigners(state, action) {
	  if (state === undefined) state = { state: _constantsFetched_signers2['default'].NONE };
	
	  switch (action.type) {
	    case _constantsFetched_signers2['default'].SUCCESS:
	      return {
	        state: _constantsFetched_signers2['default'].SUCCESS,
	        data: action.result
	      };
	    case _constantsFetched_signers2['default'].NONE:
	    case _constantsFetched_signers2['default'].PENDING:
	    case _constantsFetched_signers2['default'].FAIL:
	    case _constantsFetched_signers2['default'].NOT_EXIST:
	      return { state: action.type };
	    case _actionsNetwork.SET_PARAMS:
	      return { state: _constantsFetched_signers2['default'].NONE };
	    default:
	      return state;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routeRecognizer = __webpack_require__(1091);
	
	var _routeRecognizer2 = _interopRequireDefault(_routeRecognizer);
	
	var _url = __webpack_require__(119);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	// routeTable is derived from Horizon init_web.go. `routeTable` is intended to
	// look similar to Horizon's code for routing requests.
	// The key is the url template with path template names slightly altered to
	// match with the Endpoint Setup Pane components in the laboratory.
	// Commented out code lines signify endpoints that the Laboratory does not support
	var routeTable = {
	  // r.Get("/", &RootAction{})
	  // r.Get("/metrics", &MetricsAction{})
	
	  // ledger actions
	  '/ledgers': { r: 'ledgers', e: 'all' },
	  '/ledgers/:ledger': { r: 'ledgers', e: 'single' },
	  '/ledgers/:ledger/transactions': { r: 'transactions', e: 'for_ledger' },
	  '/ledgers/:ledger/operations': { r: 'operations', e: 'for_ledger' },
	  '/ledgers/:ledger/payments': { r: 'payments', e: 'for_ledger' },
	  '/ledgers/:ledger/effects': { r: 'effects', e: 'for_ledger' },
	
	  // account actions
	  '/accounts/:account_id': { r: 'accounts', e: 'single' },
	  '/accounts/:account_id/transactions': { r: 'transactions', e: 'for_account' },
	  '/accounts/:account_id/operations': { r: 'operations', e: 'for_account' },
	  '/accounts/:account_id/payments': { r: 'payments', e: 'for_account' },
	  '/accounts/:account_id/effects': { r: 'effects', e: 'for_account' },
	  '/accounts/:account_id/offers': { r: 'offers', e: 'for_account' },
	  '/accounts/:account_id/trades': { r: 'trades', e: 'for_account' },
	
	  // transaction history actions
	  '/transactions': { r: 'transactions', e: 'all' },
	  '/transactions/:transaction': { r: 'transactions', e: 'single' },
	  '/transactions/:transaction/operations': { r: 'operations', e: 'for_transaction' },
	  '/transactions/:transaction/payments': { r: 'payments', e: 'for_transaction' },
	  '/transactions/:transaction/effects': { r: 'effects', e: 'for_transaction' },
	
	  // operation actions
	  '/operations': { r: 'operations', e: 'all' },
	  '/operations/:operation': { r: 'operations', e: 'single' },
	  '/operations/:operation/effects': { r: 'effects', e: 'for_operation' },
	
	  '/payments': { r: 'payments', e: 'all' },
	  '/effects': { r: 'effects', e: 'all' },
	
	  // r.Get("/offers/:id", &NotImplementedAction{})
	  '/order_book': { r: 'order_book', e: 'details' },
	  '/order_book/trades': { r: 'order_book', e: 'trades' },
	
	  // Transaction submission API
	  // r.Post("/transactions", &TransactionCreateAction{})
	  '/paths': { r: 'paths', e: 'all' }
	
	};
	
	// friendbot
	// r.Post("/friendbot", &FriendbotAction{})
	// r.Get("/friendbot", &FriendbotAction{})
	
	// r.NotFound(&NotFoundAction{})
	var router = new _routeRecognizer2['default']();
	_lodash2['default'].each(routeTable, function (resourceEndpoint, template) {
	  router.add([{ path: template, handler: resourceEndpoint }]);
	});
	
	function stripTemplatedCurlyBrackets(inputUrl) {
	  return inputUrl.replace(/\{.+\}$/, '');
	}
	
	function horizonUrlParser(inputUrl) {
	  var parsedPath = _url2['default'].parse(stripTemplatedCurlyBrackets(inputUrl)).path;
	  if (parsedPath === null) {
	    return;
	  }
	
	  var recognizeResult = router.recognize(parsedPath);
	  if (typeof recognizeResult === 'undefined' || recognizeResult.length === 0) {
	    return;
	  }
	
	  // Path params shadow and take higher precedence than query params
	  var params = _lodash2['default'].assign({}, recognizeResult.queryParams, recognizeResult[0].params);
	  laboratorifyParams(params);
	
	  return {
	    resource: recognizeResult[0].handler.r,
	    endpoint: recognizeResult[0].handler.e,
	    params: params
	  };
	}
	
	// This converts the url params into the internal data structure used in the
	// laboratory. For more info, take a look at `../data/endpoints.js` and look at
	// the keys named `path`.
	// This function mutate the params object passed in.
	// - Converts root level items into children of root level objects
	function laboratorifyParams(params) {
	  assignToParam(params, 'selling_asset_type', 'selling_asset', 'type');
	  assignToParam(params, 'selling_asset_code', 'selling_asset', 'code');
	  assignToParam(params, 'selling_asset_issuer', 'selling_asset', 'issuer');
	
	  assignToParam(params, 'buying_asset_type', 'buying_asset', 'type');
	  assignToParam(params, 'buying_asset_code', 'buying_asset', 'code');
	  assignToParam(params, 'buying_asset_issuer', 'buying_asset', 'issuer');
	
	  assignToParam(params, 'destination_asset_type', 'buying_asset', 'type');
	  assignToParam(params, 'destination_asset_code', 'buying_asset', 'code');
	  assignToParam(params, 'destination_asset_issuer', 'buying_asset', 'issuer');
	}
	
	// assignToParam helps the laboratorify process by moving a root level item into
	// a object with specified target keys.
	// @param {object} params - Object of all params. Will be mutated
	// @param {string} source - original key to move. Will be deleted if exists
	// @param {string} destObj - object to move into. Will be created if not exist
	// @param {string} destKey - key name to move source into
	function assignToParam(params, source, destObj, destKey) {
	  if (!_lodash2['default'].has(params, source)) {
	    return;
	  }
	  if (!_lodash2['default'].has(params, destObj)) {
	    params[destObj] = {};
	  } else if (typeof params[destObj] !== 'object') {
	    console.error('Non object already exists in key. This is likely due to tampering of the values in the url');
	    return;
	  }
	  params[destObj][destKey] = params[source];
	  delete params[source];
	}
	
	exports['default'] = horizonUrlParser;
	module.exports = exports['default'];

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _linkBuilder = __webpack_require__(206);
	
	// Map of functions specific to JSON property keys that creates urls for a given
	// value.
	// A function can also return undefined if it doesn't deem the value worthy of
	// linking (for example: invalid account ID or keys that have ambiguous names)
	var accountIdGenerator = function accountIdGenerator(value) {
	  if (value.length === 56) {
	    return (0, _linkBuilder.singleAccount)(value);
	  }
	};
	var linkHighlighterRules = {
	  'envelope_xdr': function envelope_xdr(value) {
	    return (0, _linkBuilder.xdrViewer)(value, 'TransactionEnvelope');
	  },
	  'result_xdr': function result_xdr(value) {
	    return (0, _linkBuilder.xdrViewer)(value, 'TransactionResult');
	  },
	  'result_meta_xdr': function result_meta_xdr(value) {
	    return (0, _linkBuilder.xdrViewer)(value, 'TransactionMeta');
	  },
	  'fee_meta_xdr': function fee_meta_xdr(value) {
	    return (0, _linkBuilder.xdrViewer)(value, 'OperationMeta');
	  },
	  'id': accountIdGenerator,
	  'public_key': accountIdGenerator,
	  'account_id': accountIdGenerator,
	  'funder': accountIdGenerator,
	  'account': accountIdGenerator,
	  'source_account': accountIdGenerator,
	  'destination_account': accountIdGenerator,
	  'href': _linkBuilder.horizonUrlToExplorerLink
	};
	
	exports['default'] = linkHighlighterRules;
	module.exports = exports['default'];

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	// This is a module that creates hyperlinks in a JSON highlighted document
	// generated by prism. It is not directly a prism plugin but rather a function
	// that works with the HTML string generated by the prism highlighter.
	
	// The specific rules on how to highlight is in ./linkHighlighterRules.js
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = jsonLinkHighlighter;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _linkHighlighterRules = __webpack_require__(569);
	
	var _linkHighlighterRules2 = _interopRequireDefault(_linkHighlighterRules);
	
	// @param {string} code - Valid html generated by prism.js in JSON language mode
	// @returns {string} code - Valid html string but with some spans converted to anchors
	
	function jsonLinkHighlighter(code) {
	  var parser = new DOMParser();
	  var document = parser.parseFromString(code, 'text/html');
	  var body = document.childNodes[0].childNodes[1];
	
	  // Edit the token elements in place
	  _lodash2['default'].each(body.children, function (token, index) {
	    if (token.className.indexOf('property') > 0) {
	      annotatePropertyToken(token);
	    }
	  });
	  return body.innerHTML;
	}
	
	// Takes in a property highlighted item. If functionality is defined for it's
	// corresponding property (only string type supported) and the content is valid,
	// then we will turn the value node into a link.
	// @param {HTMLElement} propertyToken - The token element of property type (assigned by prism)
	var highlightableTokenClasses = {
	  'token string': true,
	  'token boolean': true,
	  'token number': true
	};
	function annotatePropertyToken(propertyToken) {
	  validatePropertyTokenSiblings(propertyToken);
	  var valueToken = propertyToken.nextElementSibling.nextElementSibling;
	  if (!_lodash2['default'].has(highlightableTokenClasses, valueToken.className)) {
	    return;
	  }
	
	  var urlGenerator = _linkHighlighterRules2['default'][unQuote(propertyToken.innerHTML)];
	  if (typeof urlGenerator === 'undefined') {
	    return;
	  }
	
	  var safeUnescapedValueText = valueToken.innerHTML.replace(/\&amp;/g, '&');
	  var href = urlGenerator(unQuote(safeUnescapedValueText));
	  if (typeof href === 'undefined') {
	    return;
	  }
	  nodeToAnchor(valueToken, href);
	}
	
	// Validate the siblings so that the highlighter will fail fast if some unexpected
	// changes happen such as the prism output changing.
	var validSecondSiblingClasses = {
	  'token punctuation': true,
	  'token string': true,
	  'token boolean': true,
	  'token number': true,
	  'token property': true };
	// Prism.js incorrectly parses strings with escape sequences
	function validatePropertyTokenSiblings(propertyToken) {
	  var firstSibling = propertyToken.nextElementSibling;
	  var secondSibling = firstSibling.nextElementSibling;
	
	  if (firstSibling.className !== 'token operator') {
	    throw new Error('Prism jsonLinkHighlighter: Unexpected first sibling to property token with class: ' + firstSibling.className);
	  }
	
	  if (!_lodash2['default'].has(validSecondSiblingClasses, secondSibling.className)) {
	    throw new Error('Prism jsonLinkHighlighter: Unexpected second sibling to property token with class: ' + secondSibling.className);
	  }
	}
	
	// Converts a span into an anchor. Only preserves className
	// @param {HTMLElement} node - Item to be converted to an anchor
	// @param {string} href - Url to link to
	function nodeToAnchor(node, href) {
	  node.outerHTML = '<a href="' + href + '" class="' + node.className + '">' + node.innerHTML + '</a>';
	}
	
	function unQuote(input) {
	  return input.substring(1, input.length - 1);
	}
	module.exports = exports['default'];

/***/ }),
/* 571 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// DO NOT MAKE EDITS TO THIS FILE
	// Instead, just generate a new version from prismjs.com and paste it here
	
	// We use this over the npm version because it offers more flexibility in choosing
	// which languages we can use.
	
	/* http://prismjs.com/download.html?themes=prism&languages=markup+css+clike+javascript+json */
	"use strict";
	
	var _self = "undefined" != typeof window ? window : "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope ? self : {},
	    Prism = (function () {
	  var e = /\blang(?:uage)?-(\w+)\b/i,
	      t = 0,
	      n = _self.Prism = { util: { encode: function encode(e) {
	        return e instanceof a ? new a(e.type, n.util.encode(e.content), e.alias) : "Array" === n.util.type(e) ? e.map(n.util.encode) : e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
	      }, type: function type(e) {
	        return Object.prototype.toString.call(e).match(/\[object (\w+)\]/)[1];
	      }, objId: function objId(e) {
	        return e.__id || Object.defineProperty(e, "__id", { value: ++t }), e.__id;
	      }, clone: function clone(e) {
	        var t = n.util.type(e);switch (t) {case "Object":
	            var a = {};for (var r in e) e.hasOwnProperty(r) && (a[r] = n.util.clone(e[r]));return a;case "Array":
	            return e.map && e.map(function (e) {
	              return n.util.clone(e);
	            });}return e;
	      } }, languages: { extend: function extend(e, t) {
	        var a = n.util.clone(n.languages[e]);for (var r in t) a[r] = t[r];return a;
	      }, insertBefore: function insertBefore(e, t, a, r) {
	        r = r || n.languages;var l = r[e];if (2 == arguments.length) {
	          a = arguments[1];for (var i in a) a.hasOwnProperty(i) && (l[i] = a[i]);return l;
	        }var o = {};for (var s in l) if (l.hasOwnProperty(s)) {
	          if (s == t) for (var i in a) a.hasOwnProperty(i) && (o[i] = a[i]);o[s] = l[s];
	        }return n.languages.DFS(n.languages, function (t, n) {
	          n === r[e] && t != e && (this[t] = o);
	        }), r[e] = o;
	      }, DFS: function DFS(e, t, a, r) {
	        r = r || {};for (var l in e) e.hasOwnProperty(l) && (t.call(e, l, e[l], a || l), "Object" !== n.util.type(e[l]) || r[n.util.objId(e[l])] ? "Array" !== n.util.type(e[l]) || r[n.util.objId(e[l])] || (r[n.util.objId(e[l])] = !0, n.languages.DFS(e[l], t, l, r)) : (r[n.util.objId(e[l])] = !0, n.languages.DFS(e[l], t, null, r)));
	      } }, plugins: {}, highlightAll: function highlightAll(e, t) {
	      var a = { callback: t, selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code' };n.hooks.run("before-highlightall", a);for (var r, l = a.elements || document.querySelectorAll(a.selector), i = 0; r = l[i++];) n.highlightElement(r, e === !0, a.callback);
	    }, highlightElement: function highlightElement(t, a, r) {
	      for (var l, i, o = t; o && !e.test(o.className);) o = o.parentNode;o && (l = (o.className.match(e) || [, ""])[1], i = n.languages[l]), t.className = t.className.replace(e, "").replace(/\s+/g, " ") + " language-" + l, o = t.parentNode, /pre/i.test(o.nodeName) && (o.className = o.className.replace(e, "").replace(/\s+/g, " ") + " language-" + l);var s = t.textContent,
	          u = { element: t, language: l, grammar: i, code: s };if (!s || !i) return n.hooks.run("complete", u), void 0;if ((n.hooks.run("before-highlight", u), a && _self.Worker)) {
	        var c = new Worker(n.filename);c.onmessage = function (e) {
	          u.highlightedCode = e.data, n.hooks.run("before-insert", u), u.element.innerHTML = u.highlightedCode, r && r.call(u.element), n.hooks.run("after-highlight", u), n.hooks.run("complete", u);
	        }, c.postMessage(JSON.stringify({ language: u.language, code: u.code, immediateClose: !0 }));
	      } else u.highlightedCode = n.highlight(u.code, u.grammar, u.language), n.hooks.run("before-insert", u), u.element.innerHTML = u.highlightedCode, r && r.call(t), n.hooks.run("after-highlight", u), n.hooks.run("complete", u);
	    }, highlight: function highlight(e, t, r) {
	      var l = n.tokenize(e, t);return a.stringify(n.util.encode(l), r);
	    }, tokenize: function tokenize(e, t) {
	      var a = n.Token,
	          r = [e],
	          l = t.rest;if (l) {
	        for (var i in l) t[i] = l[i];delete t.rest;
	      }e: for (var i in t) if (t.hasOwnProperty(i) && t[i]) {
	        var o = t[i];o = "Array" === n.util.type(o) ? o : [o];for (var s = 0; s < o.length; ++s) {
	          var u = o[s],
	              c = u.inside,
	              g = !!u.lookbehind,
	              h = !!u.greedy,
	              f = 0,
	              d = u.alias;u = u.pattern || u;for (var p = 0; p < r.length; p++) {
	            var m = r[p];if (r.length > e.length) break e;if (!(m instanceof a)) {
	              u.lastIndex = 0;var v = u.exec(m),
	                  y = 1;if (!v && h && p != r.length - 1) {
	                var b = r[p + 1].matchedStr || r[p + 1],
	                    k = m + b;if ((p < r.length - 2 && (k += r[p + 2].matchedStr || r[p + 2]), u.lastIndex = 0, v = u.exec(k), !v)) continue;var w = v.index + (g ? v[1].length : 0);if (w >= m.length) continue;var _ = v.index + v[0].length,
	                    P = m.length + b.length;y = 3, P >= _ && (y = 2, k = k.slice(0, P)), m = k;
	              }if (v) {
	                g && (f = v[1].length);var w = v.index + f,
	                    v = v[0].slice(f),
	                    _ = w + v.length,
	                    S = m.slice(0, w),
	                    O = m.slice(_),
	                    j = [p, y];S && j.push(S);var A = new a(i, c ? n.tokenize(v, c) : v, d, v);j.push(A), O && j.push(O), Array.prototype.splice.apply(r, j);
	              }
	            }
	          }
	        }
	      }return r;
	    }, hooks: { all: {}, add: function add(e, t) {
	        var a = n.hooks.all;a[e] = a[e] || [], a[e].push(t);
	      }, run: function run(e, t) {
	        var a = n.hooks.all[e];if (a && a.length) for (var r, l = 0; r = a[l++];) r(t);
	      } } },
	      a = n.Token = function (e, t, n, a) {
	    this.type = e, this.content = t, this.alias = n, this.matchedStr = a || null;
	  };if ((a.stringify = function (e, t, r) {
	    if ("string" == typeof e) return e;if ("Array" === n.util.type(e)) return e.map(function (n) {
	      return a.stringify(n, t, e);
	    }).join("");var l = { type: e.type, content: a.stringify(e.content, t, r), tag: "span", classes: ["token", e.type], attributes: {}, language: t, parent: r };if (("comment" == l.type && (l.attributes.spellcheck = "true"), e.alias)) {
	      var i = "Array" === n.util.type(e.alias) ? e.alias : [e.alias];Array.prototype.push.apply(l.classes, i);
	    }n.hooks.run("wrap", l);var o = "";for (var s in l.attributes) o += (o ? " " : "") + s + '="' + (l.attributes[s] || "") + '"';return "<" + l.tag + ' class="' + l.classes.join(" ") + '" ' + o + ">" + l.content + "</" + l.tag + ">";
	  }, !_self.document)) return _self.addEventListener ? (_self.addEventListener("message", function (e) {
	    var t = JSON.parse(e.data),
	        a = t.language,
	        r = t.code,
	        l = t.immediateClose;_self.postMessage(n.highlight(r, n.languages[a], a)), l && _self.close();
	  }, !1), _self.Prism) : _self.Prism;var r = document.currentScript || [].slice.call(document.getElementsByTagName("script")).pop();return r && (n.filename = r.src, document.addEventListener && !r.hasAttribute("data-manual") && document.addEventListener("DOMContentLoaded", n.highlightAll)), _self.Prism;
	})();"undefined" != typeof module && module.exports && (module.exports = Prism), "undefined" != typeof global && (global.Prism = Prism);
	Prism.languages.markup = { comment: /<!--[\w\W]*?-->/, prolog: /<\?[\w\W]+?\?>/, doctype: /<!DOCTYPE[\w\W]+?>/, cdata: /<!\[CDATA\[[\w\W]*?]]>/i, tag: { pattern: /<\/?(?!\d)[^\s>\/=.$<]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\\1|\\?(?!\1)[\w\W])*\1|[^\s'">=]+))?)*\s*\/?>/i, inside: { tag: { pattern: /^<\/?[^\s>\/]+/i, inside: { punctuation: /^<\/?/, namespace: /^[^\s>\/:]+:/ } }, "attr-value": { pattern: /=(?:('|")[\w\W]*?(\1)|[^\s>]+)/i, inside: { punctuation: /[=>"']/ } }, punctuation: /\/?>/, "attr-name": { pattern: /[^\s>\/]+/, inside: { namespace: /^[^\s>\/:]+:/ } } } }, entity: /&#?[\da-z]{1,8};/i }, Prism.hooks.add("wrap", function (a) {
	  "entity" === a.type && (a.attributes.title = a.content.replace(/&amp;/, "&"));
	}), Prism.languages.xml = Prism.languages.markup, Prism.languages.html = Prism.languages.markup, Prism.languages.mathml = Prism.languages.markup, Prism.languages.svg = Prism.languages.markup;
	Prism.languages.css = { comment: /\/\*[\w\W]*?\*\//, atrule: { pattern: /@[\w-]+?.*?(;|(?=\s*\{))/i, inside: { rule: /@[\w-]+/ } }, url: /url\((?:(["'])(\\(?:\r\n|[\w\W])|(?!\1)[^\\\r\n])*\1|.*?)\)/i, selector: /[^\{\}\s][^\{\};]*?(?=\s*\{)/, string: /("|')(\\(?:\r\n|[\w\W])|(?!\1)[^\\\r\n])*\1/, property: /(\b|\B)[\w-]+(?=\s*:)/i, important: /\B!important\b/i, "function": /[-a-z0-9]+(?=\()/i, punctuation: /[(){};:]/ }, Prism.languages.css.atrule.inside.rest = Prism.util.clone(Prism.languages.css), Prism.languages.markup && (Prism.languages.insertBefore("markup", "tag", { style: { pattern: /(<style[\w\W]*?>)[\w\W]*?(?=<\/style>)/i, lookbehind: !0, inside: Prism.languages.css, alias: "language-css" } }), Prism.languages.insertBefore("inside", "attr-value", { "style-attr": { pattern: /\s*style=("|').*?\1/i, inside: { "attr-name": { pattern: /^\s*style/i, inside: Prism.languages.markup.tag.inside }, punctuation: /^\s*=\s*['"]|['"]\s*$/, "attr-value": { pattern: /.+/i, inside: Prism.languages.css } }, alias: "language-css" } }, Prism.languages.markup.tag));
	Prism.languages.clike = { comment: [{ pattern: /(^|[^\\])\/\*[\w\W]*?\*\//, lookbehind: !0 }, { pattern: /(^|[^\\:])\/\/.*/, lookbehind: !0 }], string: { pattern: /(["'])(\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, greedy: !0 }, "class-name": { pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[a-z0-9_\.\\]+/i, lookbehind: !0, inside: { punctuation: /(\.|\\)/ } }, keyword: /\b(if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/, "boolean": /\b(true|false)\b/, "function": /[a-z0-9_]+(?=\()/i, number: /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)\b/i, operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/, punctuation: /[{}[\];(),.:]/ };
	Prism.languages.javascript = Prism.languages.extend("clike", { keyword: /\b(as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/, number: /\b-?(0x[\dA-Fa-f]+|0b[01]+|0o[0-7]+|\d*\.?\d+([Ee][+-]?\d+)?|NaN|Infinity)\b/, "function": /[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*(?=\()/i }), Prism.languages.insertBefore("javascript", "keyword", { regex: { pattern: /(^|[^\/])\/(?!\/)(\[.+?]|\\.|[^\/\\\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})]))/, lookbehind: !0, greedy: !0 } }), Prism.languages.insertBefore("javascript", "class-name", { "template-string": { pattern: /`(?:\\\\|\\?[^\\])*?`/, inside: { interpolation: { pattern: /\$\{[^}]+\}/, inside: { "interpolation-punctuation": { pattern: /^\$\{|\}$/, alias: "punctuation" }, rest: Prism.languages.javascript } }, string: /[\s\S]+/ } } }), Prism.languages.markup && Prism.languages.insertBefore("markup", "tag", { script: { pattern: /(<script[\w\W]*?>)[\w\W]*?(?=<\/script>)/i, lookbehind: !0, inside: Prism.languages.javascript, alias: "language-javascript" } }), Prism.languages.js = Prism.languages.javascript;
	Prism.languages.json = { property: /".*?"(?=\s*:)/gi, string: /"(?!:)(\\?[^"])*?"(?!:)/g, number: /\b-?(0x[\dA-Fa-f]+|\d*\.?\d+([Ee]-?\d+)?)\b/g, punctuation: /[{}[\]);,]/g, operator: /:/g, "boolean": /\b(true|false)\b/gi, "null": /\bnull\b/gi }, Prism.languages.jsonp = Prism.languages.json;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(772);
	
	__webpack_require__(1089);
	
	__webpack_require__(573);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(580);
	module.exports = __webpack_require__(46).RegExp.escape;


/***/ }),
/* 574 */
[1178, 9, 155, 14],
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(7);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(3);
	var toPrimitive = __webpack_require__(61);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(90);
	var gOPS = __webpack_require__(159);
	var pIE = __webpack_require__(128);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(129)('native-function-to-string', Function.toString);


/***/ }),
/* 579 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(1);
	var $re = __webpack_require__(579)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(319) });
	
	__webpack_require__(76)('copyWithin');


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $every = __webpack_require__(58)(4);
	
	$export($export.P + $export.F * !__webpack_require__(48)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { fill: __webpack_require__(210) });
	
	__webpack_require__(76)('fill');


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $filter = __webpack_require__(58)(2);
	
	$export($export.P + $export.F * !__webpack_require__(48)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(58)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(76)(KEY);


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(58)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(76)(KEY);


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $forEach = __webpack_require__(58)(0);
	var STRICT = __webpack_require__(48)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(47);
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(18);
	var call = __webpack_require__(330);
	var isArrayIter = __webpack_require__(218);
	var toLength = __webpack_require__(15);
	var createProperty = __webpack_require__(212);
	var getIterFn = __webpack_require__(234);
	
	$export($export.S + $export.F * !__webpack_require__(157)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $indexOf = __webpack_require__(152)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(48)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(155) });


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(42);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(127) != Object || !__webpack_require__(48)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(42);
	var toInteger = __webpack_require__(49);
	var toLength = __webpack_require__(15);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(48)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $map = __webpack_require__(58)(1);
	
	$export($export.P + $export.F * !__webpack_require__(48)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var createProperty = __webpack_require__(212);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(321);
	
	$export($export.P + $export.F * !__webpack_require__(48)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(321);
	
	$export($export.P + $export.F * !__webpack_require__(48)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var html = __webpack_require__(216);
	var cof = __webpack_require__(45);
	var toAbsoluteIndex = __webpack_require__(94);
	var toLength = __webpack_require__(15);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(7)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $some = __webpack_require__(58)(3);
	
	$export($export.P + $export.F * !__webpack_require__(48)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(27);
	var toObject = __webpack_require__(18);
	var fails = __webpack_require__(7);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(48)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(93)('Array');


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(1);
	var toISOString = __webpack_require__(575);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(18);
	var toPrimitive = __webpack_require__(61);
	
	$export($export.P + $export.F * __webpack_require__(7)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(14)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(34)(proto, TO_PRIMITIVE, __webpack_require__(576));


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(35)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Function', { bind: __webpack_require__(322) });


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(9);
	var getPrototypeOf = __webpack_require__(41);
	var HAS_INSTANCE = __webpack_require__(14)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(17).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(17).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(16) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(1);
	var log1p = __webpack_require__(333);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(1);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(1);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(1);
	var sign = __webpack_require__(222);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(1);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(1);
	var $expm1 = __webpack_require__(221);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { fround: __webpack_require__(332) });


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(1);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(1);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(333) });


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { sign: __webpack_require__(222) });


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(221);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(221);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var has = __webpack_require__(39);
	var cof = __webpack_require__(45);
	var inheritIfRequired = __webpack_require__(217);
	var toPrimitive = __webpack_require__(61);
	var fails = __webpack_require__(7);
	var gOPN = __webpack_require__(89).f;
	var gOPD = __webpack_require__(40).f;
	var dP = __webpack_require__(17).f;
	var $trim = __webpack_require__(111).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(88)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(16) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(35)(global, NUMBER, $Number);
	}


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(1);
	var _isFinite = __webpack_require__(5).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(329) });


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(1);
	var isInteger = __webpack_require__(329);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(341);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(342);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toInteger = __webpack_require__(49);
	var aNumberValue = __webpack_require__(318);
	var repeat = __webpack_require__(229);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(7)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $fails = __webpack_require__(7);
	var aNumberValue = __webpack_require__(318);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(335) });


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(88) });


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(16), 'Object', { defineProperties: __webpack_require__(336) });


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(16), 'Object', { defineProperty: __webpack_require__(17).f });


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(9);
	var meta = __webpack_require__(78).onFreeze;
	
	__webpack_require__(60)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(42);
	var $getOwnPropertyDescriptor = __webpack_require__(40).f;
	
	__webpack_require__(60)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(60)('getOwnPropertyNames', function () {
	  return __webpack_require__(337).f;
	});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(18);
	var $getPrototypeOf = __webpack_require__(41);
	
	__webpack_require__(60)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(9);
	
	__webpack_require__(60)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(9);
	
	__webpack_require__(60)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(9);
	
	__webpack_require__(60)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { is: __webpack_require__(345) });


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(18);
	var $keys = __webpack_require__(90);
	
	__webpack_require__(60)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(9);
	var meta = __webpack_require__(78).onFreeze;
	
	__webpack_require__(60)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(9);
	var meta = __webpack_require__(78).onFreeze;
	
	__webpack_require__(60)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(226).set });


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(108);
	var test = {};
	test[__webpack_require__(14)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(35)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(341);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(342);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(77);
	var global = __webpack_require__(5);
	var ctx = __webpack_require__(47);
	var classof = __webpack_require__(108);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(9);
	var aFunction = __webpack_require__(27);
	var anInstance = __webpack_require__(86);
	var forOf = __webpack_require__(87);
	var speciesConstructor = __webpack_require__(130);
	var task = __webpack_require__(231).set;
	var microtask = __webpack_require__(223)();
	var newPromiseCapabilityModule = __webpack_require__(224);
	var perform = __webpack_require__(343);
	var userAgent = __webpack_require__(165);
	var promiseResolve = __webpack_require__(344);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(14)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(92)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(110)($Promise, PROMISE);
	__webpack_require__(93)(PROMISE);
	Wrapper = __webpack_require__(46)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(157)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(27);
	var anObject = __webpack_require__(3);
	var rApply = (__webpack_require__(5).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(7)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(1);
	var create = __webpack_require__(88);
	var aFunction = __webpack_require__(27);
	var anObject = __webpack_require__(3);
	var isObject = __webpack_require__(9);
	var fails = __webpack_require__(7);
	var bind = __webpack_require__(322);
	var rConstruct = (__webpack_require__(5).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(17);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(3);
	var toPrimitive = __webpack_require__(61);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(1);
	var gOPD = __webpack_require__(40).f;
	var anObject = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(3);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(219)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(40);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(1);
	var getProto = __webpack_require__(41);
	var anObject = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(40);
	var getPrototypeOf = __webpack_require__(41);
	var has = __webpack_require__(39);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(9);
	var anObject = __webpack_require__(3);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(3);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(340) });


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(3);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(1);
	var setProto = __webpack_require__(226);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(17);
	var gOPD = __webpack_require__(40);
	var getPrototypeOf = __webpack_require__(41);
	var has = __webpack_require__(39);
	var $export = __webpack_require__(1);
	var createDesc = __webpack_require__(91);
	var anObject = __webpack_require__(3);
	var isObject = __webpack_require__(9);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var inheritIfRequired = __webpack_require__(217);
	var dP = __webpack_require__(17).f;
	var gOPN = __webpack_require__(89).f;
	var isRegExp = __webpack_require__(156);
	var $flags = __webpack_require__(126);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(16) && (!CORRECT_NEW || __webpack_require__(7)(function () {
	  re2[__webpack_require__(14)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(35)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(93)('RegExp');


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(3);
	var toLength = __webpack_require__(15);
	var advanceStringIndex = __webpack_require__(209);
	var regExpExec = __webpack_require__(160);
	
	// @@match logic
	__webpack_require__(154)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(3);
	var toObject = __webpack_require__(18);
	var toLength = __webpack_require__(15);
	var toInteger = __webpack_require__(49);
	var advanceStringIndex = __webpack_require__(209);
	var regExpExec = __webpack_require__(160);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(154)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(3);
	var sameValue = __webpack_require__(345);
	var regExpExec = __webpack_require__(160);
	
	// @@search logic
	__webpack_require__(154)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(156);
	var anObject = __webpack_require__(3);
	var speciesConstructor = __webpack_require__(130);
	var advanceStringIndex = __webpack_require__(209);
	var toLength = __webpack_require__(15);
	var callRegExpExec = __webpack_require__(160);
	var regexpExec = __webpack_require__(225);
	var fails = __webpack_require__(7);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(154)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(351);
	var anObject = __webpack_require__(3);
	var $flags = __webpack_require__(126);
	var DESCRIPTORS = __webpack_require__(16);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(35)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(36)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(36)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(36)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(36)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(163)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(15);
	var context = __webpack_require__(228);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(215)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(36)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(36)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(36)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var toAbsoluteIndex = __webpack_require__(94);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(1);
	var context = __webpack_require__(228);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(215)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(36)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 690 */
[1216, 163, 220],
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(36)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(42);
	var toLength = __webpack_require__(15);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(229)
	});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(36)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(15);
	var context = __webpack_require__(228);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(215)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(36)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(36)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(36)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(111)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(5);
	var has = __webpack_require__(39);
	var DESCRIPTORS = __webpack_require__(16);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(35);
	var META = __webpack_require__(78).KEY;
	var $fails = __webpack_require__(7);
	var shared = __webpack_require__(129);
	var setToStringTag = __webpack_require__(110);
	var uid = __webpack_require__(95);
	var wks = __webpack_require__(14);
	var wksExt = __webpack_require__(348);
	var wksDefine = __webpack_require__(233);
	var enumKeys = __webpack_require__(577);
	var isArray = __webpack_require__(155);
	var anObject = __webpack_require__(3);
	var isObject = __webpack_require__(9);
	var toObject = __webpack_require__(18);
	var toIObject = __webpack_require__(42);
	var toPrimitive = __webpack_require__(61);
	var createDesc = __webpack_require__(91);
	var _create = __webpack_require__(88);
	var gOPNExt = __webpack_require__(337);
	var $GOPD = __webpack_require__(40);
	var $GOPS = __webpack_require__(159);
	var $DP = __webpack_require__(17);
	var $keys = __webpack_require__(90);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(89).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(128).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(77)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(34)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $typed = __webpack_require__(164);
	var buffer = __webpack_require__(232);
	var anObject = __webpack_require__(3);
	var toAbsoluteIndex = __webpack_require__(94);
	var toLength = __webpack_require__(15);
	var isObject = __webpack_require__(9);
	var ArrayBuffer = __webpack_require__(5).ArrayBuffer;
	var speciesConstructor = __webpack_require__(130);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(93)(ARRAY_BUFFER);


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	$export($export.G + $export.W + $export.F * !__webpack_require__(164).ABV, {
	  DataView: __webpack_require__(232).DataView
	});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(325);
	var validate = __webpack_require__(96);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(153)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(326);
	var toObject = __webpack_require__(18);
	var toLength = __webpack_require__(15);
	var aFunction = __webpack_require__(27);
	var arraySpeciesCreate = __webpack_require__(211);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(76)('flatMap');


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(326);
	var toObject = __webpack_require__(18);
	var toLength = __webpack_require__(15);
	var toInteger = __webpack_require__(49);
	var arraySpeciesCreate = __webpack_require__(211);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(76)('flatten');


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(1);
	var $includes = __webpack_require__(152)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(76)('includes');


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(1);
	var microtask = __webpack_require__(223)();
	var process = __webpack_require__(5).process;
	var isNode = __webpack_require__(45)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(1);
	var cof = __webpack_require__(45);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.G, { global: __webpack_require__(5) });


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(161)('Map');


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(162)('Map');


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(324)('Map') });


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var scale = __webpack_require__(334);
	var fround = __webpack_require__(332);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { scale: __webpack_require__(334) });


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(18);
	var aFunction = __webpack_require__(27);
	var $defineProperty = __webpack_require__(17);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(16) && $export($export.P + __webpack_require__(158), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(18);
	var aFunction = __webpack_require__(27);
	var $defineProperty = __webpack_require__(17);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(16) && $export($export.P + __webpack_require__(158), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $entries = __webpack_require__(339)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(1);
	var ownKeys = __webpack_require__(340);
	var toIObject = __webpack_require__(42);
	var gOPD = __webpack_require__(40);
	var createProperty = __webpack_require__(212);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(18);
	var toPrimitive = __webpack_require__(61);
	var getPrototypeOf = __webpack_require__(41);
	var getOwnPropertyDescriptor = __webpack_require__(40).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(16) && $export($export.P + __webpack_require__(158), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(18);
	var toPrimitive = __webpack_require__(61);
	var getPrototypeOf = __webpack_require__(41);
	var getOwnPropertyDescriptor = __webpack_require__(40).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(16) && $export($export.P + __webpack_require__(158), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $values = __webpack_require__(339)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(1);
	var global = __webpack_require__(5);
	var core = __webpack_require__(46);
	var microtask = __webpack_require__(223)();
	var OBSERVABLE = __webpack_require__(14)('observable');
	var aFunction = __webpack_require__(27);
	var anObject = __webpack_require__(3);
	var anInstance = __webpack_require__(86);
	var redefineAll = __webpack_require__(92);
	var hide = __webpack_require__(34);
	var forOf = __webpack_require__(87);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(93)('Observable');


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(1);
	var core = __webpack_require__(46);
	var global = __webpack_require__(5);
	var speciesConstructor = __webpack_require__(130);
	var promiseResolve = __webpack_require__(344);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(1);
	var newPromiseCapability = __webpack_require__(224);
	var perform = __webpack_require__(343);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(3);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(3);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(352);
	var from = __webpack_require__(320);
	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(3);
	var getPrototypeOf = __webpack_require__(41);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(3);
	var getPrototypeOf = __webpack_require__(41);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(3);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(3);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(3);
	var getPrototypeOf = __webpack_require__(41);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(3);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(66);
	var anObject = __webpack_require__(3);
	var aFunction = __webpack_require__(27);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(161)('Set');


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(162)('Set');


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(324)('Set') });


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(163)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(1);
	var defined = __webpack_require__(59);
	var toLength = __webpack_require__(15);
	var isRegExp = __webpack_require__(156);
	var getFlags = __webpack_require__(126);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(219)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(346);
	var userAgent = __webpack_require__(165);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(346);
	var userAgent = __webpack_require__(165);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(111)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(111)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(233)('asyncIterator');


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(233)('observable');


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.S, 'System', { global: __webpack_require__(5) });


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(161)('WeakMap');


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(162)('WeakMap');


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(161)('WeakSet');


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(162)('WeakSet');


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(235);
	var getKeys = __webpack_require__(90);
	var redefine = __webpack_require__(35);
	var global = __webpack_require__(5);
	var hide = __webpack_require__(34);
	var Iterators = __webpack_require__(109);
	var wks = __webpack_require__(14);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $task = __webpack_require__(231);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(5);
	var $export = __webpack_require__(1);
	var userAgent = __webpack_require__(165);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(700);
	__webpack_require__(639);
	__webpack_require__(641);
	__webpack_require__(640);
	__webpack_require__(643);
	__webpack_require__(645);
	__webpack_require__(650);
	__webpack_require__(644);
	__webpack_require__(642);
	__webpack_require__(652);
	__webpack_require__(651);
	__webpack_require__(647);
	__webpack_require__(648);
	__webpack_require__(646);
	__webpack_require__(638);
	__webpack_require__(649);
	__webpack_require__(653);
	__webpack_require__(654);
	__webpack_require__(606);
	__webpack_require__(608);
	__webpack_require__(607);
	__webpack_require__(656);
	__webpack_require__(655);
	__webpack_require__(626);
	__webpack_require__(636);
	__webpack_require__(637);
	__webpack_require__(627);
	__webpack_require__(628);
	__webpack_require__(629);
	__webpack_require__(630);
	__webpack_require__(631);
	__webpack_require__(632);
	__webpack_require__(633);
	__webpack_require__(634);
	__webpack_require__(635);
	__webpack_require__(609);
	__webpack_require__(610);
	__webpack_require__(611);
	__webpack_require__(612);
	__webpack_require__(613);
	__webpack_require__(614);
	__webpack_require__(615);
	__webpack_require__(616);
	__webpack_require__(617);
	__webpack_require__(618);
	__webpack_require__(619);
	__webpack_require__(620);
	__webpack_require__(621);
	__webpack_require__(622);
	__webpack_require__(623);
	__webpack_require__(624);
	__webpack_require__(625);
	__webpack_require__(687);
	__webpack_require__(692);
	__webpack_require__(699);
	__webpack_require__(690);
	__webpack_require__(682);
	__webpack_require__(683);
	__webpack_require__(688);
	__webpack_require__(693);
	__webpack_require__(695);
	__webpack_require__(678);
	__webpack_require__(679);
	__webpack_require__(680);
	__webpack_require__(681);
	__webpack_require__(684);
	__webpack_require__(685);
	__webpack_require__(686);
	__webpack_require__(689);
	__webpack_require__(691);
	__webpack_require__(694);
	__webpack_require__(696);
	__webpack_require__(697);
	__webpack_require__(698);
	__webpack_require__(601);
	__webpack_require__(603);
	__webpack_require__(602);
	__webpack_require__(605);
	__webpack_require__(604);
	__webpack_require__(590);
	__webpack_require__(588);
	__webpack_require__(594);
	__webpack_require__(591);
	__webpack_require__(597);
	__webpack_require__(599);
	__webpack_require__(587);
	__webpack_require__(593);
	__webpack_require__(584);
	__webpack_require__(598);
	__webpack_require__(582);
	__webpack_require__(596);
	__webpack_require__(595);
	__webpack_require__(589);
	__webpack_require__(592);
	__webpack_require__(581);
	__webpack_require__(583);
	__webpack_require__(586);
	__webpack_require__(585);
	__webpack_require__(600);
	__webpack_require__(235);
	__webpack_require__(672);
	__webpack_require__(350);
	__webpack_require__(677);
	__webpack_require__(351);
	__webpack_require__(673);
	__webpack_require__(674);
	__webpack_require__(675);
	__webpack_require__(676);
	__webpack_require__(657);
	__webpack_require__(349);
	__webpack_require__(352);
	__webpack_require__(353);
	__webpack_require__(712);
	__webpack_require__(701);
	__webpack_require__(702);
	__webpack_require__(707);
	__webpack_require__(710);
	__webpack_require__(711);
	__webpack_require__(705);
	__webpack_require__(708);
	__webpack_require__(706);
	__webpack_require__(709);
	__webpack_require__(703);
	__webpack_require__(704);
	__webpack_require__(658);
	__webpack_require__(659);
	__webpack_require__(660);
	__webpack_require__(661);
	__webpack_require__(662);
	__webpack_require__(665);
	__webpack_require__(663);
	__webpack_require__(664);
	__webpack_require__(666);
	__webpack_require__(667);
	__webpack_require__(668);
	__webpack_require__(669);
	__webpack_require__(671);
	__webpack_require__(670);
	__webpack_require__(715);
	__webpack_require__(713);
	__webpack_require__(714);
	__webpack_require__(756);
	__webpack_require__(759);
	__webpack_require__(758);
	__webpack_require__(760);
	__webpack_require__(761);
	__webpack_require__(757);
	__webpack_require__(762);
	__webpack_require__(763);
	__webpack_require__(737);
	__webpack_require__(740);
	__webpack_require__(736);
	__webpack_require__(734);
	__webpack_require__(735);
	__webpack_require__(738);
	__webpack_require__(739);
	__webpack_require__(721);
	__webpack_require__(755);
	__webpack_require__(720);
	__webpack_require__(754);
	__webpack_require__(766);
	__webpack_require__(768);
	__webpack_require__(719);
	__webpack_require__(753);
	__webpack_require__(765);
	__webpack_require__(767);
	__webpack_require__(718);
	__webpack_require__(764);
	__webpack_require__(717);
	__webpack_require__(722);
	__webpack_require__(723);
	__webpack_require__(724);
	__webpack_require__(725);
	__webpack_require__(726);
	__webpack_require__(728);
	__webpack_require__(727);
	__webpack_require__(729);
	__webpack_require__(730);
	__webpack_require__(731);
	__webpack_require__(733);
	__webpack_require__(732);
	__webpack_require__(742);
	__webpack_require__(743);
	__webpack_require__(744);
	__webpack_require__(745);
	__webpack_require__(747);
	__webpack_require__(746);
	__webpack_require__(749);
	__webpack_require__(748);
	__webpack_require__(750);
	__webpack_require__(751);
	__webpack_require__(752);
	__webpack_require__(716);
	__webpack_require__(741);
	__webpack_require__(771);
	__webpack_require__(770);
	__webpack_require__(769);
	module.exports = __webpack_require__(46);


/***/ }),
/* 773 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = __webpack_require__(797);
	var Queue = __webpack_require__(794);
	var util = __webpack_require__(13);
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	function _drainQueue(queue) {
	    while (queue.length() > 0) {
	        _drainQueueStep(queue);
	    }
	}
	
	function _drainQueueStep(queue) {
	    var fn = queue.shift();
	    if (typeof fn !== "function") {
	        fn._settlePromises();
	    } else {
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	}
	
	Async.prototype._drainQueues = function () {
	    _drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    _drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = __webpack_require__(790)();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = __webpack_require__(13);
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (true) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	    if (true) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = __webpack_require__(13);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise._isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent._isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            promise._setWillBeCancelled();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this._isCancellable()) return;
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype._isCancellable = function() {
	    return this.isPending() && !this._isCancelled();
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this._isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};


/***/ }),
/* 779 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = __webpack_require__(80).Warning;
	var util = __webpack_require__(13);
	var es5 = __webpack_require__(97);
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
	var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (false ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    var self = this;
	    setTimeout(function() {
	        self._notifyUnhandledRejection();
	    }, 1);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        if (typeof CustomEvent === "function") {
	            var event = new CustomEvent("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var eventData = {
	                    detail: event,
	                    cancelable: true
	                };
	                es5.defineProperty(
	                    eventData, "promise", {value: event.promise});
	                es5.defineProperty(eventData, "reason", {value: event.reason});
	                var domEvent = new CustomEvent(name.toLowerCase(), eventData);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else if (typeof Event === "function") {
	            var event = new Event("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new Event(name.toLowerCase(), {
	                    cancelable: true
	                });
	                domEvent.detail = event;
	                es5.defineProperty(domEvent, "promise", {value: event.promise});
	                es5.defineProperty(domEvent, "reason", {value: event.reason});
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else {
	            var event = document.createEvent("CustomEvent");
	            event.initCustomEvent("testingtheevent", false, true, {});
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = document.createEvent("CustomEvent");
	                domEvent.initCustomEvent(name.toLowerCase(), false, true,
	                    event);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        }
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	    return Promise;
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._dereferenceTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this._isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function longStackTracesDereferenceTrace() {
	    this._trace = undefined;
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var handlerLine = "";
	        var creatorLine = "";
	        if (promiseCreated._trace) {
	            var traceLines = promiseCreated._trace.stack.split("\n");
	            var stack = cleanStack(traceLines);
	            for (var i = stack.length - 1; i >= 0; --i) {
	                var line = stack[i];
	                if (!nodeFramePattern.test(line)) {
	                    var lineMatches = line.match(parseLinePattern);
	                    if (lineMatches) {
	                        handlerLine  = "at " + lineMatches[1] +
	                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
	                    }
	                    break;
	                }
	            }
	
	            if (stack.length > 0) {
	                var firstUserLine = stack[0];
	                for (var i = 0; i < traceLines.length; ++i) {
	
	                    if (traceLines[i] === firstUserLine) {
	                        if (i > 0) {
	                            creatorLine = "\n" + traceLines[i - 1];
	                        }
	                        break;
	                    }
	                }
	
	            }
	        }
	        var msg = "a promise was created in a " + name +
	            "handler " + handlerLine + "but was not returned from it, " +
	            "see http://goo.gl/rRqMUw" +
	            creatorLine;
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0 && error.name != "SyntaxError") {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = (firstLineError.stack || "").split("\n");
	    var lastStackLines = (lastLineError.stack || "").split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};


/***/ }),
/* 782 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	var PromiseAll = Promise.all;
	
	function promiseAllThis() {
	    return PromiseAll(this);
	}
	
	function PromiseMapSeries(promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
	}
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, this, undefined);
	};
	
	Promise.prototype.mapSeries = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, promises, undefined);
	};
	
	Promise.mapSeries = PromiseMapSeries;
	};
	


/***/ }),
/* 783 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
	var util = __webpack_require__(13);
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	var catchFilter = __webpack_require__(356)(NEXT_FILTER);
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret === NEXT_FILTER) {
	            return ret;
	        } else if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise._isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	Promise.prototype.tapCatch = function (handlerOrPredicate) {
	    var len = arguments.length;
	    if(len === 1) {
	        return this._passThrough(handlerOrPredicate,
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    } else {
	         var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(new TypeError(
	                    "tapCatch statement predicate: "
	                    + "expecting an object but got " + util.classString(item)
	                ));
	            }
	        }
	        catchInstances.length = j;
	        var handler = arguments[i];
	        return this._passThrough(catchFilter(catchInstances, handler, this),
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    }
	
	};
	
	return PassThroughHandlerContext;
	};


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise,
	                          Proxyable,
	                          debug) {
	var errors = __webpack_require__(80);
	var TypeError = errors.TypeError;
	var util = __webpack_require__(13);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    if (debug.cancellation()) {
	        var internal = new Promise(INTERNAL);
	        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
	        this._promise = internal.lastly(function() {
	            return _finallyPromise;
	        });
	        internal._captureStackTrace();
	        internal._setOnCancel(this);
	    } else {
	        var promise = this._promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	    }
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	    this._yieldedPromise = null;
	    this._cancellationPhase = false;
	}
	util.inherits(PromiseSpawn, Proxyable);
	
	PromiseSpawn.prototype._isResolved = function() {
	    return this._promise === null;
	};
	
	PromiseSpawn.prototype._cleanup = function() {
	    this._promise = this._generator = null;
	    if (debug.cancellation() && this._finallyPromise !== null) {
	        this._finallyPromise._fulfill();
	        this._finallyPromise = null;
	    }
	};
	
	PromiseSpawn.prototype._promiseCancelled = function() {
	    if (this._isResolved()) return;
	    var implementsReturn = typeof this._generator["return"] !== "undefined";
	
	    var result;
	    if (!implementsReturn) {
	        var reason = new Promise.CancellationError(
	            "generator .return() sentinel");
	        Promise.coroutine.returnSentinel = reason;
	        this._promise._attachExtraTrace(reason);
	        this._promise._pushContext();
	        result = tryCatch(this._generator["throw"]).call(this._generator,
	                                                         reason);
	        this._promise._popContext();
	    } else {
	        this._promise._pushContext();
	        result = tryCatch(this._generator["return"]).call(this._generator,
	                                                          undefined);
	        this._promise._popContext();
	    }
	    this._cancellationPhase = true;
	    this._yieldedPromise = null;
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseFulfilled = function(value) {
	    this._yieldedPromise = null;
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseRejected = function(reason) {
	    this._yieldedPromise = null;
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._resultCancelled = function() {
	    if (this._yieldedPromise instanceof Promise) {
	        var promise = this._yieldedPromise;
	        this._yieldedPromise = null;
	        promise.cancel();
	    }
	};
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._promiseFulfilled(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    var promise = this._promise;
	    if (result === errorObj) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._rejectCallback(result.e, false);
	        }
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._resolveCallback(value);
	        }
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._promiseRejected(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise = maybePromise._target();
	        var bitField = maybePromise._bitField;
	        ;
	        if (((bitField & 50397184) === 0)) {
	            this._yieldedPromise = maybePromise;
	            maybePromise._proxy(this, null);
	        } else if (((bitField & 33554432) !== 0)) {
	            Promise._async.invoke(
	                this._promiseFulfilled, this, maybePromise._value()
	            );
	        } else if (((bitField & 16777216) !== 0)) {
	            Promise._async.invoke(
	                this._promiseRejected, this, maybePromise._reason()
	            );
	        } else {
	            this._promiseCancelled();
	        }
	    }
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        var ret = spawn.promise();
	        spawn._generator = generator;
	        spawn._promiseFulfilled(undefined);
	        return ret;
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
	         getDomain) {
	var util = __webpack_require__(13);
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (true) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", "async", code)
	                           (tryCatch, errorObj, Promise, async);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (true) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                            holder.asyncNeeded = false;
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	
	                if (!ret._isFateSealed()) {
	                    if (holder.asyncNeeded) {
	                        var domain = getDomain();
	                        if (domain !== null) {
	                            holder.fn = util.domainBind(domain, holder.fn);
	                        }
	                    }
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];};
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(13);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : util.domainBind(domain, fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = [];
	    async.invoke(this._asyncInit, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	
	MappingPromiseArray.prototype._asyncInit = function() {
	    this._init$(undefined, -2);
	};
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	
	    if (index < 0) {
	        index = (index * -1) - 1;
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return true;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return false;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var promise = this._promise;
	        var callback = this._callback;
	        var receiver = promise._boundValue();
	        promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        var promiseCreated = promise._popContext();
	        debug.checkForgottenReturns(
	            ret,
	            promiseCreated,
	            preservedValues !== null ? "Promise.filter" : "Promise.map",
	            promise
	        );
	        if (ret === errorObj) {
	            this._reject(ret.e);
	            return true;
	        }
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            var bitField = maybePromise._bitField;
	            ;
	            if (((bitField & 50397184) === 0)) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = maybePromise;
	                maybePromise._proxy(this, (index + 1) * -1);
	                return false;
	            } else if (((bitField & 33554432) !== 0)) {
	                ret = maybePromise._value();
	            } else if (((bitField & 16777216) !== 0)) {
	                this._reject(maybePromise._reason());
	                return true;
	            } else {
	                this._cancel();
	                return true;
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	        return true;
	    }
	    return false;
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	
	    var limit = 0;
	    if (options !== undefined) {
	        if (typeof options === "object" && options !== null) {
	            if (typeof options.concurrency !== "number") {
	                return Promise.reject(
	                    new TypeError("'concurrency' must be a number but it is " +
	                                    util.classString(options.concurrency)));
	            }
	            limit = options.concurrency;
	        } else {
	            return Promise.reject(new TypeError(
	                            "options argument must be an object but it is " +
	                             util.classString(options)));
	        }
	    }
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
	}
	
	Promise.prototype.map = function (fn, options) {
	    return map(this, fn, options, null);
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    return map(promises, fn, options, _filter);
	};
	
	
	};


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = __webpack_require__(13);
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise) {
	var util = __webpack_require__(13);
	var async = Promise._async;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var newReason = new Error(reason + "");
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
	                                                                     options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = __webpack_require__(13);
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = __webpack_require__(97);
	var Async = __webpack_require__(774);
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = __webpack_require__(80);
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = __webpack_require__(801)(Promise, INTERNAL);
	var PromiseArray =
	    __webpack_require__(791)(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = __webpack_require__(779)(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = __webpack_require__(780)(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    __webpack_require__(784)(Promise, tryConvertToPromise, NEXT_FILTER);
	var catchFilter = __webpack_require__(356)(NEXT_FILTER);
	var nodebackForPromise = __webpack_require__(357);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (self == null || self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	
	}
	
	function Promise(executor) {
	    if (executor !== INTERNAL) {
	        check(this, executor);
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._resolveFromExecutor(executor);
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("Catch statement predicate: " +
	                    "expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	
	        if (typeof fn !== "function") {
	            throw new TypeError("The last argument to .catch() " +
	                "must be a function, got " + util.toString(fn));
	        }
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" &&
	                    util.domainBind(domain, handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setWillBeCancelled = function() {
	    this._bitField = this._bitField | 8388608;
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    if (executor === INTERNAL) return;
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	        this._dereferenceTrace();
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
	    es5.defineProperty(Promise.prototype, Symbol.toStringTag, {
	        get: function () {
	            return "Object";
	        }
	    });
	}
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	__webpack_require__(788)(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	__webpack_require__(775)(Promise, INTERNAL, tryConvertToPromise, debug);
	__webpack_require__(778)(Promise, PromiseArray, apiRejection, debug);
	__webpack_require__(781)(Promise);
	__webpack_require__(800)(Promise);
	__webpack_require__(786)(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
	Promise.Promise = Promise;
	Promise.version = "3.5.5";
	__webpack_require__(777)(Promise);
	__webpack_require__(785)(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
	__webpack_require__(787)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(789)(Promise);
	__webpack_require__(792)(Promise, INTERNAL);
	__webpack_require__(793)(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	__webpack_require__(795)(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	__webpack_require__(796)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(798)(Promise, PromiseArray, debug);
	__webpack_require__(799)(Promise, PromiseArray, apiRejection);
	__webpack_require__(802)(Promise, INTERNAL, debug);
	__webpack_require__(803)(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
	__webpack_require__(773)(Promise);
	__webpack_require__(782)(Promise, INTERNAL);
	__webpack_require__(783)(Promise, INTERNAL);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = __webpack_require__(13);
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    case -6: return new Map();
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise._isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = __webpack_require__(13);
	var nodebackForPromise = __webpack_require__(357);
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = __webpack_require__(80).TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (true) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn, _, multiArgs) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	    var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode);
	    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL",
	                        body)(
	                    Promise,
	                    fn,
	                    receiver,
	                    withAppended,
	                    maybeWrapAsError,
	                    nodebackForPromise,
	                    util.tryCatch,
	                    util.errorObj,
	                    util.notEnumerableProp,
	                    INTERNAL);
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise, multiArgs);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key,
	                                           fn, suffix, multiArgs);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver, multiArgs) {
	    return makeNodePromisified(callback, receiver, undefined,
	                                callback, null, multiArgs);
	}
	
	Promise.promisify = function (fn, options) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    options = Object(options);
	    var receiver = options.context === undefined ? THIS : options.context;
	    var multiArgs = !!options.multiArgs;
	    var ret = promisify(fn, receiver, multiArgs);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    options = Object(options);
	    var multiArgs = !!options.multiArgs;
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier,
	                multiArgs);
	            promisifyAll(value, suffix, filter, promisifier, multiArgs);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
	};
	};
	


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(13);
	var isObject = util.isObject;
	var es5 = __webpack_require__(97);
	var Es6Map;
	if (typeof Map === "function") Es6Map = Map;
	
	var mapToEntries = (function() {
	    var index = 0;
	    var size = 0;
	
	    function extractEntry(value, key) {
	        this[index] = value;
	        this[index + size] = key;
	        index++;
	    }
	
	    return function mapToEntries(map) {
	        size = map.size;
	        index = 0;
	        var ret = new Array(map.size * 2);
	        map.forEach(extractEntry, ret);
	        return ret;
	    };
	})();
	
	var entriesToMap = function(entries) {
	    var ret = new Es6Map();
	    var length = entries.length / 2 | 0;
	    for (var i = 0; i < length; ++i) {
	        var key = entries[length + i];
	        var value = entries[i];
	        ret.set(key, value);
	    }
	    return ret;
	};
	
	function PropertiesPromiseArray(obj) {
	    var isMap = false;
	    var entries;
	    if (Es6Map !== undefined && obj instanceof Es6Map) {
	        entries = mapToEntries(obj);
	        isMap = true;
	    } else {
	        var keys = es5.keys(obj);
	        var len = keys.length;
	        entries = new Array(len * 2);
	        for (var i = 0; i < len; ++i) {
	            var key = keys[i];
	            entries[i] = obj[key];
	            entries[i + len] = key;
	        }
	    }
	    this.constructor$(entries);
	    this._isMap = isMap;
	    this._init$(undefined, isMap ? -6 : -3);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val;
	        if (this._isMap) {
	            val = entriesToMap(this._values);
	        } else {
	            val = {};
	            var keyOffset = this.length();
	            for (var i = 0, len = this.length(); i < len; ++i) {
	                val[this._values[i + keyOffset]] = this._values[i];
	            }
	        }
	        this._resolve(val);
	        return true;
	    }
	    return false;
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 2);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};


/***/ }),
/* 794 */
/***/ (function(module, exports) {

	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(13);
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else {
	        promises = util.asArray(promises);
	        if (promises === null)
	            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 3);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(13);
	var tryCatch = util.tryCatch;
	
	function ReductionPromiseArray(promises, fn, initialValue, _each) {
	    this.constructor$(promises);
	    var domain = getDomain();
	    this._fn = domain === null ? fn : util.domainBind(domain, fn);
	    if (initialValue !== undefined) {
	        initialValue = Promise.resolve(initialValue);
	        initialValue._attachCancellationCallback(this);
	    }
	    this._initialValue = initialValue;
	    this._currentCancellable = null;
	    if(_each === INTERNAL) {
	        this._eachValues = Array(this._length);
	    } else if (_each === 0) {
	        this._eachValues = null;
	    } else {
	        this._eachValues = undefined;
	    }
	    this._promise._captureStackTrace();
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._gotAccum = function(accum) {
	    if (this._eachValues !== undefined && 
	        this._eachValues !== null && 
	        accum !== INTERNAL) {
	        this._eachValues.push(accum);
	    }
	};
	
	ReductionPromiseArray.prototype._eachComplete = function(value) {
	    if (this._eachValues !== null) {
	        this._eachValues.push(value);
	    }
	    return this._eachValues;
	};
	
	ReductionPromiseArray.prototype._init = function() {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function() {
	    this._resolve(this._eachValues !== undefined ? this._eachValues
	                                                 : this._initialValue);
	};
	
	ReductionPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	ReductionPromiseArray.prototype._resolve = function(value) {
	    this._promise._resolveCallback(value);
	    this._values = null;
	};
	
	ReductionPromiseArray.prototype._resultCancelled = function(sender) {
	    if (sender === this._initialValue) return this._cancel();
	    if (this._isResolved()) return;
	    this._resultCancelled$();
	    if (this._currentCancellable instanceof Promise) {
	        this._currentCancellable.cancel();
	    }
	    if (this._initialValue instanceof Promise) {
	        this._initialValue.cancel();
	    }
	};
	
	ReductionPromiseArray.prototype._iterate = function (values) {
	    this._values = values;
	    var value;
	    var i;
	    var length = values.length;
	    if (this._initialValue !== undefined) {
	        value = this._initialValue;
	        i = 0;
	    } else {
	        value = Promise.resolve(values[0]);
	        i = 1;
	    }
	
	    this._currentCancellable = value;
	
	    if (!value.isRejected()) {
	        for (; i < length; ++i) {
	            var ctx = {
	                accum: null,
	                value: values[i],
	                index: i,
	                length: length,
	                array: this
	            };
	            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
	        }
	    }
	
	    if (this._eachValues !== undefined) {
	        value = value
	            ._then(this._eachComplete, undefined, undefined, this, undefined);
	    }
	    value._then(completed, completed, undefined, value, this);
	};
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	
	function completed(valueOrReason, array) {
	    if (this.isFulfilled()) {
	        array._resolve(valueOrReason);
	    } else {
	        array._reject(valueOrReason);
	    }
	}
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	function gotAccum(accum) {
	    this.accum = accum;
	    this.array._gotAccum(accum);
	    var value = tryConvertToPromise(this.value, this.array._promise);
	    if (value instanceof Promise) {
	        this.array._currentCancellable = value;
	        return value._then(gotValue, undefined, undefined, this, undefined);
	    } else {
	        return gotValue.call(this, value);
	    }
	}
	
	function gotValue(value) {
	    var array = this.array;
	    var promise = array._promise;
	    var fn = tryCatch(array._fn);
	    promise._pushContext();
	    var ret;
	    if (array._eachValues !== undefined) {
	        ret = fn.call(promise._boundValue(), value, this.index, this.length);
	    } else {
	        ret = fn.call(promise._boundValue(),
	                              this.accum, value, this.index, this.length);
	    }
	    if (ret instanceof Promise) {
	        array._currentCancellable = ret;
	    }
	    var promiseCreated = promise._popContext();
	    debug.checkForgottenReturns(
	        ret,
	        promiseCreated,
	        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
	        promise
	    );
	    return ret;
	}
	};


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, setImmediate) {"use strict";
	var util = __webpack_require__(13);
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function" &&
	           typeof NativePromise.resolve === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            (window.navigator.standalone || window.cordova)) &&
	          ("classList" in document.documentElement)) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	            toggleScheduled = true;
	            div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(26), __webpack_require__(482).setImmediate))

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	    function(Promise, PromiseArray, debug) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = __webpack_require__(13);
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 33554432;
	    ret._settledValueField = value;
	    return this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 16777216;
	    ret._settledValueField = reason;
	    return this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    debug.deprecated(".settle()", ".reflect()");
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return Promise.settle(this);
	};
	};


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = __webpack_require__(13);
	var RangeError = __webpack_require__(80).RangeError;
	var AggregateError = __webpack_require__(80).AggregateError;
	var isArray = util.isArray;
	var CANCELLATION = {};
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	        return true;
	    }
	    return false;
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._promiseCancelled = function () {
	    if (this._values instanceof Promise || this._values == null) {
	        return this._cancel();
	    }
	    this._addRejected(CANCELLATION);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._checkOutcome = function() {
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            if (this._values[i] !== CANCELLATION) {
	                e.push(this._values[i]);
	            }
	        }
	        if (e.length > 0) {
	            this._reject(e);
	        } else {
	            this._cancel();
	        }
	        return true;
	    }
	    return false;
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};


/***/ }),
/* 800 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled = function() {
	    return (this._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.__isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype._isCancelled = function() {
	    return this._target().__isCancelled();
	};
	
	Promise.prototype.isCancelled = function() {
	    return (this._target()._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = __webpack_require__(13);
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, debug) {
	var util = __webpack_require__(13);
	var TimeoutError = Promise.TimeoutError;
	
	function HandleWrapper(handle)  {
	    this.handle = handle;
	}
	
	HandleWrapper.prototype._resultCancelled = function() {
	    clearTimeout(this.handle);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (ms, value) {
	    var ret;
	    var handle;
	    if (value !== undefined) {
	        ret = Promise.resolve(value)
	                ._then(afterValue, null, null, ms, undefined);
	        if (debug.cancellation() && value instanceof Promise) {
	            ret._setOnCancel(value);
	        }
	    } else {
	        ret = new Promise(INTERNAL);
	        handle = setTimeout(function() { ret._fulfill(); }, +ms);
	        if (debug.cancellation()) {
	            ret._setOnCancel(new HandleWrapper(handle));
	        }
	        ret._captureStackTrace();
	    }
	    ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(ms, this);
	};
	
	var afterTimeout = function (promise, message, parent) {
	    var err;
	    if (typeof message !== "string") {
	        if (message instanceof Error) {
	            err = message;
	        } else {
	            err = new TimeoutError("operation timed out");
	        }
	    } else {
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._reject(err);
	
	    if (parent != null) {
	        parent.cancel();
	    }
	};
	
	function successClear(value) {
	    clearTimeout(this.handle);
	    return value;
	}
	
	function failureClear(reason) {
	    clearTimeout(this.handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret, parent;
	
	    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
	        if (ret.isPending()) {
	            afterTimeout(ret, message, parent);
	        }
	    }, ms));
	
	    if (debug.cancellation()) {
	        parent = this.then();
	        ret = parent._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	        ret._setOnCancel(handleWrapper);
	    } else {
	        ret = this._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	    }
	
	    return ret;
	};
	
	};


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext, INTERNAL, debug) {
	    var util = __webpack_require__(13);
	    var TypeError = __webpack_require__(80).TypeError;
	    var inherits = __webpack_require__(13).inherits;
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var NULL = {};
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = new Promise(INTERNAL);
	        function iterator() {
	            if (i >= len) return ret._fulfill();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret;
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return NULL;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== NULL
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    function ResourceList(length) {
	        this.length = length;
	        this.promise = null;
	        this[length-1] = null;
	    }
	
	    ResourceList.prototype._resultCancelled = function() {
	        var len = this.length;
	        for (var i = 0; i < len; ++i) {
	            var item = this[i];
	            if (item instanceof Promise) {
	                item.cancel();
	            }
	        }
	    };
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new ResourceList(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var reflectedResources = new Array(resources.length);
	        for (var i = 0; i < reflectedResources.length; ++i) {
	            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
	        }
	
	        var resultPromise = Promise.all(reflectedResources)
	            .then(function(inspections) {
	                for (var i = 0; i < inspections.length; ++i) {
	                    var inspection = inspections[i];
	                    if (inspection.isRejected()) {
	                        errorObj.e = inspection.error();
	                        return errorObj;
	                    } else if (!inspection.isFulfilled()) {
	                        resultPromise.cancel();
	                        return;
	                    }
	                    inspections[i] = inspection.value();
	                }
	                promise._pushContext();
	
	                fn = tryCatch(fn);
	                var ret = spreadArgs
	                    ? fn.apply(undefined, inspections) : fn(inspections);
	                var promiseCreated = promise._popContext();
	                debug.checkForgottenReturns(
	                    ret, promiseCreated, "Promise.using", promise);
	                return ret;
	            });
	
	        var promise = resultPromise.lastly(function() {
	            var inspection = new Promise.PromiseInspection(resultPromise);
	            return dispose(resources, inspection);
	        });
	        resources.promise = promise;
	        promise._setOnCancel(resources);
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 131072;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 131072) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~131072);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};


/***/ }),
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var ReactIs = __webpack_require__(1020);
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextType: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromError: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var FORWARD_REF_STATICS = {
	    '$$typeof': true,
	    render: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true
	};
	
	var MEMO_STATICS = {
	    '$$typeof': true,
	    compare: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true,
	    type: true
	};
	
	var TYPE_STATICS = {};
	TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	function getStatics(component) {
	    if (ReactIs.isMemo(component)) {
	        return MEMO_STATICS;
	    }
	    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        var targetStatics = getStatics(targetComponent);
	        var sourceStatics = getStatics(sourceComponent);
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 845 */,
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1015);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */
/***/ (function(module, exports) {

	/** @license React v16.8.6
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1019);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(423);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(425);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(426);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(2);
	
	var _storeShape = __webpack_require__(425);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(1023);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(1024);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(426);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(266);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(844);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(846);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(64);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */
/***/ (function(module, exports) {

	'use strict';
	
	function thunkMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	  var getState = _ref.getState;
	
	  return function (next) {
	    return function (action) {
	      return typeof action === 'function' ? action(dispatch, getState) : next(action);
	    };
	  };
	}
	
	module.exports = thunkMiddleware;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(461);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(462);
	
	var _isPlainObject = __webpack_require__(266);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(463);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1088);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(73)(module)))

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1090 */,
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {(function() {
	    "use strict";
	    function $$route$recognizer$dsl$$Target(path, matcher, delegate) {
	      this.path = path;
	      this.matcher = matcher;
	      this.delegate = delegate;
	    }
	
	    $$route$recognizer$dsl$$Target.prototype = {
	      to: function(target, callback) {
	        var delegate = this.delegate;
	
	        if (delegate && delegate.willAddRoute) {
	          target = delegate.willAddRoute(this.matcher.target, target);
	        }
	
	        this.matcher.add(this.path, target);
	
	        if (callback) {
	          if (callback.length === 0) { throw new Error("You must have an argument in the function passed to `to`"); }
	          this.matcher.addChild(this.path, target, callback, this.delegate);
	        }
	        return this;
	      }
	    };
	
	    function $$route$recognizer$dsl$$Matcher(target) {
	      this.routes = {};
	      this.children = {};
	      this.target = target;
	    }
	
	    $$route$recognizer$dsl$$Matcher.prototype = {
	      add: function(path, handler) {
	        this.routes[path] = handler;
	      },
	
	      addChild: function(path, target, callback, delegate) {
	        var matcher = new $$route$recognizer$dsl$$Matcher(target);
	        this.children[path] = matcher;
	
	        var match = $$route$recognizer$dsl$$generateMatch(path, matcher, delegate);
	
	        if (delegate && delegate.contextEntered) {
	          delegate.contextEntered(target, match);
	        }
	
	        callback(match);
	      }
	    };
	
	    function $$route$recognizer$dsl$$generateMatch(startingPath, matcher, delegate) {
	      return function(path, nestedCallback) {
	        var fullPath = startingPath + path;
	
	        if (nestedCallback) {
	          nestedCallback($$route$recognizer$dsl$$generateMatch(fullPath, matcher, delegate));
	        } else {
	          return new $$route$recognizer$dsl$$Target(startingPath + path, matcher, delegate);
	        }
	      };
	    }
	
	    function $$route$recognizer$dsl$$addRoute(routeArray, path, handler) {
	      var len = 0;
	      for (var i=0; i<routeArray.length; i++) {
	        len += routeArray[i].path.length;
	      }
	
	      path = path.substr(len);
	      var route = { path: path, handler: handler };
	      routeArray.push(route);
	    }
	
	    function $$route$recognizer$dsl$$eachRoute(baseRoute, matcher, callback, binding) {
	      var routes = matcher.routes;
	
	      for (var path in routes) {
	        if (routes.hasOwnProperty(path)) {
	          var routeArray = baseRoute.slice();
	          $$route$recognizer$dsl$$addRoute(routeArray, path, routes[path]);
	
	          if (matcher.children[path]) {
	            $$route$recognizer$dsl$$eachRoute(routeArray, matcher.children[path], callback, binding);
	          } else {
	            callback.call(binding, routeArray);
	          }
	        }
	      }
	    }
	
	    var $$route$recognizer$dsl$$default = function(callback, addRouteCallback) {
	      var matcher = new $$route$recognizer$dsl$$Matcher();
	
	      callback($$route$recognizer$dsl$$generateMatch("", matcher, this.delegate));
	
	      $$route$recognizer$dsl$$eachRoute([], matcher, function(route) {
	        if (addRouteCallback) { addRouteCallback(this, route); }
	        else { this.add(route); }
	      }, this);
	    };
	
	    var $$route$recognizer$$specials = [
	      '/', '.', '*', '+', '?', '|',
	      '(', ')', '[', ']', '{', '}', '\\'
	    ];
	
	    var $$route$recognizer$$escapeRegex = new RegExp('(\\' + $$route$recognizer$$specials.join('|\\') + ')', 'g');
	
	    function $$route$recognizer$$isArray(test) {
	      return Object.prototype.toString.call(test) === "[object Array]";
	    }
	
	    // A Segment represents a segment in the original route description.
	    // Each Segment type provides an `eachChar` and `regex` method.
	    //
	    // The `eachChar` method invokes the callback with one or more character
	    // specifications. A character specification consumes one or more input
	    // characters.
	    //
	    // The `regex` method returns a regex fragment for the segment. If the
	    // segment is a dynamic of star segment, the regex fragment also includes
	    // a capture.
	    //
	    // A character specification contains:
	    //
	    // * `validChars`: a String with a list of all valid characters, or
	    // * `invalidChars`: a String with a list of all invalid characters
	    // * `repeat`: true if the character specification can repeat
	
	    function $$route$recognizer$$StaticSegment(string) { this.string = string; }
	    $$route$recognizer$$StaticSegment.prototype = {
	      eachChar: function(currentState) {
	        var string = this.string, ch;
	
	        for (var i=0; i<string.length; i++) {
	          ch = string.charAt(i);
	          currentState = currentState.put({ invalidChars: undefined, repeat: false, validChars: ch });
	        }
	
	        return currentState;
	      },
	
	      regex: function() {
	        return this.string.replace($$route$recognizer$$escapeRegex, '\\$1');
	      },
	
	      generate: function() {
	        return this.string;
	      }
	    };
	
	    function $$route$recognizer$$DynamicSegment(name) { this.name = name; }
	    $$route$recognizer$$DynamicSegment.prototype = {
	      eachChar: function(currentState) {
	        return currentState.put({ invalidChars: "/", repeat: true, validChars: undefined });
	      },
	
	      regex: function() {
	        return "([^/]+)";
	      },
	
	      generate: function(params) {
	        return params[this.name];
	      }
	    };
	
	    function $$route$recognizer$$StarSegment(name) { this.name = name; }
	    $$route$recognizer$$StarSegment.prototype = {
	      eachChar: function(currentState) {
	        return currentState.put({ invalidChars: "", repeat: true, validChars: undefined });
	      },
	
	      regex: function() {
	        return "(.+)";
	      },
	
	      generate: function(params) {
	        return params[this.name];
	      }
	    };
	
	    function $$route$recognizer$$EpsilonSegment() {}
	    $$route$recognizer$$EpsilonSegment.prototype = {
	      eachChar: function(currentState) {
	        return currentState;
	      },
	      regex: function() { return ""; },
	      generate: function() { return ""; }
	    };
	
	    function $$route$recognizer$$parse(route, names, specificity) {
	      // normalize route as not starting with a "/". Recognition will
	      // also normalize.
	      if (route.charAt(0) === "/") { route = route.substr(1); }
	
	      var segments = route.split("/");
	      var results = new Array(segments.length);
	
	      // A routes has specificity determined by the order that its different segments
	      // appear in. This system mirrors how the magnitude of numbers written as strings
	      // works.
	      // Consider a number written as: "abc". An example would be "200". Any other number written
	      // "xyz" will be smaller than "abc" so long as `a > z`. For instance, "199" is smaller
	      // then "200", even though "y" and "z" (which are both 9) are larger than "0" (the value
	      // of (`b` and `c`). This is because the leading symbol, "2", is larger than the other
	      // leading symbol, "1".
	      // The rule is that symbols to the left carry more weight than symbols to the right
	      // when a number is written out as a string. In the above strings, the leading digit
	      // represents how many 100's are in the number, and it carries more weight than the middle
	      // number which represents how many 10's are in the number.
	      // This system of number magnitude works well for route specificity, too. A route written as
	      // `a/b/c` will be more specific than `x/y/z` as long as `a` is more specific than
	      // `x`, irrespective of the other parts.
	      // Because of this similarity, we assign each type of segment a number value written as a
	      // string. We can find the specificity of compound routes by concatenating these strings
	      // together, from left to right. After we have looped through all of the segments,
	      // we convert the string to a number.
	      specificity.val = '';
	
	      for (var i=0; i<segments.length; i++) {
	        var segment = segments[i], match;
	
	        if (match = segment.match(/^:([^\/]+)$/)) {
	          results[i] = new $$route$recognizer$$DynamicSegment(match[1]);
	          names.push(match[1]);
	          specificity.val += '3';
	        } else if (match = segment.match(/^\*([^\/]+)$/)) {
	          results[i] = new $$route$recognizer$$StarSegment(match[1]);
	          specificity.val += '1';
	          names.push(match[1]);
	        } else if(segment === "") {
	          results[i] = new $$route$recognizer$$EpsilonSegment();
	          specificity.val += '2';
	        } else {
	          results[i] = new $$route$recognizer$$StaticSegment(segment);
	          specificity.val += '4';
	        }
	      }
	
	      specificity.val = +specificity.val;
	
	      return results;
	    }
	
	    // A State has a character specification and (`charSpec`) and a list of possible
	    // subsequent states (`nextStates`).
	    //
	    // If a State is an accepting state, it will also have several additional
	    // properties:
	    //
	    // * `regex`: A regular expression that is used to extract parameters from paths
	    //   that reached this accepting state.
	    // * `handlers`: Information on how to convert the list of captures into calls
	    //   to registered handlers with the specified parameters
	    // * `types`: How many static, dynamic or star segments in this route. Used to
	    //   decide which route to use if multiple registered routes match a path.
	    //
	    // Currently, State is implemented naively by looping over `nextStates` and
	    // comparing a character specification against a character. A more efficient
	    // implementation would use a hash of keys pointing at one or more next states.
	
	    function $$route$recognizer$$State(charSpec) {
	      this.charSpec = charSpec;
	      this.nextStates = [];
	      this.charSpecs = {};
	      this.regex = undefined;
	      this.handlers = undefined;
	      this.specificity = undefined;
	    }
	
	    $$route$recognizer$$State.prototype = {
	      get: function(charSpec) {
	        if (this.charSpecs[charSpec.validChars]) {
	          return this.charSpecs[charSpec.validChars];
	        }
	
	        var nextStates = this.nextStates;
	
	        for (var i=0; i<nextStates.length; i++) {
	          var child = nextStates[i];
	
	          var isEqual = child.charSpec.validChars === charSpec.validChars;
	          isEqual = isEqual && child.charSpec.invalidChars === charSpec.invalidChars;
	
	          if (isEqual) {
	            this.charSpecs[charSpec.validChars] = child;
	            return child;
	          }
	        }
	      },
	
	      put: function(charSpec) {
	        var state;
	
	        // If the character specification already exists in a child of the current
	        // state, just return that state.
	        if (state = this.get(charSpec)) { return state; }
	
	        // Make a new state for the character spec
	        state = new $$route$recognizer$$State(charSpec);
	
	        // Insert the new state as a child of the current state
	        this.nextStates.push(state);
	
	        // If this character specification repeats, insert the new state as a child
	        // of itself. Note that this will not trigger an infinite loop because each
	        // transition during recognition consumes a character.
	        if (charSpec.repeat) {
	          state.nextStates.push(state);
	        }
	
	        // Return the new state
	        return state;
	      },
	
	      // Find a list of child states matching the next character
	      match: function(ch) {
	        var nextStates = this.nextStates,
	            child, charSpec, chars;
	
	        var returned = [];
	
	        for (var i=0; i<nextStates.length; i++) {
	          child = nextStates[i];
	
	          charSpec = child.charSpec;
	
	          if (typeof (chars = charSpec.validChars) !== 'undefined') {
	            if (chars.indexOf(ch) !== -1) { returned.push(child); }
	          } else if (typeof (chars = charSpec.invalidChars) !== 'undefined') {
	            if (chars.indexOf(ch) === -1) { returned.push(child); }
	          }
	        }
	
	        return returned;
	      }
	    };
	
	    // Sort the routes by specificity
	    function $$route$recognizer$$sortSolutions(states) {
	      return states.sort(function(a, b) {
	        return b.specificity.val - a.specificity.val;
	      });
	    }
	
	    function $$route$recognizer$$recognizeChar(states, ch) {
	      var nextStates = [];
	
	      for (var i=0, l=states.length; i<l; i++) {
	        var state = states[i];
	
	        nextStates = nextStates.concat(state.match(ch));
	      }
	
	      return nextStates;
	    }
	
	    var $$route$recognizer$$oCreate = Object.create || function(proto) {
	      function F() {}
	      F.prototype = proto;
	      return new F();
	    };
	
	    function $$route$recognizer$$RecognizeResults(queryParams) {
	      this.queryParams = queryParams || {};
	    }
	    $$route$recognizer$$RecognizeResults.prototype = $$route$recognizer$$oCreate({
	      splice: Array.prototype.splice,
	      slice:  Array.prototype.slice,
	      push:   Array.prototype.push,
	      length: 0,
	      queryParams: null
	    });
	
	    function $$route$recognizer$$findHandler(state, path, queryParams) {
	      var handlers = state.handlers, regex = state.regex;
	      var captures = path.match(regex), currentCapture = 1;
	      var result = new $$route$recognizer$$RecognizeResults(queryParams);
	
	      result.length = handlers.length;
	
	      for (var i=0; i<handlers.length; i++) {
	        var handler = handlers[i], names = handler.names, params = {};
	
	        for (var j=0; j<names.length; j++) {
	          params[names[j]] = captures[currentCapture++];
	        }
	
	        result[i] = { handler: handler.handler, params: params, isDynamic: !!names.length };
	      }
	
	      return result;
	    }
	
	    function $$route$recognizer$$decodeQueryParamPart(part) {
	      // http://www.w3.org/TR/html401/interact/forms.html#h-17.13.4.1
	      part = part.replace(/\+/gm, '%20');
	      var result;
	      try {
	        result = decodeURIComponent(part);
	      } catch(error) {result = '';}
	      return result;
	    }
	
	    // The main interface
	
	    var $$route$recognizer$$RouteRecognizer = function() {
	      this.rootState = new $$route$recognizer$$State();
	      this.names = {};
	    };
	
	
	    $$route$recognizer$$RouteRecognizer.prototype = {
	      add: function(routes, options) {
	        var currentState = this.rootState, regex = "^",
	            specificity = {},
	            handlers = new Array(routes.length), allSegments = [], name;
	
	        var isEmpty = true;
	
	        for (var i=0; i<routes.length; i++) {
	          var route = routes[i], names = [];
	
	          var segments = $$route$recognizer$$parse(route.path, names, specificity);
	
	          allSegments = allSegments.concat(segments);
	
	          for (var j=0; j<segments.length; j++) {
	            var segment = segments[j];
	
	            if (segment instanceof $$route$recognizer$$EpsilonSegment) { continue; }
	
	            isEmpty = false;
	
	            // Add a "/" for the new segment
	            currentState = currentState.put({ invalidChars: undefined, repeat: false, validChars: "/" });
	            regex += "/";
	
	            // Add a representation of the segment to the NFA and regex
	            currentState = segment.eachChar(currentState);
	            regex += segment.regex();
	          }
	          var handler = { handler: route.handler, names: names };
	          handlers[i] = handler;
	        }
	
	        if (isEmpty) {
	          currentState = currentState.put({ invalidChars: undefined, repeat: false, validChars: "/" });
	          regex += "/";
	        }
	
	        currentState.handlers = handlers;
	        currentState.regex = new RegExp(regex + "$");
	        currentState.specificity = specificity;
	
	        if (name = options && options.as) {
	          this.names[name] = {
	            segments: allSegments,
	            handlers: handlers
	          };
	        }
	      },
	
	      handlersFor: function(name) {
	        var route = this.names[name];
	
	        if (!route) { throw new Error("There is no route named " + name); }
	
	        var result = new Array(route.handlers.length);
	
	        for (var i=0; i<route.handlers.length; i++) {
	          result[i] = route.handlers[i];
	        }
	
	        return result;
	      },
	
	      hasRoute: function(name) {
	        return !!this.names[name];
	      },
	
	      generate: function(name, params) {
	        var route = this.names[name], output = "";
	        if (!route) { throw new Error("There is no route named " + name); }
	
	        var segments = route.segments;
	
	        for (var i=0; i<segments.length; i++) {
	          var segment = segments[i];
	
	          if (segment instanceof $$route$recognizer$$EpsilonSegment) { continue; }
	
	          output += "/";
	          output += segment.generate(params);
	        }
	
	        if (output.charAt(0) !== '/') { output = '/' + output; }
	
	        if (params && params.queryParams) {
	          output += this.generateQueryString(params.queryParams, route.handlers);
	        }
	
	        return output;
	      },
	
	      generateQueryString: function(params, handlers) {
	        var pairs = [];
	        var keys = [];
	        for(var key in params) {
	          if (params.hasOwnProperty(key)) {
	            keys.push(key);
	          }
	        }
	        keys.sort();
	        for (var i = 0; i < keys.length; i++) {
	          key = keys[i];
	          var value = params[key];
	          if (value == null) {
	            continue;
	          }
	          var pair = encodeURIComponent(key);
	          if ($$route$recognizer$$isArray(value)) {
	            for (var j = 0; j < value.length; j++) {
	              var arrayPair = key + '[]' + '=' + encodeURIComponent(value[j]);
	              pairs.push(arrayPair);
	            }
	          } else {
	            pair += "=" + encodeURIComponent(value);
	            pairs.push(pair);
	          }
	        }
	
	        if (pairs.length === 0) { return ''; }
	
	        return "?" + pairs.join("&");
	      },
	
	      parseQueryString: function(queryString) {
	        var pairs = queryString.split("&"), queryParams = {};
	        for(var i=0; i < pairs.length; i++) {
	          var pair      = pairs[i].split('='),
	              key       = $$route$recognizer$$decodeQueryParamPart(pair[0]),
	              keyLength = key.length,
	              isArray = false,
	              value;
	          if (pair.length === 1) {
	            value = 'true';
	          } else {
	            //Handle arrays
	            if (keyLength > 2 && key.slice(keyLength -2) === '[]') {
	              isArray = true;
	              key = key.slice(0, keyLength - 2);
	              if(!queryParams[key]) {
	                queryParams[key] = [];
	              }
	            }
	            value = pair[1] ? $$route$recognizer$$decodeQueryParamPart(pair[1]) : '';
	          }
	          if (isArray) {
	            queryParams[key].push(value);
	          } else {
	            queryParams[key] = value;
	          }
	        }
	        return queryParams;
	      },
	
	      recognize: function(path) {
	        var states = [ this.rootState ],
	            pathLen, i, l, queryStart, queryParams = {},
	            isSlashDropped = false;
	
	        queryStart = path.indexOf('?');
	        if (queryStart !== -1) {
	          var queryString = path.substr(queryStart + 1, path.length);
	          path = path.substr(0, queryStart);
	          queryParams = this.parseQueryString(queryString);
	        }
	
	        path = decodeURI(path);
	
	        if (path.charAt(0) !== "/") { path = "/" + path; }
	
	        pathLen = path.length;
	        if (pathLen > 1 && path.charAt(pathLen - 1) === "/") {
	          path = path.substr(0, pathLen - 1);
	          isSlashDropped = true;
	        }
	
	        for (i=0; i<path.length; i++) {
	          states = $$route$recognizer$$recognizeChar(states, path.charAt(i));
	          if (!states.length) { break; }
	        }
	
	        var solutions = [];
	        for (i=0; i<states.length; i++) {
	          if (states[i].handlers) { solutions.push(states[i]); }
	        }
	
	        states = $$route$recognizer$$sortSolutions(solutions);
	
	        var state = solutions[0];
	
	        if (state && state.handlers) {
	          // if a trailing slash was dropped and a star segment is the last segment
	          // specified, put the trailing slash back
	          if (isSlashDropped && state.regex.source.slice(-5) === "(.+)$") {
	            path = path + "/";
	          }
	          return $$route$recognizer$$findHandler(state, path, queryParams);
	        }
	      }
	    };
	
	    $$route$recognizer$$RouteRecognizer.prototype.map = $$route$recognizer$dsl$$default;
	
	    $$route$recognizer$$RouteRecognizer.VERSION = '0.1.11';
	
	    var $$route$recognizer$$default = $$route$recognizer$$RouteRecognizer;
	
	    /* global define:true module:true window: true */
	    if ("function" === 'function' && __webpack_require__(487)['amd']) {
	      !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return $$route$recognizer$$default; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined' && module['exports']) {
	      module['exports'] = $$route$recognizer$$default;
	    } else if (typeof this !== 'undefined') {
	      this['RouteRecognizer'] = $$route$recognizer$$default;
	    }
	}).call(this);
	
	//# sourceMappingURL=route-recognizer.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)(module)))

/***/ }),
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__( 1157 );

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	// Copyright 2014 Google Inc. All rights reserved
	//
	// Use of this source code is governed by a BSD-style
	// license that can be found in the LICENSE file or at
	// https://developers.google.com/open-source/licenses/bsd
	
	/**
	 * @fileoverview The U2F api.
	 */
	
	'use strict';
	
	/** Namespace for the U2F api.
	 * @type {Object}
	 */
	var u2f = u2f || {};
	
	module.exports = u2f; // Adaptation for u2f-api package
	
	/**
	 * The U2F extension id
	 * @type {string}
	 * @const
	 */
	u2f.EXTENSION_ID = 'kmendfapggjehodndflmmgagdbamhnfd';
	
	/**
	 * Message types for messsages to/from the extension
	 * @const
	 * @enum {string}
	 */
	u2f.MessageTypes = {
	  'U2F_REGISTER_REQUEST': 'u2f_register_request',
	  'U2F_SIGN_REQUEST': 'u2f_sign_request',
	  'U2F_REGISTER_RESPONSE': 'u2f_register_response',
	  'U2F_SIGN_RESPONSE': 'u2f_sign_response'
	};
	
	/**
	 * Response status codes
	 * @const
	 * @enum {number}
	 */
	u2f.ErrorCodes = {
	  'OK': 0,
	  'OTHER_ERROR': 1,
	  'BAD_REQUEST': 2,
	  'CONFIGURATION_UNSUPPORTED': 3,
	  'DEVICE_INELIGIBLE': 4,
	  'TIMEOUT': 5
	};
	
	/**
	 * A message type for registration requests
	 * @typedef {{
	 *   type: u2f.MessageTypes,
	 *   signRequests: Array.<u2f.SignRequest>,
	 *   registerRequests: ?Array.<u2f.RegisterRequest>,
	 *   timeoutSeconds: ?number,
	 *   requestId: ?number
	 * }}
	 */
	u2f.Request;
	
	/**
	 * A message for registration responses
	 * @typedef {{
	 *   type: u2f.MessageTypes,
	 *   responseData: (u2f.Error | u2f.RegisterResponse | u2f.SignResponse),
	 *   requestId: ?number
	 * }}
	 */
	u2f.Response;
	
	/**
	 * An error object for responses
	 * @typedef {{
	 *   errorCode: u2f.ErrorCodes,
	 *   errorMessage: ?string
	 * }}
	 */
	u2f.Error;
	
	/**
	 * Data object for a single sign request.
	 * @typedef {{
	 *   version: string,
	 *   challenge: string,
	 *   keyHandle: string,
	 *   appId: string
	 * }}
	 */
	u2f.SignRequest;
	
	/**
	 * Data object for a sign response.
	 * @typedef {{
	 *   keyHandle: string,
	 *   signatureData: string,
	 *   clientData: string
	 * }}
	 */
	u2f.SignResponse;
	
	/**
	 * Data object for a registration request.
	 * @typedef {{
	 *   version: string,
	 *   challenge: string,
	 *   appId: string
	 * }}
	 */
	u2f.RegisterRequest;
	
	/**
	 * Data object for a registration response.
	 * @typedef {{
	 *   registrationData: string,
	 *   clientData: string
	 * }}
	 */
	u2f.RegisterResponse;
	
	
	// Low level MessagePort API support
	
	/**
	 * Call MessagePort disconnect
	 */
	u2f.disconnect = function() {
	  if (u2f.port_ && u2f.port_.port_) {
	    u2f.port_.port_.disconnect();
	    u2f.port_ = null;
	  }
	};
	
	/**
	 * Sets up a MessagePort to the U2F extension using the
	 * available mechanisms.
	 * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
	 */
	u2f.getMessagePort = function(callback) {
	  if (typeof chrome != 'undefined' && chrome.runtime) {
	    // The actual message here does not matter, but we need to get a reply
	    // for the callback to run. Thus, send an empty signature request
	    // in order to get a failure response.
	    var msg = {
	      type: u2f.MessageTypes.U2F_SIGN_REQUEST,
	      signRequests: []
	    };
	    chrome.runtime.sendMessage(u2f.EXTENSION_ID, msg, function() {
	      if (!chrome.runtime.lastError) {
	        // We are on a whitelisted origin and can talk directly
	        // with the extension.
	        u2f.getChromeRuntimePort_(callback);
	      } else {
	        // chrome.runtime was available, but we couldn't message
	        // the extension directly, use iframe
	        u2f.getIframePort_(callback);
	      }
	    });
	  } else {
	    // chrome.runtime was not available at all, which is normal
	    // when this origin doesn't have access to any extensions.
	    u2f.getIframePort_(callback);
	  }
	};
	
	/**
	 * Connects directly to the extension via chrome.runtime.connect
	 * @param {function(u2f.WrappedChromeRuntimePort_)} callback
	 * @private
	 */
	u2f.getChromeRuntimePort_ = function(callback) {
	  var port = chrome.runtime.connect(u2f.EXTENSION_ID,
	    {'includeTlsChannelId': true});
	  setTimeout(function() {
	    callback(null, new u2f.WrappedChromeRuntimePort_(port));
	  }, 0);
	};
	
	/**
	 * A wrapper for chrome.runtime.Port that is compatible with MessagePort.
	 * @param {Port} port
	 * @constructor
	 * @private
	 */
	u2f.WrappedChromeRuntimePort_ = function(port) {
	  this.port_ = port;
	};
	
	/**
	 * Posts a message on the underlying channel.
	 * @param {Object} message
	 */
	u2f.WrappedChromeRuntimePort_.prototype.postMessage = function(message) {
	  this.port_.postMessage(message);
	};
	
	/**
	 * Emulates the HTML 5 addEventListener interface. Works only for the
	 * onmessage event, which is hooked up to the chrome.runtime.Port.onMessage.
	 * @param {string} eventName
	 * @param {function({data: Object})} handler
	 */
	u2f.WrappedChromeRuntimePort_.prototype.addEventListener =
	    function(eventName, handler) {
	  var name = eventName.toLowerCase();
	  if (name == 'message' || name == 'onmessage') {
	    this.port_.onMessage.addListener(function(message) {
	      // Emulate a minimal MessageEvent object
	      handler({'data': message});
	    });
	  } else {
	    console.error('WrappedChromeRuntimePort only supports onMessage');
	  }
	};
	
	/**
	 * Sets up an embedded trampoline iframe, sourced from the extension.
	 * @param {function(MessagePort)} callback
	 * @private
	 */
	u2f.getIframePort_ = function(callback) {
	  // Create the iframe
	  var iframeOrigin = 'chrome-extension://' + u2f.EXTENSION_ID;
	  var iframe = document.createElement('iframe');
	  iframe.src = iframeOrigin + '/u2f-comms.html';
	  iframe.setAttribute('style', 'display:none');
	  document.body.appendChild(iframe);
	
	  var hasCalledBack = false;
	
	  var channel = new MessageChannel();
	  var ready = function(message) {
	    if (message.data == 'ready') {
	      channel.port1.removeEventListener('message', ready);
	      if (!hasCalledBack)
	      {
	        hasCalledBack = true;
	        callback(null, channel.port1);
	      }
	    } else {
	      console.error('First event on iframe port was not "ready"');
	    }
	  };
	  channel.port1.addEventListener('message', ready);
	  channel.port1.start();
	
	  iframe.addEventListener('load', function() {
	    // Deliver the port to the iframe and initialize
	    iframe.contentWindow.postMessage('init', iframeOrigin, [channel.port2]);
	  });
	
	  // Give this 200ms to initialize, after that, we treat this method as failed
	  setTimeout(function() {
	    if (!hasCalledBack)
	    {
	      hasCalledBack = true;
	      callback(new Error("IFrame extension not supported"));
	    }
	  }, 200);
	};
	
	
	// High-level JS API
	
	/**
	 * Default extension response timeout in seconds.
	 * @const
	 */
	u2f.EXTENSION_TIMEOUT_SEC = 30;
	
	/**
	 * A singleton instance for a MessagePort to the extension.
	 * @type {MessagePort|u2f.WrappedChromeRuntimePort_}
	 * @private
	 */
	u2f.port_ = null;
	
	/**
	 * Callbacks waiting for a port
	 * @type {Array.<function((MessagePort|u2f.WrappedChromeRuntimePort_))>}
	 * @private
	 */
	u2f.waitingForPort_ = [];
	
	/**
	 * A counter for requestIds.
	 * @type {number}
	 * @private
	 */
	u2f.reqCounter_ = 0;
	
	/**
	 * A map from requestIds to client callbacks
	 * @type {Object.<number,(function((u2f.Error|u2f.RegisterResponse))
	 *                       |function((u2f.Error|u2f.SignResponse)))>}
	 * @private
	 */
	u2f.callbackMap_ = {};
	
	/**
	 * Creates or retrieves the MessagePort singleton to use.
	 * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
	 * @private
	 */
	u2f.getPortSingleton_ = function(callback) {
	  if (u2f.port_) {
	    callback(null, u2f.port_);
	  } else {
	    if (u2f.waitingForPort_.length == 0) {
	      u2f.getMessagePort(function(err, port) {
	        if (!err) {
	          u2f.port_ = port;
	          u2f.port_.addEventListener('message',
	            /** @type {function(Event)} */ (u2f.responseHandler_));
	        }
	
	        // Careful, here be async callbacks. Maybe.
	        while (u2f.waitingForPort_.length)
	          u2f.waitingForPort_.shift()(err, port);
	      });
	    }
	    u2f.waitingForPort_.push(callback);
	  }
	};
	
	/**
	 * Handles response messages from the extension.
	 * @param {MessageEvent.<u2f.Response>} message
	 * @private
	 */
	u2f.responseHandler_ = function(message) {
	  var response = message.data;
	  var reqId = response['requestId'];
	  if (!reqId || !u2f.callbackMap_[reqId]) {
	    console.error('Unknown or missing requestId in response.');
	    return;
	  }
	  var cb = u2f.callbackMap_[reqId];
	  delete u2f.callbackMap_[reqId];
	  cb(null, response['responseData']);
	};
	
	/**
	 * Calls the callback with true or false as first and only argument
	 * @param {Function} callback
	 */
	u2f.isSupported = function(callback) {
	  u2f.getPortSingleton_(function(err, port) {
	    callback(!err);
	  });
	}
	
	/**
	 * Dispatches an array of sign requests to available U2F tokens.
	 * @param {Array.<u2f.SignRequest>} signRequests
	 * @param {function((u2f.Error|u2f.SignResponse))} callback
	 * @param {number=} opt_timeoutSeconds
	 */
	u2f.sign = function(signRequests, callback, opt_timeoutSeconds) {
	  u2f.getPortSingleton_(function(err, port) {
	    if (err)
	      return callback(err);
	
	    var reqId = ++u2f.reqCounter_;
	    u2f.callbackMap_[reqId] = callback;
	    var req = {
	      type: u2f.MessageTypes.U2F_SIGN_REQUEST,
	      signRequests: signRequests,
	      timeoutSeconds: (typeof opt_timeoutSeconds !== 'undefined' ?
	        opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC),
	      requestId: reqId
	    };
	    port.postMessage(req);
	  });
	};
	
	/**
	 * Dispatches register requests to available U2F tokens. An array of sign
	 * requests identifies already registered tokens.
	 * @param {Array.<u2f.RegisterRequest>} registerRequests
	 * @param {Array.<u2f.SignRequest>} signRequests
	 * @param {function((u2f.Error|u2f.RegisterResponse))} callback
	 * @param {number=} opt_timeoutSeconds
	 */
	u2f.register = function(registerRequests, signRequests,
	    callback, opt_timeoutSeconds) {
	  u2f.getPortSingleton_(function(err, port) {
	    if (err)
	      return callback(err);
	
	    var reqId = ++u2f.reqCounter_;
	    u2f.callbackMap_[reqId] = callback;
	    var req = {
	      type: u2f.MessageTypes.U2F_REGISTER_REQUEST,
	      signRequests: signRequests,
	      registerRequests: registerRequests,
	      timeoutSeconds: (typeof opt_timeoutSeconds !== 'undefined' ?
	        opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC),
	      requestId: reqId
	    };
	    port.postMessage(req);
	  });
	};


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	module.exports = API;
	
	var chromeApi = __webpack_require__( 1156 );
	
	// Feature detection (yes really)
	var isBrowser = ( typeof navigator !== 'undefined' ) && !!navigator.userAgent;
	var isSafari = isBrowser && navigator.userAgent.match( /Safari\// )
		&& !navigator.userAgent.match( /Chrome\// );
	var isEDGE = isBrowser && navigator.userAgent.match( /Edge\/1[2345]/ );
	
	var _backend = null;
	function getBackend( Promise )
	{
		if ( !_backend )
			_backend = new Promise( function( resolve, reject )
			{
				function notSupported( )
				{
					// Note; {native: true} means *not* using Google's hack
					resolve( { u2f: null, native: true } );
				}
	
				if ( !isBrowser )
					return notSupported( );
	
				if ( isSafari )
					// Safari doesn't support U2F, and the Safari-FIDO-U2F
					// extension lacks full support (Multi-facet apps), so we
					// block it until proper support.
					return notSupported( );
	
				var hasNativeSupport =
					( typeof window.u2f !== 'undefined' ) &&
					( typeof window.u2f.sign === 'function' );
	
				if ( hasNativeSupport )
					resolve( { u2f: window.u2f, native: true } );
	
				if ( isEDGE )
					// We don't want to check for Google's extension hack on EDGE
					// as it'll cause trouble (popups, etc)
					return notSupported( );
	
				if ( location.protocol === 'http:' )
					// U2F isn't supported over http, only https
					return notSupported( );
	
				if ( typeof MessageChannel === 'undefined' )
					// Unsupported browser, the chrome hack would throw
					return notSupported( );
	
				// Test for google extension support
				chromeApi.isSupported( function( ok )
				{
					if ( ok )
						resolve( { u2f: chromeApi, native: false } );
					else
						notSupported( );
				} );
			} );
	
		return _backend;
	}
	
	function API( Promise )
	{
		return {
			isSupported   : isSupported.bind( Promise ),
			ensureSupport : ensureSupport.bind( Promise ),
			register      : register.bind( Promise ),
			sign          : sign.bind( Promise ),
			ErrorCodes    : API.ErrorCodes,
			ErrorNames    : API.ErrorNames
		};
	}
	
	API.ErrorCodes = {
		CANCELLED: -1,
		OK: 0,
		OTHER_ERROR: 1,
		BAD_REQUEST: 2,
		CONFIGURATION_UNSUPPORTED: 3,
		DEVICE_INELIGIBLE: 4,
		TIMEOUT: 5
	};
	API.ErrorNames = {
		"-1": "CANCELLED",
		"0": "OK",
		"1": "OTHER_ERROR",
		"2": "BAD_REQUEST",
		"3": "CONFIGURATION_UNSUPPORTED",
		"4": "DEVICE_INELIGIBLE",
		"5": "TIMEOUT"
	};
	
	function makeError( msg, err )
	{
		var code = err != null ? err.errorCode : 1; // Default to OTHER_ERROR
		var type = API.ErrorNames[ '' + code ];
		var error = new Error( msg );
		error.metaData = {
			type: type,
			code: code
		}
		return error;
	}
	
	function deferPromise( Promise, promise )
	{
		var ret = { };
		ret.promise = new Promise( function( resolve, reject ) {
			ret.resolve = resolve;
			ret.reject = reject;
			promise.then( resolve, reject );
		} );
		/**
		 * Reject request promise and disconnect port if 'disconnect' flag is true
		 * @param {string} msg
		 * @param {boolean} disconnect
		 */
		ret.promise.cancel = function( msg, disconnect )
		{
			getBackend( Promise )
			.then( function( backend )
			{
				if ( disconnect && !backend.native )
					backend.u2f.disconnect( );
	
				ret.reject( makeError( msg, { errorCode: -1 } ) );
			} );
		};
		return ret;
	}
	
	function defer( Promise, fun )
	{
		return deferPromise( Promise, new Promise( function( resolve, reject )
		{
			try
			{
				fun && fun( resolve, reject );
			}
			catch ( err )
			{
				reject( err );
			}
		} ) );
	}
	
	function isSupported( )
	{
		var Promise = this;
	
		return getBackend( Promise )
		.then( function( backend )
		{
			return !!backend.u2f;
		} );
	}
	
	function _ensureSupport( backend )
	{
		if ( !backend.u2f )
		{
			if ( location.protocol === 'http:' )
				throw new Error( "U2F isn't supported over http, only https" );
			throw new Error( "U2F not supported" );
		}
	}
	
	function ensureSupport( )
	{
		var Promise = this;
	
		return getBackend( Promise )
		.then( _ensureSupport );
	}
	
	function register( registerRequests, signRequests /* = null */, timeout )
	{
		var Promise = this;
	
		if ( !Array.isArray( registerRequests ) )
			registerRequests = [ registerRequests ];
	
		if ( typeof signRequests === 'number' && typeof timeout === 'undefined' )
		{
			timeout = signRequests;
			signRequests = null;
		}
	
		if ( !signRequests )
			signRequests = [ ];
	
		return deferPromise( Promise, getBackend( Promise )
		.then( function( backend )
		{
			_ensureSupport( backend );
	
			var native = backend.native;
			var u2f = backend.u2f;
	
			return new Promise( function( resolve, reject )
			{
				function cbNative( response )
				{
					if ( response.errorCode )
						reject( makeError( "Registration failed", response ) );
					else
					{
						delete response.errorCode;
						resolve( response );
					}
				}
	
				function cbChrome( err, response )
				{
					if ( err )
						reject( err );
					else if ( response.errorCode )
						reject( makeError( "Registration failed", response ) );
					else
						resolve( response );
				}
	
				if ( native )
				{
					var appId = registerRequests[ 0 ].appId;
	
					u2f.register(
						appId, registerRequests, signRequests, cbNative, timeout );
				}
				else
				{
					u2f.register(
						registerRequests, signRequests, cbChrome, timeout );
				}
			} );
		} ) ).promise;
	}
	
	function sign( signRequests, timeout )
	{
		var Promise = this;
	
		if ( !Array.isArray( signRequests ) )
			signRequests = [ signRequests ];
	
		return deferPromise( Promise, getBackend( Promise )
		.then( function( backend )
		{
			_ensureSupport( backend );
	
			var native = backend.native;
			var u2f = backend.u2f;
	
			return new Promise( function( resolve, reject )
			{
				function cbNative( response )
				{
					if ( response.errorCode )
						reject( makeError( "Sign failed", response ) );
					else
					{
						delete response.errorCode;
						resolve( response );
					}
				}
	
				function cbChrome( err, response )
				{
					if ( err )
						reject( err );
					else if ( response.errorCode )
						reject( makeError( "Sign failed", response ) );
					else
						resolve( response );
				}
	
				if ( native )
				{
					var appId = signRequests[ 0 ].appId;
					var challenge = signRequests[ 0 ].challenge;
	
					u2f.sign( appId, challenge, signRequests, cbNative, timeout );
				}
				else
				{
					u2f.sign( signRequests, cbChrome, timeout );
				}
			} );
		} ) ).promise;
	}
	
	function makeDefault( func )
	{
		API[ func ] = function( )
		{
			if ( !global.Promise )
				// This is very unlikely to ever happen, since browsers
				// supporting U2F will most likely support Promises.
				throw new Error( "The platform doesn't natively support promises" );
	
			var args = [ ].slice.call( arguments );
			return API( global.Promise )[ func ].apply( null, args );
		};
	}
	
	// Provide default functions using the built-in Promise if available.
	makeDefault( 'isSupported' );
	makeDefault( 'ensureSupport' );
	makeDefault( 'register' );
	makeDefault( 'sign' );
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports){
			module.exports = factory();
		} else {
			global.UriTemplate = factory();
		}
	})(this, function () {
		var uriTemplateGlobalModifiers = {
			"+": true,
			"#": true,
			".": true,
			"/": true,
			";": true,
			"?": true,
			"&": true
		};
		var uriTemplateSuffices = {
			"*": true
		};
	
		function notReallyPercentEncode(string) {
			return encodeURI(string).replace(/%25[0-9][0-9]/g, function (doubleEncoded) {
				return "%" + doubleEncoded.substring(3);
			});
		}
	
		function uriTemplateSubstitution(spec) {
			var modifier = "";
			if (uriTemplateGlobalModifiers[spec.charAt(0)]) {
				modifier = spec.charAt(0);
				spec = spec.substring(1);
			}
			var separator = "";
			var prefix = "";
			var shouldEscape = true;
			var showVariables = false;
			var trimEmptyString = false;
			if (modifier == '+') {
				shouldEscape = false;
			} else if (modifier == ".") {
				prefix = ".";
				separator = ".";
			} else if (modifier == "/") {
				prefix = "/";
				separator = "/";
			} else if (modifier == '#') {
				prefix = "#";
				shouldEscape = false;
			} else if (modifier == ';') {
				prefix = ";";
				separator = ";",
				showVariables = true;
				trimEmptyString = true;
			} else if (modifier == '?') {
				prefix = "?";
				separator = "&",
				showVariables = true;
			} else if (modifier == '&') {
				prefix = "&";
				separator = "&",
				showVariables = true;
			}
	
			var varNames = [];
			var varList = spec.split(",");
			var varSpecs = [];
			var varSpecMap = {};
			for (var i = 0; i < varList.length; i++) {
				var varName = varList[i];
				var truncate = null;
				if (varName.indexOf(":") != -1) {
					var parts = varName.split(":");
					varName = parts[0];
					truncate = parseInt(parts[1]);
				}
				var suffices = {};
				while (uriTemplateSuffices[varName.charAt(varName.length - 1)]) {
					suffices[varName.charAt(varName.length - 1)] = true;
					varName = varName.substring(0, varName.length - 1);
				}
				var varSpec = {
					truncate: truncate,
					name: varName,
					suffices: suffices
				};
				varSpecs.push(varSpec);
				varSpecMap[varName] = varSpec;
				varNames.push(varName);
			}
			var subFunction = function (valueFunction) {
				var result = "";
				var startIndex = 0;
				for (var i = 0; i < varSpecs.length; i++) {
					var varSpec = varSpecs[i];
					var value = valueFunction(varSpec.name);
					if (value == null || (Array.isArray(value) && value.length == 0) || (typeof value == 'object' && Object.keys(value).length == 0)) {
						startIndex++;
						continue;
					}
					if (i == startIndex) {
						result += prefix;
					} else {
						result += (separator || ",");
					}
					if (Array.isArray(value)) {
						if (showVariables) {
							result += varSpec.name + "=";
						}
						for (var j = 0; j < value.length; j++) {
							if (j > 0) {
								result += varSpec.suffices['*'] ? (separator || ",") : ",";
								if (varSpec.suffices['*'] && showVariables) {
									result += varSpec.name + "=";
								}
							}
							result += shouldEscape ? encodeURIComponent(value[j]).replace(/!/g, "%21") : notReallyPercentEncode(value[j]);
						}
					} else if (typeof value == "object") {
						if (showVariables && !varSpec.suffices['*']) {
							result += varSpec.name + "=";
						}
						var first = true;
						for (var key in value) {
							if (!first) {
								result += varSpec.suffices['*'] ? (separator || ",") : ",";
							}
							first = false;
							result += shouldEscape ? encodeURIComponent(key).replace(/!/g, "%21") : notReallyPercentEncode(key);
							result += varSpec.suffices['*'] ? '=' : ",";
							result += shouldEscape ? encodeURIComponent(value[key]).replace(/!/g, "%21") : notReallyPercentEncode(value[key]);
						}
					} else {
						if (showVariables) {
							result += varSpec.name;
							if (!trimEmptyString || value != "") {
								result += "=";
							}
						}
						if (varSpec.truncate != null) {
							value = value.substring(0, varSpec.truncate);
						}
						result += shouldEscape ? encodeURIComponent(value).replace(/!/g, "%21"): notReallyPercentEncode(value);
					}
				}
				return result;
			};
			var guessFunction = function (stringValue, resultObj) {
				if (prefix) {
					if (stringValue.substring(0, prefix.length) == prefix) {
						stringValue = stringValue.substring(prefix.length);
					} else {
						return null;
					}
				}
				if (varSpecs.length == 1 && varSpecs[0].suffices['*']) {
					var varSpec = varSpecs[0];
					var varName = varSpec.name;
					var arrayValue = varSpec.suffices['*'] ? stringValue.split(separator || ",") : [stringValue];
					var hasEquals = (shouldEscape && stringValue.indexOf('=') != -1);	// There's otherwise no way to distinguish between "{value*}" for arrays and objects
					for (var i = 1; i < arrayValue.length; i++) {
						var stringValue = arrayValue[i];
						if (hasEquals && stringValue.indexOf('=') == -1) {
							// Bit of a hack - if we're expecting "=" for key/value pairs, and values can't contain "=", then assume a value has been accidentally split
							arrayValue[i - 1] += (separator || ",") + stringValue;
							arrayValue.splice(i, 1);
							i--;
						}
					}
					for (var i = 0; i < arrayValue.length; i++) {
						var stringValue = arrayValue[i];
						if (shouldEscape && stringValue.indexOf('=') != -1) {
							hasEquals = true;
						}
						var innerArrayValue = stringValue.split(",");
						for (var j = 0; j < innerArrayValue.length; j++) {
							if (shouldEscape) {
								innerArrayValue[j] = decodeURIComponent(innerArrayValue[j]);
							}
						}
						if (innerArrayValue.length == 1) {
							arrayValue[i] = innerArrayValue[0];
						} else {
							arrayValue[i] = innerArrayValue;
						}
					}
	
					if (showVariables || hasEquals) {
						var objectValue = resultObj[varName] || {};
						for (var j = 0; j < arrayValue.length; j++) {
							var innerValue = stringValue;
							if (showVariables && !innerValue) {
								// The empty string isn't a valid variable, so if our value is zero-length we have nothing
								continue;
							}
							if (typeof arrayValue[j] == "string") {
								var stringValue = arrayValue[j];
								var innerVarName = stringValue.split("=", 1)[0];
								var stringValue = stringValue.substring(innerVarName.length + 1);
								innerValue = stringValue;
							} else {
								var stringValue = arrayValue[j][0];
								var innerVarName = stringValue.split("=", 1)[0];
								var stringValue = stringValue.substring(innerVarName.length + 1);
								arrayValue[j][0] = stringValue;
								innerValue = arrayValue[j];
							}
							if (objectValue[innerVarName] !== undefined) {
								if (Array.isArray(objectValue[innerVarName])) {
									objectValue[innerVarName].push(innerValue);
								} else {
									objectValue[innerVarName] = [objectValue[innerVarName], innerValue];
								}
							} else {
								objectValue[innerVarName] = innerValue;
							}
						}
						if (Object.keys(objectValue).length == 1 && objectValue[varName] !== undefined) {
							resultObj[varName] = objectValue[varName];
						} else {
							resultObj[varName] = objectValue;
						}
					} else {
						if (resultObj[varName] !== undefined) {
							if (Array.isArray(resultObj[varName])) {
								resultObj[varName] = resultObj[varName].concat(arrayValue);
							} else {
								resultObj[varName] = [resultObj[varName]].concat(arrayValue);
							}
						} else {
							if (arrayValue.length == 1 && !varSpec.suffices['*']) {
								resultObj[varName] = arrayValue[0];
							} else {
								resultObj[varName] = arrayValue;
							}
						}
					}
				} else {
					var arrayValue = (varSpecs.length == 1) ? [stringValue] : stringValue.split(separator || ",");
					var specIndexMap = {};
					for (var i = 0; i < arrayValue.length; i++) {
						// Try from beginning
						var firstStarred = 0;
						for (; firstStarred < varSpecs.length - 1 && firstStarred < i; firstStarred++) {
							if (varSpecs[firstStarred].suffices['*']) {
								break;
							}
						}
						if (firstStarred == i) {
							// The first [i] of them have no "*" suffix
							specIndexMap[i] = i;
							continue;
						} else {
							// Try from the end
							for (var lastStarred = varSpecs.length - 1; lastStarred > 0 && (varSpecs.length - lastStarred) < (arrayValue.length - i); lastStarred--) {
								if (varSpecs[lastStarred].suffices['*']) {
									break;
								}
							}
							if ((varSpecs.length - lastStarred) == (arrayValue.length - i)) {
								// The last [length - i] of them have no "*" suffix
								specIndexMap[i] = lastStarred;
								continue;
							}
						}
						// Just give up and use the first one
						specIndexMap[i] = firstStarred;
					}
					for (var i = 0; i < arrayValue.length; i++) {
						var stringValue = arrayValue[i];
						if (!stringValue && showVariables) {
							// The empty string isn't a valid variable, so if our value is zero-length we have nothing
							continue;
						}
						var innerArrayValue = stringValue.split(",");
						var hasEquals = false;
	
						if (showVariables) {
							var stringValue = innerArrayValue[0]; // using innerArrayValue
							var varName = stringValue.split("=", 1)[0];
							var stringValue = stringValue.substring(varName.length + 1);
							innerArrayValue[0] = stringValue;
							var varSpec = varSpecMap[varName] || varSpecs[0];
						} else {
							var varSpec = varSpecs[specIndexMap[i]];
							var varName = varSpec.name;
						}
	
						for (var j = 0; j < innerArrayValue.length; j++) {
							if (shouldEscape) {
								innerArrayValue[j] = decodeURIComponent(innerArrayValue[j]);
							}
						}
	
						if ((showVariables || varSpec.suffices['*'])&& resultObj[varName] !== undefined) {
							if (Array.isArray(resultObj[varName])) {
								resultObj[varName] = resultObj[varName].concat(innerArrayValue);
							} else {
								resultObj[varName] = [resultObj[varName]].concat(innerArrayValue);
							}
						} else {
							if (innerArrayValue.length == 1 && !varSpec.suffices['*']) {
								resultObj[varName] = innerArrayValue[0];
							} else {
								resultObj[varName] = innerArrayValue;
							}
						}
					}
				}
			};
			subFunction.varNames = varNames;
			return {
				prefix: prefix,
				substitution: subFunction,
				unSubstitution: guessFunction
			};
		}
	
		function UriTemplate(template) {
			if (!(this instanceof UriTemplate)) {
				return new UriTemplate(template);
			}
			var parts = template.split("{");
			var textParts = [parts.shift()];
			var prefixes = [];
			var substitutions = [];
			var unSubstitutions = [];
			var varNames = [];
			while (parts.length > 0) {
				var part = parts.shift();
				var spec = part.split("}")[0];
				var remainder = part.substring(spec.length + 1);
				var funcs = uriTemplateSubstitution(spec);
				substitutions.push(funcs.substitution);
				unSubstitutions.push(funcs.unSubstitution);
				prefixes.push(funcs.prefix);
				textParts.push(remainder);
				varNames = varNames.concat(funcs.substitution.varNames);
			}
			this.fill = function (valueFunction) {
				if (valueFunction && typeof valueFunction !== 'function') {
					var value = valueFunction;
					valueFunction = function (varName) {
						return value[varName];
					};
				}
	
				var result = textParts[0];
				for (var i = 0; i < substitutions.length; i++) {
					var substitution = substitutions[i];
					result += substitution(valueFunction);
					result += textParts[i + 1];
				}
				return result;
			};
			this.fromUri = function (substituted) {
				var result = {};
				for (var i = 0; i < textParts.length; i++) {
					var part = textParts[i];
					if (substituted.substring(0, part.length) !== part) {
						return undefined;
					}
					substituted = substituted.substring(part.length);
					if (i >= textParts.length - 1) {
						if (substituted == "") {
							break;
						} else {
							return undefined;
						}
					}
					var nextPart = textParts[i + 1];
					var offset = i;
					while (true) {
						if (offset == textParts.length - 2) {
							var endPart = substituted.substring(substituted.length - nextPart.length);
							if (endPart !== nextPart) {
								return undefined;
							}
							var stringValue = substituted.substring(0, substituted.length - nextPart.length);
							substituted = endPart;
						} else if (nextPart) {
							var nextPartPos = substituted.indexOf(nextPart);
							var stringValue = substituted.substring(0, nextPartPos);
							substituted = substituted.substring(nextPartPos);
						} else if (prefixes[offset + 1]) {
							var nextPartPos = substituted.indexOf(prefixes[offset + 1]);
							if (nextPartPos === -1) nextPartPos = substituted.length;
							var stringValue = substituted.substring(0, nextPartPos);
							substituted = substituted.substring(nextPartPos);
						} else if (textParts.length > offset + 2) {
							// If the separator between this variable and the next is blank (with no prefix), continue onwards
							offset++;
							nextPart = textParts[offset + 1];
							continue;
						} else {
							var stringValue = substituted;
							substituted = "";
						}
						break;
					}
					unSubstitutions[i](stringValue, result);
				}
				return result;
			}
			this.varNames = varNames;
			this.template = template;
		}
		UriTemplate.prototype = {
			toString: function () {
				return this.template;
			},
			fillFromObject: function (obj) {
				return this.fill(obj);
			}
		};
	
		return UriTemplate;
	});


/***/ })
]);


// WEBPACK FOOTER //
// app-2e1932a2827a90e97376.js